const normalizeToValidation = ({ value, length, canRepeatNumber = false, }) => {
    if (!value)
        return undefined;
    value = value.toString()?.replace(/\D/g, '');
    if (length) {
        if (value.length !== length)
            return undefined;
    }
    if (!canRepeatNumber) {
        const invalidSequences = new Set(Array.from(Array(10).keys()).map((f) => String(f).repeat(length ?? 0)));
        if (invalidSequences.has(value))
            return undefined;
    }
    return value;
};

const renavamValidator = (renavam) => {
    const VALID_LENGTH = 11;
    renavam = normalizeToValidation({ value: renavam, length: VALID_LENGTH });
    if (!renavam)
        return false;
    const checkDigits = renavam.slice(10, renavam.length);
    const baseDigits = renavam.slice(0, 10);
    let multiplier = 2;
    const reducerByModule11 = baseDigits
        .split('')
        .reverse()
        .reduce((accumulator, currenValue) => {
        const result = Number(currenValue) * multiplier;
        multiplier = multiplier === 9 ? 2 : ++multiplier;
        return Number(accumulator) + result;
    }, 0);
    let firstCheckDigit = 11 - (reducerByModule11 % 11);
    if (firstCheckDigit === 10 || firstCheckDigit === 11)
        firstCheckDigit = 0;
    if (firstCheckDigit.toString() !== checkDigits[0])
        return false;
    return true;
};

const cnhValidator = (cnh) => {
    const VALID_LENGTH = 11;
    cnh = normalizeToValidation({ value: cnh, length: VALID_LENGTH });
    if (!cnh)
        return false;
    const checkDigits = cnh.slice(9, cnh.length);
    const baseDigits = cnh.slice(0, 9);
    let multiplier = 2;
    let reducerByModule11 = baseDigits
        .split('')
        .reduce((accumulator, currenValue) => {
        const result = Number(currenValue) * multiplier;
        multiplier = multiplier === 10 ? 2 : ++multiplier;
        return Number(accumulator) + result;
    }, 0);
    let firstCheckDigit = 11 - (reducerByModule11 % 11);
    if (firstCheckDigit === 10 || firstCheckDigit === 11)
        firstCheckDigit = 0;
    if (firstCheckDigit.toString() !== checkDigits[0])
        return false;
    multiplier = 3;
    reducerByModule11 = (baseDigits + checkDigits[0])
        .split('')
        .reduce((accumulator, currenValue) => {
        const result = Number(currenValue) * multiplier;
        multiplier = multiplier === 11 ? 2 : ++multiplier;
        return Number(accumulator) + result;
    }, 0);
    let secondCheckDigit = 11 - (reducerByModule11 % 11);
    if (secondCheckDigit === 10 || secondCheckDigit === 11)
        secondCheckDigit = 0;
    if (secondCheckDigit.toString() !== checkDigits[1])
        return false;
    return true;
};

/**
 * This function is to be applied in cases where you need to use a reducer with increment of weights 2 to 9,
 * this process, abstracted from within the algorithm of module 11.
 * @param digits
 * @returns result
 */
const reducerCheckDigitControl = (digits) => {
    let multiplier = 2;
    const result = digits
        .split('')
        .reduce((accumulator, currenValue) => {
        const result = Number(currenValue) * multiplier;
        multiplier = multiplier === 9 ? 2 : ++multiplier;
        return Number(accumulator) + result;
    }, 0);
    return result;
};

var AC = [
	{
		ibgeCode: "1200013",
		cityName: "Acrelândia",
		state: "AC"
	},
	{
		ibgeCode: "1200054",
		cityName: "Assis Brasil",
		state: "AC"
	},
	{
		ibgeCode: "1200104",
		cityName: "Brasiléia",
		state: "AC"
	},
	{
		ibgeCode: "1200138",
		cityName: "Bujari",
		state: "AC"
	},
	{
		ibgeCode: "1200179",
		cityName: "Capixaba",
		state: "AC"
	},
	{
		ibgeCode: "1200203",
		cityName: "Cruzeiro do Sul",
		state: "AC"
	},
	{
		ibgeCode: "1200252",
		cityName: "Epitaciolândia",
		state: "AC"
	},
	{
		ibgeCode: "1200302",
		cityName: "Feijó",
		state: "AC"
	},
	{
		ibgeCode: "1200328",
		cityName: "Jordão",
		state: "AC"
	},
	{
		ibgeCode: "1200336",
		cityName: "Mâncio Lima",
		state: "AC"
	},
	{
		ibgeCode: "1200344",
		cityName: "Manoel Urbano",
		state: "AC"
	},
	{
		ibgeCode: "1200351",
		cityName: "Marechal Thaumaturgo",
		state: "AC"
	},
	{
		ibgeCode: "1200385",
		cityName: "Plácido de Castro",
		state: "AC"
	},
	{
		ibgeCode: "1200807",
		cityName: "Porto Acre",
		state: "AC"
	},
	{
		ibgeCode: "1200393",
		cityName: "Porto Walter",
		state: "AC"
	},
	{
		ibgeCode: "1200401",
		cityName: "Rio Branco",
		state: "AC"
	},
	{
		ibgeCode: "1200427",
		cityName: "Rodrigues Alves",
		state: "AC"
	},
	{
		ibgeCode: "1200435",
		cityName: "Santa Rosa do Purus",
		state: "AC"
	},
	{
		ibgeCode: "1200500",
		cityName: "Sena Madureira",
		state: "AC"
	},
	{
		ibgeCode: "1200450",
		cityName: "Senador Guiomard",
		state: "AC"
	},
	{
		ibgeCode: "1200609",
		cityName: "Tarauacá",
		state: "AC"
	},
	{
		ibgeCode: "1200708",
		cityName: "Xapuri",
		state: "AC"
	}
];
var AL = [
	{
		ibgeCode: "2700102",
		cityName: "Água Branca",
		state: "AL"
	},
	{
		ibgeCode: "2700201",
		cityName: "Anadia",
		state: "AL"
	},
	{
		ibgeCode: "2700300",
		cityName: "Arapiraca",
		state: "AL"
	},
	{
		ibgeCode: "2700409",
		cityName: "Atalaia",
		state: "AL"
	},
	{
		ibgeCode: "2700508",
		cityName: "Barra de Santo Antônio",
		state: "AL"
	},
	{
		ibgeCode: "2700607",
		cityName: "Barra de São Miguel",
		state: "AL"
	},
	{
		ibgeCode: "2700706",
		cityName: "Batalha",
		state: "AL"
	},
	{
		ibgeCode: "2700805",
		cityName: "Belém",
		state: "AL"
	},
	{
		ibgeCode: "2700904",
		cityName: "Belo Monte",
		state: "AL"
	},
	{
		ibgeCode: "2701001",
		cityName: "Boca da Mata",
		state: "AL"
	},
	{
		ibgeCode: "2701100",
		cityName: "Branquinha",
		state: "AL"
	},
	{
		ibgeCode: "2701209",
		cityName: "Cacimbinhas",
		state: "AL"
	},
	{
		ibgeCode: "2701308",
		cityName: "Cajueiro",
		state: "AL"
	},
	{
		ibgeCode: "2701357",
		cityName: "Campestre",
		state: "AL"
	},
	{
		ibgeCode: "2701407",
		cityName: "Campo Alegre",
		state: "AL"
	},
	{
		ibgeCode: "2701506",
		cityName: "Campo Grande",
		state: "AL"
	},
	{
		ibgeCode: "2701605",
		cityName: "Canapi",
		state: "AL"
	},
	{
		ibgeCode: "2701704",
		cityName: "Capela",
		state: "AL"
	},
	{
		ibgeCode: "2701803",
		cityName: "Carneiros",
		state: "AL"
	},
	{
		ibgeCode: "2701902",
		cityName: "Chã Preta",
		state: "AL"
	},
	{
		ibgeCode: "2702009",
		cityName: "Coité do Nóia",
		state: "AL"
	},
	{
		ibgeCode: "2702108",
		cityName: "Colônia Leopoldina",
		state: "AL"
	},
	{
		ibgeCode: "2702207",
		cityName: "Coqueiro Seco",
		state: "AL"
	},
	{
		ibgeCode: "2702306",
		cityName: "Coruripe",
		state: "AL"
	},
	{
		ibgeCode: "2702355",
		cityName: "Craíbas",
		state: "AL"
	},
	{
		ibgeCode: "2702405",
		cityName: "Delmiro Gouveia",
		state: "AL"
	},
	{
		ibgeCode: "2702504",
		cityName: "Dois Riachos",
		state: "AL"
	},
	{
		ibgeCode: "2702553",
		cityName: "Estrela de Alagoas",
		state: "AL"
	},
	{
		ibgeCode: "2702603",
		cityName: "Feira Grande",
		state: "AL"
	},
	{
		ibgeCode: "2702702",
		cityName: "Feliz Deserto",
		state: "AL"
	},
	{
		ibgeCode: "2702801",
		cityName: "Flexeiras",
		state: "AL"
	},
	{
		ibgeCode: "2702900",
		cityName: "Girau do Ponciano",
		state: "AL"
	},
	{
		ibgeCode: "2703007",
		cityName: "Ibateguara",
		state: "AL"
	},
	{
		ibgeCode: "2703106",
		cityName: "Igaci",
		state: "AL"
	},
	{
		ibgeCode: "2703205",
		cityName: "Igreja Nova",
		state: "AL"
	},
	{
		ibgeCode: "2703304",
		cityName: "Inhapi",
		state: "AL"
	},
	{
		ibgeCode: "2703403",
		cityName: "Jacaré dos Homens",
		state: "AL"
	},
	{
		ibgeCode: "2703502",
		cityName: "Jacuípe",
		state: "AL"
	},
	{
		ibgeCode: "2703601",
		cityName: "Japaratinga",
		state: "AL"
	},
	{
		ibgeCode: "2703700",
		cityName: "Jaramataia",
		state: "AL"
	},
	{
		ibgeCode: "2703759",
		cityName: "Jequiá da Praia",
		state: "AL"
	},
	{
		ibgeCode: "2703809",
		cityName: "Joaquim Gomes",
		state: "AL"
	},
	{
		ibgeCode: "2703908",
		cityName: "Jundiá",
		state: "AL"
	},
	{
		ibgeCode: "2704005",
		cityName: "Junqueiro",
		state: "AL"
	},
	{
		ibgeCode: "2704104",
		cityName: "Lagoa da Canoa",
		state: "AL"
	},
	{
		ibgeCode: "2704203",
		cityName: "Limoeiro de Anadia",
		state: "AL"
	},
	{
		ibgeCode: "2704302",
		cityName: "Maceió",
		state: "AL"
	},
	{
		ibgeCode: "2704401",
		cityName: "Major Isidoro",
		state: "AL"
	},
	{
		ibgeCode: "2704906",
		cityName: "Mar Vermelho",
		state: "AL"
	},
	{
		ibgeCode: "2704500",
		cityName: "Maragogi",
		state: "AL"
	},
	{
		ibgeCode: "2704609",
		cityName: "Maravilha",
		state: "AL"
	},
	{
		ibgeCode: "2704708",
		cityName: "Marechal Deodoro",
		state: "AL"
	},
	{
		ibgeCode: "2704807",
		cityName: "Maribondo",
		state: "AL"
	},
	{
		ibgeCode: "2705002",
		cityName: "Mata Grande",
		state: "AL"
	},
	{
		ibgeCode: "2705101",
		cityName: "Matriz de Camaragibe",
		state: "AL"
	},
	{
		ibgeCode: "2705200",
		cityName: "Messias",
		state: "AL"
	},
	{
		ibgeCode: "2705309",
		cityName: "Minador do Negrão",
		state: "AL"
	},
	{
		ibgeCode: "2705408",
		cityName: "Monteirópolis",
		state: "AL"
	},
	{
		ibgeCode: "2705507",
		cityName: "Murici",
		state: "AL"
	},
	{
		ibgeCode: "2705606",
		cityName: "Novo Lino",
		state: "AL"
	},
	{
		ibgeCode: "2705705",
		cityName: "Olho d'Água das Flores",
		state: "AL"
	},
	{
		ibgeCode: "2705804",
		cityName: "Olho d'Água do Casado",
		state: "AL"
	},
	{
		ibgeCode: "2705903",
		cityName: "Olho d'Água Grande",
		state: "AL"
	},
	{
		ibgeCode: "2706000",
		cityName: "Olivença",
		state: "AL"
	},
	{
		ibgeCode: "2706109",
		cityName: "Ouro Branco",
		state: "AL"
	},
	{
		ibgeCode: "2706208",
		cityName: "Palestina",
		state: "AL"
	},
	{
		ibgeCode: "2706307",
		cityName: "Palmeira dos Índios",
		state: "AL"
	},
	{
		ibgeCode: "2706406",
		cityName: "Pão de Açúcar",
		state: "AL"
	},
	{
		ibgeCode: "2706422",
		cityName: "Pariconha",
		state: "AL"
	},
	{
		ibgeCode: "2706448",
		cityName: "Paripueira",
		state: "AL"
	},
	{
		ibgeCode: "2706505",
		cityName: "Passo de Camaragibe",
		state: "AL"
	},
	{
		ibgeCode: "2706604",
		cityName: "Paulo Jacinto",
		state: "AL"
	},
	{
		ibgeCode: "2706703",
		cityName: "Penedo",
		state: "AL"
	},
	{
		ibgeCode: "2706802",
		cityName: "Piaçabuçu",
		state: "AL"
	},
	{
		ibgeCode: "2706901",
		cityName: "Pilar",
		state: "AL"
	},
	{
		ibgeCode: "2707008",
		cityName: "Pindoba",
		state: "AL"
	},
	{
		ibgeCode: "2707107",
		cityName: "Piranhas",
		state: "AL"
	},
	{
		ibgeCode: "2707206",
		cityName: "Poço das Trincheiras",
		state: "AL"
	},
	{
		ibgeCode: "2707305",
		cityName: "Porto Calvo",
		state: "AL"
	},
	{
		ibgeCode: "2707404",
		cityName: "Porto de Pedras",
		state: "AL"
	},
	{
		ibgeCode: "2707503",
		cityName: "Porto Real do Colégio",
		state: "AL"
	},
	{
		ibgeCode: "2707602",
		cityName: "Quebrangulo",
		state: "AL"
	},
	{
		ibgeCode: "2707701",
		cityName: "Rio Largo",
		state: "AL"
	},
	{
		ibgeCode: "2707800",
		cityName: "Roteiro",
		state: "AL"
	},
	{
		ibgeCode: "2707909",
		cityName: "Santa Luzia do Norte",
		state: "AL"
	},
	{
		ibgeCode: "2708006",
		cityName: "Santana do Ipanema",
		state: "AL"
	},
	{
		ibgeCode: "2708105",
		cityName: "Santana do Mundaú",
		state: "AL"
	},
	{
		ibgeCode: "2708204",
		cityName: "São Brás",
		state: "AL"
	},
	{
		ibgeCode: "2708303",
		cityName: "São José da Laje",
		state: "AL"
	},
	{
		ibgeCode: "2708402",
		cityName: "São José da Tapera",
		state: "AL"
	},
	{
		ibgeCode: "2708501",
		cityName: "São Luís do Quitunde",
		state: "AL"
	},
	{
		ibgeCode: "2708600",
		cityName: "São Miguel dos Campos",
		state: "AL"
	},
	{
		ibgeCode: "2708709",
		cityName: "São Miguel dos Milagres",
		state: "AL"
	},
	{
		ibgeCode: "2708808",
		cityName: "São Sebastião",
		state: "AL"
	},
	{
		ibgeCode: "2708907",
		cityName: "Satuba",
		state: "AL"
	},
	{
		ibgeCode: "2708956",
		cityName: "Senador Rui Palmeira",
		state: "AL"
	},
	{
		ibgeCode: "2709004",
		cityName: "Tanque d'Arca",
		state: "AL"
	},
	{
		ibgeCode: "2709103",
		cityName: "Taquarana",
		state: "AL"
	},
	{
		ibgeCode: "2709152",
		cityName: "Teotônio Vilela",
		state: "AL"
	},
	{
		ibgeCode: "2709202",
		cityName: "Traipu",
		state: "AL"
	},
	{
		ibgeCode: "2709301",
		cityName: "União dos Palmares",
		state: "AL"
	},
	{
		ibgeCode: "2709400",
		cityName: "Viçosa",
		state: "AL"
	}
];
var AP = [
	{
		ibgeCode: "1600105",
		cityName: "Amapá",
		state: "AP"
	},
	{
		ibgeCode: "1600204",
		cityName: "Calçoene",
		state: "AP"
	},
	{
		ibgeCode: "1600212",
		cityName: "Cutias",
		state: "AP"
	},
	{
		ibgeCode: "1600238",
		cityName: "Ferreira Gomes",
		state: "AP"
	},
	{
		ibgeCode: "1600253",
		cityName: "Itaubal",
		state: "AP"
	},
	{
		ibgeCode: "1600279",
		cityName: "Laranjal do Jari",
		state: "AP"
	},
	{
		ibgeCode: "1600303",
		cityName: "Macapá",
		state: "AP"
	},
	{
		ibgeCode: "1600402",
		cityName: "Mazagão",
		state: "AP"
	},
	{
		ibgeCode: "1600501",
		cityName: "Oiapoque",
		state: "AP"
	},
	{
		ibgeCode: "1600154",
		cityName: "Pedra Branca do Amapari",
		state: "AP"
	},
	{
		ibgeCode: "1600535",
		cityName: "Porto Grande",
		state: "AP"
	},
	{
		ibgeCode: "1600550",
		cityName: "Pracuúba",
		state: "AP"
	},
	{
		ibgeCode: "1600600",
		cityName: "Santana",
		state: "AP"
	},
	{
		ibgeCode: "1600055",
		cityName: "Serra do Navio",
		state: "AP"
	},
	{
		ibgeCode: "1600709",
		cityName: "Tartarugalzinho",
		state: "AP"
	},
	{
		ibgeCode: "1600808",
		cityName: "Vitória do Jari",
		state: "AP"
	}
];
var AM = [
	{
		ibgeCode: "1300029",
		cityName: "Alvarães",
		state: "AM"
	},
	{
		ibgeCode: "1300060",
		cityName: "Amaturá",
		state: "AM"
	},
	{
		ibgeCode: "1300086",
		cityName: "Anamã",
		state: "AM"
	},
	{
		ibgeCode: "1300102",
		cityName: "Anori",
		state: "AM"
	},
	{
		ibgeCode: "1300144",
		cityName: "Apuí",
		state: "AM"
	},
	{
		ibgeCode: "1300201",
		cityName: "Atalaia do Norte",
		state: "AM"
	},
	{
		ibgeCode: "1300300",
		cityName: "Autazes",
		state: "AM"
	},
	{
		ibgeCode: "1300409",
		cityName: "Barcelos",
		state: "AM"
	},
	{
		ibgeCode: "1300508",
		cityName: "Barreirinha",
		state: "AM"
	},
	{
		ibgeCode: "1300607",
		cityName: "Benjamin Constant",
		state: "AM"
	},
	{
		ibgeCode: "1300631",
		cityName: "Beruri",
		state: "AM"
	},
	{
		ibgeCode: "1300680",
		cityName: "Boa Vista do Ramos",
		state: "AM"
	},
	{
		ibgeCode: "1300706",
		cityName: "Boca do Acre",
		state: "AM"
	},
	{
		ibgeCode: "1300805",
		cityName: "Borba",
		state: "AM"
	},
	{
		ibgeCode: "1300839",
		cityName: "Caapiranga",
		state: "AM"
	},
	{
		ibgeCode: "1300904",
		cityName: "Canutama",
		state: "AM"
	},
	{
		ibgeCode: "1301001",
		cityName: "Carauari",
		state: "AM"
	},
	{
		ibgeCode: "1301100",
		cityName: "Careiro",
		state: "AM"
	},
	{
		ibgeCode: "1301159",
		cityName: "Careiro da Várzea",
		state: "AM"
	},
	{
		ibgeCode: "1301209",
		cityName: "Coari",
		state: "AM"
	},
	{
		ibgeCode: "1301308",
		cityName: "Codajás",
		state: "AM"
	},
	{
		ibgeCode: "1301407",
		cityName: "Eirunepé",
		state: "AM"
	},
	{
		ibgeCode: "1301506",
		cityName: "Envira",
		state: "AM"
	},
	{
		ibgeCode: "1301605",
		cityName: "Fonte Boa",
		state: "AM"
	},
	{
		ibgeCode: "1301654",
		cityName: "Guajará",
		state: "AM"
	},
	{
		ibgeCode: "1301704",
		cityName: "Humaitá",
		state: "AM"
	},
	{
		ibgeCode: "1301803",
		cityName: "Ipixuna",
		state: "AM"
	},
	{
		ibgeCode: "1301852",
		cityName: "Iranduba",
		state: "AM"
	},
	{
		ibgeCode: "1301902",
		cityName: "Itacoatiara",
		state: "AM"
	},
	{
		ibgeCode: "1301951",
		cityName: "Itamarati",
		state: "AM"
	},
	{
		ibgeCode: "1302009",
		cityName: "Itapiranga",
		state: "AM"
	},
	{
		ibgeCode: "1302108",
		cityName: "Japurá",
		state: "AM"
	},
	{
		ibgeCode: "1302207",
		cityName: "Juruá",
		state: "AM"
	},
	{
		ibgeCode: "1302306",
		cityName: "Jutaí",
		state: "AM"
	},
	{
		ibgeCode: "1302405",
		cityName: "Lábrea",
		state: "AM"
	},
	{
		ibgeCode: "1302504",
		cityName: "Manacapuru",
		state: "AM"
	},
	{
		ibgeCode: "1302553",
		cityName: "Manaquiri",
		state: "AM"
	},
	{
		ibgeCode: "1302603",
		cityName: "Manaus",
		state: "AM"
	},
	{
		ibgeCode: "1302702",
		cityName: "Manicoré",
		state: "AM"
	},
	{
		ibgeCode: "1302801",
		cityName: "Maraã",
		state: "AM"
	},
	{
		ibgeCode: "1302900",
		cityName: "Maués",
		state: "AM"
	},
	{
		ibgeCode: "1303007",
		cityName: "Nhamundá",
		state: "AM"
	},
	{
		ibgeCode: "1303106",
		cityName: "Nova Olinda do Norte",
		state: "AM"
	},
	{
		ibgeCode: "1303205",
		cityName: "Novo Airão",
		state: "AM"
	},
	{
		ibgeCode: "1303304",
		cityName: "Novo Aripuanã",
		state: "AM"
	},
	{
		ibgeCode: "1303403",
		cityName: "Parintins",
		state: "AM"
	},
	{
		ibgeCode: "1303502",
		cityName: "Pauini",
		state: "AM"
	},
	{
		ibgeCode: "1303536",
		cityName: "Presidente Figueiredo",
		state: "AM"
	},
	{
		ibgeCode: "1303569",
		cityName: "Rio Preto da Eva",
		state: "AM"
	},
	{
		ibgeCode: "1303601",
		cityName: "Santa Isabel do Rio Negro",
		state: "AM"
	},
	{
		ibgeCode: "1303700",
		cityName: "Santo Antônio do Içá",
		state: "AM"
	},
	{
		ibgeCode: "1303809",
		cityName: "São Gabriel da Cachoeira",
		state: "AM"
	},
	{
		ibgeCode: "1303908",
		cityName: "São Paulo de Olivença",
		state: "AM"
	},
	{
		ibgeCode: "1303957",
		cityName: "São Sebastião do Uatumã",
		state: "AM"
	},
	{
		ibgeCode: "1304005",
		cityName: "Silves",
		state: "AM"
	},
	{
		ibgeCode: "1304062",
		cityName: "Tabatinga",
		state: "AM"
	},
	{
		ibgeCode: "1304104",
		cityName: "Tapauá",
		state: "AM"
	},
	{
		ibgeCode: "1304203",
		cityName: "Tefé",
		state: "AM"
	},
	{
		ibgeCode: "1304237",
		cityName: "Tonantins",
		state: "AM"
	},
	{
		ibgeCode: "1304260",
		cityName: "Uarini",
		state: "AM"
	},
	{
		ibgeCode: "1304302",
		cityName: "Urucará",
		state: "AM"
	},
	{
		ibgeCode: "1304401",
		cityName: "Urucurituba",
		state: "AM"
	}
];
var BA = [
	{
		ibgeCode: "2900108",
		cityName: "Abaíra",
		state: "BA"
	},
	{
		ibgeCode: "2900207",
		cityName: "Abaré",
		state: "BA"
	},
	{
		ibgeCode: "2900306",
		cityName: "Acajutiba",
		state: "BA"
	},
	{
		ibgeCode: "2900355",
		cityName: "Adustina",
		state: "BA"
	},
	{
		ibgeCode: "2900405",
		cityName: "Água Fria",
		state: "BA"
	},
	{
		ibgeCode: "2900603",
		cityName: "Aiquara",
		state: "BA"
	},
	{
		ibgeCode: "2900702",
		cityName: "Alagoinhas",
		state: "BA"
	},
	{
		ibgeCode: "2900801",
		cityName: "Alcobaça",
		state: "BA"
	},
	{
		ibgeCode: "2900900",
		cityName: "Almadina",
		state: "BA"
	},
	{
		ibgeCode: "2901007",
		cityName: "Amargosa",
		state: "BA"
	},
	{
		ibgeCode: "2901106",
		cityName: "Amélia Rodrigues",
		state: "BA"
	},
	{
		ibgeCode: "2901155",
		cityName: "América Dourada",
		state: "BA"
	},
	{
		ibgeCode: "2901205",
		cityName: "Anagé",
		state: "BA"
	},
	{
		ibgeCode: "2901304",
		cityName: "Andaraí",
		state: "BA"
	},
	{
		ibgeCode: "2901353",
		cityName: "Andorinha",
		state: "BA"
	},
	{
		ibgeCode: "2901403",
		cityName: "Angical",
		state: "BA"
	},
	{
		ibgeCode: "2901502",
		cityName: "Anguera",
		state: "BA"
	},
	{
		ibgeCode: "2901601",
		cityName: "Antas",
		state: "BA"
	},
	{
		ibgeCode: "2901700",
		cityName: "Antônio Cardoso",
		state: "BA"
	},
	{
		ibgeCode: "2901809",
		cityName: "Antônio Gonçalves",
		state: "BA"
	},
	{
		ibgeCode: "2901908",
		cityName: "Aporá",
		state: "BA"
	},
	{
		ibgeCode: "2901957",
		cityName: "Apuarema",
		state: "BA"
	},
	{
		ibgeCode: "2902054",
		cityName: "Araçás",
		state: "BA"
	},
	{
		ibgeCode: "2902005",
		cityName: "Aracatu",
		state: "BA"
	},
	{
		ibgeCode: "2902104",
		cityName: "Araci",
		state: "BA"
	},
	{
		ibgeCode: "2902203",
		cityName: "Aramari",
		state: "BA"
	},
	{
		ibgeCode: "2902252",
		cityName: "Arataca",
		state: "BA"
	},
	{
		ibgeCode: "2902302",
		cityName: "Aratuípe",
		state: "BA"
	},
	{
		ibgeCode: "2902401",
		cityName: "Aurelino Leal",
		state: "BA"
	},
	{
		ibgeCode: "2902500",
		cityName: "Baianópolis",
		state: "BA"
	},
	{
		ibgeCode: "2902609",
		cityName: "Baixa Grande",
		state: "BA"
	},
	{
		ibgeCode: "2902658",
		cityName: "Banzaê",
		state: "BA"
	},
	{
		ibgeCode: "2902708",
		cityName: "Barra",
		state: "BA"
	},
	{
		ibgeCode: "2902807",
		cityName: "Barra da Estiva",
		state: "BA"
	},
	{
		ibgeCode: "2902906",
		cityName: "Barra do Choça",
		state: "BA"
	},
	{
		ibgeCode: "2903003",
		cityName: "Barra do Mendes",
		state: "BA"
	},
	{
		ibgeCode: "2903102",
		cityName: "Barra do Rocha",
		state: "BA"
	},
	{
		ibgeCode: "2903201",
		cityName: "Barreiras",
		state: "BA"
	},
	{
		ibgeCode: "2903235",
		cityName: "Barro Alto",
		state: "BA"
	},
	{
		ibgeCode: "2903300",
		cityName: "Barro Preto",
		state: "BA"
	},
	{
		ibgeCode: "2903276",
		cityName: "Barrocas",
		state: "BA"
	},
	{
		ibgeCode: "2903409",
		cityName: "Belmonte",
		state: "BA"
	},
	{
		ibgeCode: "2903508",
		cityName: "Belo Campo",
		state: "BA"
	},
	{
		ibgeCode: "2903607",
		cityName: "Biritinga",
		state: "BA"
	},
	{
		ibgeCode: "2903706",
		cityName: "Boa Nova",
		state: "BA"
	},
	{
		ibgeCode: "2903805",
		cityName: "Boa Vista do Tupim",
		state: "BA"
	},
	{
		ibgeCode: "2903904",
		cityName: "Bom Jesus da Lapa",
		state: "BA"
	},
	{
		ibgeCode: "2903953",
		cityName: "Bom Jesus da Serra",
		state: "BA"
	},
	{
		ibgeCode: "2904001",
		cityName: "Boninal",
		state: "BA"
	},
	{
		ibgeCode: "2904050",
		cityName: "Bonito",
		state: "BA"
	},
	{
		ibgeCode: "2904100",
		cityName: "Boquira",
		state: "BA"
	},
	{
		ibgeCode: "2904209",
		cityName: "Botuporã",
		state: "BA"
	},
	{
		ibgeCode: "2904308",
		cityName: "Brejões",
		state: "BA"
	},
	{
		ibgeCode: "2904407",
		cityName: "Brejolândia",
		state: "BA"
	},
	{
		ibgeCode: "2904506",
		cityName: "Brotas de Macaúbas",
		state: "BA"
	},
	{
		ibgeCode: "2904605",
		cityName: "Brumado",
		state: "BA"
	},
	{
		ibgeCode: "2904704",
		cityName: "Buerarema",
		state: "BA"
	},
	{
		ibgeCode: "2904753",
		cityName: "Buritirama",
		state: "BA"
	},
	{
		ibgeCode: "2904803",
		cityName: "Caatiba",
		state: "BA"
	},
	{
		ibgeCode: "2904852",
		cityName: "Cabaceiras do Paraguaçu",
		state: "BA"
	},
	{
		ibgeCode: "2904902",
		cityName: "Cachoeira",
		state: "BA"
	},
	{
		ibgeCode: "2905008",
		cityName: "Caculé",
		state: "BA"
	},
	{
		ibgeCode: "2905107",
		cityName: "Caém",
		state: "BA"
	},
	{
		ibgeCode: "2905156",
		cityName: "Caetanos",
		state: "BA"
	},
	{
		ibgeCode: "2905206",
		cityName: "Caetité",
		state: "BA"
	},
	{
		ibgeCode: "2905305",
		cityName: "Cafarnaum",
		state: "BA"
	},
	{
		ibgeCode: "2905404",
		cityName: "Cairu",
		state: "BA"
	},
	{
		ibgeCode: "2905503",
		cityName: "Caldeirão Grande",
		state: "BA"
	},
	{
		ibgeCode: "2905602",
		cityName: "Camacan",
		state: "BA"
	},
	{
		ibgeCode: "2905701",
		cityName: "Camaçari",
		state: "BA"
	},
	{
		ibgeCode: "2905800",
		cityName: "Camamu",
		state: "BA"
	},
	{
		ibgeCode: "2905909",
		cityName: "Campo Alegre de Lourdes",
		state: "BA"
	},
	{
		ibgeCode: "2906006",
		cityName: "Campo Formoso",
		state: "BA"
	},
	{
		ibgeCode: "2906105",
		cityName: "Canápolis",
		state: "BA"
	},
	{
		ibgeCode: "2906204",
		cityName: "Canarana",
		state: "BA"
	},
	{
		ibgeCode: "2906303",
		cityName: "Canavieiras",
		state: "BA"
	},
	{
		ibgeCode: "2906402",
		cityName: "Candeal",
		state: "BA"
	},
	{
		ibgeCode: "2906501",
		cityName: "Candeias",
		state: "BA"
	},
	{
		ibgeCode: "2906600",
		cityName: "Candiba",
		state: "BA"
	},
	{
		ibgeCode: "2906709",
		cityName: "Cândido Sales",
		state: "BA"
	},
	{
		ibgeCode: "2906808",
		cityName: "Cansanção",
		state: "BA"
	},
	{
		ibgeCode: "2906824",
		cityName: "Canudos",
		state: "BA"
	},
	{
		ibgeCode: "2906857",
		cityName: "Capela do Alto Alegre",
		state: "BA"
	},
	{
		ibgeCode: "2906873",
		cityName: "Capim Grosso",
		state: "BA"
	},
	{
		ibgeCode: "2906899",
		cityName: "Caraíbas",
		state: "BA"
	},
	{
		ibgeCode: "2906907",
		cityName: "Caravelas",
		state: "BA"
	},
	{
		ibgeCode: "2907004",
		cityName: "Cardeal da Silva",
		state: "BA"
	},
	{
		ibgeCode: "2907103",
		cityName: "Carinhanha",
		state: "BA"
	},
	{
		ibgeCode: "2907202",
		cityName: "Casa Nova",
		state: "BA"
	},
	{
		ibgeCode: "2907301",
		cityName: "Castro Alves",
		state: "BA"
	},
	{
		ibgeCode: "2907400",
		cityName: "Catolândia",
		state: "BA"
	},
	{
		ibgeCode: "2907509",
		cityName: "Catu",
		state: "BA"
	},
	{
		ibgeCode: "2907558",
		cityName: "Caturama",
		state: "BA"
	},
	{
		ibgeCode: "2907608",
		cityName: "Central",
		state: "BA"
	},
	{
		ibgeCode: "2907707",
		cityName: "Chorrochó",
		state: "BA"
	},
	{
		ibgeCode: "2907806",
		cityName: "Cícero Dantas",
		state: "BA"
	},
	{
		ibgeCode: "2907905",
		cityName: "Cipó",
		state: "BA"
	},
	{
		ibgeCode: "2908002",
		cityName: "Coaraci",
		state: "BA"
	},
	{
		ibgeCode: "2908101",
		cityName: "Cocos",
		state: "BA"
	},
	{
		ibgeCode: "2908200",
		cityName: "Conceição da Feira",
		state: "BA"
	},
	{
		ibgeCode: "2918902",
		cityName: "Lajedão",
		state: "BA"
	},
	{
		ibgeCode: "2908309",
		cityName: "Conceição do Almeida",
		state: "BA"
	},
	{
		ibgeCode: "2908408",
		cityName: "Conceição do Coité",
		state: "BA"
	},
	{
		ibgeCode: "2908507",
		cityName: "Conceição do Jacuípe",
		state: "BA"
	},
	{
		ibgeCode: "2908606",
		cityName: "Conde",
		state: "BA"
	},
	{
		ibgeCode: "2908705",
		cityName: "Condeúba",
		state: "BA"
	},
	{
		ibgeCode: "2908804",
		cityName: "Contendas do Sincorá",
		state: "BA"
	},
	{
		ibgeCode: "2908903",
		cityName: "Coração de Maria",
		state: "BA"
	},
	{
		ibgeCode: "2909000",
		cityName: "Cordeiros",
		state: "BA"
	},
	{
		ibgeCode: "2909109",
		cityName: "Coribe",
		state: "BA"
	},
	{
		ibgeCode: "2909208",
		cityName: "Coronel João Sá",
		state: "BA"
	},
	{
		ibgeCode: "2909307",
		cityName: "Correntina",
		state: "BA"
	},
	{
		ibgeCode: "2909406",
		cityName: "Cotegipe",
		state: "BA"
	},
	{
		ibgeCode: "2909505",
		cityName: "Cravolândia",
		state: "BA"
	},
	{
		ibgeCode: "2909604",
		cityName: "Crisópolis",
		state: "BA"
	},
	{
		ibgeCode: "2909703",
		cityName: "Cristópolis",
		state: "BA"
	},
	{
		ibgeCode: "2909802",
		cityName: "Cruz das Almas",
		state: "BA"
	},
	{
		ibgeCode: "2909901",
		cityName: "Curaçá",
		state: "BA"
	},
	{
		ibgeCode: "2910008",
		cityName: "Dário Meira",
		state: "BA"
	},
	{
		ibgeCode: "2910057",
		cityName: "Dias d'Ávila",
		state: "BA"
	},
	{
		ibgeCode: "2910107",
		cityName: "Dom Basílio",
		state: "BA"
	},
	{
		ibgeCode: "2910206",
		cityName: "Dom Macedo Costa",
		state: "BA"
	},
	{
		ibgeCode: "2910305",
		cityName: "Elísio Medrado",
		state: "BA"
	},
	{
		ibgeCode: "2910404",
		cityName: "Encruzilhada",
		state: "BA"
	},
	{
		ibgeCode: "2910503",
		cityName: "Entre Rios",
		state: "BA"
	},
	{
		ibgeCode: "2900504",
		cityName: "Érico Cardoso",
		state: "BA"
	},
	{
		ibgeCode: "2910602",
		cityName: "Esplanada",
		state: "BA"
	},
	{
		ibgeCode: "2910701",
		cityName: "Euclides da Cunha",
		state: "BA"
	},
	{
		ibgeCode: "2910727",
		cityName: "Eunápolis",
		state: "BA"
	},
	{
		ibgeCode: "2910750",
		cityName: "Fátima",
		state: "BA"
	},
	{
		ibgeCode: "2910776",
		cityName: "Feira da Mata",
		state: "BA"
	},
	{
		ibgeCode: "2910800",
		cityName: "Feira de Santana",
		state: "BA"
	},
	{
		ibgeCode: "2910859",
		cityName: "Filadélfia",
		state: "BA"
	},
	{
		ibgeCode: "2910909",
		cityName: "Firmino Alves",
		state: "BA"
	},
	{
		ibgeCode: "2911006",
		cityName: "Floresta Azul",
		state: "BA"
	},
	{
		ibgeCode: "2911105",
		cityName: "Formosa do Rio Preto",
		state: "BA"
	},
	{
		ibgeCode: "2911204",
		cityName: "Gandu",
		state: "BA"
	},
	{
		ibgeCode: "2911253",
		cityName: "Gavião",
		state: "BA"
	},
	{
		ibgeCode: "2911303",
		cityName: "Gentio do Ouro",
		state: "BA"
	},
	{
		ibgeCode: "2911402",
		cityName: "Glória",
		state: "BA"
	},
	{
		ibgeCode: "2911501",
		cityName: "Gongogi",
		state: "BA"
	},
	{
		ibgeCode: "2911600",
		cityName: "Governador Mangabeira",
		state: "BA"
	},
	{
		ibgeCode: "2911659",
		cityName: "Guajeru",
		state: "BA"
	},
	{
		ibgeCode: "2911709",
		cityName: "Guanambi",
		state: "BA"
	},
	{
		ibgeCode: "2911808",
		cityName: "Guaratinga",
		state: "BA"
	},
	{
		ibgeCode: "2911857",
		cityName: "Heliópolis",
		state: "BA"
	},
	{
		ibgeCode: "2911907",
		cityName: "Iaçu",
		state: "BA"
	},
	{
		ibgeCode: "2912004",
		cityName: "Ibiassucê",
		state: "BA"
	},
	{
		ibgeCode: "2912103",
		cityName: "Ibicaraí",
		state: "BA"
	},
	{
		ibgeCode: "2912202",
		cityName: "Ibicoara",
		state: "BA"
	},
	{
		ibgeCode: "2912301",
		cityName: "Ibicuí",
		state: "BA"
	},
	{
		ibgeCode: "2912400",
		cityName: "Ibipeba",
		state: "BA"
	},
	{
		ibgeCode: "2912509",
		cityName: "Ibipitanga",
		state: "BA"
	},
	{
		ibgeCode: "2912608",
		cityName: "Ibiquera",
		state: "BA"
	},
	{
		ibgeCode: "2912707",
		cityName: "Ibirapitanga",
		state: "BA"
	},
	{
		ibgeCode: "2912806",
		cityName: "Ibirapuã",
		state: "BA"
	},
	{
		ibgeCode: "2912905",
		cityName: "Ibirataia",
		state: "BA"
	},
	{
		ibgeCode: "2913002",
		cityName: "Ibitiara",
		state: "BA"
	},
	{
		ibgeCode: "2913101",
		cityName: "Ibititá",
		state: "BA"
	},
	{
		ibgeCode: "2913200",
		cityName: "Ibotirama",
		state: "BA"
	},
	{
		ibgeCode: "2913309",
		cityName: "Ichu",
		state: "BA"
	},
	{
		ibgeCode: "2913408",
		cityName: "Igaporã",
		state: "BA"
	},
	{
		ibgeCode: "2913457",
		cityName: "Igrapiúna",
		state: "BA"
	},
	{
		ibgeCode: "2913507",
		cityName: "Iguaí",
		state: "BA"
	},
	{
		ibgeCode: "2913606",
		cityName: "Ilhéus",
		state: "BA"
	},
	{
		ibgeCode: "2913705",
		cityName: "Inhambupe",
		state: "BA"
	},
	{
		ibgeCode: "2913804",
		cityName: "Ipecaetá",
		state: "BA"
	},
	{
		ibgeCode: "2913903",
		cityName: "Ipiaú",
		state: "BA"
	},
	{
		ibgeCode: "2914000",
		cityName: "Ipirá",
		state: "BA"
	},
	{
		ibgeCode: "2914109",
		cityName: "Ipupiara",
		state: "BA"
	},
	{
		ibgeCode: "2914208",
		cityName: "Irajuba",
		state: "BA"
	},
	{
		ibgeCode: "2914307",
		cityName: "Iramaia",
		state: "BA"
	},
	{
		ibgeCode: "2914406",
		cityName: "Iraquara",
		state: "BA"
	},
	{
		ibgeCode: "2914505",
		cityName: "Irará",
		state: "BA"
	},
	{
		ibgeCode: "2914604",
		cityName: "Irecê",
		state: "BA"
	},
	{
		ibgeCode: "2914653",
		cityName: "Itabela",
		state: "BA"
	},
	{
		ibgeCode: "2914703",
		cityName: "Itaberaba",
		state: "BA"
	},
	{
		ibgeCode: "2914802",
		cityName: "Itabuna",
		state: "BA"
	},
	{
		ibgeCode: "2914901",
		cityName: "Itacaré",
		state: "BA"
	},
	{
		ibgeCode: "2915007",
		cityName: "Itaeté",
		state: "BA"
	},
	{
		ibgeCode: "2915106",
		cityName: "Itagi",
		state: "BA"
	},
	{
		ibgeCode: "2915205",
		cityName: "Itagibá",
		state: "BA"
	},
	{
		ibgeCode: "2915304",
		cityName: "Itagimirim",
		state: "BA"
	},
	{
		ibgeCode: "2915353",
		cityName: "Itaguaçu da Bahia",
		state: "BA"
	},
	{
		ibgeCode: "2915403",
		cityName: "Itaju do Colônia",
		state: "BA"
	},
	{
		ibgeCode: "2915502",
		cityName: "Itajuípe",
		state: "BA"
	},
	{
		ibgeCode: "2915601",
		cityName: "Itamaraju",
		state: "BA"
	},
	{
		ibgeCode: "2915700",
		cityName: "Itamari",
		state: "BA"
	},
	{
		ibgeCode: "2915809",
		cityName: "Itambé",
		state: "BA"
	},
	{
		ibgeCode: "2915908",
		cityName: "Itanagra",
		state: "BA"
	},
	{
		ibgeCode: "2916005",
		cityName: "Itanhém",
		state: "BA"
	},
	{
		ibgeCode: "2916104",
		cityName: "Itaparica",
		state: "BA"
	},
	{
		ibgeCode: "2916203",
		cityName: "Itapé",
		state: "BA"
	},
	{
		ibgeCode: "2916302",
		cityName: "Itapebi",
		state: "BA"
	},
	{
		ibgeCode: "2916401",
		cityName: "Itapetinga",
		state: "BA"
	},
	{
		ibgeCode: "2916500",
		cityName: "Itapicuru",
		state: "BA"
	},
	{
		ibgeCode: "2916609",
		cityName: "Itapitanga",
		state: "BA"
	},
	{
		ibgeCode: "2916708",
		cityName: "Itaquara",
		state: "BA"
	},
	{
		ibgeCode: "2916807",
		cityName: "Itarantim",
		state: "BA"
	},
	{
		ibgeCode: "2916856",
		cityName: "Itatim",
		state: "BA"
	},
	{
		ibgeCode: "2916906",
		cityName: "Itiruçu",
		state: "BA"
	},
	{
		ibgeCode: "2917003",
		cityName: "Itiúba",
		state: "BA"
	},
	{
		ibgeCode: "2917102",
		cityName: "Itororó",
		state: "BA"
	},
	{
		ibgeCode: "2917201",
		cityName: "Ituaçu",
		state: "BA"
	},
	{
		ibgeCode: "2917300",
		cityName: "Ituberá",
		state: "BA"
	},
	{
		ibgeCode: "2917334",
		cityName: "Iuiu",
		state: "BA"
	},
	{
		ibgeCode: "2917359",
		cityName: "Jaborandi",
		state: "BA"
	},
	{
		ibgeCode: "2917409",
		cityName: "Jacaraci",
		state: "BA"
	},
	{
		ibgeCode: "2917508",
		cityName: "Jacobina",
		state: "BA"
	},
	{
		ibgeCode: "2917607",
		cityName: "Jaguaquara",
		state: "BA"
	},
	{
		ibgeCode: "2917706",
		cityName: "Jaguarari",
		state: "BA"
	},
	{
		ibgeCode: "2917805",
		cityName: "Jaguaripe",
		state: "BA"
	},
	{
		ibgeCode: "2917904",
		cityName: "Jandaíra",
		state: "BA"
	},
	{
		ibgeCode: "2918001",
		cityName: "Jequié",
		state: "BA"
	},
	{
		ibgeCode: "2918100",
		cityName: "Jeremoabo",
		state: "BA"
	},
	{
		ibgeCode: "2918209",
		cityName: "Jiquiriçá",
		state: "BA"
	},
	{
		ibgeCode: "2918308",
		cityName: "Jitaúna",
		state: "BA"
	},
	{
		ibgeCode: "2918357",
		cityName: "João Dourado",
		state: "BA"
	},
	{
		ibgeCode: "2918407",
		cityName: "Juazeiro",
		state: "BA"
	},
	{
		ibgeCode: "2918456",
		cityName: "Jucuruçu",
		state: "BA"
	},
	{
		ibgeCode: "2918506",
		cityName: "Jussara",
		state: "BA"
	},
	{
		ibgeCode: "2918555",
		cityName: "Jussari",
		state: "BA"
	},
	{
		ibgeCode: "2918605",
		cityName: "Jussiape",
		state: "BA"
	},
	{
		ibgeCode: "2918704",
		cityName: "Lafaiete Coutinho",
		state: "BA"
	},
	{
		ibgeCode: "2918753",
		cityName: "Lagoa Real",
		state: "BA"
	},
	{
		ibgeCode: "2918803",
		cityName: "Laje",
		state: "BA"
	},
	{
		ibgeCode: "2919009",
		cityName: "Lajedinho",
		state: "BA"
	},
	{
		ibgeCode: "2919058",
		cityName: "Lajedo do Tabocal",
		state: "BA"
	},
	{
		ibgeCode: "2919108",
		cityName: "Lamarão",
		state: "BA"
	},
	{
		ibgeCode: "2919157",
		cityName: "Lapão",
		state: "BA"
	},
	{
		ibgeCode: "2919207",
		cityName: "Lauro de Freitas",
		state: "BA"
	},
	{
		ibgeCode: "2919306",
		cityName: "Lençóis",
		state: "BA"
	},
	{
		ibgeCode: "2919405",
		cityName: "Licínio de Almeida",
		state: "BA"
	},
	{
		ibgeCode: "2919504",
		cityName: "Livramento de Nossa Senhora",
		state: "BA"
	},
	{
		ibgeCode: "2919553",
		cityName: "Luís Eduardo Magalhães",
		state: "BA"
	},
	{
		ibgeCode: "2919603",
		cityName: "Macajuba",
		state: "BA"
	},
	{
		ibgeCode: "2919702",
		cityName: "Macarani",
		state: "BA"
	},
	{
		ibgeCode: "2919801",
		cityName: "Macaúbas",
		state: "BA"
	},
	{
		ibgeCode: "2919900",
		cityName: "Macururé",
		state: "BA"
	},
	{
		ibgeCode: "2919926",
		cityName: "Madre de Deus",
		state: "BA"
	},
	{
		ibgeCode: "2919959",
		cityName: "Maetinga",
		state: "BA"
	},
	{
		ibgeCode: "2920007",
		cityName: "Maiquinique",
		state: "BA"
	},
	{
		ibgeCode: "2920106",
		cityName: "Mairi",
		state: "BA"
	},
	{
		ibgeCode: "2920205",
		cityName: "Malhada",
		state: "BA"
	},
	{
		ibgeCode: "2920304",
		cityName: "Malhada de Pedras",
		state: "BA"
	},
	{
		ibgeCode: "2920403",
		cityName: "Manoel Vitorino",
		state: "BA"
	},
	{
		ibgeCode: "2920452",
		cityName: "Mansidão",
		state: "BA"
	},
	{
		ibgeCode: "2920502",
		cityName: "Maracás",
		state: "BA"
	},
	{
		ibgeCode: "2920601",
		cityName: "Maragogipe",
		state: "BA"
	},
	{
		ibgeCode: "2920700",
		cityName: "Maraú",
		state: "BA"
	},
	{
		ibgeCode: "2920809",
		cityName: "Marcionílio Souza",
		state: "BA"
	},
	{
		ibgeCode: "2920908",
		cityName: "Mascote",
		state: "BA"
	},
	{
		ibgeCode: "2921005",
		cityName: "Mata de São João",
		state: "BA"
	},
	{
		ibgeCode: "2921054",
		cityName: "Matina",
		state: "BA"
	},
	{
		ibgeCode: "2921104",
		cityName: "Medeiros Neto",
		state: "BA"
	},
	{
		ibgeCode: "2921203",
		cityName: "Miguel Calmon",
		state: "BA"
	},
	{
		ibgeCode: "2921302",
		cityName: "Milagres",
		state: "BA"
	},
	{
		ibgeCode: "2921401",
		cityName: "Mirangaba",
		state: "BA"
	},
	{
		ibgeCode: "2921450",
		cityName: "Mirante",
		state: "BA"
	},
	{
		ibgeCode: "2921500",
		cityName: "Monte Santo",
		state: "BA"
	},
	{
		ibgeCode: "2921609",
		cityName: "Morpará",
		state: "BA"
	},
	{
		ibgeCode: "2921708",
		cityName: "Morro do Chapéu",
		state: "BA"
	},
	{
		ibgeCode: "2921807",
		cityName: "Mortugaba",
		state: "BA"
	},
	{
		ibgeCode: "2921906",
		cityName: "Mucugê",
		state: "BA"
	},
	{
		ibgeCode: "2922003",
		cityName: "Mucuri",
		state: "BA"
	},
	{
		ibgeCode: "2922052",
		cityName: "Mulungu do Morro",
		state: "BA"
	},
	{
		ibgeCode: "2922102",
		cityName: "Mundo Novo",
		state: "BA"
	},
	{
		ibgeCode: "2922201",
		cityName: "Muniz Ferreira",
		state: "BA"
	},
	{
		ibgeCode: "2922250",
		cityName: "Muquém do São Francisco",
		state: "BA"
	},
	{
		ibgeCode: "2922300",
		cityName: "Muritiba",
		state: "BA"
	},
	{
		ibgeCode: "2922409",
		cityName: "Mutuípe",
		state: "BA"
	},
	{
		ibgeCode: "2922508",
		cityName: "Nazaré",
		state: "BA"
	},
	{
		ibgeCode: "2922607",
		cityName: "Nilo Peçanha",
		state: "BA"
	},
	{
		ibgeCode: "2922656",
		cityName: "Nordestina",
		state: "BA"
	},
	{
		ibgeCode: "2922706",
		cityName: "Nova Canaã",
		state: "BA"
	},
	{
		ibgeCode: "2922730",
		cityName: "Nova Fátima",
		state: "BA"
	},
	{
		ibgeCode: "2922755",
		cityName: "Nova Ibiá",
		state: "BA"
	},
	{
		ibgeCode: "2922805",
		cityName: "Nova Itarana",
		state: "BA"
	},
	{
		ibgeCode: "2922854",
		cityName: "Nova Redenção",
		state: "BA"
	},
	{
		ibgeCode: "2922904",
		cityName: "Nova Soure",
		state: "BA"
	},
	{
		ibgeCode: "2923001",
		cityName: "Nova Viçosa",
		state: "BA"
	},
	{
		ibgeCode: "2923035",
		cityName: "Novo Horizonte",
		state: "BA"
	},
	{
		ibgeCode: "2923050",
		cityName: "Novo Triunfo",
		state: "BA"
	},
	{
		ibgeCode: "2923100",
		cityName: "Olindina",
		state: "BA"
	},
	{
		ibgeCode: "2923209",
		cityName: "Oliveira dos Brejinhos",
		state: "BA"
	},
	{
		ibgeCode: "2923308",
		cityName: "Ouriçangas",
		state: "BA"
	},
	{
		ibgeCode: "2923357",
		cityName: "Ourolândia",
		state: "BA"
	},
	{
		ibgeCode: "2923407",
		cityName: "Palmas de Monte Alto",
		state: "BA"
	},
	{
		ibgeCode: "2923506",
		cityName: "Palmeiras",
		state: "BA"
	},
	{
		ibgeCode: "2923605",
		cityName: "Paramirim",
		state: "BA"
	},
	{
		ibgeCode: "2923704",
		cityName: "Paratinga",
		state: "BA"
	},
	{
		ibgeCode: "2923803",
		cityName: "Paripiranga",
		state: "BA"
	},
	{
		ibgeCode: "2923902",
		cityName: "Pau Brasil",
		state: "BA"
	},
	{
		ibgeCode: "2924009",
		cityName: "Paulo Afonso",
		state: "BA"
	},
	{
		ibgeCode: "2924058",
		cityName: "Pé de Serra",
		state: "BA"
	},
	{
		ibgeCode: "2924108",
		cityName: "Pedrão",
		state: "BA"
	},
	{
		ibgeCode: "2924207",
		cityName: "Pedro Alexandre",
		state: "BA"
	},
	{
		ibgeCode: "2924306",
		cityName: "Piatã",
		state: "BA"
	},
	{
		ibgeCode: "2924405",
		cityName: "Pilão Arcado",
		state: "BA"
	},
	{
		ibgeCode: "2924504",
		cityName: "Pindaí",
		state: "BA"
	},
	{
		ibgeCode: "2924603",
		cityName: "Pindobaçu",
		state: "BA"
	},
	{
		ibgeCode: "2924652",
		cityName: "Pintadas",
		state: "BA"
	},
	{
		ibgeCode: "2924678",
		cityName: "Piraí do Norte",
		state: "BA"
	},
	{
		ibgeCode: "2924702",
		cityName: "Piripá",
		state: "BA"
	},
	{
		ibgeCode: "2924801",
		cityName: "Piritiba",
		state: "BA"
	},
	{
		ibgeCode: "2924900",
		cityName: "Planaltino",
		state: "BA"
	},
	{
		ibgeCode: "2925006",
		cityName: "Planalto",
		state: "BA"
	},
	{
		ibgeCode: "2925105",
		cityName: "Poções",
		state: "BA"
	},
	{
		ibgeCode: "2925204",
		cityName: "Pojuca",
		state: "BA"
	},
	{
		ibgeCode: "2925253",
		cityName: "Ponto Novo",
		state: "BA"
	},
	{
		ibgeCode: "2925303",
		cityName: "Porto Seguro",
		state: "BA"
	},
	{
		ibgeCode: "2925402",
		cityName: "Potiraguá",
		state: "BA"
	},
	{
		ibgeCode: "2925501",
		cityName: "Prado",
		state: "BA"
	},
	{
		ibgeCode: "2925600",
		cityName: "Presidente Dutra",
		state: "BA"
	},
	{
		ibgeCode: "2925709",
		cityName: "Presidente Jânio Quadros",
		state: "BA"
	},
	{
		ibgeCode: "2925758",
		cityName: "Presidente Tancredo Neves",
		state: "BA"
	},
	{
		ibgeCode: "2925808",
		cityName: "Queimadas",
		state: "BA"
	},
	{
		ibgeCode: "2925907",
		cityName: "Quijingue",
		state: "BA"
	},
	{
		ibgeCode: "2925931",
		cityName: "Quixabeira",
		state: "BA"
	},
	{
		ibgeCode: "2925956",
		cityName: "Rafael Jambeiro",
		state: "BA"
	},
	{
		ibgeCode: "2926004",
		cityName: "Remanso",
		state: "BA"
	},
	{
		ibgeCode: "2926103",
		cityName: "Retirolândia",
		state: "BA"
	},
	{
		ibgeCode: "2926202",
		cityName: "Riachão das Neves",
		state: "BA"
	},
	{
		ibgeCode: "2926301",
		cityName: "Riachão do Jacuípe",
		state: "BA"
	},
	{
		ibgeCode: "2926400",
		cityName: "Riacho de Santana",
		state: "BA"
	},
	{
		ibgeCode: "2926509",
		cityName: "Ribeira do Amparo",
		state: "BA"
	},
	{
		ibgeCode: "2926608",
		cityName: "Ribeira do Pombal",
		state: "BA"
	},
	{
		ibgeCode: "2926657",
		cityName: "Ribeirão do Largo",
		state: "BA"
	},
	{
		ibgeCode: "2926707",
		cityName: "Rio de Contas",
		state: "BA"
	},
	{
		ibgeCode: "2926806",
		cityName: "Rio do Antônio",
		state: "BA"
	},
	{
		ibgeCode: "2926905",
		cityName: "Rio do Pires",
		state: "BA"
	},
	{
		ibgeCode: "2927002",
		cityName: "Rio Real",
		state: "BA"
	},
	{
		ibgeCode: "2927101",
		cityName: "Rodelas",
		state: "BA"
	},
	{
		ibgeCode: "2927200",
		cityName: "Ruy Barbosa",
		state: "BA"
	},
	{
		ibgeCode: "2927309",
		cityName: "Salinas da Margarida",
		state: "BA"
	},
	{
		ibgeCode: "2927408",
		cityName: "Salvador",
		state: "BA"
	},
	{
		ibgeCode: "2927507",
		cityName: "Santa Bárbara",
		state: "BA"
	},
	{
		ibgeCode: "2927606",
		cityName: "Santa Brígida",
		state: "BA"
	},
	{
		ibgeCode: "2927705",
		cityName: "Santa Cruz Cabrália",
		state: "BA"
	},
	{
		ibgeCode: "2927804",
		cityName: "Santa Cruz da Vitória",
		state: "BA"
	},
	{
		ibgeCode: "2927903",
		cityName: "Santa Inês",
		state: "BA"
	},
	{
		ibgeCode: "2928059",
		cityName: "Santa Luzia",
		state: "BA"
	},
	{
		ibgeCode: "2928109",
		cityName: "Santa Maria da Vitória",
		state: "BA"
	},
	{
		ibgeCode: "2928406",
		cityName: "Santa Rita de Cássia",
		state: "BA"
	},
	{
		ibgeCode: "2928505",
		cityName: "Santa Terezinha",
		state: "BA"
	},
	{
		ibgeCode: "2928000",
		cityName: "Santaluz",
		state: "BA"
	},
	{
		ibgeCode: "2928208",
		cityName: "Santana",
		state: "BA"
	},
	{
		ibgeCode: "2928307",
		cityName: "Santanópolis",
		state: "BA"
	},
	{
		ibgeCode: "2928604",
		cityName: "Santo Amaro",
		state: "BA"
	},
	{
		ibgeCode: "2928703",
		cityName: "Santo Antônio de Jesus",
		state: "BA"
	},
	{
		ibgeCode: "2928802",
		cityName: "Santo Estêvão",
		state: "BA"
	},
	{
		ibgeCode: "2928901",
		cityName: "São Desidério",
		state: "BA"
	},
	{
		ibgeCode: "2928950",
		cityName: "São Domingos",
		state: "BA"
	},
	{
		ibgeCode: "2929107",
		cityName: "São Felipe",
		state: "BA"
	},
	{
		ibgeCode: "2929008",
		cityName: "São Félix",
		state: "BA"
	},
	{
		ibgeCode: "2929057",
		cityName: "São Félix do Coribe",
		state: "BA"
	},
	{
		ibgeCode: "2929206",
		cityName: "São Francisco do Conde",
		state: "BA"
	},
	{
		ibgeCode: "2929255",
		cityName: "São Gabriel",
		state: "BA"
	},
	{
		ibgeCode: "2929305",
		cityName: "São Gonçalo dos Campos",
		state: "BA"
	},
	{
		ibgeCode: "2929354",
		cityName: "São José da Vitória",
		state: "BA"
	},
	{
		ibgeCode: "2929370",
		cityName: "São José do Jacuípe",
		state: "BA"
	},
	{
		ibgeCode: "2929404",
		cityName: "São Miguel das Matas",
		state: "BA"
	},
	{
		ibgeCode: "2929503",
		cityName: "São Sebastião do Passé",
		state: "BA"
	},
	{
		ibgeCode: "2929602",
		cityName: "Sapeaçu",
		state: "BA"
	},
	{
		ibgeCode: "2929701",
		cityName: "Sátiro Dias",
		state: "BA"
	},
	{
		ibgeCode: "2929750",
		cityName: "Saubara",
		state: "BA"
	},
	{
		ibgeCode: "2929800",
		cityName: "Saúde",
		state: "BA"
	},
	{
		ibgeCode: "2929909",
		cityName: "Seabra",
		state: "BA"
	},
	{
		ibgeCode: "2930006",
		cityName: "Sebastião Laranjeiras",
		state: "BA"
	},
	{
		ibgeCode: "2930105",
		cityName: "Senhor do Bonfim",
		state: "BA"
	},
	{
		ibgeCode: "2930204",
		cityName: "Sento Sé",
		state: "BA"
	},
	{
		ibgeCode: "2930154",
		cityName: "Serra do Ramalho",
		state: "BA"
	},
	{
		ibgeCode: "2930303",
		cityName: "Serra Dourada",
		state: "BA"
	},
	{
		ibgeCode: "2930402",
		cityName: "Serra Preta",
		state: "BA"
	},
	{
		ibgeCode: "2930501",
		cityName: "Serrinha",
		state: "BA"
	},
	{
		ibgeCode: "2930600",
		cityName: "Serrolândia",
		state: "BA"
	},
	{
		ibgeCode: "2930709",
		cityName: "Simões Filho",
		state: "BA"
	},
	{
		ibgeCode: "2930758",
		cityName: "Sítio do Mato",
		state: "BA"
	},
	{
		ibgeCode: "2930766",
		cityName: "Sítio do Quinto",
		state: "BA"
	},
	{
		ibgeCode: "2930774",
		cityName: "Sobradinho",
		state: "BA"
	},
	{
		ibgeCode: "2930808",
		cityName: "Souto Soares",
		state: "BA"
	},
	{
		ibgeCode: "2930907",
		cityName: "Tabocas do Brejo Velho",
		state: "BA"
	},
	{
		ibgeCode: "2931004",
		cityName: "Tanhaçu",
		state: "BA"
	},
	{
		ibgeCode: "2931053",
		cityName: "Tanque Novo",
		state: "BA"
	},
	{
		ibgeCode: "2931103",
		cityName: "Tanquinho",
		state: "BA"
	},
	{
		ibgeCode: "2931202",
		cityName: "Taperoá",
		state: "BA"
	},
	{
		ibgeCode: "2931301",
		cityName: "Tapiramutá",
		state: "BA"
	},
	{
		ibgeCode: "2931350",
		cityName: "Teixeira de Freitas",
		state: "BA"
	},
	{
		ibgeCode: "2931400",
		cityName: "Teodoro Sampaio",
		state: "BA"
	},
	{
		ibgeCode: "2931509",
		cityName: "Teofilândia",
		state: "BA"
	},
	{
		ibgeCode: "2931608",
		cityName: "Teolândia",
		state: "BA"
	},
	{
		ibgeCode: "2931707",
		cityName: "Terra Nova",
		state: "BA"
	},
	{
		ibgeCode: "2931806",
		cityName: "Tremedal",
		state: "BA"
	},
	{
		ibgeCode: "2931905",
		cityName: "Tucano",
		state: "BA"
	},
	{
		ibgeCode: "2932002",
		cityName: "Uauá",
		state: "BA"
	},
	{
		ibgeCode: "2932101",
		cityName: "Ubaíra",
		state: "BA"
	},
	{
		ibgeCode: "2932200",
		cityName: "Ubaitaba",
		state: "BA"
	},
	{
		ibgeCode: "2932309",
		cityName: "Ubatã",
		state: "BA"
	},
	{
		ibgeCode: "2932408",
		cityName: "Uibaí",
		state: "BA"
	},
	{
		ibgeCode: "2932457",
		cityName: "Umburanas",
		state: "BA"
	},
	{
		ibgeCode: "2932507",
		cityName: "Una",
		state: "BA"
	},
	{
		ibgeCode: "2932606",
		cityName: "Urandi",
		state: "BA"
	},
	{
		ibgeCode: "2932705",
		cityName: "Uruçuca",
		state: "BA"
	},
	{
		ibgeCode: "2932804",
		cityName: "Utinga",
		state: "BA"
	},
	{
		ibgeCode: "2932903",
		cityName: "Valença",
		state: "BA"
	},
	{
		ibgeCode: "2933000",
		cityName: "Valente",
		state: "BA"
	},
	{
		ibgeCode: "2933059",
		cityName: "Várzea da Roça",
		state: "BA"
	},
	{
		ibgeCode: "2933109",
		cityName: "Várzea do Poço",
		state: "BA"
	},
	{
		ibgeCode: "2933158",
		cityName: "Várzea Nova",
		state: "BA"
	},
	{
		ibgeCode: "2933174",
		cityName: "Varzedo",
		state: "BA"
	},
	{
		ibgeCode: "2933208",
		cityName: "Vera Cruz",
		state: "BA"
	},
	{
		ibgeCode: "2933257",
		cityName: "Vereda",
		state: "BA"
	},
	{
		ibgeCode: "2933307",
		cityName: "Vitória da Conquista",
		state: "BA"
	},
	{
		ibgeCode: "2933406",
		cityName: "Wagner",
		state: "BA"
	},
	{
		ibgeCode: "2933455",
		cityName: "Wanderley",
		state: "BA"
	},
	{
		ibgeCode: "2933505",
		cityName: "Wenceslau Guimarães",
		state: "BA"
	},
	{
		ibgeCode: "2933604",
		cityName: "Xique-Xique",
		state: "BA"
	}
];
var CE = [
	{
		ibgeCode: "2300101",
		cityName: "Abaiara",
		state: "CE"
	},
	{
		ibgeCode: "2300150",
		cityName: "Acarape",
		state: "CE"
	},
	{
		ibgeCode: "2300200",
		cityName: "Acaraú",
		state: "CE"
	},
	{
		ibgeCode: "2300309",
		cityName: "Acopiara",
		state: "CE"
	},
	{
		ibgeCode: "2300408",
		cityName: "Aiuaba",
		state: "CE"
	},
	{
		ibgeCode: "2300507",
		cityName: "Alcântaras",
		state: "CE"
	},
	{
		ibgeCode: "2300606",
		cityName: "Altaneira",
		state: "CE"
	},
	{
		ibgeCode: "2300705",
		cityName: "Alto Santo",
		state: "CE"
	},
	{
		ibgeCode: "2300754",
		cityName: "Amontada",
		state: "CE"
	},
	{
		ibgeCode: "2300804",
		cityName: "Antonina do Norte",
		state: "CE"
	},
	{
		ibgeCode: "2300903",
		cityName: "Apuiarés",
		state: "CE"
	},
	{
		ibgeCode: "2301000",
		cityName: "Aquiraz",
		state: "CE"
	},
	{
		ibgeCode: "2301109",
		cityName: "Aracati",
		state: "CE"
	},
	{
		ibgeCode: "2301208",
		cityName: "Aracoiaba",
		state: "CE"
	},
	{
		ibgeCode: "2301257",
		cityName: "Ararendá",
		state: "CE"
	},
	{
		ibgeCode: "2301307",
		cityName: "Araripe",
		state: "CE"
	},
	{
		ibgeCode: "2301406",
		cityName: "Aratuba",
		state: "CE"
	},
	{
		ibgeCode: "2301505",
		cityName: "Arneiroz",
		state: "CE"
	},
	{
		ibgeCode: "2301604",
		cityName: "Assaré",
		state: "CE"
	},
	{
		ibgeCode: "2301703",
		cityName: "Aurora",
		state: "CE"
	},
	{
		ibgeCode: "2301802",
		cityName: "Baixio",
		state: "CE"
	},
	{
		ibgeCode: "2301851",
		cityName: "Banabuiú",
		state: "CE"
	},
	{
		ibgeCode: "2301901",
		cityName: "Barbalha",
		state: "CE"
	},
	{
		ibgeCode: "2301950",
		cityName: "Barreira",
		state: "CE"
	},
	{
		ibgeCode: "2302008",
		cityName: "Barro",
		state: "CE"
	},
	{
		ibgeCode: "2302057",
		cityName: "Barroquinha",
		state: "CE"
	},
	{
		ibgeCode: "2302107",
		cityName: "Baturité",
		state: "CE"
	},
	{
		ibgeCode: "2302206",
		cityName: "Beberibe",
		state: "CE"
	},
	{
		ibgeCode: "2302305",
		cityName: "Bela Cruz",
		state: "CE"
	},
	{
		ibgeCode: "2302404",
		cityName: "Boa Viagem",
		state: "CE"
	},
	{
		ibgeCode: "2302503",
		cityName: "Brejo Santo",
		state: "CE"
	},
	{
		ibgeCode: "2302602",
		cityName: "Camocim",
		state: "CE"
	},
	{
		ibgeCode: "2302701",
		cityName: "Campos Sales",
		state: "CE"
	},
	{
		ibgeCode: "2302800",
		cityName: "Canindé",
		state: "CE"
	},
	{
		ibgeCode: "2302909",
		cityName: "Capistrano",
		state: "CE"
	},
	{
		ibgeCode: "2303006",
		cityName: "Caridade",
		state: "CE"
	},
	{
		ibgeCode: "2303105",
		cityName: "Cariré",
		state: "CE"
	},
	{
		ibgeCode: "2303204",
		cityName: "Caririaçu",
		state: "CE"
	},
	{
		ibgeCode: "2303303",
		cityName: "Cariús",
		state: "CE"
	},
	{
		ibgeCode: "2303402",
		cityName: "Carnaubal",
		state: "CE"
	},
	{
		ibgeCode: "2303501",
		cityName: "Cascavel",
		state: "CE"
	},
	{
		ibgeCode: "2303600",
		cityName: "Catarina",
		state: "CE"
	},
	{
		ibgeCode: "2303659",
		cityName: "Catunda",
		state: "CE"
	},
	{
		ibgeCode: "2303709",
		cityName: "Caucaia",
		state: "CE"
	},
	{
		ibgeCode: "2303808",
		cityName: "Cedro",
		state: "CE"
	},
	{
		ibgeCode: "2303907",
		cityName: "Chaval",
		state: "CE"
	},
	{
		ibgeCode: "2303931",
		cityName: "Choró",
		state: "CE"
	},
	{
		ibgeCode: "2303956",
		cityName: "Chorozinho",
		state: "CE"
	},
	{
		ibgeCode: "2304004",
		cityName: "Coreaú",
		state: "CE"
	},
	{
		ibgeCode: "2304103",
		cityName: "Crateús",
		state: "CE"
	},
	{
		ibgeCode: "2304202",
		cityName: "Crato",
		state: "CE"
	},
	{
		ibgeCode: "2304236",
		cityName: "Croatá",
		state: "CE"
	},
	{
		ibgeCode: "2304251",
		cityName: "Cruz",
		state: "CE"
	},
	{
		ibgeCode: "2304269",
		cityName: "Deputado Irapuan Pinheiro",
		state: "CE"
	},
	{
		ibgeCode: "2304277",
		cityName: "Ereré",
		state: "CE"
	},
	{
		ibgeCode: "2304285",
		cityName: "Eusébio",
		state: "CE"
	},
	{
		ibgeCode: "2304301",
		cityName: "Farias Brito",
		state: "CE"
	},
	{
		ibgeCode: "2304350",
		cityName: "Forquilha",
		state: "CE"
	},
	{
		ibgeCode: "2304400",
		cityName: "Fortaleza",
		state: "CE"
	},
	{
		ibgeCode: "2304459",
		cityName: "Fortim",
		state: "CE"
	},
	{
		ibgeCode: "2304509",
		cityName: "Frecheirinha",
		state: "CE"
	},
	{
		ibgeCode: "2304608",
		cityName: "General Sampaio",
		state: "CE"
	},
	{
		ibgeCode: "2304657",
		cityName: "Graça",
		state: "CE"
	},
	{
		ibgeCode: "2304707",
		cityName: "Granja",
		state: "CE"
	},
	{
		ibgeCode: "2304806",
		cityName: "Granjeiro",
		state: "CE"
	},
	{
		ibgeCode: "2304905",
		cityName: "Groaíras",
		state: "CE"
	},
	{
		ibgeCode: "2304954",
		cityName: "Guaiúba",
		state: "CE"
	},
	{
		ibgeCode: "2305001",
		cityName: "Guaraciaba do Norte",
		state: "CE"
	},
	{
		ibgeCode: "2305100",
		cityName: "Guaramiranga",
		state: "CE"
	},
	{
		ibgeCode: "2305209",
		cityName: "Hidrolândia",
		state: "CE"
	},
	{
		ibgeCode: "2305233",
		cityName: "Horizonte",
		state: "CE"
	},
	{
		ibgeCode: "2305266",
		cityName: "Ibaretama",
		state: "CE"
	},
	{
		ibgeCode: "2305308",
		cityName: "Ibiapina",
		state: "CE"
	},
	{
		ibgeCode: "2305332",
		cityName: "Ibicuitinga",
		state: "CE"
	},
	{
		ibgeCode: "2305357",
		cityName: "Icapuí",
		state: "CE"
	},
	{
		ibgeCode: "2305407",
		cityName: "Icó",
		state: "CE"
	},
	{
		ibgeCode: "2305506",
		cityName: "Iguatu",
		state: "CE"
	},
	{
		ibgeCode: "2305605",
		cityName: "Independência",
		state: "CE"
	},
	{
		ibgeCode: "2305654",
		cityName: "Ipaporanga",
		state: "CE"
	},
	{
		ibgeCode: "2305704",
		cityName: "Ipaumirim",
		state: "CE"
	},
	{
		ibgeCode: "2305803",
		cityName: "Ipu",
		state: "CE"
	},
	{
		ibgeCode: "2305902",
		cityName: "Ipueiras",
		state: "CE"
	},
	{
		ibgeCode: "2306009",
		cityName: "Iracema",
		state: "CE"
	},
	{
		ibgeCode: "2306108",
		cityName: "Irauçuba",
		state: "CE"
	},
	{
		ibgeCode: "2306207",
		cityName: "Itaiçaba",
		state: "CE"
	},
	{
		ibgeCode: "2306256",
		cityName: "Itaitinga",
		state: "CE"
	},
	{
		ibgeCode: "2306306",
		cityName: "Itapajé",
		state: "CE"
	},
	{
		ibgeCode: "2306405",
		cityName: "Itapipoca",
		state: "CE"
	},
	{
		ibgeCode: "2306504",
		cityName: "Itapiúna",
		state: "CE"
	},
	{
		ibgeCode: "2306553",
		cityName: "Itarema",
		state: "CE"
	},
	{
		ibgeCode: "2306603",
		cityName: "Itatira",
		state: "CE"
	},
	{
		ibgeCode: "2306702",
		cityName: "Jaguaretama",
		state: "CE"
	},
	{
		ibgeCode: "2306801",
		cityName: "Jaguaribara",
		state: "CE"
	},
	{
		ibgeCode: "2306900",
		cityName: "Jaguaribe",
		state: "CE"
	},
	{
		ibgeCode: "2307007",
		cityName: "Jaguaruana",
		state: "CE"
	},
	{
		ibgeCode: "2307106",
		cityName: "Jardim",
		state: "CE"
	},
	{
		ibgeCode: "2307205",
		cityName: "Jati",
		state: "CE"
	},
	{
		ibgeCode: "2307254",
		cityName: "Jijoca de Jericoacoara",
		state: "CE"
	},
	{
		ibgeCode: "2307304",
		cityName: "Juazeiro do Norte",
		state: "CE"
	},
	{
		ibgeCode: "2307403",
		cityName: "Jucás",
		state: "CE"
	},
	{
		ibgeCode: "2307502",
		cityName: "Lavras da Mangabeira",
		state: "CE"
	},
	{
		ibgeCode: "2307601",
		cityName: "Limoeiro do Norte",
		state: "CE"
	},
	{
		ibgeCode: "2307635",
		cityName: "Madalena",
		state: "CE"
	},
	{
		ibgeCode: "2307650",
		cityName: "Maracanaú",
		state: "CE"
	},
	{
		ibgeCode: "2307700",
		cityName: "Maranguape",
		state: "CE"
	},
	{
		ibgeCode: "2307809",
		cityName: "Marco",
		state: "CE"
	},
	{
		ibgeCode: "2307908",
		cityName: "Martinópole",
		state: "CE"
	},
	{
		ibgeCode: "2308005",
		cityName: "Massapê",
		state: "CE"
	},
	{
		ibgeCode: "2308104",
		cityName: "Mauriti",
		state: "CE"
	},
	{
		ibgeCode: "2308203",
		cityName: "Meruoca",
		state: "CE"
	},
	{
		ibgeCode: "2308302",
		cityName: "Milagres",
		state: "CE"
	},
	{
		ibgeCode: "2308351",
		cityName: "Milhã",
		state: "CE"
	},
	{
		ibgeCode: "2308377",
		cityName: "Miraíma",
		state: "CE"
	},
	{
		ibgeCode: "2308401",
		cityName: "Missão Velha",
		state: "CE"
	},
	{
		ibgeCode: "2308500",
		cityName: "Mombaça",
		state: "CE"
	},
	{
		ibgeCode: "2308609",
		cityName: "Monsenhor Tabosa",
		state: "CE"
	},
	{
		ibgeCode: "2308708",
		cityName: "Morada Nova",
		state: "CE"
	},
	{
		ibgeCode: "2308807",
		cityName: "Moraújo",
		state: "CE"
	},
	{
		ibgeCode: "2308906",
		cityName: "Morrinhos",
		state: "CE"
	},
	{
		ibgeCode: "2309003",
		cityName: "Mucambo",
		state: "CE"
	},
	{
		ibgeCode: "2309102",
		cityName: "Mulungu",
		state: "CE"
	},
	{
		ibgeCode: "2309201",
		cityName: "Nova Olinda",
		state: "CE"
	},
	{
		ibgeCode: "2309300",
		cityName: "Nova Russas",
		state: "CE"
	},
	{
		ibgeCode: "2309409",
		cityName: "Novo Oriente",
		state: "CE"
	},
	{
		ibgeCode: "2309458",
		cityName: "Ocara",
		state: "CE"
	},
	{
		ibgeCode: "2309508",
		cityName: "Orós",
		state: "CE"
	},
	{
		ibgeCode: "2309607",
		cityName: "Pacajus",
		state: "CE"
	},
	{
		ibgeCode: "2309706",
		cityName: "Pacatuba",
		state: "CE"
	},
	{
		ibgeCode: "2309805",
		cityName: "Pacoti",
		state: "CE"
	},
	{
		ibgeCode: "2309904",
		cityName: "Pacujá",
		state: "CE"
	},
	{
		ibgeCode: "2310001",
		cityName: "Palhano",
		state: "CE"
	},
	{
		ibgeCode: "2310100",
		cityName: "Palmácia",
		state: "CE"
	},
	{
		ibgeCode: "2310209",
		cityName: "Paracuru",
		state: "CE"
	},
	{
		ibgeCode: "2310258",
		cityName: "Paraipaba",
		state: "CE"
	},
	{
		ibgeCode: "2310308",
		cityName: "Parambu",
		state: "CE"
	},
	{
		ibgeCode: "2310407",
		cityName: "Paramoti",
		state: "CE"
	},
	{
		ibgeCode: "2310506",
		cityName: "Pedra Branca",
		state: "CE"
	},
	{
		ibgeCode: "2310605",
		cityName: "Penaforte",
		state: "CE"
	},
	{
		ibgeCode: "2310704",
		cityName: "Pentecoste",
		state: "CE"
	},
	{
		ibgeCode: "2310803",
		cityName: "Pereiro",
		state: "CE"
	},
	{
		ibgeCode: "2310852",
		cityName: "Pindoretama",
		state: "CE"
	},
	{
		ibgeCode: "2310902",
		cityName: "Piquet Carneiro",
		state: "CE"
	},
	{
		ibgeCode: "2310951",
		cityName: "Pires Ferreira",
		state: "CE"
	},
	{
		ibgeCode: "2311009",
		cityName: "Poranga",
		state: "CE"
	},
	{
		ibgeCode: "2311108",
		cityName: "Porteiras",
		state: "CE"
	},
	{
		ibgeCode: "2311207",
		cityName: "Potengi",
		state: "CE"
	},
	{
		ibgeCode: "2311231",
		cityName: "Potiretama",
		state: "CE"
	},
	{
		ibgeCode: "2311264",
		cityName: "Quiterianópolis",
		state: "CE"
	},
	{
		ibgeCode: "2311306",
		cityName: "Quixadá",
		state: "CE"
	},
	{
		ibgeCode: "2311355",
		cityName: "Quixelô",
		state: "CE"
	},
	{
		ibgeCode: "2311405",
		cityName: "Quixeramobim",
		state: "CE"
	},
	{
		ibgeCode: "2311504",
		cityName: "Quixeré",
		state: "CE"
	},
	{
		ibgeCode: "2311603",
		cityName: "Redenção",
		state: "CE"
	},
	{
		ibgeCode: "2311702",
		cityName: "Reriutaba",
		state: "CE"
	},
	{
		ibgeCode: "2311801",
		cityName: "Russas",
		state: "CE"
	},
	{
		ibgeCode: "2311900",
		cityName: "Saboeiro",
		state: "CE"
	},
	{
		ibgeCode: "2311959",
		cityName: "Salitre",
		state: "CE"
	},
	{
		ibgeCode: "2312205",
		cityName: "Santa Quitéria",
		state: "CE"
	},
	{
		ibgeCode: "2312007",
		cityName: "Santana do Acaraú",
		state: "CE"
	},
	{
		ibgeCode: "2312106",
		cityName: "Santana do Cariri",
		state: "CE"
	},
	{
		ibgeCode: "2312304",
		cityName: "São Benedito",
		state: "CE"
	},
	{
		ibgeCode: "2312403",
		cityName: "São Gonçalo do Amarante",
		state: "CE"
	},
	{
		ibgeCode: "2312502",
		cityName: "São João do Jaguaribe",
		state: "CE"
	},
	{
		ibgeCode: "2312601",
		cityName: "São Luís do Curu",
		state: "CE"
	},
	{
		ibgeCode: "2312700",
		cityName: "Senador Pompeu",
		state: "CE"
	},
	{
		ibgeCode: "2312809",
		cityName: "Senador Sá",
		state: "CE"
	},
	{
		ibgeCode: "2312908",
		cityName: "Sobral",
		state: "CE"
	},
	{
		ibgeCode: "2313005",
		cityName: "Solonópole",
		state: "CE"
	},
	{
		ibgeCode: "2313104",
		cityName: "Tabuleiro do Norte",
		state: "CE"
	},
	{
		ibgeCode: "2313203",
		cityName: "Tamboril",
		state: "CE"
	},
	{
		ibgeCode: "2313252",
		cityName: "Tarrafas",
		state: "CE"
	},
	{
		ibgeCode: "2313302",
		cityName: "Tauá",
		state: "CE"
	},
	{
		ibgeCode: "2313351",
		cityName: "Tejuçuoca",
		state: "CE"
	},
	{
		ibgeCode: "2313401",
		cityName: "Tianguá",
		state: "CE"
	},
	{
		ibgeCode: "2313500",
		cityName: "Trairi",
		state: "CE"
	},
	{
		ibgeCode: "2313559",
		cityName: "Tururu",
		state: "CE"
	},
	{
		ibgeCode: "2313609",
		cityName: "Ubajara",
		state: "CE"
	},
	{
		ibgeCode: "2313708",
		cityName: "Umari",
		state: "CE"
	},
	{
		ibgeCode: "2313757",
		cityName: "Umirim",
		state: "CE"
	},
	{
		ibgeCode: "2313807",
		cityName: "Uruburetama",
		state: "CE"
	},
	{
		ibgeCode: "2313906",
		cityName: "Uruoca",
		state: "CE"
	},
	{
		ibgeCode: "2313955",
		cityName: "Varjota",
		state: "CE"
	},
	{
		ibgeCode: "2314003",
		cityName: "Várzea Alegre",
		state: "CE"
	},
	{
		ibgeCode: "2314102",
		cityName: "Viçosa do Ceará",
		state: "CE"
	}
];
var DF = [
	{
		ibgeCode: "5300108",
		cityName: "Brasília",
		state: "DF"
	}
];
var ES = [
	{
		ibgeCode: "3200102",
		cityName: "Afonso Cláudio",
		state: "ES"
	},
	{
		ibgeCode: "3200169",
		cityName: "Água Doce do Norte",
		state: "ES"
	},
	{
		ibgeCode: "3200136",
		cityName: "Águia Branca",
		state: "ES"
	},
	{
		ibgeCode: "3200201",
		cityName: "Alegre",
		state: "ES"
	},
	{
		ibgeCode: "3200300",
		cityName: "Alfredo Chaves",
		state: "ES"
	},
	{
		ibgeCode: "3200359",
		cityName: "Alto Rio Novo",
		state: "ES"
	},
	{
		ibgeCode: "3200409",
		cityName: "Anchieta",
		state: "ES"
	},
	{
		ibgeCode: "3200508",
		cityName: "Apiacá",
		state: "ES"
	},
	{
		ibgeCode: "3200607",
		cityName: "Aracruz",
		state: "ES"
	},
	{
		ibgeCode: "3200706",
		cityName: "Atílio Vivácqua",
		state: "ES"
	},
	{
		ibgeCode: "3200805",
		cityName: "Baixo Guandu",
		state: "ES"
	},
	{
		ibgeCode: "3200904",
		cityName: "Barra de São Francisco",
		state: "ES"
	},
	{
		ibgeCode: "3201001",
		cityName: "Boa Esperança",
		state: "ES"
	},
	{
		ibgeCode: "3201100",
		cityName: "Bom Jesus do Norte",
		state: "ES"
	},
	{
		ibgeCode: "3201159",
		cityName: "Brejetuba",
		state: "ES"
	},
	{
		ibgeCode: "3201209",
		cityName: "Cachoeiro de Itapemirim",
		state: "ES"
	},
	{
		ibgeCode: "3201308",
		cityName: "Cariacica",
		state: "ES"
	},
	{
		ibgeCode: "3201407",
		cityName: "Castelo",
		state: "ES"
	},
	{
		ibgeCode: "3201506",
		cityName: "Colatina",
		state: "ES"
	},
	{
		ibgeCode: "3201605",
		cityName: "Conceição da Barra",
		state: "ES"
	},
	{
		ibgeCode: "3201704",
		cityName: "Conceição do Castelo",
		state: "ES"
	},
	{
		ibgeCode: "3201803",
		cityName: "Divino de São Lourenço",
		state: "ES"
	},
	{
		ibgeCode: "3201902",
		cityName: "Domingos Martins",
		state: "ES"
	},
	{
		ibgeCode: "3202009",
		cityName: "Dores do Rio Preto",
		state: "ES"
	},
	{
		ibgeCode: "3202108",
		cityName: "Ecoporanga",
		state: "ES"
	},
	{
		ibgeCode: "3202207",
		cityName: "Fundão",
		state: "ES"
	},
	{
		ibgeCode: "3202256",
		cityName: "Governador Lindenberg",
		state: "ES"
	},
	{
		ibgeCode: "3202306",
		cityName: "Guaçuí",
		state: "ES"
	},
	{
		ibgeCode: "3202405",
		cityName: "Guarapari",
		state: "ES"
	},
	{
		ibgeCode: "3202454",
		cityName: "Ibatiba",
		state: "ES"
	},
	{
		ibgeCode: "3202504",
		cityName: "Ibiraçu",
		state: "ES"
	},
	{
		ibgeCode: "3202553",
		cityName: "Ibitirama",
		state: "ES"
	},
	{
		ibgeCode: "3202603",
		cityName: "Iconha",
		state: "ES"
	},
	{
		ibgeCode: "3202652",
		cityName: "Irupi",
		state: "ES"
	},
	{
		ibgeCode: "3202702",
		cityName: "Itaguaçu",
		state: "ES"
	},
	{
		ibgeCode: "3202801",
		cityName: "Itapemirim",
		state: "ES"
	},
	{
		ibgeCode: "3202900",
		cityName: "Itarana",
		state: "ES"
	},
	{
		ibgeCode: "3203007",
		cityName: "Iúna",
		state: "ES"
	},
	{
		ibgeCode: "3203056",
		cityName: "Jaguaré",
		state: "ES"
	},
	{
		ibgeCode: "3203106",
		cityName: "Jerônimo Monteiro",
		state: "ES"
	},
	{
		ibgeCode: "3203130",
		cityName: "João Neiva",
		state: "ES"
	},
	{
		ibgeCode: "3203163",
		cityName: "Laranja da Terra",
		state: "ES"
	},
	{
		ibgeCode: "3203205",
		cityName: "Linhares",
		state: "ES"
	},
	{
		ibgeCode: "3203304",
		cityName: "Mantenópolis",
		state: "ES"
	},
	{
		ibgeCode: "3203320",
		cityName: "Marataízes",
		state: "ES"
	},
	{
		ibgeCode: "3203346",
		cityName: "Marechal Floriano",
		state: "ES"
	},
	{
		ibgeCode: "3203353",
		cityName: "Marilândia",
		state: "ES"
	},
	{
		ibgeCode: "3203403",
		cityName: "Mimoso do Sul",
		state: "ES"
	},
	{
		ibgeCode: "3203502",
		cityName: "Montanha",
		state: "ES"
	},
	{
		ibgeCode: "3203601",
		cityName: "Mucurici",
		state: "ES"
	},
	{
		ibgeCode: "3203700",
		cityName: "Muniz Freire",
		state: "ES"
	},
	{
		ibgeCode: "3203809",
		cityName: "Muqui",
		state: "ES"
	},
	{
		ibgeCode: "3203908",
		cityName: "Nova Venécia",
		state: "ES"
	},
	{
		ibgeCode: "3204005",
		cityName: "Pancas",
		state: "ES"
	},
	{
		ibgeCode: "3204054",
		cityName: "Pedro Canário",
		state: "ES"
	},
	{
		ibgeCode: "3204104",
		cityName: "Pinheiros",
		state: "ES"
	},
	{
		ibgeCode: "3204203",
		cityName: "Piúma",
		state: "ES"
	},
	{
		ibgeCode: "3204252",
		cityName: "Ponto Belo",
		state: "ES"
	},
	{
		ibgeCode: "3204302",
		cityName: "Presidente Kennedy",
		state: "ES"
	},
	{
		ibgeCode: "3204351",
		cityName: "Rio Bananal",
		state: "ES"
	},
	{
		ibgeCode: "3204401",
		cityName: "Rio Novo do Sul",
		state: "ES"
	},
	{
		ibgeCode: "3204500",
		cityName: "Santa Leopoldina",
		state: "ES"
	},
	{
		ibgeCode: "3204559",
		cityName: "Santa Maria de Jetibá",
		state: "ES"
	},
	{
		ibgeCode: "3204609",
		cityName: "Santa Teresa",
		state: "ES"
	},
	{
		ibgeCode: "3204658",
		cityName: "São Domingos do Norte",
		state: "ES"
	},
	{
		ibgeCode: "3204708",
		cityName: "São Gabriel da Palha",
		state: "ES"
	},
	{
		ibgeCode: "3204807",
		cityName: "São José do Calçado",
		state: "ES"
	},
	{
		ibgeCode: "3204906",
		cityName: "São Mateus",
		state: "ES"
	},
	{
		ibgeCode: "3204955",
		cityName: "São Roque do Canaã",
		state: "ES"
	},
	{
		ibgeCode: "3205002",
		cityName: "Serra",
		state: "ES"
	},
	{
		ibgeCode: "3205010",
		cityName: "Sooretama",
		state: "ES"
	},
	{
		ibgeCode: "3205036",
		cityName: "Vargem Alta",
		state: "ES"
	},
	{
		ibgeCode: "3205069",
		cityName: "Venda Nova do Imigrante",
		state: "ES"
	},
	{
		ibgeCode: "3205101",
		cityName: "Viana",
		state: "ES"
	},
	{
		ibgeCode: "3205150",
		cityName: "Vila Pavão",
		state: "ES"
	},
	{
		ibgeCode: "3205176",
		cityName: "Vila Valério",
		state: "ES"
	},
	{
		ibgeCode: "3205200",
		cityName: "Vila Velha",
		state: "ES"
	},
	{
		ibgeCode: "3205309",
		cityName: "Vitória",
		state: "ES"
	}
];
var GO = [
	{
		ibgeCode: "5211008",
		cityName: "Itapirapuã",
		state: "GO"
	},
	{
		ibgeCode: "5200050",
		cityName: "Abadia de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5200100",
		cityName: "Abadiânia",
		state: "GO"
	},
	{
		ibgeCode: "5200134",
		cityName: "Acreúna",
		state: "GO"
	},
	{
		ibgeCode: "5200159",
		cityName: "Adelândia",
		state: "GO"
	},
	{
		ibgeCode: "5200175",
		cityName: "Água Fria de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5200209",
		cityName: "Água Limpa",
		state: "GO"
	},
	{
		ibgeCode: "5200258",
		cityName: "Águas Lindas de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5200308",
		cityName: "Alexânia",
		state: "GO"
	},
	{
		ibgeCode: "5200506",
		cityName: "Aloândia",
		state: "GO"
	},
	{
		ibgeCode: "5200555",
		cityName: "Alto Horizonte",
		state: "GO"
	},
	{
		ibgeCode: "5200605",
		cityName: "Alto Paraíso de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5200803",
		cityName: "Alvorada do Norte",
		state: "GO"
	},
	{
		ibgeCode: "5200829",
		cityName: "Amaralina",
		state: "GO"
	},
	{
		ibgeCode: "5200852",
		cityName: "Americano do Brasil",
		state: "GO"
	},
	{
		ibgeCode: "5200902",
		cityName: "Amorinópolis",
		state: "GO"
	},
	{
		ibgeCode: "5201108",
		cityName: "Anápolis",
		state: "GO"
	},
	{
		ibgeCode: "5201207",
		cityName: "Anhanguera",
		state: "GO"
	},
	{
		ibgeCode: "5201306",
		cityName: "Anicuns",
		state: "GO"
	},
	{
		ibgeCode: "5201405",
		cityName: "Aparecida de Goiânia",
		state: "GO"
	},
	{
		ibgeCode: "5201454",
		cityName: "Aparecida do Rio Doce",
		state: "GO"
	},
	{
		ibgeCode: "5201504",
		cityName: "Aporé",
		state: "GO"
	},
	{
		ibgeCode: "5201603",
		cityName: "Araçu",
		state: "GO"
	},
	{
		ibgeCode: "5201702",
		cityName: "Aragarças",
		state: "GO"
	},
	{
		ibgeCode: "5201801",
		cityName: "Aragoiânia",
		state: "GO"
	},
	{
		ibgeCode: "5202155",
		cityName: "Araguapaz",
		state: "GO"
	},
	{
		ibgeCode: "5202353",
		cityName: "Arenópolis",
		state: "GO"
	},
	{
		ibgeCode: "5202502",
		cityName: "Aruanã",
		state: "GO"
	},
	{
		ibgeCode: "5202601",
		cityName: "Aurilândia",
		state: "GO"
	},
	{
		ibgeCode: "5202809",
		cityName: "Avelinópolis",
		state: "GO"
	},
	{
		ibgeCode: "5203104",
		cityName: "Baliza",
		state: "GO"
	},
	{
		ibgeCode: "5203203",
		cityName: "Barro Alto",
		state: "GO"
	},
	{
		ibgeCode: "5203302",
		cityName: "Bela Vista de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5203401",
		cityName: "Bom Jardim de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5203500",
		cityName: "Bom Jesus de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5203559",
		cityName: "Bonfinópolis",
		state: "GO"
	},
	{
		ibgeCode: "5203575",
		cityName: "Bonópolis",
		state: "GO"
	},
	{
		ibgeCode: "5203609",
		cityName: "Brazabrantes",
		state: "GO"
	},
	{
		ibgeCode: "5203807",
		cityName: "Britânia",
		state: "GO"
	},
	{
		ibgeCode: "5203906",
		cityName: "Buriti Alegre",
		state: "GO"
	},
	{
		ibgeCode: "5203939",
		cityName: "Buriti de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5203962",
		cityName: "Buritinópolis",
		state: "GO"
	},
	{
		ibgeCode: "5204003",
		cityName: "Cabeceiras",
		state: "GO"
	},
	{
		ibgeCode: "5204102",
		cityName: "Cachoeira Alta",
		state: "GO"
	},
	{
		ibgeCode: "5204201",
		cityName: "Cachoeira de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5204250",
		cityName: "Cachoeira Dourada",
		state: "GO"
	},
	{
		ibgeCode: "5204300",
		cityName: "Caçu",
		state: "GO"
	},
	{
		ibgeCode: "5204409",
		cityName: "Caiapônia",
		state: "GO"
	},
	{
		ibgeCode: "5204508",
		cityName: "Caldas Novas",
		state: "GO"
	},
	{
		ibgeCode: "5204557",
		cityName: "Caldazinha",
		state: "GO"
	},
	{
		ibgeCode: "5204607",
		cityName: "Campestre de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5204656",
		cityName: "Campinaçu",
		state: "GO"
	},
	{
		ibgeCode: "5204706",
		cityName: "Campinorte",
		state: "GO"
	},
	{
		ibgeCode: "5204805",
		cityName: "Campo Alegre de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5204854",
		cityName: "Campo Limpo de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5204904",
		cityName: "Campos Belos",
		state: "GO"
	},
	{
		ibgeCode: "5204953",
		cityName: "Campos Verdes",
		state: "GO"
	},
	{
		ibgeCode: "5205000",
		cityName: "Carmo do Rio Verde",
		state: "GO"
	},
	{
		ibgeCode: "5205059",
		cityName: "Castelândia",
		state: "GO"
	},
	{
		ibgeCode: "5205109",
		cityName: "Catalão",
		state: "GO"
	},
	{
		ibgeCode: "5205208",
		cityName: "Caturaí",
		state: "GO"
	},
	{
		ibgeCode: "5205307",
		cityName: "Cavalcante",
		state: "GO"
	},
	{
		ibgeCode: "5205406",
		cityName: "Ceres",
		state: "GO"
	},
	{
		ibgeCode: "5205455",
		cityName: "Cezarina",
		state: "GO"
	},
	{
		ibgeCode: "5205471",
		cityName: "Chapadão do Céu",
		state: "GO"
	},
	{
		ibgeCode: "5205497",
		cityName: "Cidade Ocidental",
		state: "GO"
	},
	{
		ibgeCode: "5205513",
		cityName: "Cocalzinho de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5205521",
		cityName: "Colinas do Sul",
		state: "GO"
	},
	{
		ibgeCode: "5205703",
		cityName: "Córrego do Ouro",
		state: "GO"
	},
	{
		ibgeCode: "5205802",
		cityName: "Corumbá de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5205901",
		cityName: "Corumbaíba",
		state: "GO"
	},
	{
		ibgeCode: "5206206",
		cityName: "Cristalina",
		state: "GO"
	},
	{
		ibgeCode: "5206305",
		cityName: "Cristianópolis",
		state: "GO"
	},
	{
		ibgeCode: "5206404",
		cityName: "Crixás",
		state: "GO"
	},
	{
		ibgeCode: "5206503",
		cityName: "Cromínia",
		state: "GO"
	},
	{
		ibgeCode: "5206602",
		cityName: "Cumari",
		state: "GO"
	},
	{
		ibgeCode: "5206701",
		cityName: "Damianópolis",
		state: "GO"
	},
	{
		ibgeCode: "5206800",
		cityName: "Damolândia",
		state: "GO"
	},
	{
		ibgeCode: "5206909",
		cityName: "Davinópolis",
		state: "GO"
	},
	{
		ibgeCode: "5207105",
		cityName: "Diorama",
		state: "GO"
	},
	{
		ibgeCode: "5208301",
		cityName: "Divinópolis de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5207253",
		cityName: "Doverlândia",
		state: "GO"
	},
	{
		ibgeCode: "5207352",
		cityName: "Edealina",
		state: "GO"
	},
	{
		ibgeCode: "5207402",
		cityName: "Edéia",
		state: "GO"
	},
	{
		ibgeCode: "5207501",
		cityName: "Estrela do Norte",
		state: "GO"
	},
	{
		ibgeCode: "5207535",
		cityName: "Faina",
		state: "GO"
	},
	{
		ibgeCode: "5207600",
		cityName: "Fazenda Nova",
		state: "GO"
	},
	{
		ibgeCode: "5207808",
		cityName: "Firminópolis",
		state: "GO"
	},
	{
		ibgeCode: "5207907",
		cityName: "Flores de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5208004",
		cityName: "Formosa",
		state: "GO"
	},
	{
		ibgeCode: "5208103",
		cityName: "Formoso",
		state: "GO"
	},
	{
		ibgeCode: "5208152",
		cityName: "Gameleira de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5208400",
		cityName: "Goianápolis",
		state: "GO"
	},
	{
		ibgeCode: "5208509",
		cityName: "Goiandira",
		state: "GO"
	},
	{
		ibgeCode: "5208608",
		cityName: "Goianésia",
		state: "GO"
	},
	{
		ibgeCode: "5208707",
		cityName: "Goiânia",
		state: "GO"
	},
	{
		ibgeCode: "5208806",
		cityName: "Goianira",
		state: "GO"
	},
	{
		ibgeCode: "5208905",
		cityName: "Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5209101",
		cityName: "Goiatuba",
		state: "GO"
	},
	{
		ibgeCode: "5209150",
		cityName: "Gouvelândia",
		state: "GO"
	},
	{
		ibgeCode: "5209200",
		cityName: "Guapó",
		state: "GO"
	},
	{
		ibgeCode: "5209291",
		cityName: "Guaraíta",
		state: "GO"
	},
	{
		ibgeCode: "5209408",
		cityName: "Guarani de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5209457",
		cityName: "Guarinos",
		state: "GO"
	},
	{
		ibgeCode: "5209606",
		cityName: "Heitoraí",
		state: "GO"
	},
	{
		ibgeCode: "5209705",
		cityName: "Hidrolândia",
		state: "GO"
	},
	{
		ibgeCode: "5209804",
		cityName: "Hidrolina",
		state: "GO"
	},
	{
		ibgeCode: "5209903",
		cityName: "Iaciara",
		state: "GO"
	},
	{
		ibgeCode: "5209937",
		cityName: "Inaciolândia",
		state: "GO"
	},
	{
		ibgeCode: "5209952",
		cityName: "Indiara",
		state: "GO"
	},
	{
		ibgeCode: "5210000",
		cityName: "Inhumas",
		state: "GO"
	},
	{
		ibgeCode: "5210109",
		cityName: "Ipameri",
		state: "GO"
	},
	{
		ibgeCode: "5210158",
		cityName: "Ipiranga de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5210208",
		cityName: "Iporá",
		state: "GO"
	},
	{
		ibgeCode: "5210307",
		cityName: "Israelândia",
		state: "GO"
	},
	{
		ibgeCode: "5210406",
		cityName: "Itaberaí",
		state: "GO"
	},
	{
		ibgeCode: "5210562",
		cityName: "Itaguari",
		state: "GO"
	},
	{
		ibgeCode: "5210604",
		cityName: "Itaguaru",
		state: "GO"
	},
	{
		ibgeCode: "5210802",
		cityName: "Itajá",
		state: "GO"
	},
	{
		ibgeCode: "5210901",
		cityName: "Itapaci",
		state: "GO"
	},
	{
		ibgeCode: "5211206",
		cityName: "Itapuranga",
		state: "GO"
	},
	{
		ibgeCode: "5211305",
		cityName: "Itarumã",
		state: "GO"
	},
	{
		ibgeCode: "5211404",
		cityName: "Itauçu",
		state: "GO"
	},
	{
		ibgeCode: "5211503",
		cityName: "Itumbiara",
		state: "GO"
	},
	{
		ibgeCode: "5211602",
		cityName: "Ivolândia",
		state: "GO"
	},
	{
		ibgeCode: "5211701",
		cityName: "Jandaia",
		state: "GO"
	},
	{
		ibgeCode: "5211800",
		cityName: "Jaraguá",
		state: "GO"
	},
	{
		ibgeCode: "5211909",
		cityName: "Jataí",
		state: "GO"
	},
	{
		ibgeCode: "5212006",
		cityName: "Jaupaci",
		state: "GO"
	},
	{
		ibgeCode: "5212055",
		cityName: "Jesúpolis",
		state: "GO"
	},
	{
		ibgeCode: "5212105",
		cityName: "Joviânia",
		state: "GO"
	},
	{
		ibgeCode: "5212204",
		cityName: "Jussara",
		state: "GO"
	},
	{
		ibgeCode: "5212253",
		cityName: "Lagoa Santa",
		state: "GO"
	},
	{
		ibgeCode: "5212303",
		cityName: "Leopoldo de Bulhões",
		state: "GO"
	},
	{
		ibgeCode: "5212501",
		cityName: "Luziânia",
		state: "GO"
	},
	{
		ibgeCode: "5212600",
		cityName: "Mairipotaba",
		state: "GO"
	},
	{
		ibgeCode: "5212709",
		cityName: "Mambaí",
		state: "GO"
	},
	{
		ibgeCode: "5212808",
		cityName: "Mara Rosa",
		state: "GO"
	},
	{
		ibgeCode: "5212907",
		cityName: "Marzagão",
		state: "GO"
	},
	{
		ibgeCode: "5212956",
		cityName: "Matrinchã",
		state: "GO"
	},
	{
		ibgeCode: "5213004",
		cityName: "Maurilândia",
		state: "GO"
	},
	{
		ibgeCode: "5213053",
		cityName: "Mimoso de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5213087",
		cityName: "Minaçu",
		state: "GO"
	},
	{
		ibgeCode: "5213103",
		cityName: "Mineiros",
		state: "GO"
	},
	{
		ibgeCode: "5213400",
		cityName: "Moiporá",
		state: "GO"
	},
	{
		ibgeCode: "5213509",
		cityName: "Monte Alegre de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5213707",
		cityName: "Montes Claros de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5213756",
		cityName: "Montividiu",
		state: "GO"
	},
	{
		ibgeCode: "5213772",
		cityName: "Montividiu do Norte",
		state: "GO"
	},
	{
		ibgeCode: "5213806",
		cityName: "Morrinhos",
		state: "GO"
	},
	{
		ibgeCode: "5213855",
		cityName: "Morro Agudo de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5213905",
		cityName: "Mossâmedes",
		state: "GO"
	},
	{
		ibgeCode: "5214002",
		cityName: "Mozarlândia",
		state: "GO"
	},
	{
		ibgeCode: "5214051",
		cityName: "Mundo Novo",
		state: "GO"
	},
	{
		ibgeCode: "5214101",
		cityName: "Mutunópolis",
		state: "GO"
	},
	{
		ibgeCode: "5214408",
		cityName: "Nazário",
		state: "GO"
	},
	{
		ibgeCode: "5214507",
		cityName: "Nerópolis",
		state: "GO"
	},
	{
		ibgeCode: "5214606",
		cityName: "Niquelândia",
		state: "GO"
	},
	{
		ibgeCode: "5214705",
		cityName: "Nova América",
		state: "GO"
	},
	{
		ibgeCode: "5214804",
		cityName: "Nova Aurora",
		state: "GO"
	},
	{
		ibgeCode: "5214838",
		cityName: "Nova Crixás",
		state: "GO"
	},
	{
		ibgeCode: "5214861",
		cityName: "Nova Glória",
		state: "GO"
	},
	{
		ibgeCode: "5214879",
		cityName: "Nova Iguaçu de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5214903",
		cityName: "Nova Roma",
		state: "GO"
	},
	{
		ibgeCode: "5215009",
		cityName: "Nova Veneza",
		state: "GO"
	},
	{
		ibgeCode: "5215207",
		cityName: "Novo Brasil",
		state: "GO"
	},
	{
		ibgeCode: "5215231",
		cityName: "Novo Gama",
		state: "GO"
	},
	{
		ibgeCode: "5215256",
		cityName: "Novo Planalto",
		state: "GO"
	},
	{
		ibgeCode: "5215306",
		cityName: "Orizona",
		state: "GO"
	},
	{
		ibgeCode: "5215405",
		cityName: "Ouro Verde de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5215504",
		cityName: "Ouvidor",
		state: "GO"
	},
	{
		ibgeCode: "5215603",
		cityName: "Padre Bernardo",
		state: "GO"
	},
	{
		ibgeCode: "5215652",
		cityName: "Palestina de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5215702",
		cityName: "Palmeiras de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5215801",
		cityName: "Palmelo",
		state: "GO"
	},
	{
		ibgeCode: "5215900",
		cityName: "Palminópolis",
		state: "GO"
	},
	{
		ibgeCode: "5216007",
		cityName: "Panamá",
		state: "GO"
	},
	{
		ibgeCode: "5216304",
		cityName: "Paranaiguara",
		state: "GO"
	},
	{
		ibgeCode: "5216403",
		cityName: "Paraúna",
		state: "GO"
	},
	{
		ibgeCode: "5216452",
		cityName: "Perolândia",
		state: "GO"
	},
	{
		ibgeCode: "5216809",
		cityName: "Petrolina de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5216908",
		cityName: "Pilar de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5217104",
		cityName: "Piracanjuba",
		state: "GO"
	},
	{
		ibgeCode: "5217203",
		cityName: "Piranhas",
		state: "GO"
	},
	{
		ibgeCode: "5217302",
		cityName: "Pirenópolis",
		state: "GO"
	},
	{
		ibgeCode: "5217401",
		cityName: "Pires do Rio",
		state: "GO"
	},
	{
		ibgeCode: "5217609",
		cityName: "Planaltina",
		state: "GO"
	},
	{
		ibgeCode: "5217708",
		cityName: "Pontalina",
		state: "GO"
	},
	{
		ibgeCode: "5218003",
		cityName: "Porangatu",
		state: "GO"
	},
	{
		ibgeCode: "5218052",
		cityName: "Porteirão",
		state: "GO"
	},
	{
		ibgeCode: "5218102",
		cityName: "Portelândia",
		state: "GO"
	},
	{
		ibgeCode: "5218300",
		cityName: "Posse",
		state: "GO"
	},
	{
		ibgeCode: "5218391",
		cityName: "Professor Jamil",
		state: "GO"
	},
	{
		ibgeCode: "5218508",
		cityName: "Quirinópolis",
		state: "GO"
	},
	{
		ibgeCode: "5218607",
		cityName: "Rialma",
		state: "GO"
	},
	{
		ibgeCode: "5218706",
		cityName: "Rianápolis",
		state: "GO"
	},
	{
		ibgeCode: "5218789",
		cityName: "Rio Quente",
		state: "GO"
	},
	{
		ibgeCode: "5218805",
		cityName: "Rio Verde",
		state: "GO"
	},
	{
		ibgeCode: "5218904",
		cityName: "Rubiataba",
		state: "GO"
	},
	{
		ibgeCode: "5219001",
		cityName: "Sanclerlândia",
		state: "GO"
	},
	{
		ibgeCode: "5219100",
		cityName: "Santa Bárbara de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5219209",
		cityName: "Santa Cruz de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5219258",
		cityName: "Santa Fé de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5219308",
		cityName: "Santa Helena de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5219357",
		cityName: "Santa Isabel",
		state: "GO"
	},
	{
		ibgeCode: "5219407",
		cityName: "Santa Rita do Araguaia",
		state: "GO"
	},
	{
		ibgeCode: "5219456",
		cityName: "Santa Rita do Novo Destino",
		state: "GO"
	},
	{
		ibgeCode: "5219506",
		cityName: "Santa Rosa de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5219605",
		cityName: "Santa Tereza de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5219704",
		cityName: "Santa Terezinha de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5219712",
		cityName: "Santo Antônio da Barra",
		state: "GO"
	},
	{
		ibgeCode: "5219738",
		cityName: "Santo Antônio de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5219753",
		cityName: "Santo Antônio do Descoberto",
		state: "GO"
	},
	{
		ibgeCode: "5219803",
		cityName: "São Domingos",
		state: "GO"
	},
	{
		ibgeCode: "5219902",
		cityName: "São Francisco de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5220058",
		cityName: "São João da Paraúna",
		state: "GO"
	},
	{
		ibgeCode: "5220009",
		cityName: "São João d'Aliança",
		state: "GO"
	},
	{
		ibgeCode: "5220108",
		cityName: "São Luís de Montes Belos",
		state: "GO"
	},
	{
		ibgeCode: "5220157",
		cityName: "São Luiz do Norte",
		state: "GO"
	},
	{
		ibgeCode: "5220207",
		cityName: "São Miguel do Araguaia",
		state: "GO"
	},
	{
		ibgeCode: "5220264",
		cityName: "São Miguel do Passa Quatro",
		state: "GO"
	},
	{
		ibgeCode: "5220280",
		cityName: "São Patrício",
		state: "GO"
	},
	{
		ibgeCode: "5220405",
		cityName: "São Simão",
		state: "GO"
	},
	{
		ibgeCode: "5220454",
		cityName: "Senador Canedo",
		state: "GO"
	},
	{
		ibgeCode: "5220504",
		cityName: "Serranópolis",
		state: "GO"
	},
	{
		ibgeCode: "5220603",
		cityName: "Silvânia",
		state: "GO"
	},
	{
		ibgeCode: "5220686",
		cityName: "Simolândia",
		state: "GO"
	},
	{
		ibgeCode: "5220702",
		cityName: "Sítio d'Abadia",
		state: "GO"
	},
	{
		ibgeCode: "5221007",
		cityName: "Taquaral de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5221080",
		cityName: "Teresina de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5221197",
		cityName: "Terezópolis de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5221304",
		cityName: "Três Ranchos",
		state: "GO"
	},
	{
		ibgeCode: "5221403",
		cityName: "Trindade",
		state: "GO"
	},
	{
		ibgeCode: "5221452",
		cityName: "Trombas",
		state: "GO"
	},
	{
		ibgeCode: "5221502",
		cityName: "Turvânia",
		state: "GO"
	},
	{
		ibgeCode: "5221551",
		cityName: "Turvelândia",
		state: "GO"
	},
	{
		ibgeCode: "5221577",
		cityName: "Uirapuru",
		state: "GO"
	},
	{
		ibgeCode: "5221601",
		cityName: "Uruaçu",
		state: "GO"
	},
	{
		ibgeCode: "5221700",
		cityName: "Uruana",
		state: "GO"
	},
	{
		ibgeCode: "5221809",
		cityName: "Urutaí",
		state: "GO"
	},
	{
		ibgeCode: "5221858",
		cityName: "Valparaíso de Goiás",
		state: "GO"
	},
	{
		ibgeCode: "5221908",
		cityName: "Varjão",
		state: "GO"
	},
	{
		ibgeCode: "5222005",
		cityName: "Vianópolis",
		state: "GO"
	},
	{
		ibgeCode: "5222054",
		cityName: "Vicentinópolis",
		state: "GO"
	},
	{
		ibgeCode: "5222203",
		cityName: "Vila Boa",
		state: "GO"
	},
	{
		ibgeCode: "5222302",
		cityName: "Vila Propício",
		state: "GO"
	}
];
var MA = [
	{
		ibgeCode: "2100055",
		cityName: "Açailândia",
		state: "MA"
	},
	{
		ibgeCode: "2100105",
		cityName: "Afonso Cunha",
		state: "MA"
	},
	{
		ibgeCode: "2100154",
		cityName: "Água Doce do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2100204",
		cityName: "Alcântara",
		state: "MA"
	},
	{
		ibgeCode: "2100303",
		cityName: "Aldeias Altas",
		state: "MA"
	},
	{
		ibgeCode: "2100402",
		cityName: "Altamira do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2100436",
		cityName: "Alto Alegre do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2100477",
		cityName: "Alto Alegre do Pindaré",
		state: "MA"
	},
	{
		ibgeCode: "2100501",
		cityName: "Alto Parnaíba",
		state: "MA"
	},
	{
		ibgeCode: "2100550",
		cityName: "Amapá do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2100600",
		cityName: "Amarante do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2100709",
		cityName: "Anajatuba",
		state: "MA"
	},
	{
		ibgeCode: "2100808",
		cityName: "Anapurus",
		state: "MA"
	},
	{
		ibgeCode: "2100832",
		cityName: "Apicum-Açu",
		state: "MA"
	},
	{
		ibgeCode: "2100873",
		cityName: "Araguanã",
		state: "MA"
	},
	{
		ibgeCode: "2100907",
		cityName: "Araioses",
		state: "MA"
	},
	{
		ibgeCode: "2100956",
		cityName: "Arame",
		state: "MA"
	},
	{
		ibgeCode: "2101004",
		cityName: "Arari",
		state: "MA"
	},
	{
		ibgeCode: "2101103",
		cityName: "Axixá",
		state: "MA"
	},
	{
		ibgeCode: "2101202",
		cityName: "Bacabal",
		state: "MA"
	},
	{
		ibgeCode: "2101251",
		cityName: "Bacabeira",
		state: "MA"
	},
	{
		ibgeCode: "2101301",
		cityName: "Bacuri",
		state: "MA"
	},
	{
		ibgeCode: "2101350",
		cityName: "Bacurituba",
		state: "MA"
	},
	{
		ibgeCode: "2101400",
		cityName: "Balsas",
		state: "MA"
	},
	{
		ibgeCode: "2101509",
		cityName: "Barão de Grajaú",
		state: "MA"
	},
	{
		ibgeCode: "2101608",
		cityName: "Barra do Corda",
		state: "MA"
	},
	{
		ibgeCode: "2101707",
		cityName: "Barreirinhas",
		state: "MA"
	},
	{
		ibgeCode: "2101772",
		cityName: "Bela Vista do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2101731",
		cityName: "Belágua",
		state: "MA"
	},
	{
		ibgeCode: "2101806",
		cityName: "Benedito Leite",
		state: "MA"
	},
	{
		ibgeCode: "2101905",
		cityName: "Bequimão",
		state: "MA"
	},
	{
		ibgeCode: "2101939",
		cityName: "Bernardo do Mearim",
		state: "MA"
	},
	{
		ibgeCode: "2101970",
		cityName: "Boa Vista do Gurupi",
		state: "MA"
	},
	{
		ibgeCode: "2102002",
		cityName: "Bom Jardim",
		state: "MA"
	},
	{
		ibgeCode: "2102036",
		cityName: "Bom Jesus das Selvas",
		state: "MA"
	},
	{
		ibgeCode: "2102077",
		cityName: "Bom Lugar",
		state: "MA"
	},
	{
		ibgeCode: "2102101",
		cityName: "Brejo",
		state: "MA"
	},
	{
		ibgeCode: "2102150",
		cityName: "Brejo de Areia",
		state: "MA"
	},
	{
		ibgeCode: "2102200",
		cityName: "Buriti",
		state: "MA"
	},
	{
		ibgeCode: "2102309",
		cityName: "Buriti Bravo",
		state: "MA"
	},
	{
		ibgeCode: "2102325",
		cityName: "Buriticupu",
		state: "MA"
	},
	{
		ibgeCode: "2102358",
		cityName: "Buritirana",
		state: "MA"
	},
	{
		ibgeCode: "2102374",
		cityName: "Cachoeira Grande",
		state: "MA"
	},
	{
		ibgeCode: "2102408",
		cityName: "Cajapió",
		state: "MA"
	},
	{
		ibgeCode: "2102507",
		cityName: "Cajari",
		state: "MA"
	},
	{
		ibgeCode: "2102556",
		cityName: "Campestre do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2102606",
		cityName: "Cândido Mendes",
		state: "MA"
	},
	{
		ibgeCode: "2102705",
		cityName: "Cantanhede",
		state: "MA"
	},
	{
		ibgeCode: "2102754",
		cityName: "Capinzal do Norte",
		state: "MA"
	},
	{
		ibgeCode: "2102804",
		cityName: "Carolina",
		state: "MA"
	},
	{
		ibgeCode: "2102903",
		cityName: "Carutapera",
		state: "MA"
	},
	{
		ibgeCode: "2103000",
		cityName: "Caxias",
		state: "MA"
	},
	{
		ibgeCode: "2103109",
		cityName: "Cedral",
		state: "MA"
	},
	{
		ibgeCode: "2103125",
		cityName: "Central do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2103158",
		cityName: "Centro do Guilherme",
		state: "MA"
	},
	{
		ibgeCode: "2103174",
		cityName: "Centro Novo do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2103208",
		cityName: "Chapadinha",
		state: "MA"
	},
	{
		ibgeCode: "2103257",
		cityName: "Cidelândia",
		state: "MA"
	},
	{
		ibgeCode: "2103307",
		cityName: "Codó",
		state: "MA"
	},
	{
		ibgeCode: "2103406",
		cityName: "Coelho Neto",
		state: "MA"
	},
	{
		ibgeCode: "2103505",
		cityName: "Colinas",
		state: "MA"
	},
	{
		ibgeCode: "2103554",
		cityName: "Conceição do Lago-Açu",
		state: "MA"
	},
	{
		ibgeCode: "2103604",
		cityName: "Coroatá",
		state: "MA"
	},
	{
		ibgeCode: "2103703",
		cityName: "Cururupu",
		state: "MA"
	},
	{
		ibgeCode: "2103752",
		cityName: "Davinópolis",
		state: "MA"
	},
	{
		ibgeCode: "2103802",
		cityName: "Dom Pedro",
		state: "MA"
	},
	{
		ibgeCode: "2103901",
		cityName: "Duque Bacelar",
		state: "MA"
	},
	{
		ibgeCode: "2104008",
		cityName: "Esperantinópolis",
		state: "MA"
	},
	{
		ibgeCode: "2104057",
		cityName: "Estreito",
		state: "MA"
	},
	{
		ibgeCode: "2104073",
		cityName: "Feira Nova do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2104081",
		cityName: "Fernando Falcão",
		state: "MA"
	},
	{
		ibgeCode: "2104099",
		cityName: "Formosa da Serra Negra",
		state: "MA"
	},
	{
		ibgeCode: "2104107",
		cityName: "Fortaleza dos Nogueiras",
		state: "MA"
	},
	{
		ibgeCode: "2104206",
		cityName: "Fortuna",
		state: "MA"
	},
	{
		ibgeCode: "2104305",
		cityName: "Godofredo Viana",
		state: "MA"
	},
	{
		ibgeCode: "2104404",
		cityName: "Gonçalves Dias",
		state: "MA"
	},
	{
		ibgeCode: "2104503",
		cityName: "Governador Archer",
		state: "MA"
	},
	{
		ibgeCode: "2104552",
		cityName: "Governador Edison Lobão",
		state: "MA"
	},
	{
		ibgeCode: "2104602",
		cityName: "Governador Eugênio Barros",
		state: "MA"
	},
	{
		ibgeCode: "2104628",
		cityName: "Governador Luiz Rocha",
		state: "MA"
	},
	{
		ibgeCode: "2104651",
		cityName: "Governador Newton Bello",
		state: "MA"
	},
	{
		ibgeCode: "2104677",
		cityName: "Governador Nunes Freire",
		state: "MA"
	},
	{
		ibgeCode: "2104701",
		cityName: "Graça Aranha",
		state: "MA"
	},
	{
		ibgeCode: "2104800",
		cityName: "Grajaú",
		state: "MA"
	},
	{
		ibgeCode: "2104909",
		cityName: "Guimarães",
		state: "MA"
	},
	{
		ibgeCode: "2105005",
		cityName: "Humberto de Campos",
		state: "MA"
	},
	{
		ibgeCode: "2105104",
		cityName: "Icatu",
		state: "MA"
	},
	{
		ibgeCode: "2105153",
		cityName: "Igarapé do Meio",
		state: "MA"
	},
	{
		ibgeCode: "2105203",
		cityName: "Igarapé Grande",
		state: "MA"
	},
	{
		ibgeCode: "2105302",
		cityName: "Imperatriz",
		state: "MA"
	},
	{
		ibgeCode: "2105351",
		cityName: "Itaipava do Grajaú",
		state: "MA"
	},
	{
		ibgeCode: "2105401",
		cityName: "Itapecuru Mirim",
		state: "MA"
	},
	{
		ibgeCode: "2105427",
		cityName: "Itinga do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2105450",
		cityName: "Jatobá",
		state: "MA"
	},
	{
		ibgeCode: "2105476",
		cityName: "Jenipapo dos Vieiras",
		state: "MA"
	},
	{
		ibgeCode: "2105500",
		cityName: "João Lisboa",
		state: "MA"
	},
	{
		ibgeCode: "2105609",
		cityName: "Joselândia",
		state: "MA"
	},
	{
		ibgeCode: "2105658",
		cityName: "Junco do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2105708",
		cityName: "Lago da Pedra",
		state: "MA"
	},
	{
		ibgeCode: "2105807",
		cityName: "Lago do Junco",
		state: "MA"
	},
	{
		ibgeCode: "2105948",
		cityName: "Lago dos Rodrigues",
		state: "MA"
	},
	{
		ibgeCode: "2105906",
		cityName: "Lago Verde",
		state: "MA"
	},
	{
		ibgeCode: "2105922",
		cityName: "Lagoa do Mato",
		state: "MA"
	},
	{
		ibgeCode: "2105963",
		cityName: "Lagoa Grande do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2105989",
		cityName: "Lajeado Novo",
		state: "MA"
	},
	{
		ibgeCode: "2106003",
		cityName: "Lima Campos",
		state: "MA"
	},
	{
		ibgeCode: "2106102",
		cityName: "Loreto",
		state: "MA"
	},
	{
		ibgeCode: "2106201",
		cityName: "Luís Domingues",
		state: "MA"
	},
	{
		ibgeCode: "2106300",
		cityName: "Magalhães de Almeida",
		state: "MA"
	},
	{
		ibgeCode: "2106326",
		cityName: "Maracaçumé",
		state: "MA"
	},
	{
		ibgeCode: "2106359",
		cityName: "Marajá do Sena",
		state: "MA"
	},
	{
		ibgeCode: "2106375",
		cityName: "Maranhãozinho",
		state: "MA"
	},
	{
		ibgeCode: "2106409",
		cityName: "Mata Roma",
		state: "MA"
	},
	{
		ibgeCode: "2106508",
		cityName: "Matinha",
		state: "MA"
	},
	{
		ibgeCode: "2106607",
		cityName: "Matões",
		state: "MA"
	},
	{
		ibgeCode: "2106631",
		cityName: "Matões do Norte",
		state: "MA"
	},
	{
		ibgeCode: "2106672",
		cityName: "Milagres do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2106706",
		cityName: "Mirador",
		state: "MA"
	},
	{
		ibgeCode: "2106755",
		cityName: "Miranda do Norte",
		state: "MA"
	},
	{
		ibgeCode: "2106805",
		cityName: "Mirinzal",
		state: "MA"
	},
	{
		ibgeCode: "2106904",
		cityName: "Monção",
		state: "MA"
	},
	{
		ibgeCode: "2107001",
		cityName: "Montes Altos",
		state: "MA"
	},
	{
		ibgeCode: "2107100",
		cityName: "Morros",
		state: "MA"
	},
	{
		ibgeCode: "2107209",
		cityName: "Nina Rodrigues",
		state: "MA"
	},
	{
		ibgeCode: "2107258",
		cityName: "Nova Colinas",
		state: "MA"
	},
	{
		ibgeCode: "2107308",
		cityName: "Nova Iorque",
		state: "MA"
	},
	{
		ibgeCode: "2107357",
		cityName: "Nova Olinda do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2107407",
		cityName: "Olho d'Água das Cunhãs",
		state: "MA"
	},
	{
		ibgeCode: "2107456",
		cityName: "Olinda Nova do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2107506",
		cityName: "Paço do Lumiar",
		state: "MA"
	},
	{
		ibgeCode: "2107605",
		cityName: "Palmeirândia",
		state: "MA"
	},
	{
		ibgeCode: "2107704",
		cityName: "Paraibano",
		state: "MA"
	},
	{
		ibgeCode: "2107803",
		cityName: "Parnarama",
		state: "MA"
	},
	{
		ibgeCode: "2107902",
		cityName: "Passagem Franca",
		state: "MA"
	},
	{
		ibgeCode: "2108009",
		cityName: "Pastos Bons",
		state: "MA"
	},
	{
		ibgeCode: "2108058",
		cityName: "Paulino Neves",
		state: "MA"
	},
	{
		ibgeCode: "2108108",
		cityName: "Paulo Ramos",
		state: "MA"
	},
	{
		ibgeCode: "2108207",
		cityName: "Pedreiras",
		state: "MA"
	},
	{
		ibgeCode: "2108256",
		cityName: "Pedro do Rosário",
		state: "MA"
	},
	{
		ibgeCode: "2108306",
		cityName: "Penalva",
		state: "MA"
	},
	{
		ibgeCode: "2108405",
		cityName: "Peri Mirim",
		state: "MA"
	},
	{
		ibgeCode: "2108454",
		cityName: "Peritoró",
		state: "MA"
	},
	{
		ibgeCode: "2108504",
		cityName: "Pindaré-Mirim",
		state: "MA"
	},
	{
		ibgeCode: "2108603",
		cityName: "Pinheiro",
		state: "MA"
	},
	{
		ibgeCode: "2108702",
		cityName: "Pio XII",
		state: "MA"
	},
	{
		ibgeCode: "2108801",
		cityName: "Pirapemas",
		state: "MA"
	},
	{
		ibgeCode: "2108900",
		cityName: "Poção de Pedras",
		state: "MA"
	},
	{
		ibgeCode: "2109007",
		cityName: "Porto Franco",
		state: "MA"
	},
	{
		ibgeCode: "2109056",
		cityName: "Porto Rico do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2109106",
		cityName: "Presidente Dutra",
		state: "MA"
	},
	{
		ibgeCode: "2109205",
		cityName: "Presidente Juscelino",
		state: "MA"
	},
	{
		ibgeCode: "2109239",
		cityName: "Presidente Médici",
		state: "MA"
	},
	{
		ibgeCode: "2109270",
		cityName: "Presidente Sarney",
		state: "MA"
	},
	{
		ibgeCode: "2109304",
		cityName: "Presidente Vargas",
		state: "MA"
	},
	{
		ibgeCode: "2109403",
		cityName: "Primeira Cruz",
		state: "MA"
	},
	{
		ibgeCode: "2109452",
		cityName: "Raposa",
		state: "MA"
	},
	{
		ibgeCode: "2109502",
		cityName: "Riachão",
		state: "MA"
	},
	{
		ibgeCode: "2109551",
		cityName: "Ribamar Fiquene",
		state: "MA"
	},
	{
		ibgeCode: "2109601",
		cityName: "Rosário",
		state: "MA"
	},
	{
		ibgeCode: "2109700",
		cityName: "Sambaíba",
		state: "MA"
	},
	{
		ibgeCode: "2109759",
		cityName: "Santa Filomena do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2109809",
		cityName: "Santa Helena",
		state: "MA"
	},
	{
		ibgeCode: "2109908",
		cityName: "Santa Inês",
		state: "MA"
	},
	{
		ibgeCode: "2110005",
		cityName: "Santa Luzia",
		state: "MA"
	},
	{
		ibgeCode: "2110039",
		cityName: "Santa Luzia do Paruá",
		state: "MA"
	},
	{
		ibgeCode: "2110104",
		cityName: "Santa Quitéria do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2110203",
		cityName: "Santa Rita",
		state: "MA"
	},
	{
		ibgeCode: "2110237",
		cityName: "Santana do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2110278",
		cityName: "Santo Amaro do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2110302",
		cityName: "Santo Antônio dos Lopes",
		state: "MA"
	},
	{
		ibgeCode: "2110401",
		cityName: "São Benedito do Rio Preto",
		state: "MA"
	},
	{
		ibgeCode: "2110500",
		cityName: "São Bento",
		state: "MA"
	},
	{
		ibgeCode: "2110609",
		cityName: "São Bernardo",
		state: "MA"
	},
	{
		ibgeCode: "2110658",
		cityName: "São Domingos do Azeitão",
		state: "MA"
	},
	{
		ibgeCode: "2110708",
		cityName: "São Domingos do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2110807",
		cityName: "São Félix de Balsas",
		state: "MA"
	},
	{
		ibgeCode: "2110856",
		cityName: "São Francisco do Brejão",
		state: "MA"
	},
	{
		ibgeCode: "2110906",
		cityName: "São Francisco do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2111003",
		cityName: "São João Batista",
		state: "MA"
	},
	{
		ibgeCode: "2111029",
		cityName: "São João do Carú",
		state: "MA"
	},
	{
		ibgeCode: "2111052",
		cityName: "São João do Paraíso",
		state: "MA"
	},
	{
		ibgeCode: "2111078",
		cityName: "São João do Soter",
		state: "MA"
	},
	{
		ibgeCode: "2111102",
		cityName: "São João dos Patos",
		state: "MA"
	},
	{
		ibgeCode: "2111201",
		cityName: "São José de Ribamar",
		state: "MA"
	},
	{
		ibgeCode: "2111250",
		cityName: "São José dos Basílios",
		state: "MA"
	},
	{
		ibgeCode: "2111300",
		cityName: "São Luís",
		state: "MA"
	},
	{
		ibgeCode: "2111409",
		cityName: "São Luís Gonzaga do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2111508",
		cityName: "São Mateus do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2111532",
		cityName: "São Pedro da Água Branca",
		state: "MA"
	},
	{
		ibgeCode: "2111573",
		cityName: "São Pedro dos Crentes",
		state: "MA"
	},
	{
		ibgeCode: "2111607",
		cityName: "São Raimundo das Mangabeiras",
		state: "MA"
	},
	{
		ibgeCode: "2111631",
		cityName: "São Raimundo do Doca Bezerra",
		state: "MA"
	},
	{
		ibgeCode: "2111672",
		cityName: "São Roberto",
		state: "MA"
	},
	{
		ibgeCode: "2111706",
		cityName: "São Vicente Ferrer",
		state: "MA"
	},
	{
		ibgeCode: "2111722",
		cityName: "Satubinha",
		state: "MA"
	},
	{
		ibgeCode: "2111748",
		cityName: "Senador Alexandre Costa",
		state: "MA"
	},
	{
		ibgeCode: "2111763",
		cityName: "Senador La Rocque",
		state: "MA"
	},
	{
		ibgeCode: "2111789",
		cityName: "Serrano do Maranhão",
		state: "MA"
	},
	{
		ibgeCode: "2111805",
		cityName: "Sítio Novo",
		state: "MA"
	},
	{
		ibgeCode: "2111904",
		cityName: "Sucupira do Norte",
		state: "MA"
	},
	{
		ibgeCode: "2111953",
		cityName: "Sucupira do Riachão",
		state: "MA"
	},
	{
		ibgeCode: "2112001",
		cityName: "Tasso Fragoso",
		state: "MA"
	},
	{
		ibgeCode: "2112100",
		cityName: "Timbiras",
		state: "MA"
	},
	{
		ibgeCode: "2112209",
		cityName: "Timon",
		state: "MA"
	},
	{
		ibgeCode: "2112233",
		cityName: "Trizidela do Vale",
		state: "MA"
	},
	{
		ibgeCode: "2112274",
		cityName: "Tufilândia",
		state: "MA"
	},
	{
		ibgeCode: "2112308",
		cityName: "Tuntum",
		state: "MA"
	},
	{
		ibgeCode: "2112407",
		cityName: "Turiaçu",
		state: "MA"
	},
	{
		ibgeCode: "2112456",
		cityName: "Turilândia",
		state: "MA"
	},
	{
		ibgeCode: "2112506",
		cityName: "Tutóia",
		state: "MA"
	},
	{
		ibgeCode: "2112605",
		cityName: "Urbano Santos",
		state: "MA"
	},
	{
		ibgeCode: "2112704",
		cityName: "Vargem Grande",
		state: "MA"
	},
	{
		ibgeCode: "2112803",
		cityName: "Viana",
		state: "MA"
	},
	{
		ibgeCode: "2112852",
		cityName: "Vila Nova dos Martírios",
		state: "MA"
	},
	{
		ibgeCode: "2112902",
		cityName: "Vitória do Mearim",
		state: "MA"
	},
	{
		ibgeCode: "2113009",
		cityName: "Vitorino Freire",
		state: "MA"
	},
	{
		ibgeCode: "2114007",
		cityName: "Zé Doca",
		state: "MA"
	}
];
var MT = [
	{
		ibgeCode: "5108501",
		cityName: "Vera",
		state: "MT"
	},
	{
		ibgeCode: "5100102",
		cityName: "Acorizal",
		state: "MT"
	},
	{
		ibgeCode: "5100201",
		cityName: "Água Boa",
		state: "MT"
	},
	{
		ibgeCode: "5100250",
		cityName: "Alta Floresta",
		state: "MT"
	},
	{
		ibgeCode: "5100300",
		cityName: "Alto Araguaia",
		state: "MT"
	},
	{
		ibgeCode: "5100359",
		cityName: "Alto Boa Vista",
		state: "MT"
	},
	{
		ibgeCode: "5100409",
		cityName: "Alto Garças",
		state: "MT"
	},
	{
		ibgeCode: "5100508",
		cityName: "Alto Paraguai",
		state: "MT"
	},
	{
		ibgeCode: "5100607",
		cityName: "Alto Taquari",
		state: "MT"
	},
	{
		ibgeCode: "5100805",
		cityName: "Apiacás",
		state: "MT"
	},
	{
		ibgeCode: "5101001",
		cityName: "Araguaiana",
		state: "MT"
	},
	{
		ibgeCode: "5101209",
		cityName: "Araguainha",
		state: "MT"
	},
	{
		ibgeCode: "5101258",
		cityName: "Araputanga",
		state: "MT"
	},
	{
		ibgeCode: "5101308",
		cityName: "Arenápolis",
		state: "MT"
	},
	{
		ibgeCode: "5101407",
		cityName: "Aripuanã",
		state: "MT"
	},
	{
		ibgeCode: "5101605",
		cityName: "Barão de Melgaço",
		state: "MT"
	},
	{
		ibgeCode: "5101704",
		cityName: "Barra do Bugres",
		state: "MT"
	},
	{
		ibgeCode: "5101803",
		cityName: "Barra do Garças",
		state: "MT"
	},
	{
		ibgeCode: "5101852",
		cityName: "Bom Jesus do Araguaia",
		state: "MT"
	},
	{
		ibgeCode: "5101902",
		cityName: "Brasnorte",
		state: "MT"
	},
	{
		ibgeCode: "5102504",
		cityName: "Cáceres",
		state: "MT"
	},
	{
		ibgeCode: "5102603",
		cityName: "Campinápolis",
		state: "MT"
	},
	{
		ibgeCode: "5102637",
		cityName: "Campo Novo do Parecis",
		state: "MT"
	},
	{
		ibgeCode: "5102678",
		cityName: "Campo Verde",
		state: "MT"
	},
	{
		ibgeCode: "5102686",
		cityName: "Campos de Júlio",
		state: "MT"
	},
	{
		ibgeCode: "5102694",
		cityName: "Canabrava do Norte",
		state: "MT"
	},
	{
		ibgeCode: "5102702",
		cityName: "Canarana",
		state: "MT"
	},
	{
		ibgeCode: "5102793",
		cityName: "Carlinda",
		state: "MT"
	},
	{
		ibgeCode: "5102850",
		cityName: "Castanheira",
		state: "MT"
	},
	{
		ibgeCode: "5103007",
		cityName: "Chapada dos Guimarães",
		state: "MT"
	},
	{
		ibgeCode: "5103056",
		cityName: "Cláudia",
		state: "MT"
	},
	{
		ibgeCode: "5103106",
		cityName: "Cocalinho",
		state: "MT"
	},
	{
		ibgeCode: "5103205",
		cityName: "Colíder",
		state: "MT"
	},
	{
		ibgeCode: "5103254",
		cityName: "Colniza",
		state: "MT"
	},
	{
		ibgeCode: "5103304",
		cityName: "Comodoro",
		state: "MT"
	},
	{
		ibgeCode: "5103353",
		cityName: "Confresa",
		state: "MT"
	},
	{
		ibgeCode: "5103361",
		cityName: "Conquista D'Oeste",
		state: "MT"
	},
	{
		ibgeCode: "5103379",
		cityName: "Cotriguaçu",
		state: "MT"
	},
	{
		ibgeCode: "5103403",
		cityName: "Cuiabá",
		state: "MT"
	},
	{
		ibgeCode: "5103437",
		cityName: "Curvelândia",
		state: "MT"
	},
	{
		ibgeCode: "5103452",
		cityName: "Denise",
		state: "MT"
	},
	{
		ibgeCode: "5103502",
		cityName: "Diamantino",
		state: "MT"
	},
	{
		ibgeCode: "5103601",
		cityName: "Dom Aquino",
		state: "MT"
	},
	{
		ibgeCode: "5103700",
		cityName: "Feliz Natal",
		state: "MT"
	},
	{
		ibgeCode: "5103809",
		cityName: "Figueirópolis D'Oeste",
		state: "MT"
	},
	{
		ibgeCode: "5103858",
		cityName: "Gaúcha do Norte",
		state: "MT"
	},
	{
		ibgeCode: "5103908",
		cityName: "General Carneiro",
		state: "MT"
	},
	{
		ibgeCode: "5103957",
		cityName: "Glória D'Oeste",
		state: "MT"
	},
	{
		ibgeCode: "5104104",
		cityName: "Guarantã do Norte",
		state: "MT"
	},
	{
		ibgeCode: "5104203",
		cityName: "Guiratinga",
		state: "MT"
	},
	{
		ibgeCode: "5104500",
		cityName: "Indiavaí",
		state: "MT"
	},
	{
		ibgeCode: "5104526",
		cityName: "Ipiranga do Norte",
		state: "MT"
	},
	{
		ibgeCode: "5104542",
		cityName: "Itanhangá",
		state: "MT"
	},
	{
		ibgeCode: "5104559",
		cityName: "Itaúba",
		state: "MT"
	},
	{
		ibgeCode: "5104609",
		cityName: "Itiquira",
		state: "MT"
	},
	{
		ibgeCode: "5104807",
		cityName: "Jaciara",
		state: "MT"
	},
	{
		ibgeCode: "5104906",
		cityName: "Jangada",
		state: "MT"
	},
	{
		ibgeCode: "5105002",
		cityName: "Jauru",
		state: "MT"
	},
	{
		ibgeCode: "5105101",
		cityName: "Juara",
		state: "MT"
	},
	{
		ibgeCode: "5105150",
		cityName: "Juína",
		state: "MT"
	},
	{
		ibgeCode: "5105176",
		cityName: "Juruena",
		state: "MT"
	},
	{
		ibgeCode: "5105200",
		cityName: "Juscimeira",
		state: "MT"
	},
	{
		ibgeCode: "5105234",
		cityName: "Lambari D'Oeste",
		state: "MT"
	},
	{
		ibgeCode: "5105259",
		cityName: "Lucas do Rio Verde",
		state: "MT"
	},
	{
		ibgeCode: "5105309",
		cityName: "Luciara",
		state: "MT"
	},
	{
		ibgeCode: "5105580",
		cityName: "Marcelândia",
		state: "MT"
	},
	{
		ibgeCode: "5105606",
		cityName: "Matupá",
		state: "MT"
	},
	{
		ibgeCode: "5105622",
		cityName: "Mirassol d'Oeste",
		state: "MT"
	},
	{
		ibgeCode: "5105903",
		cityName: "Nobres",
		state: "MT"
	},
	{
		ibgeCode: "5106000",
		cityName: "Nortelândia",
		state: "MT"
	},
	{
		ibgeCode: "5106109",
		cityName: "Nossa Senhora do Livramento",
		state: "MT"
	},
	{
		ibgeCode: "5106158",
		cityName: "Nova Bandeirantes",
		state: "MT"
	},
	{
		ibgeCode: "5106208",
		cityName: "Nova Brasilândia",
		state: "MT"
	},
	{
		ibgeCode: "5106216",
		cityName: "Nova Canaã do Norte",
		state: "MT"
	},
	{
		ibgeCode: "5108808",
		cityName: "Nova Guarita",
		state: "MT"
	},
	{
		ibgeCode: "5106182",
		cityName: "Nova Lacerda",
		state: "MT"
	},
	{
		ibgeCode: "5108857",
		cityName: "Nova Marilândia",
		state: "MT"
	},
	{
		ibgeCode: "5108907",
		cityName: "Nova Maringá",
		state: "MT"
	},
	{
		ibgeCode: "5108956",
		cityName: "Nova Monte Verde",
		state: "MT"
	},
	{
		ibgeCode: "5106224",
		cityName: "Nova Mutum",
		state: "MT"
	},
	{
		ibgeCode: "5106174",
		cityName: "Nova Nazaré",
		state: "MT"
	},
	{
		ibgeCode: "5106232",
		cityName: "Nova Olímpia",
		state: "MT"
	},
	{
		ibgeCode: "5106190",
		cityName: "Nova Santa Helena",
		state: "MT"
	},
	{
		ibgeCode: "5106240",
		cityName: "Nova Ubiratã",
		state: "MT"
	},
	{
		ibgeCode: "5106257",
		cityName: "Nova Xavantina",
		state: "MT"
	},
	{
		ibgeCode: "5106273",
		cityName: "Novo Horizonte do Norte",
		state: "MT"
	},
	{
		ibgeCode: "5106265",
		cityName: "Novo Mundo",
		state: "MT"
	},
	{
		ibgeCode: "5106315",
		cityName: "Novo Santo Antônio",
		state: "MT"
	},
	{
		ibgeCode: "5106281",
		cityName: "Novo São Joaquim",
		state: "MT"
	},
	{
		ibgeCode: "5106299",
		cityName: "Paranaíta",
		state: "MT"
	},
	{
		ibgeCode: "5106307",
		cityName: "Paranatinga",
		state: "MT"
	},
	{
		ibgeCode: "5106372",
		cityName: "Pedra Preta",
		state: "MT"
	},
	{
		ibgeCode: "5106422",
		cityName: "Peixoto de Azevedo",
		state: "MT"
	},
	{
		ibgeCode: "5106455",
		cityName: "Planalto da Serra",
		state: "MT"
	},
	{
		ibgeCode: "5106505",
		cityName: "Poconé",
		state: "MT"
	},
	{
		ibgeCode: "5106653",
		cityName: "Pontal do Araguaia",
		state: "MT"
	},
	{
		ibgeCode: "5106703",
		cityName: "Ponte Branca",
		state: "MT"
	},
	{
		ibgeCode: "5106752",
		cityName: "Pontes e Lacerda",
		state: "MT"
	},
	{
		ibgeCode: "5106778",
		cityName: "Porto Alegre do Norte",
		state: "MT"
	},
	{
		ibgeCode: "5106802",
		cityName: "Porto dos Gaúchos",
		state: "MT"
	},
	{
		ibgeCode: "5106828",
		cityName: "Porto Esperidião",
		state: "MT"
	},
	{
		ibgeCode: "5106851",
		cityName: "Porto Estrela",
		state: "MT"
	},
	{
		ibgeCode: "5107008",
		cityName: "Poxoréu",
		state: "MT"
	},
	{
		ibgeCode: "5107040",
		cityName: "Primavera do Leste",
		state: "MT"
	},
	{
		ibgeCode: "5107065",
		cityName: "Querência",
		state: "MT"
	},
	{
		ibgeCode: "5107156",
		cityName: "Reserva do Cabaçal",
		state: "MT"
	},
	{
		ibgeCode: "5107180",
		cityName: "Ribeirão Cascalheira",
		state: "MT"
	},
	{
		ibgeCode: "5107198",
		cityName: "Ribeirãozinho",
		state: "MT"
	},
	{
		ibgeCode: "5107206",
		cityName: "Rio Branco",
		state: "MT"
	},
	{
		ibgeCode: "5107578",
		cityName: "Rondolândia",
		state: "MT"
	},
	{
		ibgeCode: "5107602",
		cityName: "Rondonópolis",
		state: "MT"
	},
	{
		ibgeCode: "5107701",
		cityName: "Rosário Oeste",
		state: "MT"
	},
	{
		ibgeCode: "5107750",
		cityName: "Salto do Céu",
		state: "MT"
	},
	{
		ibgeCode: "5107248",
		cityName: "Santa Carmem",
		state: "MT"
	},
	{
		ibgeCode: "5107743",
		cityName: "Santa Cruz do Xingu",
		state: "MT"
	},
	{
		ibgeCode: "5107768",
		cityName: "Santa Rita do Trivelato",
		state: "MT"
	},
	{
		ibgeCode: "5107776",
		cityName: "Santa Terezinha",
		state: "MT"
	},
	{
		ibgeCode: "5107263",
		cityName: "Santo Afonso",
		state: "MT"
	},
	{
		ibgeCode: "5107792",
		cityName: "Santo Antônio do Leste",
		state: "MT"
	},
	{
		ibgeCode: "5107800",
		cityName: "Santo Antônio do Leverger",
		state: "MT"
	},
	{
		ibgeCode: "5107859",
		cityName: "São Félix do Araguaia",
		state: "MT"
	},
	{
		ibgeCode: "5107297",
		cityName: "São José do Povo",
		state: "MT"
	},
	{
		ibgeCode: "5107305",
		cityName: "São José do Rio Claro",
		state: "MT"
	},
	{
		ibgeCode: "5107354",
		cityName: "São José do Xingu",
		state: "MT"
	},
	{
		ibgeCode: "5107107",
		cityName: "São José dos Quatro Marcos",
		state: "MT"
	},
	{
		ibgeCode: "5107404",
		cityName: "São Pedro da Cipa",
		state: "MT"
	},
	{
		ibgeCode: "5107875",
		cityName: "Sapezal",
		state: "MT"
	},
	{
		ibgeCode: "5107883",
		cityName: "Serra Nova Dourada",
		state: "MT"
	},
	{
		ibgeCode: "5107909",
		cityName: "Sinop",
		state: "MT"
	},
	{
		ibgeCode: "5107925",
		cityName: "Sorriso",
		state: "MT"
	},
	{
		ibgeCode: "5107941",
		cityName: "Tabaporã",
		state: "MT"
	},
	{
		ibgeCode: "5107958",
		cityName: "Tangará da Serra",
		state: "MT"
	},
	{
		ibgeCode: "5108006",
		cityName: "Tapurah",
		state: "MT"
	},
	{
		ibgeCode: "5108055",
		cityName: "Terra Nova do Norte",
		state: "MT"
	},
	{
		ibgeCode: "5108105",
		cityName: "Tesouro",
		state: "MT"
	},
	{
		ibgeCode: "5108204",
		cityName: "Torixoréu",
		state: "MT"
	},
	{
		ibgeCode: "5108303",
		cityName: "União do Sul",
		state: "MT"
	},
	{
		ibgeCode: "5108352",
		cityName: "Vale de São Domingos",
		state: "MT"
	},
	{
		ibgeCode: "5108402",
		cityName: "Várzea Grande",
		state: "MT"
	},
	{
		ibgeCode: "5105507",
		cityName: "Vila Bela da Santíssima Trindade",
		state: "MT"
	},
	{
		ibgeCode: "5108600",
		cityName: "Vila Rica",
		state: "MT"
	}
];
var MS = [
	{
		ibgeCode: "5000203",
		cityName: "Água Clara",
		state: "MS"
	},
	{
		ibgeCode: "5000252",
		cityName: "Alcinópolis",
		state: "MS"
	},
	{
		ibgeCode: "5000609",
		cityName: "Amambai",
		state: "MS"
	},
	{
		ibgeCode: "5000708",
		cityName: "Anastácio",
		state: "MS"
	},
	{
		ibgeCode: "5000807",
		cityName: "Anaurilândia",
		state: "MS"
	},
	{
		ibgeCode: "5000856",
		cityName: "Angélica",
		state: "MS"
	},
	{
		ibgeCode: "5000906",
		cityName: "Antônio João",
		state: "MS"
	},
	{
		ibgeCode: "5001003",
		cityName: "Aparecida do Taboado",
		state: "MS"
	},
	{
		ibgeCode: "5001102",
		cityName: "Aquidauana",
		state: "MS"
	},
	{
		ibgeCode: "5001243",
		cityName: "Aral Moreira",
		state: "MS"
	},
	{
		ibgeCode: "5001508",
		cityName: "Bandeirantes",
		state: "MS"
	},
	{
		ibgeCode: "5001904",
		cityName: "Bataguassu",
		state: "MS"
	},
	{
		ibgeCode: "5002001",
		cityName: "Batayporã",
		state: "MS"
	},
	{
		ibgeCode: "5002100",
		cityName: "Bela Vista",
		state: "MS"
	},
	{
		ibgeCode: "5002159",
		cityName: "Bodoquena",
		state: "MS"
	},
	{
		ibgeCode: "5002209",
		cityName: "Bonito",
		state: "MS"
	},
	{
		ibgeCode: "5002308",
		cityName: "Brasilândia",
		state: "MS"
	},
	{
		ibgeCode: "5002407",
		cityName: "Caarapó",
		state: "MS"
	},
	{
		ibgeCode: "5002605",
		cityName: "Camapuã",
		state: "MS"
	},
	{
		ibgeCode: "5002704",
		cityName: "Campo Grande",
		state: "MS"
	},
	{
		ibgeCode: "5002803",
		cityName: "Caracol",
		state: "MS"
	},
	{
		ibgeCode: "5002902",
		cityName: "Cassilândia",
		state: "MS"
	},
	{
		ibgeCode: "5002951",
		cityName: "Chapadão do Sul",
		state: "MS"
	},
	{
		ibgeCode: "5003108",
		cityName: "Corguinho",
		state: "MS"
	},
	{
		ibgeCode: "5003157",
		cityName: "Coronel Sapucaia",
		state: "MS"
	},
	{
		ibgeCode: "5003207",
		cityName: "Corumbá",
		state: "MS"
	},
	{
		ibgeCode: "5003256",
		cityName: "Costa Rica",
		state: "MS"
	},
	{
		ibgeCode: "5003306",
		cityName: "Coxim",
		state: "MS"
	},
	{
		ibgeCode: "5003454",
		cityName: "Deodápolis",
		state: "MS"
	},
	{
		ibgeCode: "5003488",
		cityName: "Dois Irmãos do Buriti",
		state: "MS"
	},
	{
		ibgeCode: "5003504",
		cityName: "Douradina",
		state: "MS"
	},
	{
		ibgeCode: "5003702",
		cityName: "Dourados",
		state: "MS"
	},
	{
		ibgeCode: "5003751",
		cityName: "Eldorado",
		state: "MS"
	},
	{
		ibgeCode: "5003801",
		cityName: "Fátima do Sul",
		state: "MS"
	},
	{
		ibgeCode: "5003900",
		cityName: "Figueirão",
		state: "MS"
	},
	{
		ibgeCode: "5004007",
		cityName: "Glória de Dourados",
		state: "MS"
	},
	{
		ibgeCode: "5004106",
		cityName: "Guia Lopes da Laguna",
		state: "MS"
	},
	{
		ibgeCode: "5004304",
		cityName: "Iguatemi",
		state: "MS"
	},
	{
		ibgeCode: "5004403",
		cityName: "Inocência",
		state: "MS"
	},
	{
		ibgeCode: "5004502",
		cityName: "Itaporã",
		state: "MS"
	},
	{
		ibgeCode: "5004601",
		cityName: "Itaquiraí",
		state: "MS"
	},
	{
		ibgeCode: "5004700",
		cityName: "Ivinhema",
		state: "MS"
	},
	{
		ibgeCode: "5004809",
		cityName: "Japorã",
		state: "MS"
	},
	{
		ibgeCode: "5004908",
		cityName: "Jaraguari",
		state: "MS"
	},
	{
		ibgeCode: "5005004",
		cityName: "Jardim",
		state: "MS"
	},
	{
		ibgeCode: "5005103",
		cityName: "Jateí",
		state: "MS"
	},
	{
		ibgeCode: "5005152",
		cityName: "Juti",
		state: "MS"
	},
	{
		ibgeCode: "5005202",
		cityName: "Ladário",
		state: "MS"
	},
	{
		ibgeCode: "5005251",
		cityName: "Laguna Carapã",
		state: "MS"
	},
	{
		ibgeCode: "5005400",
		cityName: "Maracaju",
		state: "MS"
	},
	{
		ibgeCode: "5005608",
		cityName: "Miranda",
		state: "MS"
	},
	{
		ibgeCode: "5005681",
		cityName: "Mundo Novo",
		state: "MS"
	},
	{
		ibgeCode: "5005707",
		cityName: "Naviraí",
		state: "MS"
	},
	{
		ibgeCode: "5005806",
		cityName: "Nioaque",
		state: "MS"
	},
	{
		ibgeCode: "5006002",
		cityName: "Nova Alvorada do Sul",
		state: "MS"
	},
	{
		ibgeCode: "5006200",
		cityName: "Nova Andradina",
		state: "MS"
	},
	{
		ibgeCode: "5006259",
		cityName: "Novo Horizonte do Sul",
		state: "MS"
	},
	{
		ibgeCode: "5006275",
		cityName: "Paraíso das Águas",
		state: "MS"
	},
	{
		ibgeCode: "5006309",
		cityName: "Paranaíba",
		state: "MS"
	},
	{
		ibgeCode: "5006358",
		cityName: "Paranhos",
		state: "MS"
	},
	{
		ibgeCode: "5006408",
		cityName: "Pedro Gomes",
		state: "MS"
	},
	{
		ibgeCode: "5006606",
		cityName: "Ponta Porã",
		state: "MS"
	},
	{
		ibgeCode: "5006903",
		cityName: "Porto Murtinho",
		state: "MS"
	},
	{
		ibgeCode: "5007109",
		cityName: "Ribas do Rio Pardo",
		state: "MS"
	},
	{
		ibgeCode: "5007208",
		cityName: "Rio Brilhante",
		state: "MS"
	},
	{
		ibgeCode: "5007307",
		cityName: "Rio Negro",
		state: "MS"
	},
	{
		ibgeCode: "5007406",
		cityName: "Rio Verde de Mato Grosso",
		state: "MS"
	},
	{
		ibgeCode: "5007505",
		cityName: "Rochedo",
		state: "MS"
	},
	{
		ibgeCode: "5007554",
		cityName: "Santa Rita do Pardo",
		state: "MS"
	},
	{
		ibgeCode: "5007695",
		cityName: "São Gabriel do Oeste",
		state: "MS"
	},
	{
		ibgeCode: "5007802",
		cityName: "Selvíria",
		state: "MS"
	},
	{
		ibgeCode: "5007703",
		cityName: "Sete Quedas",
		state: "MS"
	},
	{
		ibgeCode: "5007901",
		cityName: "Sidrolândia",
		state: "MS"
	},
	{
		ibgeCode: "5007935",
		cityName: "Sonora",
		state: "MS"
	},
	{
		ibgeCode: "5007950",
		cityName: "Tacuru",
		state: "MS"
	},
	{
		ibgeCode: "5007976",
		cityName: "Taquarussu",
		state: "MS"
	},
	{
		ibgeCode: "5008008",
		cityName: "Terenos",
		state: "MS"
	},
	{
		ibgeCode: "5008305",
		cityName: "Três Lagoas",
		state: "MS"
	},
	{
		ibgeCode: "5008404",
		cityName: "Vicentina",
		state: "MS"
	}
];
var MG = [
	{
		ibgeCode: "3100104",
		cityName: "Abadia dos Dourados",
		state: "MG"
	},
	{
		ibgeCode: "3100203",
		cityName: "Abaeté",
		state: "MG"
	},
	{
		ibgeCode: "3100302",
		cityName: "Abre Campo",
		state: "MG"
	},
	{
		ibgeCode: "3100401",
		cityName: "Acaiaca",
		state: "MG"
	},
	{
		ibgeCode: "3100500",
		cityName: "Açucena",
		state: "MG"
	},
	{
		ibgeCode: "3100609",
		cityName: "Água Boa",
		state: "MG"
	},
	{
		ibgeCode: "3100708",
		cityName: "Água Comprida",
		state: "MG"
	},
	{
		ibgeCode: "3100807",
		cityName: "Aguanil",
		state: "MG"
	},
	{
		ibgeCode: "3100906",
		cityName: "Águas Formosas",
		state: "MG"
	},
	{
		ibgeCode: "3101003",
		cityName: "Águas Vermelhas",
		state: "MG"
	},
	{
		ibgeCode: "3101102",
		cityName: "Aimorés",
		state: "MG"
	},
	{
		ibgeCode: "3101201",
		cityName: "Aiuruoca",
		state: "MG"
	},
	{
		ibgeCode: "3101300",
		cityName: "Alagoa",
		state: "MG"
	},
	{
		ibgeCode: "3101409",
		cityName: "Albertina",
		state: "MG"
	},
	{
		ibgeCode: "3101508",
		cityName: "Além Paraíba",
		state: "MG"
	},
	{
		ibgeCode: "3101607",
		cityName: "Alfenas",
		state: "MG"
	},
	{
		ibgeCode: "3101631",
		cityName: "Alfredo Vasconcelos",
		state: "MG"
	},
	{
		ibgeCode: "3101706",
		cityName: "Almenara",
		state: "MG"
	},
	{
		ibgeCode: "3101805",
		cityName: "Alpercata",
		state: "MG"
	},
	{
		ibgeCode: "3101904",
		cityName: "Alpinópolis",
		state: "MG"
	},
	{
		ibgeCode: "3102001",
		cityName: "Alterosa",
		state: "MG"
	},
	{
		ibgeCode: "3102050",
		cityName: "Alto Caparaó",
		state: "MG"
	},
	{
		ibgeCode: "3153509",
		cityName: "Alto Jequitibá",
		state: "MG"
	},
	{
		ibgeCode: "3102100",
		cityName: "Alto Rio Doce",
		state: "MG"
	},
	{
		ibgeCode: "3102209",
		cityName: "Alvarenga",
		state: "MG"
	},
	{
		ibgeCode: "3102308",
		cityName: "Alvinópolis",
		state: "MG"
	},
	{
		ibgeCode: "3102407",
		cityName: "Alvorada de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3102506",
		cityName: "Amparo do Serra",
		state: "MG"
	},
	{
		ibgeCode: "3102605",
		cityName: "Andradas",
		state: "MG"
	},
	{
		ibgeCode: "3102803",
		cityName: "Andrelândia",
		state: "MG"
	},
	{
		ibgeCode: "3102852",
		cityName: "Angelândia",
		state: "MG"
	},
	{
		ibgeCode: "3102902",
		cityName: "Antônio Carlos",
		state: "MG"
	},
	{
		ibgeCode: "3103009",
		cityName: "Antônio Dias",
		state: "MG"
	},
	{
		ibgeCode: "3103108",
		cityName: "Antônio Prado de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3103207",
		cityName: "Araçaí",
		state: "MG"
	},
	{
		ibgeCode: "3103306",
		cityName: "Aracitaba",
		state: "MG"
	},
	{
		ibgeCode: "3103405",
		cityName: "Araçuaí",
		state: "MG"
	},
	{
		ibgeCode: "3103504",
		cityName: "Araguari",
		state: "MG"
	},
	{
		ibgeCode: "3103603",
		cityName: "Arantina",
		state: "MG"
	},
	{
		ibgeCode: "3103702",
		cityName: "Araponga",
		state: "MG"
	},
	{
		ibgeCode: "3103751",
		cityName: "Araporã",
		state: "MG"
	},
	{
		ibgeCode: "3103801",
		cityName: "Arapuá",
		state: "MG"
	},
	{
		ibgeCode: "3103900",
		cityName: "Araújos",
		state: "MG"
	},
	{
		ibgeCode: "3104007",
		cityName: "Araxá",
		state: "MG"
	},
	{
		ibgeCode: "3104106",
		cityName: "Arceburgo",
		state: "MG"
	},
	{
		ibgeCode: "3104205",
		cityName: "Arcos",
		state: "MG"
	},
	{
		ibgeCode: "3104304",
		cityName: "Areado",
		state: "MG"
	},
	{
		ibgeCode: "3104403",
		cityName: "Argirita",
		state: "MG"
	},
	{
		ibgeCode: "3104452",
		cityName: "Aricanduva",
		state: "MG"
	},
	{
		ibgeCode: "3104502",
		cityName: "Arinos",
		state: "MG"
	},
	{
		ibgeCode: "3104601",
		cityName: "Astolfo Dutra",
		state: "MG"
	},
	{
		ibgeCode: "3104700",
		cityName: "Ataléia",
		state: "MG"
	},
	{
		ibgeCode: "3104809",
		cityName: "Augusto de Lima",
		state: "MG"
	},
	{
		ibgeCode: "3104908",
		cityName: "Baependi",
		state: "MG"
	},
	{
		ibgeCode: "3105004",
		cityName: "Baldim",
		state: "MG"
	},
	{
		ibgeCode: "3105103",
		cityName: "Bambuí",
		state: "MG"
	},
	{
		ibgeCode: "3105202",
		cityName: "Bandeira",
		state: "MG"
	},
	{
		ibgeCode: "3105301",
		cityName: "Bandeira do Sul",
		state: "MG"
	},
	{
		ibgeCode: "3105400",
		cityName: "Barão de Cocais",
		state: "MG"
	},
	{
		ibgeCode: "3105509",
		cityName: "Barão de Monte Alto",
		state: "MG"
	},
	{
		ibgeCode: "3105608",
		cityName: "Barbacena",
		state: "MG"
	},
	{
		ibgeCode: "3105707",
		cityName: "Barra Longa",
		state: "MG"
	},
	{
		ibgeCode: "3105905",
		cityName: "Barroso",
		state: "MG"
	},
	{
		ibgeCode: "3106002",
		cityName: "Bela Vista de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3106101",
		cityName: "Belmiro Braga",
		state: "MG"
	},
	{
		ibgeCode: "3106200",
		cityName: "Belo Horizonte",
		state: "MG"
	},
	{
		ibgeCode: "3106309",
		cityName: "Belo Oriente",
		state: "MG"
	},
	{
		ibgeCode: "3106408",
		cityName: "Belo Vale",
		state: "MG"
	},
	{
		ibgeCode: "3106507",
		cityName: "Berilo",
		state: "MG"
	},
	{
		ibgeCode: "3106655",
		cityName: "Berizal",
		state: "MG"
	},
	{
		ibgeCode: "3106606",
		cityName: "Bertópolis",
		state: "MG"
	},
	{
		ibgeCode: "3106705",
		cityName: "Betim",
		state: "MG"
	},
	{
		ibgeCode: "3106804",
		cityName: "Bias Fortes",
		state: "MG"
	},
	{
		ibgeCode: "3106903",
		cityName: "Bicas",
		state: "MG"
	},
	{
		ibgeCode: "3107000",
		cityName: "Biquinhas",
		state: "MG"
	},
	{
		ibgeCode: "3107109",
		cityName: "Boa Esperança",
		state: "MG"
	},
	{
		ibgeCode: "3107208",
		cityName: "Bocaina de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3107307",
		cityName: "Bocaiúva",
		state: "MG"
	},
	{
		ibgeCode: "3107406",
		cityName: "Bom Despacho",
		state: "MG"
	},
	{
		ibgeCode: "3107505",
		cityName: "Bom Jardim de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3107604",
		cityName: "Bom Jesus da Penha",
		state: "MG"
	},
	{
		ibgeCode: "3107703",
		cityName: "Bom Jesus do Amparo",
		state: "MG"
	},
	{
		ibgeCode: "3107802",
		cityName: "Bom Jesus do Galho",
		state: "MG"
	},
	{
		ibgeCode: "3107901",
		cityName: "Bom Repouso",
		state: "MG"
	},
	{
		ibgeCode: "3108008",
		cityName: "Bom Sucesso",
		state: "MG"
	},
	{
		ibgeCode: "3108107",
		cityName: "Bonfim",
		state: "MG"
	},
	{
		ibgeCode: "3108206",
		cityName: "Bonfinópolis de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3108255",
		cityName: "Bonito de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3108305",
		cityName: "Borda da Mata",
		state: "MG"
	},
	{
		ibgeCode: "3108404",
		cityName: "Botelhos",
		state: "MG"
	},
	{
		ibgeCode: "3108503",
		cityName: "Botumirim",
		state: "MG"
	},
	{
		ibgeCode: "3108701",
		cityName: "Brás Pires",
		state: "MG"
	},
	{
		ibgeCode: "3108552",
		cityName: "Brasilândia de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3108602",
		cityName: "Brasília de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3108800",
		cityName: "Braúnas",
		state: "MG"
	},
	{
		ibgeCode: "3108909",
		cityName: "Brazópolis",
		state: "MG"
	},
	{
		ibgeCode: "3109006",
		cityName: "Brumadinho",
		state: "MG"
	},
	{
		ibgeCode: "3109105",
		cityName: "Bueno Brandão",
		state: "MG"
	},
	{
		ibgeCode: "3109204",
		cityName: "Buenópolis",
		state: "MG"
	},
	{
		ibgeCode: "3109253",
		cityName: "Bugre",
		state: "MG"
	},
	{
		ibgeCode: "3109303",
		cityName: "Buritis",
		state: "MG"
	},
	{
		ibgeCode: "3109402",
		cityName: "Buritizeiro",
		state: "MG"
	},
	{
		ibgeCode: "3109451",
		cityName: "Cabeceira Grande",
		state: "MG"
	},
	{
		ibgeCode: "3109501",
		cityName: "Cabo Verde",
		state: "MG"
	},
	{
		ibgeCode: "3109600",
		cityName: "Cachoeira da Prata",
		state: "MG"
	},
	{
		ibgeCode: "3109709",
		cityName: "Cachoeira de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3102704",
		cityName: "Cachoeira de Pajeú",
		state: "MG"
	},
	{
		ibgeCode: "3109808",
		cityName: "Cachoeira Dourada",
		state: "MG"
	},
	{
		ibgeCode: "3109907",
		cityName: "Caetanópolis",
		state: "MG"
	},
	{
		ibgeCode: "3110004",
		cityName: "Caeté",
		state: "MG"
	},
	{
		ibgeCode: "3110103",
		cityName: "Caiana",
		state: "MG"
	},
	{
		ibgeCode: "3110202",
		cityName: "Cajuri",
		state: "MG"
	},
	{
		ibgeCode: "3110301",
		cityName: "Caldas",
		state: "MG"
	},
	{
		ibgeCode: "3110400",
		cityName: "Camacho",
		state: "MG"
	},
	{
		ibgeCode: "3110509",
		cityName: "Camanducaia",
		state: "MG"
	},
	{
		ibgeCode: "3110608",
		cityName: "Cambuí",
		state: "MG"
	},
	{
		ibgeCode: "3110707",
		cityName: "Cambuquira",
		state: "MG"
	},
	{
		ibgeCode: "3110806",
		cityName: "Campanário",
		state: "MG"
	},
	{
		ibgeCode: "3110905",
		cityName: "Campanha",
		state: "MG"
	},
	{
		ibgeCode: "3111002",
		cityName: "Campestre",
		state: "MG"
	},
	{
		ibgeCode: "3111101",
		cityName: "Campina Verde",
		state: "MG"
	},
	{
		ibgeCode: "3111150",
		cityName: "Campo Azul",
		state: "MG"
	},
	{
		ibgeCode: "3111200",
		cityName: "Campo Belo",
		state: "MG"
	},
	{
		ibgeCode: "3111309",
		cityName: "Campo do Meio",
		state: "MG"
	},
	{
		ibgeCode: "3111408",
		cityName: "Campo Florido",
		state: "MG"
	},
	{
		ibgeCode: "3111507",
		cityName: "Campos Altos",
		state: "MG"
	},
	{
		ibgeCode: "3111606",
		cityName: "Campos Gerais",
		state: "MG"
	},
	{
		ibgeCode: "3111903",
		cityName: "Cana Verde",
		state: "MG"
	},
	{
		ibgeCode: "3111705",
		cityName: "Canaã",
		state: "MG"
	},
	{
		ibgeCode: "3111804",
		cityName: "Canápolis",
		state: "MG"
	},
	{
		ibgeCode: "3112000",
		cityName: "Candeias",
		state: "MG"
	},
	{
		ibgeCode: "3112059",
		cityName: "Cantagalo",
		state: "MG"
	},
	{
		ibgeCode: "3112109",
		cityName: "Caparaó",
		state: "MG"
	},
	{
		ibgeCode: "3112208",
		cityName: "Capela Nova",
		state: "MG"
	},
	{
		ibgeCode: "3112307",
		cityName: "Capelinha",
		state: "MG"
	},
	{
		ibgeCode: "3112406",
		cityName: "Capetinga",
		state: "MG"
	},
	{
		ibgeCode: "3112505",
		cityName: "Capim Branco",
		state: "MG"
	},
	{
		ibgeCode: "3112604",
		cityName: "Capinópolis",
		state: "MG"
	},
	{
		ibgeCode: "3112653",
		cityName: "Capitão Andrade",
		state: "MG"
	},
	{
		ibgeCode: "3112703",
		cityName: "Capitão Enéas",
		state: "MG"
	},
	{
		ibgeCode: "3112802",
		cityName: "Capitólio",
		state: "MG"
	},
	{
		ibgeCode: "3112901",
		cityName: "Caputira",
		state: "MG"
	},
	{
		ibgeCode: "3113008",
		cityName: "Caraí",
		state: "MG"
	},
	{
		ibgeCode: "3113107",
		cityName: "Caranaíba",
		state: "MG"
	},
	{
		ibgeCode: "3113206",
		cityName: "Carandaí",
		state: "MG"
	},
	{
		ibgeCode: "3113305",
		cityName: "Carangola",
		state: "MG"
	},
	{
		ibgeCode: "3113404",
		cityName: "Caratinga",
		state: "MG"
	},
	{
		ibgeCode: "3113503",
		cityName: "Carbonita",
		state: "MG"
	},
	{
		ibgeCode: "3113602",
		cityName: "Careaçu",
		state: "MG"
	},
	{
		ibgeCode: "3113701",
		cityName: "Carlos Chagas",
		state: "MG"
	},
	{
		ibgeCode: "3113800",
		cityName: "Carmésia",
		state: "MG"
	},
	{
		ibgeCode: "3113909",
		cityName: "Carmo da Cachoeira",
		state: "MG"
	},
	{
		ibgeCode: "3114006",
		cityName: "Carmo da Mata",
		state: "MG"
	},
	{
		ibgeCode: "3114105",
		cityName: "Carmo de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3114204",
		cityName: "Carmo do Cajuru",
		state: "MG"
	},
	{
		ibgeCode: "3114303",
		cityName: "Carmo do Paranaíba",
		state: "MG"
	},
	{
		ibgeCode: "3114402",
		cityName: "Carmo do Rio Claro",
		state: "MG"
	},
	{
		ibgeCode: "3114501",
		cityName: "Carmópolis de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3114550",
		cityName: "Carneirinho",
		state: "MG"
	},
	{
		ibgeCode: "3114600",
		cityName: "Carrancas",
		state: "MG"
	},
	{
		ibgeCode: "3114709",
		cityName: "Carvalhópolis",
		state: "MG"
	},
	{
		ibgeCode: "3114808",
		cityName: "Carvalhos",
		state: "MG"
	},
	{
		ibgeCode: "3114907",
		cityName: "Casa Grande",
		state: "MG"
	},
	{
		ibgeCode: "3115003",
		cityName: "Cascalho Rico",
		state: "MG"
	},
	{
		ibgeCode: "3115102",
		cityName: "Cássia",
		state: "MG"
	},
	{
		ibgeCode: "3115300",
		cityName: "Cataguases",
		state: "MG"
	},
	{
		ibgeCode: "3115359",
		cityName: "Catas Altas",
		state: "MG"
	},
	{
		ibgeCode: "3115409",
		cityName: "Catas Altas da Noruega",
		state: "MG"
	},
	{
		ibgeCode: "3115458",
		cityName: "Catuji",
		state: "MG"
	},
	{
		ibgeCode: "3115474",
		cityName: "Catuti",
		state: "MG"
	},
	{
		ibgeCode: "3115508",
		cityName: "Caxambu",
		state: "MG"
	},
	{
		ibgeCode: "3115607",
		cityName: "Cedro do Abaeté",
		state: "MG"
	},
	{
		ibgeCode: "3115706",
		cityName: "Central de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3115805",
		cityName: "Centralina",
		state: "MG"
	},
	{
		ibgeCode: "3115904",
		cityName: "Chácara",
		state: "MG"
	},
	{
		ibgeCode: "3116001",
		cityName: "Chalé",
		state: "MG"
	},
	{
		ibgeCode: "3116100",
		cityName: "Chapada do Norte",
		state: "MG"
	},
	{
		ibgeCode: "3116159",
		cityName: "Chapada Gaúcha",
		state: "MG"
	},
	{
		ibgeCode: "3116209",
		cityName: "Chiador",
		state: "MG"
	},
	{
		ibgeCode: "3116308",
		cityName: "Cipotânea",
		state: "MG"
	},
	{
		ibgeCode: "3116407",
		cityName: "Claraval",
		state: "MG"
	},
	{
		ibgeCode: "3116506",
		cityName: "Claro dos Poções",
		state: "MG"
	},
	{
		ibgeCode: "3116605",
		cityName: "Cláudio",
		state: "MG"
	},
	{
		ibgeCode: "3116704",
		cityName: "Coimbra",
		state: "MG"
	},
	{
		ibgeCode: "3116803",
		cityName: "Coluna",
		state: "MG"
	},
	{
		ibgeCode: "3116902",
		cityName: "Comendador Gomes",
		state: "MG"
	},
	{
		ibgeCode: "3117009",
		cityName: "Comercinho",
		state: "MG"
	},
	{
		ibgeCode: "3117108",
		cityName: "Conceição da Aparecida",
		state: "MG"
	},
	{
		ibgeCode: "3115201",
		cityName: "Conceição da Barra de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3117306",
		cityName: "Conceição das Alagoas",
		state: "MG"
	},
	{
		ibgeCode: "3117207",
		cityName: "Conceição das Pedras",
		state: "MG"
	},
	{
		ibgeCode: "3117405",
		cityName: "Conceição de Ipanema",
		state: "MG"
	},
	{
		ibgeCode: "3117504",
		cityName: "Conceição do Mato Dentro",
		state: "MG"
	},
	{
		ibgeCode: "3117603",
		cityName: "Conceição do Pará",
		state: "MG"
	},
	{
		ibgeCode: "3117702",
		cityName: "Conceição do Rio Verde",
		state: "MG"
	},
	{
		ibgeCode: "3117801",
		cityName: "Conceição dos Ouros",
		state: "MG"
	},
	{
		ibgeCode: "3117836",
		cityName: "Cônego Marinho",
		state: "MG"
	},
	{
		ibgeCode: "3117876",
		cityName: "Confins",
		state: "MG"
	},
	{
		ibgeCode: "3117900",
		cityName: "Congonhal",
		state: "MG"
	},
	{
		ibgeCode: "3118007",
		cityName: "Congonhas",
		state: "MG"
	},
	{
		ibgeCode: "3118106",
		cityName: "Congonhas do Norte",
		state: "MG"
	},
	{
		ibgeCode: "3118205",
		cityName: "Conquista",
		state: "MG"
	},
	{
		ibgeCode: "3118304",
		cityName: "Conselheiro Lafaiete",
		state: "MG"
	},
	{
		ibgeCode: "3118403",
		cityName: "Conselheiro Pena",
		state: "MG"
	},
	{
		ibgeCode: "3118502",
		cityName: "Consolação",
		state: "MG"
	},
	{
		ibgeCode: "3118601",
		cityName: "Contagem",
		state: "MG"
	},
	{
		ibgeCode: "3118700",
		cityName: "Coqueiral",
		state: "MG"
	},
	{
		ibgeCode: "3118809",
		cityName: "Coração de Jesus",
		state: "MG"
	},
	{
		ibgeCode: "3118908",
		cityName: "Cordisburgo",
		state: "MG"
	},
	{
		ibgeCode: "3119005",
		cityName: "Cordislândia",
		state: "MG"
	},
	{
		ibgeCode: "3119104",
		cityName: "Corinto",
		state: "MG"
	},
	{
		ibgeCode: "3119203",
		cityName: "Coroaci",
		state: "MG"
	},
	{
		ibgeCode: "3119302",
		cityName: "Coromandel",
		state: "MG"
	},
	{
		ibgeCode: "3119401",
		cityName: "Coronel Fabriciano",
		state: "MG"
	},
	{
		ibgeCode: "3119500",
		cityName: "Coronel Murta",
		state: "MG"
	},
	{
		ibgeCode: "3119609",
		cityName: "Coronel Pacheco",
		state: "MG"
	},
	{
		ibgeCode: "3119708",
		cityName: "Coronel Xavier Chaves",
		state: "MG"
	},
	{
		ibgeCode: "3119807",
		cityName: "Córrego Danta",
		state: "MG"
	},
	{
		ibgeCode: "3119906",
		cityName: "Córrego do Bom Jesus",
		state: "MG"
	},
	{
		ibgeCode: "3119955",
		cityName: "Córrego Fundo",
		state: "MG"
	},
	{
		ibgeCode: "3120003",
		cityName: "Córrego Novo",
		state: "MG"
	},
	{
		ibgeCode: "3120102",
		cityName: "Couto de Magalhães de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3120151",
		cityName: "Crisólita",
		state: "MG"
	},
	{
		ibgeCode: "3120201",
		cityName: "Cristais",
		state: "MG"
	},
	{
		ibgeCode: "3120300",
		cityName: "Cristália",
		state: "MG"
	},
	{
		ibgeCode: "3120409",
		cityName: "Cristiano Otoni",
		state: "MG"
	},
	{
		ibgeCode: "3120508",
		cityName: "Cristina",
		state: "MG"
	},
	{
		ibgeCode: "3120607",
		cityName: "Crucilândia",
		state: "MG"
	},
	{
		ibgeCode: "3120706",
		cityName: "Cruzeiro da Fortaleza",
		state: "MG"
	},
	{
		ibgeCode: "3120805",
		cityName: "Cruzília",
		state: "MG"
	},
	{
		ibgeCode: "3120839",
		cityName: "Cuparaque",
		state: "MG"
	},
	{
		ibgeCode: "3120870",
		cityName: "Curral de Dentro",
		state: "MG"
	},
	{
		ibgeCode: "3120904",
		cityName: "Curvelo",
		state: "MG"
	},
	{
		ibgeCode: "3121001",
		cityName: "Datas",
		state: "MG"
	},
	{
		ibgeCode: "3121100",
		cityName: "Delfim Moreira",
		state: "MG"
	},
	{
		ibgeCode: "3121209",
		cityName: "Delfinópolis",
		state: "MG"
	},
	{
		ibgeCode: "3121258",
		cityName: "Delta",
		state: "MG"
	},
	{
		ibgeCode: "3121308",
		cityName: "Descoberto",
		state: "MG"
	},
	{
		ibgeCode: "3121407",
		cityName: "Desterro de Entre Rios",
		state: "MG"
	},
	{
		ibgeCode: "3121506",
		cityName: "Desterro do Melo",
		state: "MG"
	},
	{
		ibgeCode: "3121605",
		cityName: "Diamantina",
		state: "MG"
	},
	{
		ibgeCode: "3121704",
		cityName: "Diogo de Vasconcelos",
		state: "MG"
	},
	{
		ibgeCode: "3121803",
		cityName: "Dionísio",
		state: "MG"
	},
	{
		ibgeCode: "3121902",
		cityName: "Divinésia",
		state: "MG"
	},
	{
		ibgeCode: "3122009",
		cityName: "Divino",
		state: "MG"
	},
	{
		ibgeCode: "3122108",
		cityName: "Divino das Laranjeiras",
		state: "MG"
	},
	{
		ibgeCode: "3122207",
		cityName: "Divinolândia de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3122306",
		cityName: "Divinópolis",
		state: "MG"
	},
	{
		ibgeCode: "3122355",
		cityName: "Divisa Alegre",
		state: "MG"
	},
	{
		ibgeCode: "3122405",
		cityName: "Divisa Nova",
		state: "MG"
	},
	{
		ibgeCode: "3122454",
		cityName: "Divisópolis",
		state: "MG"
	},
	{
		ibgeCode: "3122470",
		cityName: "Dom Bosco",
		state: "MG"
	},
	{
		ibgeCode: "3122504",
		cityName: "Dom Cavati",
		state: "MG"
	},
	{
		ibgeCode: "3122603",
		cityName: "Dom Joaquim",
		state: "MG"
	},
	{
		ibgeCode: "3122702",
		cityName: "Dom Silvério",
		state: "MG"
	},
	{
		ibgeCode: "3122801",
		cityName: "Dom Viçoso",
		state: "MG"
	},
	{
		ibgeCode: "3122900",
		cityName: "Dona Euzébia",
		state: "MG"
	},
	{
		ibgeCode: "3123007",
		cityName: "Dores de Campos",
		state: "MG"
	},
	{
		ibgeCode: "3123106",
		cityName: "Dores de Guanhães",
		state: "MG"
	},
	{
		ibgeCode: "3123205",
		cityName: "Dores do Indaiá",
		state: "MG"
	},
	{
		ibgeCode: "3123304",
		cityName: "Dores do Turvo",
		state: "MG"
	},
	{
		ibgeCode: "3123403",
		cityName: "Doresópolis",
		state: "MG"
	},
	{
		ibgeCode: "3123502",
		cityName: "Douradoquara",
		state: "MG"
	},
	{
		ibgeCode: "3123528",
		cityName: "Durandé",
		state: "MG"
	},
	{
		ibgeCode: "3123601",
		cityName: "Elói Mendes",
		state: "MG"
	},
	{
		ibgeCode: "3123700",
		cityName: "Engenheiro Caldas",
		state: "MG"
	},
	{
		ibgeCode: "3123809",
		cityName: "Engenheiro Navarro",
		state: "MG"
	},
	{
		ibgeCode: "3123858",
		cityName: "Entre Folhas",
		state: "MG"
	},
	{
		ibgeCode: "3123908",
		cityName: "Entre Rios de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3124005",
		cityName: "Ervália",
		state: "MG"
	},
	{
		ibgeCode: "3124104",
		cityName: "Esmeraldas",
		state: "MG"
	},
	{
		ibgeCode: "3124203",
		cityName: "Espera Feliz",
		state: "MG"
	},
	{
		ibgeCode: "3124302",
		cityName: "Espinosa",
		state: "MG"
	},
	{
		ibgeCode: "3124401",
		cityName: "Espírito Santo do Dourado",
		state: "MG"
	},
	{
		ibgeCode: "3124500",
		cityName: "Estiva",
		state: "MG"
	},
	{
		ibgeCode: "3124609",
		cityName: "Estrela Dalva",
		state: "MG"
	},
	{
		ibgeCode: "3124708",
		cityName: "Estrela do Indaiá",
		state: "MG"
	},
	{
		ibgeCode: "3124807",
		cityName: "Estrela do Sul",
		state: "MG"
	},
	{
		ibgeCode: "3124906",
		cityName: "Eugenópolis",
		state: "MG"
	},
	{
		ibgeCode: "3125002",
		cityName: "Ewbank da Câmara",
		state: "MG"
	},
	{
		ibgeCode: "3125101",
		cityName: "Extrema",
		state: "MG"
	},
	{
		ibgeCode: "3125200",
		cityName: "Fama",
		state: "MG"
	},
	{
		ibgeCode: "3125309",
		cityName: "Faria Lemos",
		state: "MG"
	},
	{
		ibgeCode: "3125408",
		cityName: "Felício dos Santos",
		state: "MG"
	},
	{
		ibgeCode: "3125606",
		cityName: "Felisburgo",
		state: "MG"
	},
	{
		ibgeCode: "3125705",
		cityName: "Felixlândia",
		state: "MG"
	},
	{
		ibgeCode: "3125804",
		cityName: "Fernandes Tourinho",
		state: "MG"
	},
	{
		ibgeCode: "3125903",
		cityName: "Ferros",
		state: "MG"
	},
	{
		ibgeCode: "3125952",
		cityName: "Fervedouro",
		state: "MG"
	},
	{
		ibgeCode: "3126000",
		cityName: "Florestal",
		state: "MG"
	},
	{
		ibgeCode: "3126109",
		cityName: "Formiga",
		state: "MG"
	},
	{
		ibgeCode: "3126208",
		cityName: "Formoso",
		state: "MG"
	},
	{
		ibgeCode: "3136579",
		cityName: "Josenópolis",
		state: "MG"
	},
	{
		ibgeCode: "3126307",
		cityName: "Fortaleza de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3126406",
		cityName: "Fortuna de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3126505",
		cityName: "Francisco Badaró",
		state: "MG"
	},
	{
		ibgeCode: "3126604",
		cityName: "Francisco Dumont",
		state: "MG"
	},
	{
		ibgeCode: "3126703",
		cityName: "Francisco Sá",
		state: "MG"
	},
	{
		ibgeCode: "3126752",
		cityName: "Franciscópolis",
		state: "MG"
	},
	{
		ibgeCode: "3126802",
		cityName: "Frei Gaspar",
		state: "MG"
	},
	{
		ibgeCode: "3126901",
		cityName: "Frei Inocêncio",
		state: "MG"
	},
	{
		ibgeCode: "3126950",
		cityName: "Frei Lagonegro",
		state: "MG"
	},
	{
		ibgeCode: "3127008",
		cityName: "Fronteira",
		state: "MG"
	},
	{
		ibgeCode: "3127057",
		cityName: "Fronteira dos Vales",
		state: "MG"
	},
	{
		ibgeCode: "3127073",
		cityName: "Fruta de Leite",
		state: "MG"
	},
	{
		ibgeCode: "3127107",
		cityName: "Frutal",
		state: "MG"
	},
	{
		ibgeCode: "3127206",
		cityName: "Funilândia",
		state: "MG"
	},
	{
		ibgeCode: "3127305",
		cityName: "Galiléia",
		state: "MG"
	},
	{
		ibgeCode: "3127339",
		cityName: "Gameleiras",
		state: "MG"
	},
	{
		ibgeCode: "3127354",
		cityName: "Glaucilândia",
		state: "MG"
	},
	{
		ibgeCode: "3127370",
		cityName: "Goiabeira",
		state: "MG"
	},
	{
		ibgeCode: "3127388",
		cityName: "Goianá",
		state: "MG"
	},
	{
		ibgeCode: "3127404",
		cityName: "Gonçalves",
		state: "MG"
	},
	{
		ibgeCode: "3127503",
		cityName: "Gonzaga",
		state: "MG"
	},
	{
		ibgeCode: "3127602",
		cityName: "Gouveia",
		state: "MG"
	},
	{
		ibgeCode: "3127701",
		cityName: "Governador Valadares",
		state: "MG"
	},
	{
		ibgeCode: "3127800",
		cityName: "Grão Mogol",
		state: "MG"
	},
	{
		ibgeCode: "3127909",
		cityName: "Grupiara",
		state: "MG"
	},
	{
		ibgeCode: "3128006",
		cityName: "Guanhães",
		state: "MG"
	},
	{
		ibgeCode: "3128105",
		cityName: "Guapé",
		state: "MG"
	},
	{
		ibgeCode: "3128204",
		cityName: "Guaraciaba",
		state: "MG"
	},
	{
		ibgeCode: "3128253",
		cityName: "Guaraciama",
		state: "MG"
	},
	{
		ibgeCode: "3128303",
		cityName: "Guaranésia",
		state: "MG"
	},
	{
		ibgeCode: "3128402",
		cityName: "Guarani",
		state: "MG"
	},
	{
		ibgeCode: "3128501",
		cityName: "Guarará",
		state: "MG"
	},
	{
		ibgeCode: "3128600",
		cityName: "Guarda-Mor",
		state: "MG"
	},
	{
		ibgeCode: "3128709",
		cityName: "Guaxupé",
		state: "MG"
	},
	{
		ibgeCode: "3128808",
		cityName: "Guidoval",
		state: "MG"
	},
	{
		ibgeCode: "3128907",
		cityName: "Guimarânia",
		state: "MG"
	},
	{
		ibgeCode: "3129004",
		cityName: "Guiricema",
		state: "MG"
	},
	{
		ibgeCode: "3129103",
		cityName: "Gurinhatã",
		state: "MG"
	},
	{
		ibgeCode: "3129202",
		cityName: "Heliodora",
		state: "MG"
	},
	{
		ibgeCode: "3129301",
		cityName: "Iapu",
		state: "MG"
	},
	{
		ibgeCode: "3129400",
		cityName: "Ibertioga",
		state: "MG"
	},
	{
		ibgeCode: "3129509",
		cityName: "Ibiá",
		state: "MG"
	},
	{
		ibgeCode: "3129608",
		cityName: "Ibiaí",
		state: "MG"
	},
	{
		ibgeCode: "3129657",
		cityName: "Ibiracatu",
		state: "MG"
	},
	{
		ibgeCode: "3129707",
		cityName: "Ibiraci",
		state: "MG"
	},
	{
		ibgeCode: "3129806",
		cityName: "Ibirité",
		state: "MG"
	},
	{
		ibgeCode: "3129905",
		cityName: "Ibitiúra de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3130002",
		cityName: "Ibituruna",
		state: "MG"
	},
	{
		ibgeCode: "3130051",
		cityName: "Icaraí de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3130101",
		cityName: "Igarapé",
		state: "MG"
	},
	{
		ibgeCode: "3130200",
		cityName: "Igaratinga",
		state: "MG"
	},
	{
		ibgeCode: "3130309",
		cityName: "Iguatama",
		state: "MG"
	},
	{
		ibgeCode: "3130408",
		cityName: "Ijaci",
		state: "MG"
	},
	{
		ibgeCode: "3130507",
		cityName: "Ilicínea",
		state: "MG"
	},
	{
		ibgeCode: "3130556",
		cityName: "Imbé de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3130606",
		cityName: "Inconfidentes",
		state: "MG"
	},
	{
		ibgeCode: "3130655",
		cityName: "Indaiabira",
		state: "MG"
	},
	{
		ibgeCode: "3130705",
		cityName: "Indianópolis",
		state: "MG"
	},
	{
		ibgeCode: "3130804",
		cityName: "Ingaí",
		state: "MG"
	},
	{
		ibgeCode: "3130903",
		cityName: "Inhapim",
		state: "MG"
	},
	{
		ibgeCode: "3131000",
		cityName: "Inhaúma",
		state: "MG"
	},
	{
		ibgeCode: "3131109",
		cityName: "Inimutaba",
		state: "MG"
	},
	{
		ibgeCode: "3131158",
		cityName: "Ipaba",
		state: "MG"
	},
	{
		ibgeCode: "3131208",
		cityName: "Ipanema",
		state: "MG"
	},
	{
		ibgeCode: "3131307",
		cityName: "Ipatinga",
		state: "MG"
	},
	{
		ibgeCode: "3131406",
		cityName: "Ipiaçu",
		state: "MG"
	},
	{
		ibgeCode: "3131505",
		cityName: "Ipuiúna",
		state: "MG"
	},
	{
		ibgeCode: "3131604",
		cityName: "Iraí de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3131703",
		cityName: "Itabira",
		state: "MG"
	},
	{
		ibgeCode: "3131802",
		cityName: "Itabirinha",
		state: "MG"
	},
	{
		ibgeCode: "3131901",
		cityName: "Itabirito",
		state: "MG"
	},
	{
		ibgeCode: "3132008",
		cityName: "Itacambira",
		state: "MG"
	},
	{
		ibgeCode: "3132107",
		cityName: "Itacarambi",
		state: "MG"
	},
	{
		ibgeCode: "3132206",
		cityName: "Itaguara",
		state: "MG"
	},
	{
		ibgeCode: "3132305",
		cityName: "Itaipé",
		state: "MG"
	},
	{
		ibgeCode: "3132404",
		cityName: "Itajubá",
		state: "MG"
	},
	{
		ibgeCode: "3132503",
		cityName: "Itamarandiba",
		state: "MG"
	},
	{
		ibgeCode: "3132602",
		cityName: "Itamarati de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3132701",
		cityName: "Itambacuri",
		state: "MG"
	},
	{
		ibgeCode: "3132800",
		cityName: "Itambé do Mato Dentro",
		state: "MG"
	},
	{
		ibgeCode: "3132909",
		cityName: "Itamogi",
		state: "MG"
	},
	{
		ibgeCode: "3133006",
		cityName: "Itamonte",
		state: "MG"
	},
	{
		ibgeCode: "3133105",
		cityName: "Itanhandu",
		state: "MG"
	},
	{
		ibgeCode: "3133204",
		cityName: "Itanhomi",
		state: "MG"
	},
	{
		ibgeCode: "3133303",
		cityName: "Itaobim",
		state: "MG"
	},
	{
		ibgeCode: "3133402",
		cityName: "Itapagipe",
		state: "MG"
	},
	{
		ibgeCode: "3133501",
		cityName: "Itapecerica",
		state: "MG"
	},
	{
		ibgeCode: "3133600",
		cityName: "Itapeva",
		state: "MG"
	},
	{
		ibgeCode: "3133709",
		cityName: "Itatiaiuçu",
		state: "MG"
	},
	{
		ibgeCode: "3133758",
		cityName: "Itaú de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3133808",
		cityName: "Itaúna",
		state: "MG"
	},
	{
		ibgeCode: "3133907",
		cityName: "Itaverava",
		state: "MG"
	},
	{
		ibgeCode: "3134004",
		cityName: "Itinga",
		state: "MG"
	},
	{
		ibgeCode: "3134103",
		cityName: "Itueta",
		state: "MG"
	},
	{
		ibgeCode: "3134202",
		cityName: "Ituiutaba",
		state: "MG"
	},
	{
		ibgeCode: "3134301",
		cityName: "Itumirim",
		state: "MG"
	},
	{
		ibgeCode: "3134400",
		cityName: "Iturama",
		state: "MG"
	},
	{
		ibgeCode: "3134509",
		cityName: "Itutinga",
		state: "MG"
	},
	{
		ibgeCode: "3134608",
		cityName: "Jaboticatubas",
		state: "MG"
	},
	{
		ibgeCode: "3134707",
		cityName: "Jacinto",
		state: "MG"
	},
	{
		ibgeCode: "3134806",
		cityName: "Jacuí",
		state: "MG"
	},
	{
		ibgeCode: "3134905",
		cityName: "Jacutinga",
		state: "MG"
	},
	{
		ibgeCode: "3135001",
		cityName: "Jaguaraçu",
		state: "MG"
	},
	{
		ibgeCode: "3135050",
		cityName: "Jaíba",
		state: "MG"
	},
	{
		ibgeCode: "3135076",
		cityName: "Jampruca",
		state: "MG"
	},
	{
		ibgeCode: "3135100",
		cityName: "Janaúba",
		state: "MG"
	},
	{
		ibgeCode: "3135209",
		cityName: "Januária",
		state: "MG"
	},
	{
		ibgeCode: "3135308",
		cityName: "Japaraíba",
		state: "MG"
	},
	{
		ibgeCode: "3135357",
		cityName: "Japonvar",
		state: "MG"
	},
	{
		ibgeCode: "3135407",
		cityName: "Jeceaba",
		state: "MG"
	},
	{
		ibgeCode: "3135456",
		cityName: "Jenipapo de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3135506",
		cityName: "Jequeri",
		state: "MG"
	},
	{
		ibgeCode: "3135605",
		cityName: "Jequitaí",
		state: "MG"
	},
	{
		ibgeCode: "3135704",
		cityName: "Jequitibá",
		state: "MG"
	},
	{
		ibgeCode: "3135803",
		cityName: "Jequitinhonha",
		state: "MG"
	},
	{
		ibgeCode: "3135902",
		cityName: "Jesuânia",
		state: "MG"
	},
	{
		ibgeCode: "3136009",
		cityName: "Joaíma",
		state: "MG"
	},
	{
		ibgeCode: "3136108",
		cityName: "Joanésia",
		state: "MG"
	},
	{
		ibgeCode: "3136207",
		cityName: "João Monlevade",
		state: "MG"
	},
	{
		ibgeCode: "3136306",
		cityName: "João Pinheiro",
		state: "MG"
	},
	{
		ibgeCode: "3136405",
		cityName: "Joaquim Felício",
		state: "MG"
	},
	{
		ibgeCode: "3136504",
		cityName: "Jordânia",
		state: "MG"
	},
	{
		ibgeCode: "3136520",
		cityName: "José Gonçalves de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3136553",
		cityName: "José Raydan",
		state: "MG"
	},
	{
		ibgeCode: "3136652",
		cityName: "Juatuba",
		state: "MG"
	},
	{
		ibgeCode: "3136702",
		cityName: "Juiz de Fora",
		state: "MG"
	},
	{
		ibgeCode: "3136801",
		cityName: "Juramento",
		state: "MG"
	},
	{
		ibgeCode: "3136900",
		cityName: "Juruaia",
		state: "MG"
	},
	{
		ibgeCode: "3136959",
		cityName: "Juvenília",
		state: "MG"
	},
	{
		ibgeCode: "3137007",
		cityName: "Ladainha",
		state: "MG"
	},
	{
		ibgeCode: "3137106",
		cityName: "Lagamar",
		state: "MG"
	},
	{
		ibgeCode: "3137205",
		cityName: "Lagoa da Prata",
		state: "MG"
	},
	{
		ibgeCode: "3137304",
		cityName: "Lagoa dos Patos",
		state: "MG"
	},
	{
		ibgeCode: "3137403",
		cityName: "Lagoa Dourada",
		state: "MG"
	},
	{
		ibgeCode: "3137502",
		cityName: "Lagoa Formosa",
		state: "MG"
	},
	{
		ibgeCode: "3137536",
		cityName: "Lagoa Grande",
		state: "MG"
	},
	{
		ibgeCode: "3137601",
		cityName: "Lagoa Santa",
		state: "MG"
	},
	{
		ibgeCode: "3137700",
		cityName: "Lajinha",
		state: "MG"
	},
	{
		ibgeCode: "3137809",
		cityName: "Lambari",
		state: "MG"
	},
	{
		ibgeCode: "3137908",
		cityName: "Lamim",
		state: "MG"
	},
	{
		ibgeCode: "3138005",
		cityName: "Laranjal",
		state: "MG"
	},
	{
		ibgeCode: "3138104",
		cityName: "Lassance",
		state: "MG"
	},
	{
		ibgeCode: "3138203",
		cityName: "Lavras",
		state: "MG"
	},
	{
		ibgeCode: "3138302",
		cityName: "Leandro Ferreira",
		state: "MG"
	},
	{
		ibgeCode: "3138351",
		cityName: "Leme do Prado",
		state: "MG"
	},
	{
		ibgeCode: "3138401",
		cityName: "Leopoldina",
		state: "MG"
	},
	{
		ibgeCode: "3138500",
		cityName: "Liberdade",
		state: "MG"
	},
	{
		ibgeCode: "3138609",
		cityName: "Lima Duarte",
		state: "MG"
	},
	{
		ibgeCode: "3138625",
		cityName: "Limeira do Oeste",
		state: "MG"
	},
	{
		ibgeCode: "3138658",
		cityName: "Lontra",
		state: "MG"
	},
	{
		ibgeCode: "3138674",
		cityName: "Luisburgo",
		state: "MG"
	},
	{
		ibgeCode: "3138682",
		cityName: "Luislândia",
		state: "MG"
	},
	{
		ibgeCode: "3138708",
		cityName: "Luminárias",
		state: "MG"
	},
	{
		ibgeCode: "3138807",
		cityName: "Luz",
		state: "MG"
	},
	{
		ibgeCode: "3138906",
		cityName: "Machacalis",
		state: "MG"
	},
	{
		ibgeCode: "3139003",
		cityName: "Machado",
		state: "MG"
	},
	{
		ibgeCode: "3139102",
		cityName: "Madre de Deus de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3139201",
		cityName: "Malacacheta",
		state: "MG"
	},
	{
		ibgeCode: "3139250",
		cityName: "Mamonas",
		state: "MG"
	},
	{
		ibgeCode: "3139300",
		cityName: "Manga",
		state: "MG"
	},
	{
		ibgeCode: "3139409",
		cityName: "Manhuaçu",
		state: "MG"
	},
	{
		ibgeCode: "3139508",
		cityName: "Manhumirim",
		state: "MG"
	},
	{
		ibgeCode: "3139607",
		cityName: "Mantena",
		state: "MG"
	},
	{
		ibgeCode: "3139805",
		cityName: "Mar de Espanha",
		state: "MG"
	},
	{
		ibgeCode: "3139706",
		cityName: "Maravilhas",
		state: "MG"
	},
	{
		ibgeCode: "3139904",
		cityName: "Maria da Fé",
		state: "MG"
	},
	{
		ibgeCode: "3140001",
		cityName: "Mariana",
		state: "MG"
	},
	{
		ibgeCode: "3140100",
		cityName: "Marilac",
		state: "MG"
	},
	{
		ibgeCode: "3140159",
		cityName: "Mário Campos",
		state: "MG"
	},
	{
		ibgeCode: "3140209",
		cityName: "Maripá de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3140308",
		cityName: "Marliéria",
		state: "MG"
	},
	{
		ibgeCode: "3140407",
		cityName: "Marmelópolis",
		state: "MG"
	},
	{
		ibgeCode: "3140506",
		cityName: "Martinho Campos",
		state: "MG"
	},
	{
		ibgeCode: "3140530",
		cityName: "Martins Soares",
		state: "MG"
	},
	{
		ibgeCode: "3140555",
		cityName: "Mata Verde",
		state: "MG"
	},
	{
		ibgeCode: "3140605",
		cityName: "Materlândia",
		state: "MG"
	},
	{
		ibgeCode: "3140704",
		cityName: "Mateus Leme",
		state: "MG"
	},
	{
		ibgeCode: "3171501",
		cityName: "Mathias Lobato",
		state: "MG"
	},
	{
		ibgeCode: "3140803",
		cityName: "Matias Barbosa",
		state: "MG"
	},
	{
		ibgeCode: "3140852",
		cityName: "Matias Cardoso",
		state: "MG"
	},
	{
		ibgeCode: "3140902",
		cityName: "Matipó",
		state: "MG"
	},
	{
		ibgeCode: "3141009",
		cityName: "Mato Verde",
		state: "MG"
	},
	{
		ibgeCode: "3141108",
		cityName: "Matozinhos",
		state: "MG"
	},
	{
		ibgeCode: "3141207",
		cityName: "Matutina",
		state: "MG"
	},
	{
		ibgeCode: "3141306",
		cityName: "Medeiros",
		state: "MG"
	},
	{
		ibgeCode: "3141405",
		cityName: "Medina",
		state: "MG"
	},
	{
		ibgeCode: "3141504",
		cityName: "Mendes Pimentel",
		state: "MG"
	},
	{
		ibgeCode: "3141603",
		cityName: "Mercês",
		state: "MG"
	},
	{
		ibgeCode: "3141702",
		cityName: "Mesquita",
		state: "MG"
	},
	{
		ibgeCode: "3141801",
		cityName: "Minas Novas",
		state: "MG"
	},
	{
		ibgeCode: "3141900",
		cityName: "Minduri",
		state: "MG"
	},
	{
		ibgeCode: "3142007",
		cityName: "Mirabela",
		state: "MG"
	},
	{
		ibgeCode: "3142106",
		cityName: "Miradouro",
		state: "MG"
	},
	{
		ibgeCode: "3142205",
		cityName: "Miraí",
		state: "MG"
	},
	{
		ibgeCode: "3142254",
		cityName: "Miravânia",
		state: "MG"
	},
	{
		ibgeCode: "3142304",
		cityName: "Moeda",
		state: "MG"
	},
	{
		ibgeCode: "3142403",
		cityName: "Moema",
		state: "MG"
	},
	{
		ibgeCode: "3142502",
		cityName: "Monjolos",
		state: "MG"
	},
	{
		ibgeCode: "3142601",
		cityName: "Monsenhor Paulo",
		state: "MG"
	},
	{
		ibgeCode: "3142700",
		cityName: "Montalvânia",
		state: "MG"
	},
	{
		ibgeCode: "3142809",
		cityName: "Monte Alegre de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3142908",
		cityName: "Monte Azul",
		state: "MG"
	},
	{
		ibgeCode: "3143005",
		cityName: "Monte Belo",
		state: "MG"
	},
	{
		ibgeCode: "3143104",
		cityName: "Monte Carmelo",
		state: "MG"
	},
	{
		ibgeCode: "3143153",
		cityName: "Monte Formoso",
		state: "MG"
	},
	{
		ibgeCode: "3143203",
		cityName: "Monte Santo de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3143401",
		cityName: "Monte Sião",
		state: "MG"
	},
	{
		ibgeCode: "3143302",
		cityName: "Montes Claros",
		state: "MG"
	},
	{
		ibgeCode: "3143450",
		cityName: "Montezuma",
		state: "MG"
	},
	{
		ibgeCode: "3143500",
		cityName: "Morada Nova de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3143609",
		cityName: "Morro da Garça",
		state: "MG"
	},
	{
		ibgeCode: "3143708",
		cityName: "Morro do Pilar",
		state: "MG"
	},
	{
		ibgeCode: "3143807",
		cityName: "Munhoz",
		state: "MG"
	},
	{
		ibgeCode: "3143906",
		cityName: "Muriaé",
		state: "MG"
	},
	{
		ibgeCode: "3144003",
		cityName: "Mutum",
		state: "MG"
	},
	{
		ibgeCode: "3144102",
		cityName: "Muzambinho",
		state: "MG"
	},
	{
		ibgeCode: "3144201",
		cityName: "Nacip Raydan",
		state: "MG"
	},
	{
		ibgeCode: "3144300",
		cityName: "Nanuque",
		state: "MG"
	},
	{
		ibgeCode: "3144359",
		cityName: "Naque",
		state: "MG"
	},
	{
		ibgeCode: "3144375",
		cityName: "Natalândia",
		state: "MG"
	},
	{
		ibgeCode: "3144409",
		cityName: "Natércia",
		state: "MG"
	},
	{
		ibgeCode: "3144508",
		cityName: "Nazareno",
		state: "MG"
	},
	{
		ibgeCode: "3144607",
		cityName: "Nepomuceno",
		state: "MG"
	},
	{
		ibgeCode: "3144656",
		cityName: "Ninheira",
		state: "MG"
	},
	{
		ibgeCode: "3144672",
		cityName: "Nova Belém",
		state: "MG"
	},
	{
		ibgeCode: "3144706",
		cityName: "Nova Era",
		state: "MG"
	},
	{
		ibgeCode: "3144805",
		cityName: "Nova Lima",
		state: "MG"
	},
	{
		ibgeCode: "3144904",
		cityName: "Nova Módica",
		state: "MG"
	},
	{
		ibgeCode: "3145000",
		cityName: "Nova Ponte",
		state: "MG"
	},
	{
		ibgeCode: "3145059",
		cityName: "Nova Porteirinha",
		state: "MG"
	},
	{
		ibgeCode: "3145109",
		cityName: "Nova Resende",
		state: "MG"
	},
	{
		ibgeCode: "3145208",
		cityName: "Nova Serrana",
		state: "MG"
	},
	{
		ibgeCode: "3136603",
		cityName: "Nova União",
		state: "MG"
	},
	{
		ibgeCode: "3145307",
		cityName: "Novo Cruzeiro",
		state: "MG"
	},
	{
		ibgeCode: "3145356",
		cityName: "Novo Oriente de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3145372",
		cityName: "Novorizonte",
		state: "MG"
	},
	{
		ibgeCode: "3145406",
		cityName: "Olaria",
		state: "MG"
	},
	{
		ibgeCode: "3145455",
		cityName: "Olhos-d'Água",
		state: "MG"
	},
	{
		ibgeCode: "3145505",
		cityName: "Olímpio Noronha",
		state: "MG"
	},
	{
		ibgeCode: "3145604",
		cityName: "Oliveira",
		state: "MG"
	},
	{
		ibgeCode: "3145703",
		cityName: "Oliveira Fortes",
		state: "MG"
	},
	{
		ibgeCode: "3145802",
		cityName: "Onça de Pitangui",
		state: "MG"
	},
	{
		ibgeCode: "3145851",
		cityName: "Oratórios",
		state: "MG"
	},
	{
		ibgeCode: "3145877",
		cityName: "Orizânia",
		state: "MG"
	},
	{
		ibgeCode: "3145901",
		cityName: "Ouro Branco",
		state: "MG"
	},
	{
		ibgeCode: "3146008",
		cityName: "Ouro Fino",
		state: "MG"
	},
	{
		ibgeCode: "3146107",
		cityName: "Ouro Preto",
		state: "MG"
	},
	{
		ibgeCode: "3146206",
		cityName: "Ouro Verde de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3146255",
		cityName: "Padre Carvalho",
		state: "MG"
	},
	{
		ibgeCode: "3146305",
		cityName: "Padre Paraíso",
		state: "MG"
	},
	{
		ibgeCode: "3146552",
		cityName: "Pai Pedro",
		state: "MG"
	},
	{
		ibgeCode: "3146404",
		cityName: "Paineiras",
		state: "MG"
	},
	{
		ibgeCode: "3146503",
		cityName: "Pains",
		state: "MG"
	},
	{
		ibgeCode: "3146602",
		cityName: "Paiva",
		state: "MG"
	},
	{
		ibgeCode: "3146701",
		cityName: "Palma",
		state: "MG"
	},
	{
		ibgeCode: "3146750",
		cityName: "Palmópolis",
		state: "MG"
	},
	{
		ibgeCode: "3146909",
		cityName: "Papagaios",
		state: "MG"
	},
	{
		ibgeCode: "3147105",
		cityName: "Pará de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3147006",
		cityName: "Paracatu",
		state: "MG"
	},
	{
		ibgeCode: "3147204",
		cityName: "Paraguaçu",
		state: "MG"
	},
	{
		ibgeCode: "3147303",
		cityName: "Paraisópolis",
		state: "MG"
	},
	{
		ibgeCode: "3147402",
		cityName: "Paraopeba",
		state: "MG"
	},
	{
		ibgeCode: "3147600",
		cityName: "Passa Quatro",
		state: "MG"
	},
	{
		ibgeCode: "3147709",
		cityName: "Passa Tempo",
		state: "MG"
	},
	{
		ibgeCode: "3147808",
		cityName: "Passa Vinte",
		state: "MG"
	},
	{
		ibgeCode: "3147501",
		cityName: "Passabém",
		state: "MG"
	},
	{
		ibgeCode: "3147907",
		cityName: "Passos",
		state: "MG"
	},
	{
		ibgeCode: "3147956",
		cityName: "Patis",
		state: "MG"
	},
	{
		ibgeCode: "3148004",
		cityName: "Patos de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3148103",
		cityName: "Patrocínio",
		state: "MG"
	},
	{
		ibgeCode: "3148202",
		cityName: "Patrocínio do Muriaé",
		state: "MG"
	},
	{
		ibgeCode: "3148301",
		cityName: "Paula Cândido",
		state: "MG"
	},
	{
		ibgeCode: "3148400",
		cityName: "Paulistas",
		state: "MG"
	},
	{
		ibgeCode: "3148509",
		cityName: "Pavão",
		state: "MG"
	},
	{
		ibgeCode: "3148608",
		cityName: "Peçanha",
		state: "MG"
	},
	{
		ibgeCode: "3148707",
		cityName: "Pedra Azul",
		state: "MG"
	},
	{
		ibgeCode: "3148756",
		cityName: "Pedra Bonita",
		state: "MG"
	},
	{
		ibgeCode: "3148806",
		cityName: "Pedra do Anta",
		state: "MG"
	},
	{
		ibgeCode: "3148905",
		cityName: "Pedra do Indaiá",
		state: "MG"
	},
	{
		ibgeCode: "3149002",
		cityName: "Pedra Dourada",
		state: "MG"
	},
	{
		ibgeCode: "3149101",
		cityName: "Pedralva",
		state: "MG"
	},
	{
		ibgeCode: "3149150",
		cityName: "Pedras de Maria da Cruz",
		state: "MG"
	},
	{
		ibgeCode: "3149200",
		cityName: "Pedrinópolis",
		state: "MG"
	},
	{
		ibgeCode: "3149309",
		cityName: "Pedro Leopoldo",
		state: "MG"
	},
	{
		ibgeCode: "3149408",
		cityName: "Pedro Teixeira",
		state: "MG"
	},
	{
		ibgeCode: "3149507",
		cityName: "Pequeri",
		state: "MG"
	},
	{
		ibgeCode: "3149606",
		cityName: "Pequi",
		state: "MG"
	},
	{
		ibgeCode: "3149705",
		cityName: "Perdigão",
		state: "MG"
	},
	{
		ibgeCode: "3149804",
		cityName: "Perdizes",
		state: "MG"
	},
	{
		ibgeCode: "3149903",
		cityName: "Perdões",
		state: "MG"
	},
	{
		ibgeCode: "3149952",
		cityName: "Periquito",
		state: "MG"
	},
	{
		ibgeCode: "3150000",
		cityName: "Pescador",
		state: "MG"
	},
	{
		ibgeCode: "3150109",
		cityName: "Piau",
		state: "MG"
	},
	{
		ibgeCode: "3150158",
		cityName: "Piedade de Caratinga",
		state: "MG"
	},
	{
		ibgeCode: "3150208",
		cityName: "Piedade de Ponte Nova",
		state: "MG"
	},
	{
		ibgeCode: "3150307",
		cityName: "Piedade do Rio Grande",
		state: "MG"
	},
	{
		ibgeCode: "3150406",
		cityName: "Piedade dos Gerais",
		state: "MG"
	},
	{
		ibgeCode: "3150505",
		cityName: "Pimenta",
		state: "MG"
	},
	{
		ibgeCode: "3150539",
		cityName: "Pingo-d'Água",
		state: "MG"
	},
	{
		ibgeCode: "3150570",
		cityName: "Pintópolis",
		state: "MG"
	},
	{
		ibgeCode: "3150604",
		cityName: "Piracema",
		state: "MG"
	},
	{
		ibgeCode: "3150703",
		cityName: "Pirajuba",
		state: "MG"
	},
	{
		ibgeCode: "3150802",
		cityName: "Piranga",
		state: "MG"
	},
	{
		ibgeCode: "3150901",
		cityName: "Piranguçu",
		state: "MG"
	},
	{
		ibgeCode: "3151008",
		cityName: "Piranguinho",
		state: "MG"
	},
	{
		ibgeCode: "3151107",
		cityName: "Pirapetinga",
		state: "MG"
	},
	{
		ibgeCode: "3151206",
		cityName: "Pirapora",
		state: "MG"
	},
	{
		ibgeCode: "3151305",
		cityName: "Piraúba",
		state: "MG"
	},
	{
		ibgeCode: "3151404",
		cityName: "Pitangui",
		state: "MG"
	},
	{
		ibgeCode: "3151503",
		cityName: "Piumhi",
		state: "MG"
	},
	{
		ibgeCode: "3151602",
		cityName: "Planura",
		state: "MG"
	},
	{
		ibgeCode: "3151701",
		cityName: "Poço Fundo",
		state: "MG"
	},
	{
		ibgeCode: "3151800",
		cityName: "Poços de Caldas",
		state: "MG"
	},
	{
		ibgeCode: "3151909",
		cityName: "Pocrane",
		state: "MG"
	},
	{
		ibgeCode: "3152006",
		cityName: "Pompéu",
		state: "MG"
	},
	{
		ibgeCode: "3152105",
		cityName: "Ponte Nova",
		state: "MG"
	},
	{
		ibgeCode: "3152131",
		cityName: "Ponto Chique",
		state: "MG"
	},
	{
		ibgeCode: "3152170",
		cityName: "Ponto dos Volantes",
		state: "MG"
	},
	{
		ibgeCode: "3152204",
		cityName: "Porteirinha",
		state: "MG"
	},
	{
		ibgeCode: "3152303",
		cityName: "Porto Firme",
		state: "MG"
	},
	{
		ibgeCode: "3152402",
		cityName: "Poté",
		state: "MG"
	},
	{
		ibgeCode: "3152501",
		cityName: "Pouso Alegre",
		state: "MG"
	},
	{
		ibgeCode: "3152600",
		cityName: "Pouso Alto",
		state: "MG"
	},
	{
		ibgeCode: "3152709",
		cityName: "Prados",
		state: "MG"
	},
	{
		ibgeCode: "3152808",
		cityName: "Prata",
		state: "MG"
	},
	{
		ibgeCode: "3152907",
		cityName: "Pratápolis",
		state: "MG"
	},
	{
		ibgeCode: "3153004",
		cityName: "Pratinha",
		state: "MG"
	},
	{
		ibgeCode: "3153103",
		cityName: "Presidente Bernardes",
		state: "MG"
	},
	{
		ibgeCode: "3153202",
		cityName: "Presidente Juscelino",
		state: "MG"
	},
	{
		ibgeCode: "3153301",
		cityName: "Presidente Kubitschek",
		state: "MG"
	},
	{
		ibgeCode: "3153400",
		cityName: "Presidente Olegário",
		state: "MG"
	},
	{
		ibgeCode: "3153608",
		cityName: "Prudente de Morais",
		state: "MG"
	},
	{
		ibgeCode: "3153707",
		cityName: "Quartel Geral",
		state: "MG"
	},
	{
		ibgeCode: "3153806",
		cityName: "Queluzito",
		state: "MG"
	},
	{
		ibgeCode: "3153905",
		cityName: "Raposos",
		state: "MG"
	},
	{
		ibgeCode: "3154002",
		cityName: "Raul Soares",
		state: "MG"
	},
	{
		ibgeCode: "3154101",
		cityName: "Recreio",
		state: "MG"
	},
	{
		ibgeCode: "3154150",
		cityName: "Reduto",
		state: "MG"
	},
	{
		ibgeCode: "3154200",
		cityName: "Resende Costa",
		state: "MG"
	},
	{
		ibgeCode: "3154309",
		cityName: "Resplendor",
		state: "MG"
	},
	{
		ibgeCode: "3154408",
		cityName: "Ressaquinha",
		state: "MG"
	},
	{
		ibgeCode: "3154457",
		cityName: "Riachinho",
		state: "MG"
	},
	{
		ibgeCode: "3154507",
		cityName: "Riacho dos Machados",
		state: "MG"
	},
	{
		ibgeCode: "3154606",
		cityName: "Ribeirão das Neves",
		state: "MG"
	},
	{
		ibgeCode: "3154705",
		cityName: "Ribeirão Vermelho",
		state: "MG"
	},
	{
		ibgeCode: "3154804",
		cityName: "Rio Acima",
		state: "MG"
	},
	{
		ibgeCode: "3154903",
		cityName: "Rio Casca",
		state: "MG"
	},
	{
		ibgeCode: "3155108",
		cityName: "Rio do Prado",
		state: "MG"
	},
	{
		ibgeCode: "3155009",
		cityName: "Rio Doce",
		state: "MG"
	},
	{
		ibgeCode: "3155207",
		cityName: "Rio Espera",
		state: "MG"
	},
	{
		ibgeCode: "3155306",
		cityName: "Rio Manso",
		state: "MG"
	},
	{
		ibgeCode: "3155405",
		cityName: "Rio Novo",
		state: "MG"
	},
	{
		ibgeCode: "3155504",
		cityName: "Rio Paranaíba",
		state: "MG"
	},
	{
		ibgeCode: "3155603",
		cityName: "Rio Pardo de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3155702",
		cityName: "Rio Piracicaba",
		state: "MG"
	},
	{
		ibgeCode: "3155801",
		cityName: "Rio Pomba",
		state: "MG"
	},
	{
		ibgeCode: "3155900",
		cityName: "Rio Preto",
		state: "MG"
	},
	{
		ibgeCode: "3156007",
		cityName: "Rio Vermelho",
		state: "MG"
	},
	{
		ibgeCode: "3156106",
		cityName: "Ritápolis",
		state: "MG"
	},
	{
		ibgeCode: "3156205",
		cityName: "Rochedo de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3156304",
		cityName: "Rodeiro",
		state: "MG"
	},
	{
		ibgeCode: "3156403",
		cityName: "Romaria",
		state: "MG"
	},
	{
		ibgeCode: "3156452",
		cityName: "Rosário da Limeira",
		state: "MG"
	},
	{
		ibgeCode: "3156502",
		cityName: "Rubelita",
		state: "MG"
	},
	{
		ibgeCode: "3156601",
		cityName: "Rubim",
		state: "MG"
	},
	{
		ibgeCode: "3156700",
		cityName: "Sabará",
		state: "MG"
	},
	{
		ibgeCode: "3156809",
		cityName: "Sabinópolis",
		state: "MG"
	},
	{
		ibgeCode: "3156908",
		cityName: "Sacramento",
		state: "MG"
	},
	{
		ibgeCode: "3157005",
		cityName: "Salinas",
		state: "MG"
	},
	{
		ibgeCode: "3157104",
		cityName: "Salto da Divisa",
		state: "MG"
	},
	{
		ibgeCode: "3157203",
		cityName: "Santa Bárbara",
		state: "MG"
	},
	{
		ibgeCode: "3157252",
		cityName: "Santa Bárbara do Leste",
		state: "MG"
	},
	{
		ibgeCode: "3157278",
		cityName: "Santa Bárbara do Monte Verde",
		state: "MG"
	},
	{
		ibgeCode: "3157302",
		cityName: "Santa Bárbara do Tugúrio",
		state: "MG"
	},
	{
		ibgeCode: "3157336",
		cityName: "Santa Cruz de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3157377",
		cityName: "Santa Cruz de Salinas",
		state: "MG"
	},
	{
		ibgeCode: "3157401",
		cityName: "Santa Cruz do Escalvado",
		state: "MG"
	},
	{
		ibgeCode: "3157500",
		cityName: "Santa Efigênia de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3157609",
		cityName: "Santa Fé de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3157658",
		cityName: "Santa Helena de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3157708",
		cityName: "Santa Juliana",
		state: "MG"
	},
	{
		ibgeCode: "3157807",
		cityName: "Santa Luzia",
		state: "MG"
	},
	{
		ibgeCode: "3157906",
		cityName: "Santa Margarida",
		state: "MG"
	},
	{
		ibgeCode: "3158003",
		cityName: "Santa Maria de Itabira",
		state: "MG"
	},
	{
		ibgeCode: "3158102",
		cityName: "Santa Maria do Salto",
		state: "MG"
	},
	{
		ibgeCode: "3158201",
		cityName: "Santa Maria do Suaçuí",
		state: "MG"
	},
	{
		ibgeCode: "3159209",
		cityName: "Santa Rita de Caldas",
		state: "MG"
	},
	{
		ibgeCode: "3159407",
		cityName: "Santa Rita de Ibitipoca",
		state: "MG"
	},
	{
		ibgeCode: "3159308",
		cityName: "Santa Rita de Jacutinga",
		state: "MG"
	},
	{
		ibgeCode: "3159357",
		cityName: "Santa Rita de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3159506",
		cityName: "Santa Rita do Itueto",
		state: "MG"
	},
	{
		ibgeCode: "3159605",
		cityName: "Santa Rita do Sapucaí",
		state: "MG"
	},
	{
		ibgeCode: "3159704",
		cityName: "Santa Rosa da Serra",
		state: "MG"
	},
	{
		ibgeCode: "3159803",
		cityName: "Santa Vitória",
		state: "MG"
	},
	{
		ibgeCode: "3158300",
		cityName: "Santana da Vargem",
		state: "MG"
	},
	{
		ibgeCode: "3158409",
		cityName: "Santana de Cataguases",
		state: "MG"
	},
	{
		ibgeCode: "3158508",
		cityName: "Santana de Pirapama",
		state: "MG"
	},
	{
		ibgeCode: "3158607",
		cityName: "Santana do Deserto",
		state: "MG"
	},
	{
		ibgeCode: "3158706",
		cityName: "Santana do Garambéu",
		state: "MG"
	},
	{
		ibgeCode: "3158805",
		cityName: "Santana do Jacaré",
		state: "MG"
	},
	{
		ibgeCode: "3158904",
		cityName: "Santana do Manhuaçu",
		state: "MG"
	},
	{
		ibgeCode: "3158953",
		cityName: "Santana do Paraíso",
		state: "MG"
	},
	{
		ibgeCode: "3159001",
		cityName: "Santana do Riacho",
		state: "MG"
	},
	{
		ibgeCode: "3159100",
		cityName: "Santana dos Montes",
		state: "MG"
	},
	{
		ibgeCode: "3159902",
		cityName: "Santo Antônio do Amparo",
		state: "MG"
	},
	{
		ibgeCode: "3160009",
		cityName: "Santo Antônio do Aventureiro",
		state: "MG"
	},
	{
		ibgeCode: "3160108",
		cityName: "Santo Antônio do Grama",
		state: "MG"
	},
	{
		ibgeCode: "3160207",
		cityName: "Santo Antônio do Itambé",
		state: "MG"
	},
	{
		ibgeCode: "3160306",
		cityName: "Santo Antônio do Jacinto",
		state: "MG"
	},
	{
		ibgeCode: "3160405",
		cityName: "Santo Antônio do Monte",
		state: "MG"
	},
	{
		ibgeCode: "3160454",
		cityName: "Santo Antônio do Retiro",
		state: "MG"
	},
	{
		ibgeCode: "3160504",
		cityName: "Santo Antônio do Rio Abaixo",
		state: "MG"
	},
	{
		ibgeCode: "3160603",
		cityName: "Santo Hipólito",
		state: "MG"
	},
	{
		ibgeCode: "3160702",
		cityName: "Santos Dumont",
		state: "MG"
	},
	{
		ibgeCode: "3160801",
		cityName: "São Bento Abade",
		state: "MG"
	},
	{
		ibgeCode: "3160900",
		cityName: "São Brás do Suaçuí",
		state: "MG"
	},
	{
		ibgeCode: "3160959",
		cityName: "São Domingos das Dores",
		state: "MG"
	},
	{
		ibgeCode: "3161007",
		cityName: "São Domingos do Prata",
		state: "MG"
	},
	{
		ibgeCode: "3161056",
		cityName: "São Félix de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3161106",
		cityName: "São Francisco",
		state: "MG"
	},
	{
		ibgeCode: "3161205",
		cityName: "São Francisco de Paula",
		state: "MG"
	},
	{
		ibgeCode: "3161304",
		cityName: "São Francisco de Sales",
		state: "MG"
	},
	{
		ibgeCode: "3161403",
		cityName: "São Francisco do Glória",
		state: "MG"
	},
	{
		ibgeCode: "3161502",
		cityName: "São Geraldo",
		state: "MG"
	},
	{
		ibgeCode: "3161601",
		cityName: "São Geraldo da Piedade",
		state: "MG"
	},
	{
		ibgeCode: "3161650",
		cityName: "São Geraldo do Baixio",
		state: "MG"
	},
	{
		ibgeCode: "3161700",
		cityName: "São Gonçalo do Abaeté",
		state: "MG"
	},
	{
		ibgeCode: "3161809",
		cityName: "São Gonçalo do Pará",
		state: "MG"
	},
	{
		ibgeCode: "3161908",
		cityName: "São Gonçalo do Rio Abaixo",
		state: "MG"
	},
	{
		ibgeCode: "3125507",
		cityName: "São Gonçalo do Rio Preto",
		state: "MG"
	},
	{
		ibgeCode: "3162005",
		cityName: "São Gonçalo do Sapucaí",
		state: "MG"
	},
	{
		ibgeCode: "3162104",
		cityName: "São Gotardo",
		state: "MG"
	},
	{
		ibgeCode: "3162203",
		cityName: "São João Batista do Glória",
		state: "MG"
	},
	{
		ibgeCode: "3162252",
		cityName: "São João da Lagoa",
		state: "MG"
	},
	{
		ibgeCode: "3162302",
		cityName: "São João da Mata",
		state: "MG"
	},
	{
		ibgeCode: "3162401",
		cityName: "São João da Ponte",
		state: "MG"
	},
	{
		ibgeCode: "3162450",
		cityName: "São João das Missões",
		state: "MG"
	},
	{
		ibgeCode: "3162500",
		cityName: "São João del Rei",
		state: "MG"
	},
	{
		ibgeCode: "3162559",
		cityName: "São João do Manhuaçu",
		state: "MG"
	},
	{
		ibgeCode: "3162575",
		cityName: "São João do Manteninha",
		state: "MG"
	},
	{
		ibgeCode: "3162609",
		cityName: "São João do Oriente",
		state: "MG"
	},
	{
		ibgeCode: "3162658",
		cityName: "São João do Pacuí",
		state: "MG"
	},
	{
		ibgeCode: "3162708",
		cityName: "São João do Paraíso",
		state: "MG"
	},
	{
		ibgeCode: "3162807",
		cityName: "São João Evangelista",
		state: "MG"
	},
	{
		ibgeCode: "3162906",
		cityName: "São João Nepomuceno",
		state: "MG"
	},
	{
		ibgeCode: "3162922",
		cityName: "São Joaquim de Bicas",
		state: "MG"
	},
	{
		ibgeCode: "3162948",
		cityName: "São José da Barra",
		state: "MG"
	},
	{
		ibgeCode: "3162955",
		cityName: "São José da Lapa",
		state: "MG"
	},
	{
		ibgeCode: "3163003",
		cityName: "São José da Safira",
		state: "MG"
	},
	{
		ibgeCode: "3163102",
		cityName: "São José da Varginha",
		state: "MG"
	},
	{
		ibgeCode: "3163201",
		cityName: "São José do Alegre",
		state: "MG"
	},
	{
		ibgeCode: "3163300",
		cityName: "São José do Divino",
		state: "MG"
	},
	{
		ibgeCode: "3163409",
		cityName: "São José do Goiabal",
		state: "MG"
	},
	{
		ibgeCode: "3163508",
		cityName: "São José do Jacuri",
		state: "MG"
	},
	{
		ibgeCode: "3163607",
		cityName: "São José do Mantimento",
		state: "MG"
	},
	{
		ibgeCode: "3163706",
		cityName: "São Lourenço",
		state: "MG"
	},
	{
		ibgeCode: "3163805",
		cityName: "São Miguel do Anta",
		state: "MG"
	},
	{
		ibgeCode: "3163904",
		cityName: "São Pedro da União",
		state: "MG"
	},
	{
		ibgeCode: "3164100",
		cityName: "São Pedro do Suaçuí",
		state: "MG"
	},
	{
		ibgeCode: "3164001",
		cityName: "São Pedro dos Ferros",
		state: "MG"
	},
	{
		ibgeCode: "3164209",
		cityName: "São Romão",
		state: "MG"
	},
	{
		ibgeCode: "3164308",
		cityName: "São Roque de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3164407",
		cityName: "São Sebastião da Bela Vista",
		state: "MG"
	},
	{
		ibgeCode: "3164431",
		cityName: "São Sebastião da Vargem Alegre",
		state: "MG"
	},
	{
		ibgeCode: "3164472",
		cityName: "São Sebastião do Anta",
		state: "MG"
	},
	{
		ibgeCode: "3164506",
		cityName: "São Sebastião do Maranhão",
		state: "MG"
	},
	{
		ibgeCode: "3164605",
		cityName: "São Sebastião do Oeste",
		state: "MG"
	},
	{
		ibgeCode: "3164704",
		cityName: "São Sebastião do Paraíso",
		state: "MG"
	},
	{
		ibgeCode: "3164803",
		cityName: "São Sebastião do Rio Preto",
		state: "MG"
	},
	{
		ibgeCode: "3164902",
		cityName: "São Sebastião do Rio Verde",
		state: "MG"
	},
	{
		ibgeCode: "3165008",
		cityName: "São Tiago",
		state: "MG"
	},
	{
		ibgeCode: "3165107",
		cityName: "São Tomás de Aquino",
		state: "MG"
	},
	{
		ibgeCode: "3165206",
		cityName: "São Tomé das Letras",
		state: "MG"
	},
	{
		ibgeCode: "3165305",
		cityName: "São Vicente de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3165404",
		cityName: "Sapucaí-Mirim",
		state: "MG"
	},
	{
		ibgeCode: "3165503",
		cityName: "Sardoá",
		state: "MG"
	},
	{
		ibgeCode: "3165537",
		cityName: "Sarzedo",
		state: "MG"
	},
	{
		ibgeCode: "3165560",
		cityName: "Sem-Peixe",
		state: "MG"
	},
	{
		ibgeCode: "3165578",
		cityName: "Senador Amaral",
		state: "MG"
	},
	{
		ibgeCode: "3165602",
		cityName: "Senador Cortes",
		state: "MG"
	},
	{
		ibgeCode: "3165701",
		cityName: "Senador Firmino",
		state: "MG"
	},
	{
		ibgeCode: "3165800",
		cityName: "Senador José Bento",
		state: "MG"
	},
	{
		ibgeCode: "3165909",
		cityName: "Senador Modestino Gonçalves",
		state: "MG"
	},
	{
		ibgeCode: "3166006",
		cityName: "Senhora de Oliveira",
		state: "MG"
	},
	{
		ibgeCode: "3166105",
		cityName: "Senhora do Porto",
		state: "MG"
	},
	{
		ibgeCode: "3166204",
		cityName: "Senhora dos Remédios",
		state: "MG"
	},
	{
		ibgeCode: "3166303",
		cityName: "Sericita",
		state: "MG"
	},
	{
		ibgeCode: "3166402",
		cityName: "Seritinga",
		state: "MG"
	},
	{
		ibgeCode: "3166501",
		cityName: "Serra Azul de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3166600",
		cityName: "Serra da Saudade",
		state: "MG"
	},
	{
		ibgeCode: "3166808",
		cityName: "Serra do Salitre",
		state: "MG"
	},
	{
		ibgeCode: "3166709",
		cityName: "Serra dos Aimorés",
		state: "MG"
	},
	{
		ibgeCode: "3166907",
		cityName: "Serrania",
		state: "MG"
	},
	{
		ibgeCode: "3166956",
		cityName: "Serranópolis de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3167004",
		cityName: "Serranos",
		state: "MG"
	},
	{
		ibgeCode: "3167103",
		cityName: "Serro",
		state: "MG"
	},
	{
		ibgeCode: "3167202",
		cityName: "Sete Lagoas",
		state: "MG"
	},
	{
		ibgeCode: "3165552",
		cityName: "Setubinha",
		state: "MG"
	},
	{
		ibgeCode: "3167301",
		cityName: "Silveirânia",
		state: "MG"
	},
	{
		ibgeCode: "3167400",
		cityName: "Silvianópolis",
		state: "MG"
	},
	{
		ibgeCode: "3167509",
		cityName: "Simão Pereira",
		state: "MG"
	},
	{
		ibgeCode: "3167608",
		cityName: "Simonésia",
		state: "MG"
	},
	{
		ibgeCode: "3167707",
		cityName: "Sobrália",
		state: "MG"
	},
	{
		ibgeCode: "3167806",
		cityName: "Soledade de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3167905",
		cityName: "Tabuleiro",
		state: "MG"
	},
	{
		ibgeCode: "3168002",
		cityName: "Taiobeiras",
		state: "MG"
	},
	{
		ibgeCode: "3168051",
		cityName: "Taparuba",
		state: "MG"
	},
	{
		ibgeCode: "3168101",
		cityName: "Tapira",
		state: "MG"
	},
	{
		ibgeCode: "3168200",
		cityName: "Tapiraí",
		state: "MG"
	},
	{
		ibgeCode: "3168309",
		cityName: "Taquaraçu de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3168408",
		cityName: "Tarumirim",
		state: "MG"
	},
	{
		ibgeCode: "3168507",
		cityName: "Teixeiras",
		state: "MG"
	},
	{
		ibgeCode: "3168606",
		cityName: "Teófilo Otoni",
		state: "MG"
	},
	{
		ibgeCode: "3168705",
		cityName: "Timóteo",
		state: "MG"
	},
	{
		ibgeCode: "3168804",
		cityName: "Tiradentes",
		state: "MG"
	},
	{
		ibgeCode: "3168903",
		cityName: "Tiros",
		state: "MG"
	},
	{
		ibgeCode: "3169000",
		cityName: "Tocantins",
		state: "MG"
	},
	{
		ibgeCode: "3169059",
		cityName: "Tocos do Moji",
		state: "MG"
	},
	{
		ibgeCode: "3169109",
		cityName: "Toledo",
		state: "MG"
	},
	{
		ibgeCode: "3169208",
		cityName: "Tombos",
		state: "MG"
	},
	{
		ibgeCode: "3169307",
		cityName: "Três Corações",
		state: "MG"
	},
	{
		ibgeCode: "3169356",
		cityName: "Três Marias",
		state: "MG"
	},
	{
		ibgeCode: "3169406",
		cityName: "Três Pontas",
		state: "MG"
	},
	{
		ibgeCode: "3169505",
		cityName: "Tumiritinga",
		state: "MG"
	},
	{
		ibgeCode: "3169604",
		cityName: "Tupaciguara",
		state: "MG"
	},
	{
		ibgeCode: "3169703",
		cityName: "Turmalina",
		state: "MG"
	},
	{
		ibgeCode: "3169802",
		cityName: "Turvolândia",
		state: "MG"
	},
	{
		ibgeCode: "3169901",
		cityName: "Ubá",
		state: "MG"
	},
	{
		ibgeCode: "3170008",
		cityName: "Ubaí",
		state: "MG"
	},
	{
		ibgeCode: "3170057",
		cityName: "Ubaporanga",
		state: "MG"
	},
	{
		ibgeCode: "3170107",
		cityName: "Uberaba",
		state: "MG"
	},
	{
		ibgeCode: "3170206",
		cityName: "Uberlândia",
		state: "MG"
	},
	{
		ibgeCode: "3170305",
		cityName: "Umburatiba",
		state: "MG"
	},
	{
		ibgeCode: "3170404",
		cityName: "Unaí",
		state: "MG"
	},
	{
		ibgeCode: "3170438",
		cityName: "União de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3170479",
		cityName: "Uruana de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3170503",
		cityName: "Urucânia",
		state: "MG"
	},
	{
		ibgeCode: "3170529",
		cityName: "Urucuia",
		state: "MG"
	},
	{
		ibgeCode: "3170578",
		cityName: "Vargem Alegre",
		state: "MG"
	},
	{
		ibgeCode: "3170602",
		cityName: "Vargem Bonita",
		state: "MG"
	},
	{
		ibgeCode: "3170651",
		cityName: "Vargem Grande do Rio Pardo",
		state: "MG"
	},
	{
		ibgeCode: "3170701",
		cityName: "Varginha",
		state: "MG"
	},
	{
		ibgeCode: "3170750",
		cityName: "Varjão de Minas",
		state: "MG"
	},
	{
		ibgeCode: "3170800",
		cityName: "Várzea da Palma",
		state: "MG"
	},
	{
		ibgeCode: "3170909",
		cityName: "Varzelândia",
		state: "MG"
	},
	{
		ibgeCode: "3171006",
		cityName: "Vazante",
		state: "MG"
	},
	{
		ibgeCode: "3171030",
		cityName: "Verdelândia",
		state: "MG"
	},
	{
		ibgeCode: "3171071",
		cityName: "Veredinha",
		state: "MG"
	},
	{
		ibgeCode: "3171105",
		cityName: "Veríssimo",
		state: "MG"
	},
	{
		ibgeCode: "3171154",
		cityName: "Vermelho Novo",
		state: "MG"
	},
	{
		ibgeCode: "3171204",
		cityName: "Vespasiano",
		state: "MG"
	},
	{
		ibgeCode: "3171303",
		cityName: "Viçosa",
		state: "MG"
	},
	{
		ibgeCode: "3171402",
		cityName: "Vieiras",
		state: "MG"
	},
	{
		ibgeCode: "3171600",
		cityName: "Virgem da Lapa",
		state: "MG"
	},
	{
		ibgeCode: "3171709",
		cityName: "Virgínia",
		state: "MG"
	},
	{
		ibgeCode: "3171808",
		cityName: "Virginópolis",
		state: "MG"
	},
	{
		ibgeCode: "3171907",
		cityName: "Virgolândia",
		state: "MG"
	},
	{
		ibgeCode: "3172004",
		cityName: "Visconde do Rio Branco",
		state: "MG"
	},
	{
		ibgeCode: "3172103",
		cityName: "Volta Grande",
		state: "MG"
	},
	{
		ibgeCode: "3172202",
		cityName: "Wenceslau Braz",
		state: "MG"
	}
];
var PA = [
	{
		ibgeCode: "1500107",
		cityName: "Abaetetuba",
		state: "PA"
	},
	{
		ibgeCode: "1500131",
		cityName: "Abel Figueiredo",
		state: "PA"
	},
	{
		ibgeCode: "1500206",
		cityName: "Acará",
		state: "PA"
	},
	{
		ibgeCode: "1500305",
		cityName: "Afuá",
		state: "PA"
	},
	{
		ibgeCode: "1500347",
		cityName: "Água Azul do Norte",
		state: "PA"
	},
	{
		ibgeCode: "1500404",
		cityName: "Alenquer",
		state: "PA"
	},
	{
		ibgeCode: "1500503",
		cityName: "Almeirim",
		state: "PA"
	},
	{
		ibgeCode: "1500602",
		cityName: "Altamira",
		state: "PA"
	},
	{
		ibgeCode: "1500701",
		cityName: "Anajás",
		state: "PA"
	},
	{
		ibgeCode: "1500800",
		cityName: "Ananindeua",
		state: "PA"
	},
	{
		ibgeCode: "1500859",
		cityName: "Anapu",
		state: "PA"
	},
	{
		ibgeCode: "1500909",
		cityName: "Augusto Corrêa",
		state: "PA"
	},
	{
		ibgeCode: "1500958",
		cityName: "Aurora do Pará",
		state: "PA"
	},
	{
		ibgeCode: "1501006",
		cityName: "Aveiro",
		state: "PA"
	},
	{
		ibgeCode: "1501105",
		cityName: "Bagre",
		state: "PA"
	},
	{
		ibgeCode: "1501204",
		cityName: "Baião",
		state: "PA"
	},
	{
		ibgeCode: "1501253",
		cityName: "Bannach",
		state: "PA"
	},
	{
		ibgeCode: "1501303",
		cityName: "Barcarena",
		state: "PA"
	},
	{
		ibgeCode: "1501402",
		cityName: "Belém",
		state: "PA"
	},
	{
		ibgeCode: "1501451",
		cityName: "Belterra",
		state: "PA"
	},
	{
		ibgeCode: "1501501",
		cityName: "Benevides",
		state: "PA"
	},
	{
		ibgeCode: "1501576",
		cityName: "Bom Jesus do Tocantins",
		state: "PA"
	},
	{
		ibgeCode: "1501600",
		cityName: "Bonito",
		state: "PA"
	},
	{
		ibgeCode: "1501709",
		cityName: "Bragança",
		state: "PA"
	},
	{
		ibgeCode: "1501725",
		cityName: "Brasil Novo",
		state: "PA"
	},
	{
		ibgeCode: "1501758",
		cityName: "Brejo Grande do Araguaia",
		state: "PA"
	},
	{
		ibgeCode: "1501782",
		cityName: "Breu Branco",
		state: "PA"
	},
	{
		ibgeCode: "1501808",
		cityName: "Breves",
		state: "PA"
	},
	{
		ibgeCode: "1501907",
		cityName: "Bujaru",
		state: "PA"
	},
	{
		ibgeCode: "1502004",
		cityName: "Cachoeira do Arari",
		state: "PA"
	},
	{
		ibgeCode: "1501956",
		cityName: "Cachoeira do Piriá",
		state: "PA"
	},
	{
		ibgeCode: "1502103",
		cityName: "Cametá",
		state: "PA"
	},
	{
		ibgeCode: "1502152",
		cityName: "Canaã dos Carajás",
		state: "PA"
	},
	{
		ibgeCode: "1502202",
		cityName: "Capanema",
		state: "PA"
	},
	{
		ibgeCode: "1502301",
		cityName: "Capitão Poço",
		state: "PA"
	},
	{
		ibgeCode: "1502400",
		cityName: "Castanhal",
		state: "PA"
	},
	{
		ibgeCode: "1502509",
		cityName: "Chaves",
		state: "PA"
	},
	{
		ibgeCode: "1502608",
		cityName: "Colares",
		state: "PA"
	},
	{
		ibgeCode: "1502707",
		cityName: "Conceição do Araguaia",
		state: "PA"
	},
	{
		ibgeCode: "1502756",
		cityName: "Concórdia do Pará",
		state: "PA"
	},
	{
		ibgeCode: "1502764",
		cityName: "Cumaru do Norte",
		state: "PA"
	},
	{
		ibgeCode: "1502772",
		cityName: "Curionópolis",
		state: "PA"
	},
	{
		ibgeCode: "1502806",
		cityName: "Curralinho",
		state: "PA"
	},
	{
		ibgeCode: "1502855",
		cityName: "Curuá",
		state: "PA"
	},
	{
		ibgeCode: "1502905",
		cityName: "Curuçá",
		state: "PA"
	},
	{
		ibgeCode: "1502939",
		cityName: "Dom Eliseu",
		state: "PA"
	},
	{
		ibgeCode: "1502954",
		cityName: "Eldorado do Carajás",
		state: "PA"
	},
	{
		ibgeCode: "1503002",
		cityName: "Faro",
		state: "PA"
	},
	{
		ibgeCode: "1503044",
		cityName: "Floresta do Araguaia",
		state: "PA"
	},
	{
		ibgeCode: "1503077",
		cityName: "Garrafão do Norte",
		state: "PA"
	},
	{
		ibgeCode: "1503093",
		cityName: "Goianésia do Pará",
		state: "PA"
	},
	{
		ibgeCode: "1503101",
		cityName: "Gurupá",
		state: "PA"
	},
	{
		ibgeCode: "1503200",
		cityName: "Igarapé-Açu",
		state: "PA"
	},
	{
		ibgeCode: "1503309",
		cityName: "Igarapé-Miri",
		state: "PA"
	},
	{
		ibgeCode: "1503408",
		cityName: "Inhangapi",
		state: "PA"
	},
	{
		ibgeCode: "1503457",
		cityName: "Ipixuna do Pará",
		state: "PA"
	},
	{
		ibgeCode: "1503507",
		cityName: "Irituia",
		state: "PA"
	},
	{
		ibgeCode: "1503606",
		cityName: "Itaituba",
		state: "PA"
	},
	{
		ibgeCode: "1503705",
		cityName: "Itupiranga",
		state: "PA"
	},
	{
		ibgeCode: "1503754",
		cityName: "Jacareacanga",
		state: "PA"
	},
	{
		ibgeCode: "1503804",
		cityName: "Jacundá",
		state: "PA"
	},
	{
		ibgeCode: "1503903",
		cityName: "Juruti",
		state: "PA"
	},
	{
		ibgeCode: "1504000",
		cityName: "Limoeiro do Ajuru",
		state: "PA"
	},
	{
		ibgeCode: "1504059",
		cityName: "Mãe do Rio",
		state: "PA"
	},
	{
		ibgeCode: "1504109",
		cityName: "Magalhães Barata",
		state: "PA"
	},
	{
		ibgeCode: "1504208",
		cityName: "Marabá",
		state: "PA"
	},
	{
		ibgeCode: "1504307",
		cityName: "Maracanã",
		state: "PA"
	},
	{
		ibgeCode: "1504406",
		cityName: "Marapanim",
		state: "PA"
	},
	{
		ibgeCode: "1504422",
		cityName: "Marituba",
		state: "PA"
	},
	{
		ibgeCode: "1504455",
		cityName: "Medicilândia",
		state: "PA"
	},
	{
		ibgeCode: "1504505",
		cityName: "Melgaço",
		state: "PA"
	},
	{
		ibgeCode: "1504604",
		cityName: "Mocajuba",
		state: "PA"
	},
	{
		ibgeCode: "1504703",
		cityName: "Moju",
		state: "PA"
	},
	{
		ibgeCode: "1504752",
		cityName: "Mojuí dos Campos",
		state: "PA"
	},
	{
		ibgeCode: "1504802",
		cityName: "Monte Alegre",
		state: "PA"
	},
	{
		ibgeCode: "1504901",
		cityName: "Muaná",
		state: "PA"
	},
	{
		ibgeCode: "1504950",
		cityName: "Nova Esperança do Piriá",
		state: "PA"
	},
	{
		ibgeCode: "1504976",
		cityName: "Nova Ipixuna",
		state: "PA"
	},
	{
		ibgeCode: "1505007",
		cityName: "Nova Timboteua",
		state: "PA"
	},
	{
		ibgeCode: "1505031",
		cityName: "Novo Progresso",
		state: "PA"
	},
	{
		ibgeCode: "1505064",
		cityName: "Novo Repartimento",
		state: "PA"
	},
	{
		ibgeCode: "1505106",
		cityName: "Óbidos",
		state: "PA"
	},
	{
		ibgeCode: "1505205",
		cityName: "Oeiras do Pará",
		state: "PA"
	},
	{
		ibgeCode: "1505304",
		cityName: "Oriximiná",
		state: "PA"
	},
	{
		ibgeCode: "1505403",
		cityName: "Ourém",
		state: "PA"
	},
	{
		ibgeCode: "1505437",
		cityName: "Ourilândia do Norte",
		state: "PA"
	},
	{
		ibgeCode: "1505486",
		cityName: "Pacajá",
		state: "PA"
	},
	{
		ibgeCode: "1505494",
		cityName: "Palestina do Pará",
		state: "PA"
	},
	{
		ibgeCode: "1505502",
		cityName: "Paragominas",
		state: "PA"
	},
	{
		ibgeCode: "1505536",
		cityName: "Parauapebas",
		state: "PA"
	},
	{
		ibgeCode: "1505551",
		cityName: "Pau D'Arco",
		state: "PA"
	},
	{
		ibgeCode: "1505601",
		cityName: "Peixe-Boi",
		state: "PA"
	},
	{
		ibgeCode: "1505635",
		cityName: "Piçarra",
		state: "PA"
	},
	{
		ibgeCode: "1505650",
		cityName: "Placas",
		state: "PA"
	},
	{
		ibgeCode: "1505700",
		cityName: "Ponta de Pedras",
		state: "PA"
	},
	{
		ibgeCode: "1505809",
		cityName: "Portel",
		state: "PA"
	},
	{
		ibgeCode: "1505908",
		cityName: "Porto de Moz",
		state: "PA"
	},
	{
		ibgeCode: "1506005",
		cityName: "Prainha",
		state: "PA"
	},
	{
		ibgeCode: "1506104",
		cityName: "Primavera",
		state: "PA"
	},
	{
		ibgeCode: "1506112",
		cityName: "Quatipuru",
		state: "PA"
	},
	{
		ibgeCode: "1506138",
		cityName: "Redenção",
		state: "PA"
	},
	{
		ibgeCode: "1506161",
		cityName: "Rio Maria",
		state: "PA"
	},
	{
		ibgeCode: "1506187",
		cityName: "Rondon do Pará",
		state: "PA"
	},
	{
		ibgeCode: "1506195",
		cityName: "Rurópolis",
		state: "PA"
	},
	{
		ibgeCode: "1506203",
		cityName: "Salinópolis",
		state: "PA"
	},
	{
		ibgeCode: "1506302",
		cityName: "Salvaterra",
		state: "PA"
	},
	{
		ibgeCode: "1506351",
		cityName: "Santa Bárbara do Pará",
		state: "PA"
	},
	{
		ibgeCode: "1506401",
		cityName: "Santa Cruz do Arari",
		state: "PA"
	},
	{
		ibgeCode: "1506500",
		cityName: "Santa Izabel do Pará",
		state: "PA"
	},
	{
		ibgeCode: "1506559",
		cityName: "Santa Luzia do Pará",
		state: "PA"
	},
	{
		ibgeCode: "1506583",
		cityName: "Santa Maria das Barreiras",
		state: "PA"
	},
	{
		ibgeCode: "1506609",
		cityName: "Santa Maria do Pará",
		state: "PA"
	},
	{
		ibgeCode: "1506708",
		cityName: "Santana do Araguaia",
		state: "PA"
	},
	{
		ibgeCode: "1506807",
		cityName: "Santarém",
		state: "PA"
	},
	{
		ibgeCode: "1506906",
		cityName: "Santarém Novo",
		state: "PA"
	},
	{
		ibgeCode: "1507003",
		cityName: "Santo Antônio do Tauá",
		state: "PA"
	},
	{
		ibgeCode: "1507102",
		cityName: "São Caetano de Odivelas",
		state: "PA"
	},
	{
		ibgeCode: "1507151",
		cityName: "São Domingos do Araguaia",
		state: "PA"
	},
	{
		ibgeCode: "1507201",
		cityName: "São Domingos do Capim",
		state: "PA"
	},
	{
		ibgeCode: "1507300",
		cityName: "São Félix do Xingu",
		state: "PA"
	},
	{
		ibgeCode: "1507409",
		cityName: "São Francisco do Pará",
		state: "PA"
	},
	{
		ibgeCode: "1507458",
		cityName: "São Geraldo do Araguaia",
		state: "PA"
	},
	{
		ibgeCode: "1507466",
		cityName: "São João da Ponta",
		state: "PA"
	},
	{
		ibgeCode: "1507474",
		cityName: "São João de Pirabas",
		state: "PA"
	},
	{
		ibgeCode: "1507508",
		cityName: "São João do Araguaia",
		state: "PA"
	},
	{
		ibgeCode: "1507607",
		cityName: "São Miguel do Guamá",
		state: "PA"
	},
	{
		ibgeCode: "1507706",
		cityName: "São Sebastião da Boa Vista",
		state: "PA"
	},
	{
		ibgeCode: "1507755",
		cityName: "Sapucaia",
		state: "PA"
	},
	{
		ibgeCode: "1507805",
		cityName: "Senador José Porfírio",
		state: "PA"
	},
	{
		ibgeCode: "1507904",
		cityName: "Soure",
		state: "PA"
	},
	{
		ibgeCode: "1507953",
		cityName: "Tailândia",
		state: "PA"
	},
	{
		ibgeCode: "1507961",
		cityName: "Terra Alta",
		state: "PA"
	},
	{
		ibgeCode: "1507979",
		cityName: "Terra Santa",
		state: "PA"
	},
	{
		ibgeCode: "1508001",
		cityName: "Tomé-Açu",
		state: "PA"
	},
	{
		ibgeCode: "1508035",
		cityName: "Tracuateua",
		state: "PA"
	},
	{
		ibgeCode: "1508050",
		cityName: "Trairão",
		state: "PA"
	},
	{
		ibgeCode: "1508084",
		cityName: "Tucumã",
		state: "PA"
	},
	{
		ibgeCode: "1508100",
		cityName: "Tucuruí",
		state: "PA"
	},
	{
		ibgeCode: "1508126",
		cityName: "Ulianópolis",
		state: "PA"
	},
	{
		ibgeCode: "1508159",
		cityName: "Uruará",
		state: "PA"
	},
	{
		ibgeCode: "1508209",
		cityName: "Vigia",
		state: "PA"
	},
	{
		ibgeCode: "1508308",
		cityName: "Viseu",
		state: "PA"
	},
	{
		ibgeCode: "1508357",
		cityName: "Vitória do Xingu",
		state: "PA"
	},
	{
		ibgeCode: "1508407",
		cityName: "Xinguara",
		state: "PA"
	}
];
var PB = [
	{
		ibgeCode: "2500106",
		cityName: "Água Branca",
		state: "PB"
	},
	{
		ibgeCode: "2500205",
		cityName: "Aguiar",
		state: "PB"
	},
	{
		ibgeCode: "2500304",
		cityName: "Alagoa Grande",
		state: "PB"
	},
	{
		ibgeCode: "2500403",
		cityName: "Alagoa Nova",
		state: "PB"
	},
	{
		ibgeCode: "2500502",
		cityName: "Alagoinha",
		state: "PB"
	},
	{
		ibgeCode: "2500536",
		cityName: "Alcantil",
		state: "PB"
	},
	{
		ibgeCode: "2500577",
		cityName: "Algodão de Jandaíra",
		state: "PB"
	},
	{
		ibgeCode: "2500601",
		cityName: "Alhandra",
		state: "PB"
	},
	{
		ibgeCode: "2500734",
		cityName: "Amparo",
		state: "PB"
	},
	{
		ibgeCode: "2500775",
		cityName: "Aparecida",
		state: "PB"
	},
	{
		ibgeCode: "2500809",
		cityName: "Araçagi",
		state: "PB"
	},
	{
		ibgeCode: "2500908",
		cityName: "Arara",
		state: "PB"
	},
	{
		ibgeCode: "2501005",
		cityName: "Araruna",
		state: "PB"
	},
	{
		ibgeCode: "2501104",
		cityName: "Areia",
		state: "PB"
	},
	{
		ibgeCode: "2501153",
		cityName: "Areia de Baraúnas",
		state: "PB"
	},
	{
		ibgeCode: "2501203",
		cityName: "Areial",
		state: "PB"
	},
	{
		ibgeCode: "2501302",
		cityName: "Aroeiras",
		state: "PB"
	},
	{
		ibgeCode: "2501351",
		cityName: "Assunção",
		state: "PB"
	},
	{
		ibgeCode: "2501401",
		cityName: "Baía da Traição",
		state: "PB"
	},
	{
		ibgeCode: "2501500",
		cityName: "Bananeiras",
		state: "PB"
	},
	{
		ibgeCode: "2501534",
		cityName: "Baraúna",
		state: "PB"
	},
	{
		ibgeCode: "2501609",
		cityName: "Barra de Santa Rosa",
		state: "PB"
	},
	{
		ibgeCode: "2501575",
		cityName: "Barra de Santana",
		state: "PB"
	},
	{
		ibgeCode: "2501708",
		cityName: "Barra de São Miguel",
		state: "PB"
	},
	{
		ibgeCode: "2501807",
		cityName: "Bayeux",
		state: "PB"
	},
	{
		ibgeCode: "2501906",
		cityName: "Belém",
		state: "PB"
	},
	{
		ibgeCode: "2502003",
		cityName: "Belém do Brejo do Cruz",
		state: "PB"
	},
	{
		ibgeCode: "2502052",
		cityName: "Bernardino Batista",
		state: "PB"
	},
	{
		ibgeCode: "2502102",
		cityName: "Boa Ventura",
		state: "PB"
	},
	{
		ibgeCode: "2502151",
		cityName: "Boa Vista",
		state: "PB"
	},
	{
		ibgeCode: "2502201",
		cityName: "Bom Jesus",
		state: "PB"
	},
	{
		ibgeCode: "2502300",
		cityName: "Bom Sucesso",
		state: "PB"
	},
	{
		ibgeCode: "2502409",
		cityName: "Bonito de Santa Fé",
		state: "PB"
	},
	{
		ibgeCode: "2502508",
		cityName: "Boqueirão",
		state: "PB"
	},
	{
		ibgeCode: "2502706",
		cityName: "Borborema",
		state: "PB"
	},
	{
		ibgeCode: "2502805",
		cityName: "Brejo do Cruz",
		state: "PB"
	},
	{
		ibgeCode: "2502904",
		cityName: "Brejo dos Santos",
		state: "PB"
	},
	{
		ibgeCode: "2503001",
		cityName: "Caaporã",
		state: "PB"
	},
	{
		ibgeCode: "2503100",
		cityName: "Cabaceiras",
		state: "PB"
	},
	{
		ibgeCode: "2503209",
		cityName: "Cabedelo",
		state: "PB"
	},
	{
		ibgeCode: "2503308",
		cityName: "Cachoeira dos Índios",
		state: "PB"
	},
	{
		ibgeCode: "2503407",
		cityName: "Cacimba de Areia",
		state: "PB"
	},
	{
		ibgeCode: "2503506",
		cityName: "Cacimba de Dentro",
		state: "PB"
	},
	{
		ibgeCode: "2503555",
		cityName: "Cacimbas",
		state: "PB"
	},
	{
		ibgeCode: "2503605",
		cityName: "Caiçara",
		state: "PB"
	},
	{
		ibgeCode: "2503704",
		cityName: "Cajazeiras",
		state: "PB"
	},
	{
		ibgeCode: "2503753",
		cityName: "Cajazeirinhas",
		state: "PB"
	},
	{
		ibgeCode: "2503803",
		cityName: "Caldas Brandão",
		state: "PB"
	},
	{
		ibgeCode: "2503902",
		cityName: "Camalaú",
		state: "PB"
	},
	{
		ibgeCode: "2504009",
		cityName: "Campina Grande",
		state: "PB"
	},
	{
		ibgeCode: "2504033",
		cityName: "Capim",
		state: "PB"
	},
	{
		ibgeCode: "2504074",
		cityName: "Caraúbas",
		state: "PB"
	},
	{
		ibgeCode: "2504108",
		cityName: "Carrapateira",
		state: "PB"
	},
	{
		ibgeCode: "2504157",
		cityName: "Casserengue",
		state: "PB"
	},
	{
		ibgeCode: "2504207",
		cityName: "Catingueira",
		state: "PB"
	},
	{
		ibgeCode: "2504306",
		cityName: "Catolé do Rocha",
		state: "PB"
	},
	{
		ibgeCode: "2504355",
		cityName: "Caturité",
		state: "PB"
	},
	{
		ibgeCode: "2504405",
		cityName: "Conceição",
		state: "PB"
	},
	{
		ibgeCode: "2504504",
		cityName: "Condado",
		state: "PB"
	},
	{
		ibgeCode: "2504603",
		cityName: "Conde",
		state: "PB"
	},
	{
		ibgeCode: "2504702",
		cityName: "Congo",
		state: "PB"
	},
	{
		ibgeCode: "2504801",
		cityName: "Coremas",
		state: "PB"
	},
	{
		ibgeCode: "2504850",
		cityName: "Coxixola",
		state: "PB"
	},
	{
		ibgeCode: "2504900",
		cityName: "Cruz do Espírito Santo",
		state: "PB"
	},
	{
		ibgeCode: "2505006",
		cityName: "Cubati",
		state: "PB"
	},
	{
		ibgeCode: "2505105",
		cityName: "Cuité",
		state: "PB"
	},
	{
		ibgeCode: "2505238",
		cityName: "Cuité de Mamanguape",
		state: "PB"
	},
	{
		ibgeCode: "2505204",
		cityName: "Cuitegi",
		state: "PB"
	},
	{
		ibgeCode: "2505279",
		cityName: "Curral de Cima",
		state: "PB"
	},
	{
		ibgeCode: "2505303",
		cityName: "Curral Velho",
		state: "PB"
	},
	{
		ibgeCode: "2505352",
		cityName: "Damião",
		state: "PB"
	},
	{
		ibgeCode: "2505402",
		cityName: "Desterro",
		state: "PB"
	},
	{
		ibgeCode: "2505600",
		cityName: "Diamante",
		state: "PB"
	},
	{
		ibgeCode: "2505709",
		cityName: "Dona Inês",
		state: "PB"
	},
	{
		ibgeCode: "2505808",
		cityName: "Duas Estradas",
		state: "PB"
	},
	{
		ibgeCode: "2505907",
		cityName: "Emas",
		state: "PB"
	},
	{
		ibgeCode: "2506004",
		cityName: "Esperança",
		state: "PB"
	},
	{
		ibgeCode: "2506103",
		cityName: "Fagundes",
		state: "PB"
	},
	{
		ibgeCode: "2506202",
		cityName: "Frei Martinho",
		state: "PB"
	},
	{
		ibgeCode: "2506251",
		cityName: "Gado Bravo",
		state: "PB"
	},
	{
		ibgeCode: "2506301",
		cityName: "Guarabira",
		state: "PB"
	},
	{
		ibgeCode: "2506400",
		cityName: "Gurinhém",
		state: "PB"
	},
	{
		ibgeCode: "2506509",
		cityName: "Gurjão",
		state: "PB"
	},
	{
		ibgeCode: "2506608",
		cityName: "Ibiara",
		state: "PB"
	},
	{
		ibgeCode: "2502607",
		cityName: "Igaracy",
		state: "PB"
	},
	{
		ibgeCode: "2506707",
		cityName: "Imaculada",
		state: "PB"
	},
	{
		ibgeCode: "2506806",
		cityName: "Ingá",
		state: "PB"
	},
	{
		ibgeCode: "2506905",
		cityName: "Itabaiana",
		state: "PB"
	},
	{
		ibgeCode: "2507002",
		cityName: "Itaporanga",
		state: "PB"
	},
	{
		ibgeCode: "2507101",
		cityName: "Itapororoca",
		state: "PB"
	},
	{
		ibgeCode: "2507200",
		cityName: "Itatuba",
		state: "PB"
	},
	{
		ibgeCode: "2507309",
		cityName: "Jacaraú",
		state: "PB"
	},
	{
		ibgeCode: "2507408",
		cityName: "Jericó",
		state: "PB"
	},
	{
		ibgeCode: "2507507",
		cityName: "João Pessoa",
		state: "PB"
	},
	{
		ibgeCode: "2513653",
		cityName: "Joca Claudino",
		state: "PB"
	},
	{
		ibgeCode: "2507606",
		cityName: "Juarez Távora",
		state: "PB"
	},
	{
		ibgeCode: "2507705",
		cityName: "Juazeirinho",
		state: "PB"
	},
	{
		ibgeCode: "2507804",
		cityName: "Junco do Seridó",
		state: "PB"
	},
	{
		ibgeCode: "2507903",
		cityName: "Juripiranga",
		state: "PB"
	},
	{
		ibgeCode: "2508000",
		cityName: "Juru",
		state: "PB"
	},
	{
		ibgeCode: "2508109",
		cityName: "Lagoa",
		state: "PB"
	},
	{
		ibgeCode: "2508208",
		cityName: "Lagoa de Dentro",
		state: "PB"
	},
	{
		ibgeCode: "2508307",
		cityName: "Lagoa Seca",
		state: "PB"
	},
	{
		ibgeCode: "2508406",
		cityName: "Lastro",
		state: "PB"
	},
	{
		ibgeCode: "2508505",
		cityName: "Livramento",
		state: "PB"
	},
	{
		ibgeCode: "2508554",
		cityName: "Logradouro",
		state: "PB"
	},
	{
		ibgeCode: "2508604",
		cityName: "Lucena",
		state: "PB"
	},
	{
		ibgeCode: "2508703",
		cityName: "Mãe d'Água",
		state: "PB"
	},
	{
		ibgeCode: "2508802",
		cityName: "Malta",
		state: "PB"
	},
	{
		ibgeCode: "2508901",
		cityName: "Mamanguape",
		state: "PB"
	},
	{
		ibgeCode: "2509008",
		cityName: "Manaíra",
		state: "PB"
	},
	{
		ibgeCode: "2509057",
		cityName: "Marcação",
		state: "PB"
	},
	{
		ibgeCode: "2509107",
		cityName: "Mari",
		state: "PB"
	},
	{
		ibgeCode: "2509156",
		cityName: "Marizópolis",
		state: "PB"
	},
	{
		ibgeCode: "2509206",
		cityName: "Massaranduba",
		state: "PB"
	},
	{
		ibgeCode: "2509305",
		cityName: "Mataraca",
		state: "PB"
	},
	{
		ibgeCode: "2509339",
		cityName: "Matinhas",
		state: "PB"
	},
	{
		ibgeCode: "2509370",
		cityName: "Mato Grosso",
		state: "PB"
	},
	{
		ibgeCode: "2509396",
		cityName: "Maturéia",
		state: "PB"
	},
	{
		ibgeCode: "2509404",
		cityName: "Mogeiro",
		state: "PB"
	},
	{
		ibgeCode: "2509503",
		cityName: "Montadas",
		state: "PB"
	},
	{
		ibgeCode: "2509602",
		cityName: "Monte Horebe",
		state: "PB"
	},
	{
		ibgeCode: "2509701",
		cityName: "Monteiro",
		state: "PB"
	},
	{
		ibgeCode: "2509800",
		cityName: "Mulungu",
		state: "PB"
	},
	{
		ibgeCode: "2509909",
		cityName: "Natuba",
		state: "PB"
	},
	{
		ibgeCode: "2510006",
		cityName: "Nazarezinho",
		state: "PB"
	},
	{
		ibgeCode: "2510105",
		cityName: "Nova Floresta",
		state: "PB"
	},
	{
		ibgeCode: "2510204",
		cityName: "Nova Olinda",
		state: "PB"
	},
	{
		ibgeCode: "2510303",
		cityName: "Nova Palmeira",
		state: "PB"
	},
	{
		ibgeCode: "2510402",
		cityName: "Olho d'Água",
		state: "PB"
	},
	{
		ibgeCode: "2510501",
		cityName: "Olivedos",
		state: "PB"
	},
	{
		ibgeCode: "2510600",
		cityName: "Ouro Velho",
		state: "PB"
	},
	{
		ibgeCode: "2510659",
		cityName: "Parari",
		state: "PB"
	},
	{
		ibgeCode: "2510709",
		cityName: "Passagem",
		state: "PB"
	},
	{
		ibgeCode: "2510808",
		cityName: "Patos",
		state: "PB"
	},
	{
		ibgeCode: "2510907",
		cityName: "Paulista",
		state: "PB"
	},
	{
		ibgeCode: "2511004",
		cityName: "Pedra Branca",
		state: "PB"
	},
	{
		ibgeCode: "2511103",
		cityName: "Pedra Lavrada",
		state: "PB"
	},
	{
		ibgeCode: "2511202",
		cityName: "Pedras de Fogo",
		state: "PB"
	},
	{
		ibgeCode: "2512721",
		cityName: "Pedro Régis",
		state: "PB"
	},
	{
		ibgeCode: "2511301",
		cityName: "Piancó",
		state: "PB"
	},
	{
		ibgeCode: "2511400",
		cityName: "Picuí",
		state: "PB"
	},
	{
		ibgeCode: "2511509",
		cityName: "Pilar",
		state: "PB"
	},
	{
		ibgeCode: "2511608",
		cityName: "Pilões",
		state: "PB"
	},
	{
		ibgeCode: "2511707",
		cityName: "Pilõezinhos",
		state: "PB"
	},
	{
		ibgeCode: "2511806",
		cityName: "Pirpirituba",
		state: "PB"
	},
	{
		ibgeCode: "2511905",
		cityName: "Pitimbu",
		state: "PB"
	},
	{
		ibgeCode: "2512002",
		cityName: "Pocinhos",
		state: "PB"
	},
	{
		ibgeCode: "2512036",
		cityName: "Poço Dantas",
		state: "PB"
	},
	{
		ibgeCode: "2512077",
		cityName: "Poço de José de Moura",
		state: "PB"
	},
	{
		ibgeCode: "2512101",
		cityName: "Pombal",
		state: "PB"
	},
	{
		ibgeCode: "2512200",
		cityName: "Prata",
		state: "PB"
	},
	{
		ibgeCode: "2512309",
		cityName: "Princesa Isabel",
		state: "PB"
	},
	{
		ibgeCode: "2512408",
		cityName: "Puxinanã",
		state: "PB"
	},
	{
		ibgeCode: "2512507",
		cityName: "Queimadas",
		state: "PB"
	},
	{
		ibgeCode: "2512606",
		cityName: "Quixaba",
		state: "PB"
	},
	{
		ibgeCode: "2512705",
		cityName: "Remígio",
		state: "PB"
	},
	{
		ibgeCode: "2512747",
		cityName: "Riachão",
		state: "PB"
	},
	{
		ibgeCode: "2512754",
		cityName: "Riachão do Bacamarte",
		state: "PB"
	},
	{
		ibgeCode: "2512762",
		cityName: "Riachão do Poço",
		state: "PB"
	},
	{
		ibgeCode: "2512788",
		cityName: "Riacho de Santo Antônio",
		state: "PB"
	},
	{
		ibgeCode: "2512804",
		cityName: "Riacho dos Cavalos",
		state: "PB"
	},
	{
		ibgeCode: "2512903",
		cityName: "Rio Tinto",
		state: "PB"
	},
	{
		ibgeCode: "2513000",
		cityName: "Salgadinho",
		state: "PB"
	},
	{
		ibgeCode: "2513109",
		cityName: "Salgado de São Félix",
		state: "PB"
	},
	{
		ibgeCode: "2513158",
		cityName: "Santa Cecília",
		state: "PB"
	},
	{
		ibgeCode: "2513208",
		cityName: "Santa Cruz",
		state: "PB"
	},
	{
		ibgeCode: "2513307",
		cityName: "Santa Helena",
		state: "PB"
	},
	{
		ibgeCode: "2513356",
		cityName: "Santa Inês",
		state: "PB"
	},
	{
		ibgeCode: "2513406",
		cityName: "Santa Luzia",
		state: "PB"
	},
	{
		ibgeCode: "2513703",
		cityName: "Santa Rita",
		state: "PB"
	},
	{
		ibgeCode: "2513802",
		cityName: "Santa Teresinha",
		state: "PB"
	},
	{
		ibgeCode: "2513505",
		cityName: "Santana de Mangueira",
		state: "PB"
	},
	{
		ibgeCode: "2513604",
		cityName: "Santana dos Garrotes",
		state: "PB"
	},
	{
		ibgeCode: "2513851",
		cityName: "Santo André",
		state: "PB"
	},
	{
		ibgeCode: "2513927",
		cityName: "São Bentinho",
		state: "PB"
	},
	{
		ibgeCode: "2513901",
		cityName: "São Bento",
		state: "PB"
	},
	{
		ibgeCode: "2513968",
		cityName: "São Domingos",
		state: "PB"
	},
	{
		ibgeCode: "2513943",
		cityName: "São Domingos do Cariri",
		state: "PB"
	},
	{
		ibgeCode: "2513984",
		cityName: "São Francisco",
		state: "PB"
	},
	{
		ibgeCode: "2514008",
		cityName: "São João do Cariri",
		state: "PB"
	},
	{
		ibgeCode: "2500700",
		cityName: "São João do Rio do Peixe",
		state: "PB"
	},
	{
		ibgeCode: "2514107",
		cityName: "São João do Tigre",
		state: "PB"
	},
	{
		ibgeCode: "2514206",
		cityName: "São José da Lagoa Tapada",
		state: "PB"
	},
	{
		ibgeCode: "2514305",
		cityName: "São José de Caiana",
		state: "PB"
	},
	{
		ibgeCode: "2514404",
		cityName: "São José de Espinharas",
		state: "PB"
	},
	{
		ibgeCode: "2514503",
		cityName: "São José de Piranhas",
		state: "PB"
	},
	{
		ibgeCode: "2514552",
		cityName: "São José de Princesa",
		state: "PB"
	},
	{
		ibgeCode: "2514602",
		cityName: "São José do Bonfim",
		state: "PB"
	},
	{
		ibgeCode: "2514651",
		cityName: "São José do Brejo do Cruz",
		state: "PB"
	},
	{
		ibgeCode: "2514701",
		cityName: "São José do Sabugi",
		state: "PB"
	},
	{
		ibgeCode: "2514800",
		cityName: "São José dos Cordeiros",
		state: "PB"
	},
	{
		ibgeCode: "2514453",
		cityName: "São José dos Ramos",
		state: "PB"
	},
	{
		ibgeCode: "2514909",
		cityName: "São Mamede",
		state: "PB"
	},
	{
		ibgeCode: "2515005",
		cityName: "São Miguel de Taipu",
		state: "PB"
	},
	{
		ibgeCode: "2515104",
		cityName: "São Sebastião de Lagoa de Roça",
		state: "PB"
	},
	{
		ibgeCode: "2515203",
		cityName: "São Sebastião do Umbuzeiro",
		state: "PB"
	},
	{
		ibgeCode: "2515401",
		cityName: "São Vicente do Seridó",
		state: "PB"
	},
	{
		ibgeCode: "2515302",
		cityName: "Sapé",
		state: "PB"
	},
	{
		ibgeCode: "2515500",
		cityName: "Serra Branca",
		state: "PB"
	},
	{
		ibgeCode: "2515609",
		cityName: "Serra da Raiz",
		state: "PB"
	},
	{
		ibgeCode: "2515708",
		cityName: "Serra Grande",
		state: "PB"
	},
	{
		ibgeCode: "2515807",
		cityName: "Serra Redonda",
		state: "PB"
	},
	{
		ibgeCode: "2515906",
		cityName: "Serraria",
		state: "PB"
	},
	{
		ibgeCode: "2515930",
		cityName: "Sertãozinho",
		state: "PB"
	},
	{
		ibgeCode: "2515971",
		cityName: "Sobrado",
		state: "PB"
	},
	{
		ibgeCode: "2516003",
		cityName: "Solânea",
		state: "PB"
	},
	{
		ibgeCode: "2516102",
		cityName: "Soledade",
		state: "PB"
	},
	{
		ibgeCode: "2516151",
		cityName: "Sossêgo",
		state: "PB"
	},
	{
		ibgeCode: "2516201",
		cityName: "Sousa",
		state: "PB"
	},
	{
		ibgeCode: "2516300",
		cityName: "Sumé",
		state: "PB"
	},
	{
		ibgeCode: "2516409",
		cityName: "Tacima",
		state: "PB"
	},
	{
		ibgeCode: "2516508",
		cityName: "Taperoá",
		state: "PB"
	},
	{
		ibgeCode: "2516607",
		cityName: "Tavares",
		state: "PB"
	},
	{
		ibgeCode: "2516706",
		cityName: "Teixeira",
		state: "PB"
	},
	{
		ibgeCode: "2516755",
		cityName: "Tenório",
		state: "PB"
	},
	{
		ibgeCode: "2516805",
		cityName: "Triunfo",
		state: "PB"
	},
	{
		ibgeCode: "2516904",
		cityName: "Uiraúna",
		state: "PB"
	},
	{
		ibgeCode: "2517001",
		cityName: "Umbuzeiro",
		state: "PB"
	},
	{
		ibgeCode: "2517100",
		cityName: "Várzea",
		state: "PB"
	},
	{
		ibgeCode: "2517209",
		cityName: "Vieirópolis",
		state: "PB"
	},
	{
		ibgeCode: "2505501",
		cityName: "Vista Serrana",
		state: "PB"
	},
	{
		ibgeCode: "2517407",
		cityName: "Zabelê",
		state: "PB"
	}
];
var PR = [
	{
		ibgeCode: "4113205",
		cityName: "Lapa",
		state: "PR"
	},
	{
		ibgeCode: "4100103",
		cityName: "Abatiá",
		state: "PR"
	},
	{
		ibgeCode: "4100202",
		cityName: "Adrianópolis",
		state: "PR"
	},
	{
		ibgeCode: "4100301",
		cityName: "Agudos do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4100400",
		cityName: "Almirante Tamandaré",
		state: "PR"
	},
	{
		ibgeCode: "4100459",
		cityName: "Altamira do Paraná",
		state: "PR"
	},
	{
		ibgeCode: "4128625",
		cityName: "Alto Paraíso",
		state: "PR"
	},
	{
		ibgeCode: "4100608",
		cityName: "Alto Paraná",
		state: "PR"
	},
	{
		ibgeCode: "4100707",
		cityName: "Alto Piquiri",
		state: "PR"
	},
	{
		ibgeCode: "4100509",
		cityName: "Altônia",
		state: "PR"
	},
	{
		ibgeCode: "4100806",
		cityName: "Alvorada do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4100905",
		cityName: "Amaporã",
		state: "PR"
	},
	{
		ibgeCode: "4101002",
		cityName: "Ampére",
		state: "PR"
	},
	{
		ibgeCode: "4101051",
		cityName: "Anahy",
		state: "PR"
	},
	{
		ibgeCode: "4101101",
		cityName: "Andirá",
		state: "PR"
	},
	{
		ibgeCode: "4101150",
		cityName: "Ângulo",
		state: "PR"
	},
	{
		ibgeCode: "4101200",
		cityName: "Antonina",
		state: "PR"
	},
	{
		ibgeCode: "4101309",
		cityName: "Antônio Olinto",
		state: "PR"
	},
	{
		ibgeCode: "4101408",
		cityName: "Apucarana",
		state: "PR"
	},
	{
		ibgeCode: "4101507",
		cityName: "Arapongas",
		state: "PR"
	},
	{
		ibgeCode: "4101606",
		cityName: "Arapoti",
		state: "PR"
	},
	{
		ibgeCode: "4101655",
		cityName: "Arapuã",
		state: "PR"
	},
	{
		ibgeCode: "4101705",
		cityName: "Araruna",
		state: "PR"
	},
	{
		ibgeCode: "4101804",
		cityName: "Araucária",
		state: "PR"
	},
	{
		ibgeCode: "4101853",
		cityName: "Ariranha do Ivaí",
		state: "PR"
	},
	{
		ibgeCode: "4101903",
		cityName: "Assaí",
		state: "PR"
	},
	{
		ibgeCode: "4102000",
		cityName: "Assis Chateaubriand",
		state: "PR"
	},
	{
		ibgeCode: "4102109",
		cityName: "Astorga",
		state: "PR"
	},
	{
		ibgeCode: "4102208",
		cityName: "Atalaia",
		state: "PR"
	},
	{
		ibgeCode: "4102307",
		cityName: "Balsa Nova",
		state: "PR"
	},
	{
		ibgeCode: "4102406",
		cityName: "Bandeirantes",
		state: "PR"
	},
	{
		ibgeCode: "4102505",
		cityName: "Barbosa Ferraz",
		state: "PR"
	},
	{
		ibgeCode: "4102703",
		cityName: "Barra do Jacaré",
		state: "PR"
	},
	{
		ibgeCode: "4102604",
		cityName: "Barracão",
		state: "PR"
	},
	{
		ibgeCode: "4102752",
		cityName: "Bela Vista da Caroba",
		state: "PR"
	},
	{
		ibgeCode: "4102802",
		cityName: "Bela Vista do Paraíso",
		state: "PR"
	},
	{
		ibgeCode: "4102901",
		cityName: "Bituruna",
		state: "PR"
	},
	{
		ibgeCode: "4103008",
		cityName: "Boa Esperança",
		state: "PR"
	},
	{
		ibgeCode: "4103024",
		cityName: "Boa Esperança do Iguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4103040",
		cityName: "Boa Ventura de São Roque",
		state: "PR"
	},
	{
		ibgeCode: "4103057",
		cityName: "Boa Vista da Aparecida",
		state: "PR"
	},
	{
		ibgeCode: "4103107",
		cityName: "Bocaiúva do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4103156",
		cityName: "Bom Jesus do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4103206",
		cityName: "Bom Sucesso",
		state: "PR"
	},
	{
		ibgeCode: "4103222",
		cityName: "Bom Sucesso do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4103305",
		cityName: "Borrazópolis",
		state: "PR"
	},
	{
		ibgeCode: "4103354",
		cityName: "Braganey",
		state: "PR"
	},
	{
		ibgeCode: "4103370",
		cityName: "Brasilândia do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4103404",
		cityName: "Cafeara",
		state: "PR"
	},
	{
		ibgeCode: "4103453",
		cityName: "Cafelândia",
		state: "PR"
	},
	{
		ibgeCode: "4103479",
		cityName: "Cafezal do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4103503",
		cityName: "Califórnia",
		state: "PR"
	},
	{
		ibgeCode: "4103602",
		cityName: "Cambará",
		state: "PR"
	},
	{
		ibgeCode: "4103701",
		cityName: "Cambé",
		state: "PR"
	},
	{
		ibgeCode: "4103800",
		cityName: "Cambira",
		state: "PR"
	},
	{
		ibgeCode: "4103909",
		cityName: "Campina da Lagoa",
		state: "PR"
	},
	{
		ibgeCode: "4103958",
		cityName: "Campina do Simão",
		state: "PR"
	},
	{
		ibgeCode: "4104006",
		cityName: "Campina Grande do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4104055",
		cityName: "Campo Bonito",
		state: "PR"
	},
	{
		ibgeCode: "4104105",
		cityName: "Campo do Tenente",
		state: "PR"
	},
	{
		ibgeCode: "4104204",
		cityName: "Campo Largo",
		state: "PR"
	},
	{
		ibgeCode: "4104253",
		cityName: "Campo Magro",
		state: "PR"
	},
	{
		ibgeCode: "4104303",
		cityName: "Campo Mourão",
		state: "PR"
	},
	{
		ibgeCode: "4104402",
		cityName: "Cândido de Abreu",
		state: "PR"
	},
	{
		ibgeCode: "4104428",
		cityName: "Candói",
		state: "PR"
	},
	{
		ibgeCode: "4104451",
		cityName: "Cantagalo",
		state: "PR"
	},
	{
		ibgeCode: "4104501",
		cityName: "Capanema",
		state: "PR"
	},
	{
		ibgeCode: "4104600",
		cityName: "Capitão Leônidas Marques",
		state: "PR"
	},
	{
		ibgeCode: "4104659",
		cityName: "Carambeí",
		state: "PR"
	},
	{
		ibgeCode: "4104709",
		cityName: "Carlópolis",
		state: "PR"
	},
	{
		ibgeCode: "4104808",
		cityName: "Cascavel",
		state: "PR"
	},
	{
		ibgeCode: "4104907",
		cityName: "Castro",
		state: "PR"
	},
	{
		ibgeCode: "4105003",
		cityName: "Catanduvas",
		state: "PR"
	},
	{
		ibgeCode: "4105102",
		cityName: "Centenário do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4105201",
		cityName: "Cerro Azul",
		state: "PR"
	},
	{
		ibgeCode: "4105300",
		cityName: "Céu Azul",
		state: "PR"
	},
	{
		ibgeCode: "4105409",
		cityName: "Chopinzinho",
		state: "PR"
	},
	{
		ibgeCode: "4105508",
		cityName: "Cianorte",
		state: "PR"
	},
	{
		ibgeCode: "4105607",
		cityName: "Cidade Gaúcha",
		state: "PR"
	},
	{
		ibgeCode: "4105706",
		cityName: "Clevelândia",
		state: "PR"
	},
	{
		ibgeCode: "4105805",
		cityName: "Colombo",
		state: "PR"
	},
	{
		ibgeCode: "4105904",
		cityName: "Colorado",
		state: "PR"
	},
	{
		ibgeCode: "4106001",
		cityName: "Congonhinhas",
		state: "PR"
	},
	{
		ibgeCode: "4106100",
		cityName: "Conselheiro Mairinck",
		state: "PR"
	},
	{
		ibgeCode: "4106209",
		cityName: "Contenda",
		state: "PR"
	},
	{
		ibgeCode: "4106308",
		cityName: "Corbélia",
		state: "PR"
	},
	{
		ibgeCode: "4106407",
		cityName: "Cornélio Procópio",
		state: "PR"
	},
	{
		ibgeCode: "4106456",
		cityName: "Coronel Domingos Soares",
		state: "PR"
	},
	{
		ibgeCode: "4106506",
		cityName: "Coronel Vivida",
		state: "PR"
	},
	{
		ibgeCode: "4106555",
		cityName: "Corumbataí do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4106803",
		cityName: "Cruz Machado",
		state: "PR"
	},
	{
		ibgeCode: "4106571",
		cityName: "Cruzeiro do Iguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4106605",
		cityName: "Cruzeiro do Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4106704",
		cityName: "Cruzeiro do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4106852",
		cityName: "Cruzmaltina",
		state: "PR"
	},
	{
		ibgeCode: "4106902",
		cityName: "Curitiba",
		state: "PR"
	},
	{
		ibgeCode: "4107009",
		cityName: "Curiúva",
		state: "PR"
	},
	{
		ibgeCode: "4107108",
		cityName: "Diamante do Norte",
		state: "PR"
	},
	{
		ibgeCode: "4107124",
		cityName: "Diamante do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4107157",
		cityName: "Diamante D'Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4107207",
		cityName: "Dois Vizinhos",
		state: "PR"
	},
	{
		ibgeCode: "4107256",
		cityName: "Douradina",
		state: "PR"
	},
	{
		ibgeCode: "4107306",
		cityName: "Doutor Camargo",
		state: "PR"
	},
	{
		ibgeCode: "4128633",
		cityName: "Doutor Ulysses",
		state: "PR"
	},
	{
		ibgeCode: "4107405",
		cityName: "Enéas Marques",
		state: "PR"
	},
	{
		ibgeCode: "4107504",
		cityName: "Engenheiro Beltrão",
		state: "PR"
	},
	{
		ibgeCode: "4107538",
		cityName: "Entre Rios do Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4107520",
		cityName: "Esperança Nova",
		state: "PR"
	},
	{
		ibgeCode: "4107546",
		cityName: "Espigão Alto do Iguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4107553",
		cityName: "Farol",
		state: "PR"
	},
	{
		ibgeCode: "4107603",
		cityName: "Faxinal",
		state: "PR"
	},
	{
		ibgeCode: "4107652",
		cityName: "Fazenda Rio Grande",
		state: "PR"
	},
	{
		ibgeCode: "4107702",
		cityName: "Fênix",
		state: "PR"
	},
	{
		ibgeCode: "4107736",
		cityName: "Fernandes Pinheiro",
		state: "PR"
	},
	{
		ibgeCode: "4107751",
		cityName: "Figueira",
		state: "PR"
	},
	{
		ibgeCode: "4107850",
		cityName: "Flor da Serra do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4107801",
		cityName: "Floraí",
		state: "PR"
	},
	{
		ibgeCode: "4107900",
		cityName: "Floresta",
		state: "PR"
	},
	{
		ibgeCode: "4108007",
		cityName: "Florestópolis",
		state: "PR"
	},
	{
		ibgeCode: "4108106",
		cityName: "Flórida",
		state: "PR"
	},
	{
		ibgeCode: "4108205",
		cityName: "Formosa do Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4108304",
		cityName: "Foz do Iguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4108452",
		cityName: "Foz do Jordão",
		state: "PR"
	},
	{
		ibgeCode: "4108320",
		cityName: "Francisco Alves",
		state: "PR"
	},
	{
		ibgeCode: "4108403",
		cityName: "Francisco Beltrão",
		state: "PR"
	},
	{
		ibgeCode: "4108502",
		cityName: "General Carneiro",
		state: "PR"
	},
	{
		ibgeCode: "4108551",
		cityName: "Godoy Moreira",
		state: "PR"
	},
	{
		ibgeCode: "4108601",
		cityName: "Goioerê",
		state: "PR"
	},
	{
		ibgeCode: "4108650",
		cityName: "Goioxim",
		state: "PR"
	},
	{
		ibgeCode: "4108700",
		cityName: "Grandes Rios",
		state: "PR"
	},
	{
		ibgeCode: "4108809",
		cityName: "Guaíra",
		state: "PR"
	},
	{
		ibgeCode: "4108908",
		cityName: "Guairaçá",
		state: "PR"
	},
	{
		ibgeCode: "4108957",
		cityName: "Guamiranga",
		state: "PR"
	},
	{
		ibgeCode: "4109005",
		cityName: "Guapirama",
		state: "PR"
	},
	{
		ibgeCode: "4109104",
		cityName: "Guaporema",
		state: "PR"
	},
	{
		ibgeCode: "4109203",
		cityName: "Guaraci",
		state: "PR"
	},
	{
		ibgeCode: "4109302",
		cityName: "Guaraniaçu",
		state: "PR"
	},
	{
		ibgeCode: "4109401",
		cityName: "Guarapuava",
		state: "PR"
	},
	{
		ibgeCode: "4109500",
		cityName: "Guaraqueçaba",
		state: "PR"
	},
	{
		ibgeCode: "4109609",
		cityName: "Guaratuba",
		state: "PR"
	},
	{
		ibgeCode: "4109658",
		cityName: "Honório Serpa",
		state: "PR"
	},
	{
		ibgeCode: "4109708",
		cityName: "Ibaiti",
		state: "PR"
	},
	{
		ibgeCode: "4109757",
		cityName: "Ibema",
		state: "PR"
	},
	{
		ibgeCode: "4109807",
		cityName: "Ibiporã",
		state: "PR"
	},
	{
		ibgeCode: "4109906",
		cityName: "Icaraíma",
		state: "PR"
	},
	{
		ibgeCode: "4110003",
		cityName: "Iguaraçu",
		state: "PR"
	},
	{
		ibgeCode: "4110052",
		cityName: "Iguatu",
		state: "PR"
	},
	{
		ibgeCode: "4110078",
		cityName: "Imbaú",
		state: "PR"
	},
	{
		ibgeCode: "4110102",
		cityName: "Imbituva",
		state: "PR"
	},
	{
		ibgeCode: "4110201",
		cityName: "Inácio Martins",
		state: "PR"
	},
	{
		ibgeCode: "4110300",
		cityName: "Inajá",
		state: "PR"
	},
	{
		ibgeCode: "4110409",
		cityName: "Indianópolis",
		state: "PR"
	},
	{
		ibgeCode: "4110508",
		cityName: "Ipiranga",
		state: "PR"
	},
	{
		ibgeCode: "4110607",
		cityName: "Iporã",
		state: "PR"
	},
	{
		ibgeCode: "4110656",
		cityName: "Iracema do Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4110706",
		cityName: "Irati",
		state: "PR"
	},
	{
		ibgeCode: "4110805",
		cityName: "Iretama",
		state: "PR"
	},
	{
		ibgeCode: "4110904",
		cityName: "Itaguajé",
		state: "PR"
	},
	{
		ibgeCode: "4110953",
		cityName: "Itaipulândia",
		state: "PR"
	},
	{
		ibgeCode: "4111001",
		cityName: "Itambaracá",
		state: "PR"
	},
	{
		ibgeCode: "4111100",
		cityName: "Itambé",
		state: "PR"
	},
	{
		ibgeCode: "4111209",
		cityName: "Itapejara d'Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4111258",
		cityName: "Itaperuçu",
		state: "PR"
	},
	{
		ibgeCode: "4111308",
		cityName: "Itaúna do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4111407",
		cityName: "Ivaí",
		state: "PR"
	},
	{
		ibgeCode: "4111506",
		cityName: "Ivaiporã",
		state: "PR"
	},
	{
		ibgeCode: "4111555",
		cityName: "Ivaté",
		state: "PR"
	},
	{
		ibgeCode: "4111605",
		cityName: "Ivatuba",
		state: "PR"
	},
	{
		ibgeCode: "4111704",
		cityName: "Jaboti",
		state: "PR"
	},
	{
		ibgeCode: "4111803",
		cityName: "Jacarezinho",
		state: "PR"
	},
	{
		ibgeCode: "4111902",
		cityName: "Jaguapitã",
		state: "PR"
	},
	{
		ibgeCode: "4112009",
		cityName: "Jaguariaíva",
		state: "PR"
	},
	{
		ibgeCode: "4112108",
		cityName: "Jandaia do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4112207",
		cityName: "Janiópolis",
		state: "PR"
	},
	{
		ibgeCode: "4112306",
		cityName: "Japira",
		state: "PR"
	},
	{
		ibgeCode: "4112405",
		cityName: "Japurá",
		state: "PR"
	},
	{
		ibgeCode: "4112504",
		cityName: "Jardim Alegre",
		state: "PR"
	},
	{
		ibgeCode: "4112603",
		cityName: "Jardim Olinda",
		state: "PR"
	},
	{
		ibgeCode: "4112702",
		cityName: "Jataizinho",
		state: "PR"
	},
	{
		ibgeCode: "4112751",
		cityName: "Jesuítas",
		state: "PR"
	},
	{
		ibgeCode: "4112801",
		cityName: "Joaquim Távora",
		state: "PR"
	},
	{
		ibgeCode: "4112900",
		cityName: "Jundiaí do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4112959",
		cityName: "Juranda",
		state: "PR"
	},
	{
		ibgeCode: "4113007",
		cityName: "Jussara",
		state: "PR"
	},
	{
		ibgeCode: "4113106",
		cityName: "Kaloré",
		state: "PR"
	},
	{
		ibgeCode: "4113254",
		cityName: "Laranjal",
		state: "PR"
	},
	{
		ibgeCode: "4113304",
		cityName: "Laranjeiras do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4113403",
		cityName: "Leópolis",
		state: "PR"
	},
	{
		ibgeCode: "4113429",
		cityName: "Lidianópolis",
		state: "PR"
	},
	{
		ibgeCode: "4113452",
		cityName: "Lindoeste",
		state: "PR"
	},
	{
		ibgeCode: "4113502",
		cityName: "Loanda",
		state: "PR"
	},
	{
		ibgeCode: "4113601",
		cityName: "Lobato",
		state: "PR"
	},
	{
		ibgeCode: "4113700",
		cityName: "Londrina",
		state: "PR"
	},
	{
		ibgeCode: "4113734",
		cityName: "Luiziana",
		state: "PR"
	},
	{
		ibgeCode: "4113759",
		cityName: "Lunardelli",
		state: "PR"
	},
	{
		ibgeCode: "4113809",
		cityName: "Lupionópolis",
		state: "PR"
	},
	{
		ibgeCode: "4113908",
		cityName: "Mallet",
		state: "PR"
	},
	{
		ibgeCode: "4114005",
		cityName: "Mamborê",
		state: "PR"
	},
	{
		ibgeCode: "4114104",
		cityName: "Mandaguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4114203",
		cityName: "Mandaguari",
		state: "PR"
	},
	{
		ibgeCode: "4114302",
		cityName: "Mandirituba",
		state: "PR"
	},
	{
		ibgeCode: "4114351",
		cityName: "Manfrinópolis",
		state: "PR"
	},
	{
		ibgeCode: "4114401",
		cityName: "Mangueirinha",
		state: "PR"
	},
	{
		ibgeCode: "4114500",
		cityName: "Manoel Ribas",
		state: "PR"
	},
	{
		ibgeCode: "4114609",
		cityName: "Marechal Cândido Rondon",
		state: "PR"
	},
	{
		ibgeCode: "4114708",
		cityName: "Maria Helena",
		state: "PR"
	},
	{
		ibgeCode: "4114807",
		cityName: "Marialva",
		state: "PR"
	},
	{
		ibgeCode: "4114906",
		cityName: "Marilândia do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4115002",
		cityName: "Marilena",
		state: "PR"
	},
	{
		ibgeCode: "4115101",
		cityName: "Mariluz",
		state: "PR"
	},
	{
		ibgeCode: "4115200",
		cityName: "Maringá",
		state: "PR"
	},
	{
		ibgeCode: "4115309",
		cityName: "Mariópolis",
		state: "PR"
	},
	{
		ibgeCode: "4115358",
		cityName: "Maripá",
		state: "PR"
	},
	{
		ibgeCode: "4115408",
		cityName: "Marmeleiro",
		state: "PR"
	},
	{
		ibgeCode: "4115457",
		cityName: "Marquinho",
		state: "PR"
	},
	{
		ibgeCode: "4115507",
		cityName: "Marumbi",
		state: "PR"
	},
	{
		ibgeCode: "4115606",
		cityName: "Matelândia",
		state: "PR"
	},
	{
		ibgeCode: "4115705",
		cityName: "Matinhos",
		state: "PR"
	},
	{
		ibgeCode: "4115739",
		cityName: "Mato Rico",
		state: "PR"
	},
	{
		ibgeCode: "4115754",
		cityName: "Mauá da Serra",
		state: "PR"
	},
	{
		ibgeCode: "4115804",
		cityName: "Medianeira",
		state: "PR"
	},
	{
		ibgeCode: "4115853",
		cityName: "Mercedes",
		state: "PR"
	},
	{
		ibgeCode: "4115903",
		cityName: "Mirador",
		state: "PR"
	},
	{
		ibgeCode: "4116000",
		cityName: "Miraselva",
		state: "PR"
	},
	{
		ibgeCode: "4116059",
		cityName: "Missal",
		state: "PR"
	},
	{
		ibgeCode: "4116109",
		cityName: "Moreira Sales",
		state: "PR"
	},
	{
		ibgeCode: "4116208",
		cityName: "Morretes",
		state: "PR"
	},
	{
		ibgeCode: "4116307",
		cityName: "Munhoz de Melo",
		state: "PR"
	},
	{
		ibgeCode: "4116406",
		cityName: "Nossa Senhora das Graças",
		state: "PR"
	},
	{
		ibgeCode: "4116505",
		cityName: "Nova Aliança do Ivaí",
		state: "PR"
	},
	{
		ibgeCode: "4116604",
		cityName: "Nova América da Colina",
		state: "PR"
	},
	{
		ibgeCode: "4116703",
		cityName: "Nova Aurora",
		state: "PR"
	},
	{
		ibgeCode: "4116802",
		cityName: "Nova Cantu",
		state: "PR"
	},
	{
		ibgeCode: "4116901",
		cityName: "Nova Esperança",
		state: "PR"
	},
	{
		ibgeCode: "4116950",
		cityName: "Nova Esperança do Sudoeste",
		state: "PR"
	},
	{
		ibgeCode: "4117008",
		cityName: "Nova Fátima",
		state: "PR"
	},
	{
		ibgeCode: "4117057",
		cityName: "Nova Laranjeiras",
		state: "PR"
	},
	{
		ibgeCode: "4117107",
		cityName: "Nova Londrina",
		state: "PR"
	},
	{
		ibgeCode: "4117206",
		cityName: "Nova Olímpia",
		state: "PR"
	},
	{
		ibgeCode: "4117255",
		cityName: "Nova Prata do Iguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4117214",
		cityName: "Nova Santa Bárbara",
		state: "PR"
	},
	{
		ibgeCode: "4117222",
		cityName: "Nova Santa Rosa",
		state: "PR"
	},
	{
		ibgeCode: "4117271",
		cityName: "Nova Tebas",
		state: "PR"
	},
	{
		ibgeCode: "4117297",
		cityName: "Novo Itacolomi",
		state: "PR"
	},
	{
		ibgeCode: "4117305",
		cityName: "Ortigueira",
		state: "PR"
	},
	{
		ibgeCode: "4117404",
		cityName: "Ourizona",
		state: "PR"
	},
	{
		ibgeCode: "4117453",
		cityName: "Ouro Verde do Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4117503",
		cityName: "Paiçandu",
		state: "PR"
	},
	{
		ibgeCode: "4117602",
		cityName: "Palmas",
		state: "PR"
	},
	{
		ibgeCode: "4117701",
		cityName: "Palmeira",
		state: "PR"
	},
	{
		ibgeCode: "4117800",
		cityName: "Palmital",
		state: "PR"
	},
	{
		ibgeCode: "4117909",
		cityName: "Palotina",
		state: "PR"
	},
	{
		ibgeCode: "4118006",
		cityName: "Paraíso do Norte",
		state: "PR"
	},
	{
		ibgeCode: "4118105",
		cityName: "Paranacity",
		state: "PR"
	},
	{
		ibgeCode: "4118204",
		cityName: "Paranaguá",
		state: "PR"
	},
	{
		ibgeCode: "4118303",
		cityName: "Paranapoema",
		state: "PR"
	},
	{
		ibgeCode: "4118402",
		cityName: "Paranavaí",
		state: "PR"
	},
	{
		ibgeCode: "4118451",
		cityName: "Pato Bragado",
		state: "PR"
	},
	{
		ibgeCode: "4118501",
		cityName: "Pato Branco",
		state: "PR"
	},
	{
		ibgeCode: "4118600",
		cityName: "Paula Freitas",
		state: "PR"
	},
	{
		ibgeCode: "4118709",
		cityName: "Paulo Frontin",
		state: "PR"
	},
	{
		ibgeCode: "4118808",
		cityName: "Peabiru",
		state: "PR"
	},
	{
		ibgeCode: "4118857",
		cityName: "Perobal",
		state: "PR"
	},
	{
		ibgeCode: "4118907",
		cityName: "Pérola",
		state: "PR"
	},
	{
		ibgeCode: "4119004",
		cityName: "Pérola d'Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4119103",
		cityName: "Piên",
		state: "PR"
	},
	{
		ibgeCode: "4119152",
		cityName: "Pinhais",
		state: "PR"
	},
	{
		ibgeCode: "4119251",
		cityName: "Pinhal de São Bento",
		state: "PR"
	},
	{
		ibgeCode: "4119202",
		cityName: "Pinhalão",
		state: "PR"
	},
	{
		ibgeCode: "4119301",
		cityName: "Pinhão",
		state: "PR"
	},
	{
		ibgeCode: "4119400",
		cityName: "Piraí do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4119509",
		cityName: "Piraquara",
		state: "PR"
	},
	{
		ibgeCode: "4119608",
		cityName: "Pitanga",
		state: "PR"
	},
	{
		ibgeCode: "4119657",
		cityName: "Pitangueiras",
		state: "PR"
	},
	{
		ibgeCode: "4119707",
		cityName: "Planaltina do Paraná",
		state: "PR"
	},
	{
		ibgeCode: "4119806",
		cityName: "Planalto",
		state: "PR"
	},
	{
		ibgeCode: "4119905",
		cityName: "Ponta Grossa",
		state: "PR"
	},
	{
		ibgeCode: "4119954",
		cityName: "Pontal do Paraná",
		state: "PR"
	},
	{
		ibgeCode: "4120002",
		cityName: "Porecatu",
		state: "PR"
	},
	{
		ibgeCode: "4120101",
		cityName: "Porto Amazonas",
		state: "PR"
	},
	{
		ibgeCode: "4120150",
		cityName: "Porto Barreiro",
		state: "PR"
	},
	{
		ibgeCode: "4120200",
		cityName: "Porto Rico",
		state: "PR"
	},
	{
		ibgeCode: "4120309",
		cityName: "Porto Vitória",
		state: "PR"
	},
	{
		ibgeCode: "4120333",
		cityName: "Prado Ferreira",
		state: "PR"
	},
	{
		ibgeCode: "4120358",
		cityName: "Pranchita",
		state: "PR"
	},
	{
		ibgeCode: "4120408",
		cityName: "Presidente Castelo Branco",
		state: "PR"
	},
	{
		ibgeCode: "4120507",
		cityName: "Primeiro de Maio",
		state: "PR"
	},
	{
		ibgeCode: "4120606",
		cityName: "Prudentópolis",
		state: "PR"
	},
	{
		ibgeCode: "4120655",
		cityName: "Quarto Centenário",
		state: "PR"
	},
	{
		ibgeCode: "4120705",
		cityName: "Quatiguá",
		state: "PR"
	},
	{
		ibgeCode: "4120804",
		cityName: "Quatro Barras",
		state: "PR"
	},
	{
		ibgeCode: "4120853",
		cityName: "Quatro Pontes",
		state: "PR"
	},
	{
		ibgeCode: "4120903",
		cityName: "Quedas do Iguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4121000",
		cityName: "Querência do Norte",
		state: "PR"
	},
	{
		ibgeCode: "4121109",
		cityName: "Quinta do Sol",
		state: "PR"
	},
	{
		ibgeCode: "4121208",
		cityName: "Quitandinha",
		state: "PR"
	},
	{
		ibgeCode: "4121257",
		cityName: "Ramilândia",
		state: "PR"
	},
	{
		ibgeCode: "4121307",
		cityName: "Rancho Alegre",
		state: "PR"
	},
	{
		ibgeCode: "4121356",
		cityName: "Rancho Alegre D'Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4121406",
		cityName: "Realeza",
		state: "PR"
	},
	{
		ibgeCode: "4121505",
		cityName: "Rebouças",
		state: "PR"
	},
	{
		ibgeCode: "4121604",
		cityName: "Renascença",
		state: "PR"
	},
	{
		ibgeCode: "4121703",
		cityName: "Reserva",
		state: "PR"
	},
	{
		ibgeCode: "4121752",
		cityName: "Reserva do Iguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4121802",
		cityName: "Ribeirão Claro",
		state: "PR"
	},
	{
		ibgeCode: "4121901",
		cityName: "Ribeirão do Pinhal",
		state: "PR"
	},
	{
		ibgeCode: "4122008",
		cityName: "Rio Azul",
		state: "PR"
	},
	{
		ibgeCode: "4122107",
		cityName: "Rio Bom",
		state: "PR"
	},
	{
		ibgeCode: "4122156",
		cityName: "Rio Bonito do Iguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4122172",
		cityName: "Rio Branco do Ivaí",
		state: "PR"
	},
	{
		ibgeCode: "4122206",
		cityName: "Rio Branco do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4122305",
		cityName: "Rio Negro",
		state: "PR"
	},
	{
		ibgeCode: "4122404",
		cityName: "Rolândia",
		state: "PR"
	},
	{
		ibgeCode: "4122503",
		cityName: "Roncador",
		state: "PR"
	},
	{
		ibgeCode: "4122602",
		cityName: "Rondon",
		state: "PR"
	},
	{
		ibgeCode: "4122651",
		cityName: "Rosário do Ivaí",
		state: "PR"
	},
	{
		ibgeCode: "4122701",
		cityName: "Sabáudia",
		state: "PR"
	},
	{
		ibgeCode: "4122800",
		cityName: "Salgado Filho",
		state: "PR"
	},
	{
		ibgeCode: "4122909",
		cityName: "Salto do Itararé",
		state: "PR"
	},
	{
		ibgeCode: "4123006",
		cityName: "Salto do Lontra",
		state: "PR"
	},
	{
		ibgeCode: "4123105",
		cityName: "Santa Amélia",
		state: "PR"
	},
	{
		ibgeCode: "4123204",
		cityName: "Santa Cecília do Pavão",
		state: "PR"
	},
	{
		ibgeCode: "4123303",
		cityName: "Santa Cruz de Monte Castelo",
		state: "PR"
	},
	{
		ibgeCode: "4123402",
		cityName: "Santa Fé",
		state: "PR"
	},
	{
		ibgeCode: "4123501",
		cityName: "Santa Helena",
		state: "PR"
	},
	{
		ibgeCode: "4123600",
		cityName: "Santa Inês",
		state: "PR"
	},
	{
		ibgeCode: "4123709",
		cityName: "Santa Isabel do Ivaí",
		state: "PR"
	},
	{
		ibgeCode: "4123808",
		cityName: "Santa Izabel do Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4123824",
		cityName: "Santa Lúcia",
		state: "PR"
	},
	{
		ibgeCode: "4123857",
		cityName: "Santa Maria do Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4123907",
		cityName: "Santa Mariana",
		state: "PR"
	},
	{
		ibgeCode: "4123956",
		cityName: "Santa Mônica",
		state: "PR"
	},
	{
		ibgeCode: "4124020",
		cityName: "Santa Tereza do Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4124053",
		cityName: "Santa Terezinha de Itaipu",
		state: "PR"
	},
	{
		ibgeCode: "4124004",
		cityName: "Santana do Itararé",
		state: "PR"
	},
	{
		ibgeCode: "4124103",
		cityName: "Santo Antônio da Platina",
		state: "PR"
	},
	{
		ibgeCode: "4124202",
		cityName: "Santo Antônio do Caiuá",
		state: "PR"
	},
	{
		ibgeCode: "4124301",
		cityName: "Santo Antônio do Paraíso",
		state: "PR"
	},
	{
		ibgeCode: "4124400",
		cityName: "Santo Antônio do Sudoeste",
		state: "PR"
	},
	{
		ibgeCode: "4124509",
		cityName: "Santo Inácio",
		state: "PR"
	},
	{
		ibgeCode: "4124608",
		cityName: "São Carlos do Ivaí",
		state: "PR"
	},
	{
		ibgeCode: "4124707",
		cityName: "São Jerônimo da Serra",
		state: "PR"
	},
	{
		ibgeCode: "4124806",
		cityName: "São João",
		state: "PR"
	},
	{
		ibgeCode: "4124905",
		cityName: "São João do Caiuá",
		state: "PR"
	},
	{
		ibgeCode: "4125001",
		cityName: "São João do Ivaí",
		state: "PR"
	},
	{
		ibgeCode: "4125100",
		cityName: "São João do Triunfo",
		state: "PR"
	},
	{
		ibgeCode: "4125308",
		cityName: "São Jorge do Ivaí",
		state: "PR"
	},
	{
		ibgeCode: "4125357",
		cityName: "São Jorge do Patrocínio",
		state: "PR"
	},
	{
		ibgeCode: "4125209",
		cityName: "São Jorge d'Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4125407",
		cityName: "São José da Boa Vista",
		state: "PR"
	},
	{
		ibgeCode: "4125456",
		cityName: "São José das Palmeiras",
		state: "PR"
	},
	{
		ibgeCode: "4125506",
		cityName: "São José dos Pinhais",
		state: "PR"
	},
	{
		ibgeCode: "4125555",
		cityName: "São Manoel do Paraná",
		state: "PR"
	},
	{
		ibgeCode: "4125605",
		cityName: "São Mateus do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4125704",
		cityName: "São Miguel do Iguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4125753",
		cityName: "São Pedro do Iguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4125803",
		cityName: "São Pedro do Ivaí",
		state: "PR"
	},
	{
		ibgeCode: "4125902",
		cityName: "São Pedro do Paraná",
		state: "PR"
	},
	{
		ibgeCode: "4126009",
		cityName: "São Sebastião da Amoreira",
		state: "PR"
	},
	{
		ibgeCode: "4126108",
		cityName: "São Tomé",
		state: "PR"
	},
	{
		ibgeCode: "4126207",
		cityName: "Sapopema",
		state: "PR"
	},
	{
		ibgeCode: "4126256",
		cityName: "Sarandi",
		state: "PR"
	},
	{
		ibgeCode: "4126272",
		cityName: "Saudade do Iguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4126306",
		cityName: "Sengés",
		state: "PR"
	},
	{
		ibgeCode: "4126355",
		cityName: "Serranópolis do Iguaçu",
		state: "PR"
	},
	{
		ibgeCode: "4126405",
		cityName: "Sertaneja",
		state: "PR"
	},
	{
		ibgeCode: "4126504",
		cityName: "Sertanópolis",
		state: "PR"
	},
	{
		ibgeCode: "4126603",
		cityName: "Siqueira Campos",
		state: "PR"
	},
	{
		ibgeCode: "4126652",
		cityName: "Sulina",
		state: "PR"
	},
	{
		ibgeCode: "4126678",
		cityName: "Tamarana",
		state: "PR"
	},
	{
		ibgeCode: "4126702",
		cityName: "Tamboara",
		state: "PR"
	},
	{
		ibgeCode: "4126801",
		cityName: "Tapejara",
		state: "PR"
	},
	{
		ibgeCode: "4126900",
		cityName: "Tapira",
		state: "PR"
	},
	{
		ibgeCode: "4127007",
		cityName: "Teixeira Soares",
		state: "PR"
	},
	{
		ibgeCode: "4127106",
		cityName: "Telêmaco Borba",
		state: "PR"
	},
	{
		ibgeCode: "4127205",
		cityName: "Terra Boa",
		state: "PR"
	},
	{
		ibgeCode: "4127304",
		cityName: "Terra Rica",
		state: "PR"
	},
	{
		ibgeCode: "4127403",
		cityName: "Terra Roxa",
		state: "PR"
	},
	{
		ibgeCode: "4127502",
		cityName: "Tibagi",
		state: "PR"
	},
	{
		ibgeCode: "4127601",
		cityName: "Tijucas do Sul",
		state: "PR"
	},
	{
		ibgeCode: "4127700",
		cityName: "Toledo",
		state: "PR"
	},
	{
		ibgeCode: "4127809",
		cityName: "Tomazina",
		state: "PR"
	},
	{
		ibgeCode: "4127858",
		cityName: "Três Barras do Paraná",
		state: "PR"
	},
	{
		ibgeCode: "4127882",
		cityName: "Tunas do Paraná",
		state: "PR"
	},
	{
		ibgeCode: "4127908",
		cityName: "Tuneiras do Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4127957",
		cityName: "Tupãssi",
		state: "PR"
	},
	{
		ibgeCode: "4127965",
		cityName: "Turvo",
		state: "PR"
	},
	{
		ibgeCode: "4128005",
		cityName: "Ubiratã",
		state: "PR"
	},
	{
		ibgeCode: "4128104",
		cityName: "Umuarama",
		state: "PR"
	},
	{
		ibgeCode: "4128203",
		cityName: "União da Vitória",
		state: "PR"
	},
	{
		ibgeCode: "4128302",
		cityName: "Uniflor",
		state: "PR"
	},
	{
		ibgeCode: "4128401",
		cityName: "Uraí",
		state: "PR"
	},
	{
		ibgeCode: "4128534",
		cityName: "Ventania",
		state: "PR"
	},
	{
		ibgeCode: "4128559",
		cityName: "Vera Cruz do Oeste",
		state: "PR"
	},
	{
		ibgeCode: "4128609",
		cityName: "Verê",
		state: "PR"
	},
	{
		ibgeCode: "4128658",
		cityName: "Virmond",
		state: "PR"
	},
	{
		ibgeCode: "4128708",
		cityName: "Vitorino",
		state: "PR"
	},
	{
		ibgeCode: "4128500",
		cityName: "Wenceslau Braz",
		state: "PR"
	},
	{
		ibgeCode: "4128807",
		cityName: "Xambrê",
		state: "PR"
	}
];
var PE = [
	{
		ibgeCode: "2605301",
		cityName: "Exu",
		state: "PE"
	},
	{
		ibgeCode: "2600054",
		cityName: "Abreu e Lima",
		state: "PE"
	},
	{
		ibgeCode: "2600104",
		cityName: "Afogados da Ingazeira",
		state: "PE"
	},
	{
		ibgeCode: "2600203",
		cityName: "Afrânio",
		state: "PE"
	},
	{
		ibgeCode: "2600302",
		cityName: "Agrestina",
		state: "PE"
	},
	{
		ibgeCode: "2600401",
		cityName: "Água Preta",
		state: "PE"
	},
	{
		ibgeCode: "2600500",
		cityName: "Águas Belas",
		state: "PE"
	},
	{
		ibgeCode: "2600609",
		cityName: "Alagoinha",
		state: "PE"
	},
	{
		ibgeCode: "2600708",
		cityName: "Aliança",
		state: "PE"
	},
	{
		ibgeCode: "2600807",
		cityName: "Altinho",
		state: "PE"
	},
	{
		ibgeCode: "2600906",
		cityName: "Amaraji",
		state: "PE"
	},
	{
		ibgeCode: "2601003",
		cityName: "Angelim",
		state: "PE"
	},
	{
		ibgeCode: "2601052",
		cityName: "Araçoiaba",
		state: "PE"
	},
	{
		ibgeCode: "2601102",
		cityName: "Araripina",
		state: "PE"
	},
	{
		ibgeCode: "2601201",
		cityName: "Arcoverde",
		state: "PE"
	},
	{
		ibgeCode: "2601300",
		cityName: "Barra de Guabiraba",
		state: "PE"
	},
	{
		ibgeCode: "2601409",
		cityName: "Barreiros",
		state: "PE"
	},
	{
		ibgeCode: "2601508",
		cityName: "Belém de Maria",
		state: "PE"
	},
	{
		ibgeCode: "2601607",
		cityName: "Belém do São Francisco",
		state: "PE"
	},
	{
		ibgeCode: "2601706",
		cityName: "Belo Jardim",
		state: "PE"
	},
	{
		ibgeCode: "2601805",
		cityName: "Betânia",
		state: "PE"
	},
	{
		ibgeCode: "2601904",
		cityName: "Bezerros",
		state: "PE"
	},
	{
		ibgeCode: "2602001",
		cityName: "Bodocó",
		state: "PE"
	},
	{
		ibgeCode: "2602100",
		cityName: "Bom Conselho",
		state: "PE"
	},
	{
		ibgeCode: "2602209",
		cityName: "Bom Jardim",
		state: "PE"
	},
	{
		ibgeCode: "2602308",
		cityName: "Bonito",
		state: "PE"
	},
	{
		ibgeCode: "2602407",
		cityName: "Brejão",
		state: "PE"
	},
	{
		ibgeCode: "2602506",
		cityName: "Brejinho",
		state: "PE"
	},
	{
		ibgeCode: "2602605",
		cityName: "Brejo da Madre de Deus",
		state: "PE"
	},
	{
		ibgeCode: "2602704",
		cityName: "Buenos Aires",
		state: "PE"
	},
	{
		ibgeCode: "2602803",
		cityName: "Buíque",
		state: "PE"
	},
	{
		ibgeCode: "2602902",
		cityName: "Cabo de Santo Agostinho",
		state: "PE"
	},
	{
		ibgeCode: "2603009",
		cityName: "Cabrobó",
		state: "PE"
	},
	{
		ibgeCode: "2603108",
		cityName: "Cachoeirinha",
		state: "PE"
	},
	{
		ibgeCode: "2603207",
		cityName: "Caetés",
		state: "PE"
	},
	{
		ibgeCode: "2603306",
		cityName: "Calçado",
		state: "PE"
	},
	{
		ibgeCode: "2603405",
		cityName: "Calumbi",
		state: "PE"
	},
	{
		ibgeCode: "2603454",
		cityName: "Camaragibe",
		state: "PE"
	},
	{
		ibgeCode: "2603504",
		cityName: "Camocim de São Félix",
		state: "PE"
	},
	{
		ibgeCode: "2603603",
		cityName: "Camutanga",
		state: "PE"
	},
	{
		ibgeCode: "2603702",
		cityName: "Canhotinho",
		state: "PE"
	},
	{
		ibgeCode: "2603801",
		cityName: "Capoeiras",
		state: "PE"
	},
	{
		ibgeCode: "2603900",
		cityName: "Carnaíba",
		state: "PE"
	},
	{
		ibgeCode: "2603926",
		cityName: "Carnaubeira da Penha",
		state: "PE"
	},
	{
		ibgeCode: "2604007",
		cityName: "Carpina",
		state: "PE"
	},
	{
		ibgeCode: "2604106",
		cityName: "Caruaru",
		state: "PE"
	},
	{
		ibgeCode: "2604155",
		cityName: "Casinhas",
		state: "PE"
	},
	{
		ibgeCode: "2604205",
		cityName: "Catende",
		state: "PE"
	},
	{
		ibgeCode: "2604304",
		cityName: "Cedro",
		state: "PE"
	},
	{
		ibgeCode: "2604403",
		cityName: "Chã de Alegria",
		state: "PE"
	},
	{
		ibgeCode: "2604502",
		cityName: "Chã Grande",
		state: "PE"
	},
	{
		ibgeCode: "2604601",
		cityName: "Condado",
		state: "PE"
	},
	{
		ibgeCode: "2604700",
		cityName: "Correntes",
		state: "PE"
	},
	{
		ibgeCode: "2604809",
		cityName: "Cortês",
		state: "PE"
	},
	{
		ibgeCode: "2604908",
		cityName: "Cumaru",
		state: "PE"
	},
	{
		ibgeCode: "2605004",
		cityName: "Cupira",
		state: "PE"
	},
	{
		ibgeCode: "2605103",
		cityName: "Custódia",
		state: "PE"
	},
	{
		ibgeCode: "2605152",
		cityName: "Dormentes",
		state: "PE"
	},
	{
		ibgeCode: "2605202",
		cityName: "Escada",
		state: "PE"
	},
	{
		ibgeCode: "2605400",
		cityName: "Feira Nova",
		state: "PE"
	},
	{
		ibgeCode: "2605459",
		cityName: "Fernando de Noronha",
		state: "PE"
	},
	{
		ibgeCode: "2605509",
		cityName: "Ferreiros",
		state: "PE"
	},
	{
		ibgeCode: "2605608",
		cityName: "Flores",
		state: "PE"
	},
	{
		ibgeCode: "2605707",
		cityName: "Floresta",
		state: "PE"
	},
	{
		ibgeCode: "2605806",
		cityName: "Frei Miguelinho",
		state: "PE"
	},
	{
		ibgeCode: "2605905",
		cityName: "Gameleira",
		state: "PE"
	},
	{
		ibgeCode: "2606002",
		cityName: "Garanhuns",
		state: "PE"
	},
	{
		ibgeCode: "2606101",
		cityName: "Glória do Goitá",
		state: "PE"
	},
	{
		ibgeCode: "2606200",
		cityName: "Goiana",
		state: "PE"
	},
	{
		ibgeCode: "2606309",
		cityName: "Granito",
		state: "PE"
	},
	{
		ibgeCode: "2606408",
		cityName: "Gravatá",
		state: "PE"
	},
	{
		ibgeCode: "2606507",
		cityName: "Iati",
		state: "PE"
	},
	{
		ibgeCode: "2606606",
		cityName: "Ibimirim",
		state: "PE"
	},
	{
		ibgeCode: "2606705",
		cityName: "Ibirajuba",
		state: "PE"
	},
	{
		ibgeCode: "2606804",
		cityName: "Igarassu",
		state: "PE"
	},
	{
		ibgeCode: "2606903",
		cityName: "Iguaracy",
		state: "PE"
	},
	{
		ibgeCode: "2607604",
		cityName: "Ilha de Itamaracá",
		state: "PE"
	},
	{
		ibgeCode: "2607000",
		cityName: "Inajá",
		state: "PE"
	},
	{
		ibgeCode: "2607109",
		cityName: "Ingazeira",
		state: "PE"
	},
	{
		ibgeCode: "2607208",
		cityName: "Ipojuca",
		state: "PE"
	},
	{
		ibgeCode: "2607307",
		cityName: "Ipubi",
		state: "PE"
	},
	{
		ibgeCode: "2607406",
		cityName: "Itacuruba",
		state: "PE"
	},
	{
		ibgeCode: "2607505",
		cityName: "Itaíba",
		state: "PE"
	},
	{
		ibgeCode: "2607653",
		cityName: "Itambé",
		state: "PE"
	},
	{
		ibgeCode: "2607703",
		cityName: "Itapetim",
		state: "PE"
	},
	{
		ibgeCode: "2607752",
		cityName: "Itapissuma",
		state: "PE"
	},
	{
		ibgeCode: "2607802",
		cityName: "Itaquitinga",
		state: "PE"
	},
	{
		ibgeCode: "2607901",
		cityName: "Jaboatão dos Guararapes",
		state: "PE"
	},
	{
		ibgeCode: "2607950",
		cityName: "Jaqueira",
		state: "PE"
	},
	{
		ibgeCode: "2608008",
		cityName: "Jataúba",
		state: "PE"
	},
	{
		ibgeCode: "2608057",
		cityName: "Jatobá",
		state: "PE"
	},
	{
		ibgeCode: "2608107",
		cityName: "João Alfredo",
		state: "PE"
	},
	{
		ibgeCode: "2608206",
		cityName: "Joaquim Nabuco",
		state: "PE"
	},
	{
		ibgeCode: "2608255",
		cityName: "Jucati",
		state: "PE"
	},
	{
		ibgeCode: "2608305",
		cityName: "Jupi",
		state: "PE"
	},
	{
		ibgeCode: "2608404",
		cityName: "Jurema",
		state: "PE"
	},
	{
		ibgeCode: "2608503",
		cityName: "Lagoa de Itaenga",
		state: "PE"
	},
	{
		ibgeCode: "2608453",
		cityName: "Lagoa do Carro",
		state: "PE"
	},
	{
		ibgeCode: "2608602",
		cityName: "Lagoa do Ouro",
		state: "PE"
	},
	{
		ibgeCode: "2608701",
		cityName: "Lagoa dos Gatos",
		state: "PE"
	},
	{
		ibgeCode: "2608750",
		cityName: "Lagoa Grande",
		state: "PE"
	},
	{
		ibgeCode: "2608800",
		cityName: "Lajedo",
		state: "PE"
	},
	{
		ibgeCode: "2608909",
		cityName: "Limoeiro",
		state: "PE"
	},
	{
		ibgeCode: "2609006",
		cityName: "Macaparana",
		state: "PE"
	},
	{
		ibgeCode: "2609105",
		cityName: "Machados",
		state: "PE"
	},
	{
		ibgeCode: "2609154",
		cityName: "Manari",
		state: "PE"
	},
	{
		ibgeCode: "2609204",
		cityName: "Maraial",
		state: "PE"
	},
	{
		ibgeCode: "2609303",
		cityName: "Mirandiba",
		state: "PE"
	},
	{
		ibgeCode: "2614303",
		cityName: "Moreilândia",
		state: "PE"
	},
	{
		ibgeCode: "2609402",
		cityName: "Moreno",
		state: "PE"
	},
	{
		ibgeCode: "2609501",
		cityName: "Nazaré da Mata",
		state: "PE"
	},
	{
		ibgeCode: "2609600",
		cityName: "Olinda",
		state: "PE"
	},
	{
		ibgeCode: "2609709",
		cityName: "Orobó",
		state: "PE"
	},
	{
		ibgeCode: "2609808",
		cityName: "Orocó",
		state: "PE"
	},
	{
		ibgeCode: "2609907",
		cityName: "Ouricuri",
		state: "PE"
	},
	{
		ibgeCode: "2610004",
		cityName: "Palmares",
		state: "PE"
	},
	{
		ibgeCode: "2610103",
		cityName: "Palmeirina",
		state: "PE"
	},
	{
		ibgeCode: "2610202",
		cityName: "Panelas",
		state: "PE"
	},
	{
		ibgeCode: "2610301",
		cityName: "Paranatama",
		state: "PE"
	},
	{
		ibgeCode: "2610400",
		cityName: "Parnamirim",
		state: "PE"
	},
	{
		ibgeCode: "2610509",
		cityName: "Passira",
		state: "PE"
	},
	{
		ibgeCode: "2610608",
		cityName: "Paudalho",
		state: "PE"
	},
	{
		ibgeCode: "2610707",
		cityName: "Paulista",
		state: "PE"
	},
	{
		ibgeCode: "2610806",
		cityName: "Pedra",
		state: "PE"
	},
	{
		ibgeCode: "2610905",
		cityName: "Pesqueira",
		state: "PE"
	},
	{
		ibgeCode: "2611002",
		cityName: "Petrolândia",
		state: "PE"
	},
	{
		ibgeCode: "2611101",
		cityName: "Petrolina",
		state: "PE"
	},
	{
		ibgeCode: "2611200",
		cityName: "Poção",
		state: "PE"
	},
	{
		ibgeCode: "2611309",
		cityName: "Pombos",
		state: "PE"
	},
	{
		ibgeCode: "2611408",
		cityName: "Primavera",
		state: "PE"
	},
	{
		ibgeCode: "2611507",
		cityName: "Quipapá",
		state: "PE"
	},
	{
		ibgeCode: "2611533",
		cityName: "Quixaba",
		state: "PE"
	},
	{
		ibgeCode: "2611606",
		cityName: "Recife",
		state: "PE"
	},
	{
		ibgeCode: "2611705",
		cityName: "Riacho das Almas",
		state: "PE"
	},
	{
		ibgeCode: "2611804",
		cityName: "Ribeirão",
		state: "PE"
	},
	{
		ibgeCode: "2611903",
		cityName: "Rio Formoso",
		state: "PE"
	},
	{
		ibgeCode: "2612000",
		cityName: "Sairé",
		state: "PE"
	},
	{
		ibgeCode: "2612109",
		cityName: "Salgadinho",
		state: "PE"
	},
	{
		ibgeCode: "2612208",
		cityName: "Salgueiro",
		state: "PE"
	},
	{
		ibgeCode: "2612307",
		cityName: "Saloá",
		state: "PE"
	},
	{
		ibgeCode: "2612406",
		cityName: "Sanharó",
		state: "PE"
	},
	{
		ibgeCode: "2612455",
		cityName: "Santa Cruz",
		state: "PE"
	},
	{
		ibgeCode: "2612471",
		cityName: "Santa Cruz da Baixa Verde",
		state: "PE"
	},
	{
		ibgeCode: "2612505",
		cityName: "Santa Cruz do Capibaribe",
		state: "PE"
	},
	{
		ibgeCode: "2612554",
		cityName: "Santa Filomena",
		state: "PE"
	},
	{
		ibgeCode: "2612604",
		cityName: "Santa Maria da Boa Vista",
		state: "PE"
	},
	{
		ibgeCode: "2612703",
		cityName: "Santa Maria do Cambucá",
		state: "PE"
	},
	{
		ibgeCode: "2612802",
		cityName: "Santa Terezinha",
		state: "PE"
	},
	{
		ibgeCode: "2612901",
		cityName: "São Benedito do Sul",
		state: "PE"
	},
	{
		ibgeCode: "2613008",
		cityName: "São Bento do Una",
		state: "PE"
	},
	{
		ibgeCode: "2613107",
		cityName: "São Caitano",
		state: "PE"
	},
	{
		ibgeCode: "2613206",
		cityName: "São João",
		state: "PE"
	},
	{
		ibgeCode: "2613305",
		cityName: "São Joaquim do Monte",
		state: "PE"
	},
	{
		ibgeCode: "2613404",
		cityName: "São José da Coroa Grande",
		state: "PE"
	},
	{
		ibgeCode: "2613503",
		cityName: "São José do Belmonte",
		state: "PE"
	},
	{
		ibgeCode: "2613602",
		cityName: "São José do Egito",
		state: "PE"
	},
	{
		ibgeCode: "2613701",
		cityName: "São Lourenço da Mata",
		state: "PE"
	},
	{
		ibgeCode: "2613800",
		cityName: "São Vicente Férrer",
		state: "PE"
	},
	{
		ibgeCode: "2613909",
		cityName: "Serra Talhada",
		state: "PE"
	},
	{
		ibgeCode: "2614006",
		cityName: "Serrita",
		state: "PE"
	},
	{
		ibgeCode: "2614105",
		cityName: "Sertânia",
		state: "PE"
	},
	{
		ibgeCode: "2614204",
		cityName: "Sirinhaém",
		state: "PE"
	},
	{
		ibgeCode: "2614402",
		cityName: "Solidão",
		state: "PE"
	},
	{
		ibgeCode: "2614501",
		cityName: "Surubim",
		state: "PE"
	},
	{
		ibgeCode: "2614600",
		cityName: "Tabira",
		state: "PE"
	},
	{
		ibgeCode: "2614709",
		cityName: "Tacaimbó",
		state: "PE"
	},
	{
		ibgeCode: "2614808",
		cityName: "Tacaratu",
		state: "PE"
	},
	{
		ibgeCode: "2614857",
		cityName: "Tamandaré",
		state: "PE"
	},
	{
		ibgeCode: "2615003",
		cityName: "Taquaritinga do Norte",
		state: "PE"
	},
	{
		ibgeCode: "2615102",
		cityName: "Terezinha",
		state: "PE"
	},
	{
		ibgeCode: "2615201",
		cityName: "Terra Nova",
		state: "PE"
	},
	{
		ibgeCode: "2615300",
		cityName: "Timbaúba",
		state: "PE"
	},
	{
		ibgeCode: "2615409",
		cityName: "Toritama",
		state: "PE"
	},
	{
		ibgeCode: "2615508",
		cityName: "Tracunhaém",
		state: "PE"
	},
	{
		ibgeCode: "2615607",
		cityName: "Trindade",
		state: "PE"
	},
	{
		ibgeCode: "2615706",
		cityName: "Triunfo",
		state: "PE"
	},
	{
		ibgeCode: "2615805",
		cityName: "Tupanatinga",
		state: "PE"
	},
	{
		ibgeCode: "2615904",
		cityName: "Tuparetama",
		state: "PE"
	},
	{
		ibgeCode: "2616001",
		cityName: "Venturosa",
		state: "PE"
	},
	{
		ibgeCode: "2616100",
		cityName: "Verdejante",
		state: "PE"
	},
	{
		ibgeCode: "2616183",
		cityName: "Vertente do Lério",
		state: "PE"
	},
	{
		ibgeCode: "2616209",
		cityName: "Vertentes",
		state: "PE"
	},
	{
		ibgeCode: "2616308",
		cityName: "Vicência",
		state: "PE"
	},
	{
		ibgeCode: "2616407",
		cityName: "Vitória de Santo Antão",
		state: "PE"
	},
	{
		ibgeCode: "2616506",
		cityName: "Xexéu",
		state: "PE"
	}
];
var PI = [
	{
		ibgeCode: "2200053",
		cityName: "Acauã",
		state: "PI"
	},
	{
		ibgeCode: "2200103",
		cityName: "Agricolândia",
		state: "PI"
	},
	{
		ibgeCode: "2200202",
		cityName: "Água Branca",
		state: "PI"
	},
	{
		ibgeCode: "2200251",
		cityName: "Alagoinha do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2200277",
		cityName: "Alegrete do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2200301",
		cityName: "Alto Longá",
		state: "PI"
	},
	{
		ibgeCode: "2200400",
		cityName: "Altos",
		state: "PI"
	},
	{
		ibgeCode: "2200459",
		cityName: "Alvorada do Gurguéia",
		state: "PI"
	},
	{
		ibgeCode: "2200509",
		cityName: "Amarante",
		state: "PI"
	},
	{
		ibgeCode: "2200608",
		cityName: "Angical do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2200707",
		cityName: "Anísio de Abreu",
		state: "PI"
	},
	{
		ibgeCode: "2200806",
		cityName: "Antônio Almeida",
		state: "PI"
	},
	{
		ibgeCode: "2200905",
		cityName: "Aroazes",
		state: "PI"
	},
	{
		ibgeCode: "2200954",
		cityName: "Aroeiras do Itaim",
		state: "PI"
	},
	{
		ibgeCode: "2201002",
		cityName: "Arraial",
		state: "PI"
	},
	{
		ibgeCode: "2201051",
		cityName: "Assunção do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2201101",
		cityName: "Avelino Lopes",
		state: "PI"
	},
	{
		ibgeCode: "2201150",
		cityName: "Baixa Grande do Ribeiro",
		state: "PI"
	},
	{
		ibgeCode: "2201176",
		cityName: "Barra D'Alcântara",
		state: "PI"
	},
	{
		ibgeCode: "2201200",
		cityName: "Barras",
		state: "PI"
	},
	{
		ibgeCode: "2201309",
		cityName: "Barreiras do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2201408",
		cityName: "Barro Duro",
		state: "PI"
	},
	{
		ibgeCode: "2201507",
		cityName: "Batalha",
		state: "PI"
	},
	{
		ibgeCode: "2201556",
		cityName: "Bela Vista do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2201572",
		cityName: "Belém do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2201606",
		cityName: "Beneditinos",
		state: "PI"
	},
	{
		ibgeCode: "2201705",
		cityName: "Bertolínia",
		state: "PI"
	},
	{
		ibgeCode: "2201739",
		cityName: "Betânia do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2201770",
		cityName: "Boa Hora",
		state: "PI"
	},
	{
		ibgeCode: "2201804",
		cityName: "Bocaina",
		state: "PI"
	},
	{
		ibgeCode: "2201903",
		cityName: "Bom Jesus",
		state: "PI"
	},
	{
		ibgeCode: "2201919",
		cityName: "Bom Princípio do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2201929",
		cityName: "Bonfim do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2201945",
		cityName: "Boqueirão do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2201960",
		cityName: "Brasileira",
		state: "PI"
	},
	{
		ibgeCode: "2201988",
		cityName: "Brejo do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2202000",
		cityName: "Buriti dos Lopes",
		state: "PI"
	},
	{
		ibgeCode: "2202026",
		cityName: "Buriti dos Montes",
		state: "PI"
	},
	{
		ibgeCode: "2202059",
		cityName: "Cabeceiras do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2202075",
		cityName: "Cajazeiras do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2202083",
		cityName: "Cajueiro da Praia",
		state: "PI"
	},
	{
		ibgeCode: "2202091",
		cityName: "Caldeirão Grande do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2202109",
		cityName: "Campinas do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2202117",
		cityName: "Campo Alegre do Fidalgo",
		state: "PI"
	},
	{
		ibgeCode: "2208205",
		cityName: "Pio IX",
		state: "PI"
	},
	{
		ibgeCode: "2202133",
		cityName: "Campo Grande do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2202174",
		cityName: "Campo Largo do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2202208",
		cityName: "Campo Maior",
		state: "PI"
	},
	{
		ibgeCode: "2202251",
		cityName: "Canavieira",
		state: "PI"
	},
	{
		ibgeCode: "2202307",
		cityName: "Canto do Buriti",
		state: "PI"
	},
	{
		ibgeCode: "2202406",
		cityName: "Capitão de Campos",
		state: "PI"
	},
	{
		ibgeCode: "2202455",
		cityName: "Capitão Gervásio Oliveira",
		state: "PI"
	},
	{
		ibgeCode: "2202505",
		cityName: "Caracol",
		state: "PI"
	},
	{
		ibgeCode: "2202539",
		cityName: "Caraúbas do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2202554",
		cityName: "Caridade do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2202604",
		cityName: "Castelo do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2202653",
		cityName: "Caxingó",
		state: "PI"
	},
	{
		ibgeCode: "2202703",
		cityName: "Cocal",
		state: "PI"
	},
	{
		ibgeCode: "2202711",
		cityName: "Cocal de Telha",
		state: "PI"
	},
	{
		ibgeCode: "2202729",
		cityName: "Cocal dos Alves",
		state: "PI"
	},
	{
		ibgeCode: "2202737",
		cityName: "Coivaras",
		state: "PI"
	},
	{
		ibgeCode: "2202752",
		cityName: "Colônia do Gurguéia",
		state: "PI"
	},
	{
		ibgeCode: "2202778",
		cityName: "Colônia do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2202802",
		cityName: "Conceição do Canindé",
		state: "PI"
	},
	{
		ibgeCode: "2202851",
		cityName: "Coronel José Dias",
		state: "PI"
	},
	{
		ibgeCode: "2202901",
		cityName: "Corrente",
		state: "PI"
	},
	{
		ibgeCode: "2203008",
		cityName: "Cristalândia do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2203107",
		cityName: "Cristino Castro",
		state: "PI"
	},
	{
		ibgeCode: "2203206",
		cityName: "Curimatá",
		state: "PI"
	},
	{
		ibgeCode: "2203230",
		cityName: "Currais",
		state: "PI"
	},
	{
		ibgeCode: "2203271",
		cityName: "Curral Novo do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2203255",
		cityName: "Curralinhos",
		state: "PI"
	},
	{
		ibgeCode: "2203305",
		cityName: "Demerval Lobão",
		state: "PI"
	},
	{
		ibgeCode: "2203354",
		cityName: "Dirceu Arcoverde",
		state: "PI"
	},
	{
		ibgeCode: "2203404",
		cityName: "Dom Expedito Lopes",
		state: "PI"
	},
	{
		ibgeCode: "2203453",
		cityName: "Dom Inocêncio",
		state: "PI"
	},
	{
		ibgeCode: "2203420",
		cityName: "Domingos Mourão",
		state: "PI"
	},
	{
		ibgeCode: "2203503",
		cityName: "Elesbão Veloso",
		state: "PI"
	},
	{
		ibgeCode: "2203602",
		cityName: "Eliseu Martins",
		state: "PI"
	},
	{
		ibgeCode: "2203701",
		cityName: "Esperantina",
		state: "PI"
	},
	{
		ibgeCode: "2203750",
		cityName: "Fartura do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2203800",
		cityName: "Flores do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2203859",
		cityName: "Floresta do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2203909",
		cityName: "Floriano",
		state: "PI"
	},
	{
		ibgeCode: "2204006",
		cityName: "Francinópolis",
		state: "PI"
	},
	{
		ibgeCode: "2204105",
		cityName: "Francisco Ayres",
		state: "PI"
	},
	{
		ibgeCode: "2204154",
		cityName: "Francisco Macedo",
		state: "PI"
	},
	{
		ibgeCode: "2204204",
		cityName: "Francisco Santos",
		state: "PI"
	},
	{
		ibgeCode: "2204303",
		cityName: "Fronteiras",
		state: "PI"
	},
	{
		ibgeCode: "2204352",
		cityName: "Geminiano",
		state: "PI"
	},
	{
		ibgeCode: "2204402",
		cityName: "Gilbués",
		state: "PI"
	},
	{
		ibgeCode: "2204501",
		cityName: "Guadalupe",
		state: "PI"
	},
	{
		ibgeCode: "2204550",
		cityName: "Guaribas",
		state: "PI"
	},
	{
		ibgeCode: "2204600",
		cityName: "Hugo Napoleão",
		state: "PI"
	},
	{
		ibgeCode: "2204659",
		cityName: "Ilha Grande",
		state: "PI"
	},
	{
		ibgeCode: "2204709",
		cityName: "Inhuma",
		state: "PI"
	},
	{
		ibgeCode: "2204808",
		cityName: "Ipiranga do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2204907",
		cityName: "Isaías Coelho",
		state: "PI"
	},
	{
		ibgeCode: "2205003",
		cityName: "Itainópolis",
		state: "PI"
	},
	{
		ibgeCode: "2205102",
		cityName: "Itaueira",
		state: "PI"
	},
	{
		ibgeCode: "2205151",
		cityName: "Jacobina do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2205201",
		cityName: "Jaicós",
		state: "PI"
	},
	{
		ibgeCode: "2205250",
		cityName: "Jardim do Mulato",
		state: "PI"
	},
	{
		ibgeCode: "2205276",
		cityName: "Jatobá do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2205300",
		cityName: "Jerumenha",
		state: "PI"
	},
	{
		ibgeCode: "2205359",
		cityName: "João Costa",
		state: "PI"
	},
	{
		ibgeCode: "2205409",
		cityName: "Joaquim Pires",
		state: "PI"
	},
	{
		ibgeCode: "2205458",
		cityName: "Joca Marques",
		state: "PI"
	},
	{
		ibgeCode: "2205508",
		cityName: "José de Freitas",
		state: "PI"
	},
	{
		ibgeCode: "2205516",
		cityName: "Juazeiro do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2205524",
		cityName: "Júlio Borges",
		state: "PI"
	},
	{
		ibgeCode: "2205532",
		cityName: "Jurema",
		state: "PI"
	},
	{
		ibgeCode: "2205557",
		cityName: "Lagoa Alegre",
		state: "PI"
	},
	{
		ibgeCode: "2205573",
		cityName: "Lagoa de São Francisco",
		state: "PI"
	},
	{
		ibgeCode: "2205565",
		cityName: "Lagoa do Barro do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2205581",
		cityName: "Lagoa do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2205599",
		cityName: "Lagoa do Sítio",
		state: "PI"
	},
	{
		ibgeCode: "2205540",
		cityName: "Lagoinha do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2205607",
		cityName: "Landri Sales",
		state: "PI"
	},
	{
		ibgeCode: "2205706",
		cityName: "Luís Correia",
		state: "PI"
	},
	{
		ibgeCode: "2205805",
		cityName: "Luzilândia",
		state: "PI"
	},
	{
		ibgeCode: "2205854",
		cityName: "Madeiro",
		state: "PI"
	},
	{
		ibgeCode: "2205904",
		cityName: "Manoel Emídio",
		state: "PI"
	},
	{
		ibgeCode: "2205953",
		cityName: "Marcolândia",
		state: "PI"
	},
	{
		ibgeCode: "2206001",
		cityName: "Marcos Parente",
		state: "PI"
	},
	{
		ibgeCode: "2206050",
		cityName: "Massapê do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2206100",
		cityName: "Matias Olímpio",
		state: "PI"
	},
	{
		ibgeCode: "2206209",
		cityName: "Miguel Alves",
		state: "PI"
	},
	{
		ibgeCode: "2206308",
		cityName: "Miguel Leão",
		state: "PI"
	},
	{
		ibgeCode: "2206357",
		cityName: "Milton Brandão",
		state: "PI"
	},
	{
		ibgeCode: "2206407",
		cityName: "Monsenhor Gil",
		state: "PI"
	},
	{
		ibgeCode: "2206506",
		cityName: "Monsenhor Hipólito",
		state: "PI"
	},
	{
		ibgeCode: "2206605",
		cityName: "Monte Alegre do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2206654",
		cityName: "Morro Cabeça no Tempo",
		state: "PI"
	},
	{
		ibgeCode: "2206670",
		cityName: "Morro do Chapéu do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2206696",
		cityName: "Murici dos Portelas",
		state: "PI"
	},
	{
		ibgeCode: "2206704",
		cityName: "Nazaré do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2206720",
		cityName: "Nazária",
		state: "PI"
	},
	{
		ibgeCode: "2206753",
		cityName: "Nossa Senhora de Nazaré",
		state: "PI"
	},
	{
		ibgeCode: "2206803",
		cityName: "Nossa Senhora dos Remédios",
		state: "PI"
	},
	{
		ibgeCode: "2207959",
		cityName: "Nova Santa Rita",
		state: "PI"
	},
	{
		ibgeCode: "2206902",
		cityName: "Novo Oriente do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2206951",
		cityName: "Novo Santo Antônio",
		state: "PI"
	},
	{
		ibgeCode: "2207009",
		cityName: "Oeiras",
		state: "PI"
	},
	{
		ibgeCode: "2207108",
		cityName: "Olho D'Água do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2207207",
		cityName: "Padre Marcos",
		state: "PI"
	},
	{
		ibgeCode: "2207306",
		cityName: "Paes Landim",
		state: "PI"
	},
	{
		ibgeCode: "2207355",
		cityName: "Pajeú do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2207405",
		cityName: "Palmeira do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2207504",
		cityName: "Palmeirais",
		state: "PI"
	},
	{
		ibgeCode: "2207553",
		cityName: "Paquetá",
		state: "PI"
	},
	{
		ibgeCode: "2207603",
		cityName: "Parnaguá",
		state: "PI"
	},
	{
		ibgeCode: "2207702",
		cityName: "Parnaíba",
		state: "PI"
	},
	{
		ibgeCode: "2207751",
		cityName: "Passagem Franca do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2207777",
		cityName: "Patos do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2207793",
		cityName: "Pau D'Arco do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2207801",
		cityName: "Paulistana",
		state: "PI"
	},
	{
		ibgeCode: "2207850",
		cityName: "Pavussu",
		state: "PI"
	},
	{
		ibgeCode: "2207900",
		cityName: "Pedro II",
		state: "PI"
	},
	{
		ibgeCode: "2207934",
		cityName: "Pedro Laurentino",
		state: "PI"
	},
	{
		ibgeCode: "2208007",
		cityName: "Picos",
		state: "PI"
	},
	{
		ibgeCode: "2208106",
		cityName: "Pimenteiras",
		state: "PI"
	},
	{
		ibgeCode: "2208304",
		cityName: "Piracuruca",
		state: "PI"
	},
	{
		ibgeCode: "2208403",
		cityName: "Piripiri",
		state: "PI"
	},
	{
		ibgeCode: "2208502",
		cityName: "Porto",
		state: "PI"
	},
	{
		ibgeCode: "2208551",
		cityName: "Porto Alegre do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2208601",
		cityName: "Prata do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2208650",
		cityName: "Queimada Nova",
		state: "PI"
	},
	{
		ibgeCode: "2208700",
		cityName: "Redenção do Gurguéia",
		state: "PI"
	},
	{
		ibgeCode: "2208809",
		cityName: "Regeneração",
		state: "PI"
	},
	{
		ibgeCode: "2208858",
		cityName: "Riacho Frio",
		state: "PI"
	},
	{
		ibgeCode: "2208874",
		cityName: "Ribeira do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2208908",
		cityName: "Ribeiro Gonçalves",
		state: "PI"
	},
	{
		ibgeCode: "2209005",
		cityName: "Rio Grande do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2209104",
		cityName: "Santa Cruz do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2209153",
		cityName: "Santa Cruz dos Milagres",
		state: "PI"
	},
	{
		ibgeCode: "2209203",
		cityName: "Santa Filomena",
		state: "PI"
	},
	{
		ibgeCode: "2209302",
		cityName: "Santa Luz",
		state: "PI"
	},
	{
		ibgeCode: "2209377",
		cityName: "Santa Rosa do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2209351",
		cityName: "Santana do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2209401",
		cityName: "Santo Antônio de Lisboa",
		state: "PI"
	},
	{
		ibgeCode: "2209450",
		cityName: "Santo Antônio dos Milagres",
		state: "PI"
	},
	{
		ibgeCode: "2209500",
		cityName: "Santo Inácio do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2209559",
		cityName: "São Braz do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2209609",
		cityName: "São Félix do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2209658",
		cityName: "São Francisco de Assis do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2209708",
		cityName: "São Francisco do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2209757",
		cityName: "São Gonçalo do Gurguéia",
		state: "PI"
	},
	{
		ibgeCode: "2209807",
		cityName: "São Gonçalo do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2209856",
		cityName: "São João da Canabrava",
		state: "PI"
	},
	{
		ibgeCode: "2209872",
		cityName: "São João da Fronteira",
		state: "PI"
	},
	{
		ibgeCode: "2209906",
		cityName: "São João da Serra",
		state: "PI"
	},
	{
		ibgeCode: "2209955",
		cityName: "São João da Varjota",
		state: "PI"
	},
	{
		ibgeCode: "2209971",
		cityName: "São João do Arraial",
		state: "PI"
	},
	{
		ibgeCode: "2210003",
		cityName: "São João do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2210052",
		cityName: "São José do Divino",
		state: "PI"
	},
	{
		ibgeCode: "2210102",
		cityName: "São José do Peixe",
		state: "PI"
	},
	{
		ibgeCode: "2210201",
		cityName: "São José do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2210300",
		cityName: "São Julião",
		state: "PI"
	},
	{
		ibgeCode: "2210359",
		cityName: "São Lourenço do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2210375",
		cityName: "São Luis do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2210383",
		cityName: "São Miguel da Baixa Grande",
		state: "PI"
	},
	{
		ibgeCode: "2210391",
		cityName: "São Miguel do Fidalgo",
		state: "PI"
	},
	{
		ibgeCode: "2210409",
		cityName: "São Miguel do Tapuio",
		state: "PI"
	},
	{
		ibgeCode: "2210508",
		cityName: "São Pedro do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2210607",
		cityName: "São Raimundo Nonato",
		state: "PI"
	},
	{
		ibgeCode: "2210623",
		cityName: "Sebastião Barros",
		state: "PI"
	},
	{
		ibgeCode: "2210631",
		cityName: "Sebastião Leal",
		state: "PI"
	},
	{
		ibgeCode: "2210656",
		cityName: "Sigefredo Pacheco",
		state: "PI"
	},
	{
		ibgeCode: "2210706",
		cityName: "Simões",
		state: "PI"
	},
	{
		ibgeCode: "2210805",
		cityName: "Simplício Mendes",
		state: "PI"
	},
	{
		ibgeCode: "2210904",
		cityName: "Socorro do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2210938",
		cityName: "Sussuapara",
		state: "PI"
	},
	{
		ibgeCode: "2210953",
		cityName: "Tamboril do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2210979",
		cityName: "Tanque do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2211001",
		cityName: "Teresina",
		state: "PI"
	},
	{
		ibgeCode: "2211100",
		cityName: "União",
		state: "PI"
	},
	{
		ibgeCode: "2211209",
		cityName: "Uruçuí",
		state: "PI"
	},
	{
		ibgeCode: "2211308",
		cityName: "Valença do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2211357",
		cityName: "Várzea Branca",
		state: "PI"
	},
	{
		ibgeCode: "2211407",
		cityName: "Várzea Grande",
		state: "PI"
	},
	{
		ibgeCode: "2211506",
		cityName: "Vera Mendes",
		state: "PI"
	},
	{
		ibgeCode: "2211605",
		cityName: "Vila Nova do Piauí",
		state: "PI"
	},
	{
		ibgeCode: "2211704",
		cityName: "Wall Ferraz",
		state: "PI"
	}
];
var RJ = [
	{
		ibgeCode: "3300100",
		cityName: "Angra dos Reis",
		state: "RJ"
	},
	{
		ibgeCode: "3300159",
		cityName: "Aperibé",
		state: "RJ"
	},
	{
		ibgeCode: "3300209",
		cityName: "Araruama",
		state: "RJ"
	},
	{
		ibgeCode: "3300225",
		cityName: "Areal",
		state: "RJ"
	},
	{
		ibgeCode: "3300233",
		cityName: "Armação dos Búzios",
		state: "RJ"
	},
	{
		ibgeCode: "3300258",
		cityName: "Arraial do Cabo",
		state: "RJ"
	},
	{
		ibgeCode: "3300308",
		cityName: "Barra do Piraí",
		state: "RJ"
	},
	{
		ibgeCode: "3300407",
		cityName: "Barra Mansa",
		state: "RJ"
	},
	{
		ibgeCode: "3300456",
		cityName: "Belford Roxo",
		state: "RJ"
	},
	{
		ibgeCode: "3300506",
		cityName: "Bom Jardim",
		state: "RJ"
	},
	{
		ibgeCode: "3300605",
		cityName: "Bom Jesus do Itabapoana",
		state: "RJ"
	},
	{
		ibgeCode: "3300704",
		cityName: "Cabo Frio",
		state: "RJ"
	},
	{
		ibgeCode: "3300803",
		cityName: "Cachoeiras de Macacu",
		state: "RJ"
	},
	{
		ibgeCode: "3300902",
		cityName: "Cambuci",
		state: "RJ"
	},
	{
		ibgeCode: "3301009",
		cityName: "Campos dos Goytacazes",
		state: "RJ"
	},
	{
		ibgeCode: "3301108",
		cityName: "Cantagalo",
		state: "RJ"
	},
	{
		ibgeCode: "3300936",
		cityName: "Carapebus",
		state: "RJ"
	},
	{
		ibgeCode: "3301157",
		cityName: "Cardoso Moreira",
		state: "RJ"
	},
	{
		ibgeCode: "3301207",
		cityName: "Carmo",
		state: "RJ"
	},
	{
		ibgeCode: "3301306",
		cityName: "Casimiro de Abreu",
		state: "RJ"
	},
	{
		ibgeCode: "3300951",
		cityName: "Comendador Levy Gasparian",
		state: "RJ"
	},
	{
		ibgeCode: "3301405",
		cityName: "Conceição de Macabu",
		state: "RJ"
	},
	{
		ibgeCode: "3301504",
		cityName: "Cordeiro",
		state: "RJ"
	},
	{
		ibgeCode: "3301603",
		cityName: "Duas Barras",
		state: "RJ"
	},
	{
		ibgeCode: "3301702",
		cityName: "Duque de Caxias",
		state: "RJ"
	},
	{
		ibgeCode: "3301801",
		cityName: "Engenheiro Paulo de Frontin",
		state: "RJ"
	},
	{
		ibgeCode: "3301850",
		cityName: "Guapimirim",
		state: "RJ"
	},
	{
		ibgeCode: "3301876",
		cityName: "Iguaba Grande",
		state: "RJ"
	},
	{
		ibgeCode: "3301900",
		cityName: "Itaboraí",
		state: "RJ"
	},
	{
		ibgeCode: "3302007",
		cityName: "Itaguaí",
		state: "RJ"
	},
	{
		ibgeCode: "3302056",
		cityName: "Italva",
		state: "RJ"
	},
	{
		ibgeCode: "3302106",
		cityName: "Itaocara",
		state: "RJ"
	},
	{
		ibgeCode: "3302205",
		cityName: "Itaperuna",
		state: "RJ"
	},
	{
		ibgeCode: "3302254",
		cityName: "Itatiaia",
		state: "RJ"
	},
	{
		ibgeCode: "3302270",
		cityName: "Japeri",
		state: "RJ"
	},
	{
		ibgeCode: "3302304",
		cityName: "Laje do Muriaé",
		state: "RJ"
	},
	{
		ibgeCode: "3302403",
		cityName: "Macaé",
		state: "RJ"
	},
	{
		ibgeCode: "3302452",
		cityName: "Macuco",
		state: "RJ"
	},
	{
		ibgeCode: "3302502",
		cityName: "Magé",
		state: "RJ"
	},
	{
		ibgeCode: "3302601",
		cityName: "Mangaratiba",
		state: "RJ"
	},
	{
		ibgeCode: "3302700",
		cityName: "Maricá",
		state: "RJ"
	},
	{
		ibgeCode: "3302809",
		cityName: "Mendes",
		state: "RJ"
	},
	{
		ibgeCode: "3302858",
		cityName: "Mesquita",
		state: "RJ"
	},
	{
		ibgeCode: "3302908",
		cityName: "Miguel Pereira",
		state: "RJ"
	},
	{
		ibgeCode: "3303005",
		cityName: "Miracema",
		state: "RJ"
	},
	{
		ibgeCode: "3303104",
		cityName: "Natividade",
		state: "RJ"
	},
	{
		ibgeCode: "3303203",
		cityName: "Nilópolis",
		state: "RJ"
	},
	{
		ibgeCode: "3303302",
		cityName: "Niterói",
		state: "RJ"
	},
	{
		ibgeCode: "3303401",
		cityName: "Nova Friburgo",
		state: "RJ"
	},
	{
		ibgeCode: "3303500",
		cityName: "Nova Iguaçu",
		state: "RJ"
	},
	{
		ibgeCode: "3303609",
		cityName: "Paracambi",
		state: "RJ"
	},
	{
		ibgeCode: "3303708",
		cityName: "Paraíba do Sul",
		state: "RJ"
	},
	{
		ibgeCode: "3303807",
		cityName: "Paraty",
		state: "RJ"
	},
	{
		ibgeCode: "3303856",
		cityName: "Paty do Alferes",
		state: "RJ"
	},
	{
		ibgeCode: "3303906",
		cityName: "Petrópolis",
		state: "RJ"
	},
	{
		ibgeCode: "3303955",
		cityName: "Pinheiral",
		state: "RJ"
	},
	{
		ibgeCode: "3304003",
		cityName: "Piraí",
		state: "RJ"
	},
	{
		ibgeCode: "3304102",
		cityName: "Porciúncula",
		state: "RJ"
	},
	{
		ibgeCode: "3304110",
		cityName: "Porto Real",
		state: "RJ"
	},
	{
		ibgeCode: "3304128",
		cityName: "Quatis",
		state: "RJ"
	},
	{
		ibgeCode: "3304144",
		cityName: "Queimados",
		state: "RJ"
	},
	{
		ibgeCode: "3304151",
		cityName: "Quissamã",
		state: "RJ"
	},
	{
		ibgeCode: "3304201",
		cityName: "Resende",
		state: "RJ"
	},
	{
		ibgeCode: "3304300",
		cityName: "Rio Bonito",
		state: "RJ"
	},
	{
		ibgeCode: "3304409",
		cityName: "Rio Claro",
		state: "RJ"
	},
	{
		ibgeCode: "3304508",
		cityName: "Rio das Flores",
		state: "RJ"
	},
	{
		ibgeCode: "3304524",
		cityName: "Rio das Ostras",
		state: "RJ"
	},
	{
		ibgeCode: "3304557",
		cityName: "Rio de Janeiro",
		state: "RJ"
	},
	{
		ibgeCode: "3304607",
		cityName: "Santa Maria Madalena",
		state: "RJ"
	},
	{
		ibgeCode: "3304706",
		cityName: "Santo Antônio de Pádua",
		state: "RJ"
	},
	{
		ibgeCode: "3304805",
		cityName: "São Fidélis",
		state: "RJ"
	},
	{
		ibgeCode: "3304755",
		cityName: "São Francisco de Itabapoana",
		state: "RJ"
	},
	{
		ibgeCode: "3304904",
		cityName: "São Gonçalo",
		state: "RJ"
	},
	{
		ibgeCode: "3305000",
		cityName: "São João da Barra",
		state: "RJ"
	},
	{
		ibgeCode: "3305109",
		cityName: "São João de Meriti",
		state: "RJ"
	},
	{
		ibgeCode: "3305133",
		cityName: "São José de Ubá",
		state: "RJ"
	},
	{
		ibgeCode: "3305158",
		cityName: "São José do Vale do Rio Preto",
		state: "RJ"
	},
	{
		ibgeCode: "3305208",
		cityName: "São Pedro da Aldeia",
		state: "RJ"
	},
	{
		ibgeCode: "3305307",
		cityName: "São Sebastião do Alto",
		state: "RJ"
	},
	{
		ibgeCode: "3305406",
		cityName: "Sapucaia",
		state: "RJ"
	},
	{
		ibgeCode: "3305505",
		cityName: "Saquarema",
		state: "RJ"
	},
	{
		ibgeCode: "3305554",
		cityName: "Seropédica",
		state: "RJ"
	},
	{
		ibgeCode: "3305604",
		cityName: "Silva Jardim",
		state: "RJ"
	},
	{
		ibgeCode: "3305703",
		cityName: "Sumidouro",
		state: "RJ"
	},
	{
		ibgeCode: "3305752",
		cityName: "Tanguá",
		state: "RJ"
	},
	{
		ibgeCode: "3305802",
		cityName: "Teresópolis",
		state: "RJ"
	},
	{
		ibgeCode: "3305901",
		cityName: "Trajano de Moraes",
		state: "RJ"
	},
	{
		ibgeCode: "3306008",
		cityName: "Três Rios",
		state: "RJ"
	},
	{
		ibgeCode: "3306107",
		cityName: "Valença",
		state: "RJ"
	},
	{
		ibgeCode: "3306156",
		cityName: "Varre-Sai",
		state: "RJ"
	},
	{
		ibgeCode: "3306206",
		cityName: "Vassouras",
		state: "RJ"
	},
	{
		ibgeCode: "3306305",
		cityName: "Volta Redonda",
		state: "RJ"
	}
];
var RN = [
	{
		ibgeCode: "2400109",
		cityName: "Acari",
		state: "RN"
	},
	{
		ibgeCode: "2400208",
		cityName: "Açu",
		state: "RN"
	},
	{
		ibgeCode: "2400307",
		cityName: "Afonso Bezerra",
		state: "RN"
	},
	{
		ibgeCode: "2400406",
		cityName: "Água Nova",
		state: "RN"
	},
	{
		ibgeCode: "2400505",
		cityName: "Alexandria",
		state: "RN"
	},
	{
		ibgeCode: "2400604",
		cityName: "Almino Afonso",
		state: "RN"
	},
	{
		ibgeCode: "2400703",
		cityName: "Alto do Rodrigues",
		state: "RN"
	},
	{
		ibgeCode: "2400802",
		cityName: "Angicos",
		state: "RN"
	},
	{
		ibgeCode: "2400901",
		cityName: "Antônio Martins",
		state: "RN"
	},
	{
		ibgeCode: "2401008",
		cityName: "Apodi",
		state: "RN"
	},
	{
		ibgeCode: "2401107",
		cityName: "Areia Branca",
		state: "RN"
	},
	{
		ibgeCode: "2401206",
		cityName: "Arês",
		state: "RN"
	},
	{
		ibgeCode: "2401404",
		cityName: "Baía Formosa",
		state: "RN"
	},
	{
		ibgeCode: "2401453",
		cityName: "Baraúna",
		state: "RN"
	},
	{
		ibgeCode: "2401503",
		cityName: "Barcelona",
		state: "RN"
	},
	{
		ibgeCode: "2401602",
		cityName: "Bento Fernandes",
		state: "RN"
	},
	{
		ibgeCode: "2401651",
		cityName: "Bodó",
		state: "RN"
	},
	{
		ibgeCode: "2401701",
		cityName: "Bom Jesus",
		state: "RN"
	},
	{
		ibgeCode: "2401800",
		cityName: "Brejinho",
		state: "RN"
	},
	{
		ibgeCode: "2401859",
		cityName: "Caiçara do Norte",
		state: "RN"
	},
	{
		ibgeCode: "2401909",
		cityName: "Caiçara do Rio do Vento",
		state: "RN"
	},
	{
		ibgeCode: "2402006",
		cityName: "Caicó",
		state: "RN"
	},
	{
		ibgeCode: "2401305",
		cityName: "Campo Grande",
		state: "RN"
	},
	{
		ibgeCode: "2402105",
		cityName: "Campo Redondo",
		state: "RN"
	},
	{
		ibgeCode: "2402204",
		cityName: "Canguaretama",
		state: "RN"
	},
	{
		ibgeCode: "2402303",
		cityName: "Caraúbas",
		state: "RN"
	},
	{
		ibgeCode: "2402402",
		cityName: "Carnaúba dos Dantas",
		state: "RN"
	},
	{
		ibgeCode: "2402501",
		cityName: "Carnaubais",
		state: "RN"
	},
	{
		ibgeCode: "2402600",
		cityName: "Ceará-Mirim",
		state: "RN"
	},
	{
		ibgeCode: "2402709",
		cityName: "Cerro Corá",
		state: "RN"
	},
	{
		ibgeCode: "2402808",
		cityName: "Coronel Ezequiel",
		state: "RN"
	},
	{
		ibgeCode: "2402907",
		cityName: "Coronel João Pessoa",
		state: "RN"
	},
	{
		ibgeCode: "2403004",
		cityName: "Cruzeta",
		state: "RN"
	},
	{
		ibgeCode: "2403103",
		cityName: "Currais Novos",
		state: "RN"
	},
	{
		ibgeCode: "2403202",
		cityName: "Doutor Severiano",
		state: "RN"
	},
	{
		ibgeCode: "2403301",
		cityName: "Encanto",
		state: "RN"
	},
	{
		ibgeCode: "2403400",
		cityName: "Equador",
		state: "RN"
	},
	{
		ibgeCode: "2403509",
		cityName: "Espírito Santo",
		state: "RN"
	},
	{
		ibgeCode: "2403608",
		cityName: "Extremoz",
		state: "RN"
	},
	{
		ibgeCode: "2403707",
		cityName: "Felipe Guerra",
		state: "RN"
	},
	{
		ibgeCode: "2403756",
		cityName: "Fernando Pedroza",
		state: "RN"
	},
	{
		ibgeCode: "2403806",
		cityName: "Florânia",
		state: "RN"
	},
	{
		ibgeCode: "2403905",
		cityName: "Francisco Dantas",
		state: "RN"
	},
	{
		ibgeCode: "2404002",
		cityName: "Frutuoso Gomes",
		state: "RN"
	},
	{
		ibgeCode: "2404101",
		cityName: "Galinhos",
		state: "RN"
	},
	{
		ibgeCode: "2404200",
		cityName: "Goianinha",
		state: "RN"
	},
	{
		ibgeCode: "2404309",
		cityName: "Governador Dix-Sept Rosado",
		state: "RN"
	},
	{
		ibgeCode: "2404408",
		cityName: "Grossos",
		state: "RN"
	},
	{
		ibgeCode: "2404507",
		cityName: "Guamaré",
		state: "RN"
	},
	{
		ibgeCode: "2404606",
		cityName: "Ielmo Marinho",
		state: "RN"
	},
	{
		ibgeCode: "2404705",
		cityName: "Ipanguaçu",
		state: "RN"
	},
	{
		ibgeCode: "2404804",
		cityName: "Ipueira",
		state: "RN"
	},
	{
		ibgeCode: "2404853",
		cityName: "Itajá",
		state: "RN"
	},
	{
		ibgeCode: "2404903",
		cityName: "Itaú",
		state: "RN"
	},
	{
		ibgeCode: "2405009",
		cityName: "Jaçanã",
		state: "RN"
	},
	{
		ibgeCode: "2405108",
		cityName: "Jandaíra",
		state: "RN"
	},
	{
		ibgeCode: "2405207",
		cityName: "Janduís",
		state: "RN"
	},
	{
		ibgeCode: "2405306",
		cityName: "Januário Cicco",
		state: "RN"
	},
	{
		ibgeCode: "2405405",
		cityName: "Japi",
		state: "RN"
	},
	{
		ibgeCode: "2405504",
		cityName: "Jardim de Angicos",
		state: "RN"
	},
	{
		ibgeCode: "2405603",
		cityName: "Jardim de Piranhas",
		state: "RN"
	},
	{
		ibgeCode: "2405702",
		cityName: "Jardim do Seridó",
		state: "RN"
	},
	{
		ibgeCode: "2405801",
		cityName: "João Câmara",
		state: "RN"
	},
	{
		ibgeCode: "2405900",
		cityName: "João Dias",
		state: "RN"
	},
	{
		ibgeCode: "2406007",
		cityName: "José da Penha",
		state: "RN"
	},
	{
		ibgeCode: "2406106",
		cityName: "Jucurutu",
		state: "RN"
	},
	{
		ibgeCode: "2406155",
		cityName: "Jundiá",
		state: "RN"
	},
	{
		ibgeCode: "2406205",
		cityName: "Lagoa d'Anta",
		state: "RN"
	},
	{
		ibgeCode: "2406304",
		cityName: "Lagoa de Pedras",
		state: "RN"
	},
	{
		ibgeCode: "2406403",
		cityName: "Lagoa de Velhos",
		state: "RN"
	},
	{
		ibgeCode: "2406502",
		cityName: "Lagoa Nova",
		state: "RN"
	},
	{
		ibgeCode: "2406601",
		cityName: "Lagoa Salgada",
		state: "RN"
	},
	{
		ibgeCode: "2406700",
		cityName: "Lajes",
		state: "RN"
	},
	{
		ibgeCode: "2406809",
		cityName: "Lajes Pintadas",
		state: "RN"
	},
	{
		ibgeCode: "2406908",
		cityName: "Lucrécia",
		state: "RN"
	},
	{
		ibgeCode: "2407005",
		cityName: "Luís Gomes",
		state: "RN"
	},
	{
		ibgeCode: "2407104",
		cityName: "Macaíba",
		state: "RN"
	},
	{
		ibgeCode: "2407203",
		cityName: "Macau",
		state: "RN"
	},
	{
		ibgeCode: "2407252",
		cityName: "Major Sales",
		state: "RN"
	},
	{
		ibgeCode: "2407302",
		cityName: "Marcelino Vieira",
		state: "RN"
	},
	{
		ibgeCode: "2407401",
		cityName: "Martins",
		state: "RN"
	},
	{
		ibgeCode: "2407500",
		cityName: "Maxaranguape",
		state: "RN"
	},
	{
		ibgeCode: "2407609",
		cityName: "Messias Targino",
		state: "RN"
	},
	{
		ibgeCode: "2407708",
		cityName: "Montanhas",
		state: "RN"
	},
	{
		ibgeCode: "2407807",
		cityName: "Monte Alegre",
		state: "RN"
	},
	{
		ibgeCode: "2407906",
		cityName: "Monte das Gameleiras",
		state: "RN"
	},
	{
		ibgeCode: "2408003",
		cityName: "Mossoró",
		state: "RN"
	},
	{
		ibgeCode: "2408102",
		cityName: "Natal",
		state: "RN"
	},
	{
		ibgeCode: "2408201",
		cityName: "Nísia Floresta",
		state: "RN"
	},
	{
		ibgeCode: "2408300",
		cityName: "Nova Cruz",
		state: "RN"
	},
	{
		ibgeCode: "2408409",
		cityName: "Olho d'Água do Borges",
		state: "RN"
	},
	{
		ibgeCode: "2408508",
		cityName: "Ouro Branco",
		state: "RN"
	},
	{
		ibgeCode: "2408607",
		cityName: "Paraná",
		state: "RN"
	},
	{
		ibgeCode: "2408706",
		cityName: "Paraú",
		state: "RN"
	},
	{
		ibgeCode: "2408805",
		cityName: "Parazinho",
		state: "RN"
	},
	{
		ibgeCode: "2408904",
		cityName: "Parelhas",
		state: "RN"
	},
	{
		ibgeCode: "2403251",
		cityName: "Parnamirim",
		state: "RN"
	},
	{
		ibgeCode: "2409100",
		cityName: "Passa e Fica",
		state: "RN"
	},
	{
		ibgeCode: "2409209",
		cityName: "Passagem",
		state: "RN"
	},
	{
		ibgeCode: "2409308",
		cityName: "Patu",
		state: "RN"
	},
	{
		ibgeCode: "2409407",
		cityName: "Pau dos Ferros",
		state: "RN"
	},
	{
		ibgeCode: "2409506",
		cityName: "Pedra Grande",
		state: "RN"
	},
	{
		ibgeCode: "2409605",
		cityName: "Pedra Preta",
		state: "RN"
	},
	{
		ibgeCode: "2409704",
		cityName: "Pedro Avelino",
		state: "RN"
	},
	{
		ibgeCode: "2409803",
		cityName: "Pedro Velho",
		state: "RN"
	},
	{
		ibgeCode: "2409902",
		cityName: "Pendências",
		state: "RN"
	},
	{
		ibgeCode: "2410009",
		cityName: "Pilões",
		state: "RN"
	},
	{
		ibgeCode: "2410108",
		cityName: "Poço Branco",
		state: "RN"
	},
	{
		ibgeCode: "2410207",
		cityName: "Portalegre",
		state: "RN"
	},
	{
		ibgeCode: "2410256",
		cityName: "Porto do Mangue",
		state: "RN"
	},
	{
		ibgeCode: "2410405",
		cityName: "Pureza",
		state: "RN"
	},
	{
		ibgeCode: "2410504",
		cityName: "Rafael Fernandes",
		state: "RN"
	},
	{
		ibgeCode: "2410603",
		cityName: "Rafael Godeiro",
		state: "RN"
	},
	{
		ibgeCode: "2410702",
		cityName: "Riacho da Cruz",
		state: "RN"
	},
	{
		ibgeCode: "2410801",
		cityName: "Riacho de Santana",
		state: "RN"
	},
	{
		ibgeCode: "2410900",
		cityName: "Riachuelo",
		state: "RN"
	},
	{
		ibgeCode: "2408953",
		cityName: "Rio do Fogo",
		state: "RN"
	},
	{
		ibgeCode: "2411007",
		cityName: "Rodolfo Fernandes",
		state: "RN"
	},
	{
		ibgeCode: "2411106",
		cityName: "Ruy Barbosa",
		state: "RN"
	},
	{
		ibgeCode: "2411205",
		cityName: "Santa Cruz",
		state: "RN"
	},
	{
		ibgeCode: "2409332",
		cityName: "Santa Maria",
		state: "RN"
	},
	{
		ibgeCode: "2411403",
		cityName: "Santana do Matos",
		state: "RN"
	},
	{
		ibgeCode: "2411429",
		cityName: "Santana do Seridó",
		state: "RN"
	},
	{
		ibgeCode: "2411502",
		cityName: "Santo Antônio",
		state: "RN"
	},
	{
		ibgeCode: "2411601",
		cityName: "São Bento do Norte",
		state: "RN"
	},
	{
		ibgeCode: "2411700",
		cityName: "São Bento do Trairí",
		state: "RN"
	},
	{
		ibgeCode: "2411809",
		cityName: "São Fernando",
		state: "RN"
	},
	{
		ibgeCode: "2411908",
		cityName: "São Francisco do Oeste",
		state: "RN"
	},
	{
		ibgeCode: "2412005",
		cityName: "São Gonçalo do Amarante",
		state: "RN"
	},
	{
		ibgeCode: "2412104",
		cityName: "São João do Sabugi",
		state: "RN"
	},
	{
		ibgeCode: "2412203",
		cityName: "São José de Mipibu",
		state: "RN"
	},
	{
		ibgeCode: "2412302",
		cityName: "São José do Campestre",
		state: "RN"
	},
	{
		ibgeCode: "2412401",
		cityName: "São José do Seridó",
		state: "RN"
	},
	{
		ibgeCode: "2412500",
		cityName: "São Miguel",
		state: "RN"
	},
	{
		ibgeCode: "2412559",
		cityName: "São Miguel do Gostoso",
		state: "RN"
	},
	{
		ibgeCode: "2412609",
		cityName: "São Paulo do Potengi",
		state: "RN"
	},
	{
		ibgeCode: "2412708",
		cityName: "São Pedro",
		state: "RN"
	},
	{
		ibgeCode: "2412807",
		cityName: "São Rafael",
		state: "RN"
	},
	{
		ibgeCode: "2412906",
		cityName: "São Tomé",
		state: "RN"
	},
	{
		ibgeCode: "2413003",
		cityName: "São Vicente",
		state: "RN"
	},
	{
		ibgeCode: "2413102",
		cityName: "Senador Elói de Souza",
		state: "RN"
	},
	{
		ibgeCode: "2413201",
		cityName: "Senador Georgino Avelino",
		state: "RN"
	},
	{
		ibgeCode: "2410306",
		cityName: "Serra Caiada",
		state: "RN"
	},
	{
		ibgeCode: "2413300",
		cityName: "Serra de São Bento",
		state: "RN"
	},
	{
		ibgeCode: "2413359",
		cityName: "Serra do Mel",
		state: "RN"
	},
	{
		ibgeCode: "2413409",
		cityName: "Serra Negra do Norte",
		state: "RN"
	},
	{
		ibgeCode: "2413508",
		cityName: "Serrinha",
		state: "RN"
	},
	{
		ibgeCode: "2413557",
		cityName: "Serrinha dos Pintos",
		state: "RN"
	},
	{
		ibgeCode: "2413607",
		cityName: "Severiano Melo",
		state: "RN"
	},
	{
		ibgeCode: "2413706",
		cityName: "Sítio Novo",
		state: "RN"
	},
	{
		ibgeCode: "2413805",
		cityName: "Taboleiro Grande",
		state: "RN"
	},
	{
		ibgeCode: "2413904",
		cityName: "Taipu",
		state: "RN"
	},
	{
		ibgeCode: "2414001",
		cityName: "Tangará",
		state: "RN"
	},
	{
		ibgeCode: "2414100",
		cityName: "Tenente Ananias",
		state: "RN"
	},
	{
		ibgeCode: "2414159",
		cityName: "Tenente Laurentino Cruz",
		state: "RN"
	},
	{
		ibgeCode: "2411056",
		cityName: "Tibau",
		state: "RN"
	},
	{
		ibgeCode: "2414209",
		cityName: "Tibau do Sul",
		state: "RN"
	},
	{
		ibgeCode: "2414308",
		cityName: "Timbaúba dos Batistas",
		state: "RN"
	},
	{
		ibgeCode: "2414407",
		cityName: "Touros",
		state: "RN"
	},
	{
		ibgeCode: "2414456",
		cityName: "Triunfo Potiguar",
		state: "RN"
	},
	{
		ibgeCode: "2414506",
		cityName: "Umarizal",
		state: "RN"
	},
	{
		ibgeCode: "2414605",
		cityName: "Upanema",
		state: "RN"
	},
	{
		ibgeCode: "2414704",
		cityName: "Várzea",
		state: "RN"
	},
	{
		ibgeCode: "2414753",
		cityName: "Venha-Ver",
		state: "RN"
	},
	{
		ibgeCode: "2414803",
		cityName: "Vera Cruz",
		state: "RN"
	},
	{
		ibgeCode: "2414902",
		cityName: "Viçosa",
		state: "RN"
	},
	{
		ibgeCode: "2415008",
		cityName: "Vila Flor",
		state: "RN"
	}
];
var RS = [
	{
		ibgeCode: "4300034",
		cityName: "Aceguá",
		state: "RS"
	},
	{
		ibgeCode: "4300059",
		cityName: "Água Santa",
		state: "RS"
	},
	{
		ibgeCode: "4300109",
		cityName: "Agudo",
		state: "RS"
	},
	{
		ibgeCode: "4300208",
		cityName: "Ajuricaba",
		state: "RS"
	},
	{
		ibgeCode: "4300307",
		cityName: "Alecrim",
		state: "RS"
	},
	{
		ibgeCode: "4300406",
		cityName: "Alegrete",
		state: "RS"
	},
	{
		ibgeCode: "4300455",
		cityName: "Alegria",
		state: "RS"
	},
	{
		ibgeCode: "4300471",
		cityName: "Almirante Tamandaré do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4300505",
		cityName: "Alpestre",
		state: "RS"
	},
	{
		ibgeCode: "4300554",
		cityName: "Alto Alegre",
		state: "RS"
	},
	{
		ibgeCode: "4300570",
		cityName: "Alto Feliz",
		state: "RS"
	},
	{
		ibgeCode: "4300604",
		cityName: "Alvorada",
		state: "RS"
	},
	{
		ibgeCode: "4300638",
		cityName: "Amaral Ferrador",
		state: "RS"
	},
	{
		ibgeCode: "4300646",
		cityName: "Ametista do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4300661",
		cityName: "André da Rocha",
		state: "RS"
	},
	{
		ibgeCode: "4300703",
		cityName: "Anta Gorda",
		state: "RS"
	},
	{
		ibgeCode: "4300802",
		cityName: "Antônio Prado",
		state: "RS"
	},
	{
		ibgeCode: "4300851",
		cityName: "Arambaré",
		state: "RS"
	},
	{
		ibgeCode: "4300877",
		cityName: "Araricá",
		state: "RS"
	},
	{
		ibgeCode: "4300901",
		cityName: "Aratiba",
		state: "RS"
	},
	{
		ibgeCode: "4301008",
		cityName: "Arroio do Meio",
		state: "RS"
	},
	{
		ibgeCode: "4301073",
		cityName: "Arroio do Padre",
		state: "RS"
	},
	{
		ibgeCode: "4301057",
		cityName: "Arroio do Sal",
		state: "RS"
	},
	{
		ibgeCode: "4301206",
		cityName: "Arroio do Tigre",
		state: "RS"
	},
	{
		ibgeCode: "4301107",
		cityName: "Arroio dos Ratos",
		state: "RS"
	},
	{
		ibgeCode: "4301305",
		cityName: "Arroio Grande",
		state: "RS"
	},
	{
		ibgeCode: "4301404",
		cityName: "Arvorezinha",
		state: "RS"
	},
	{
		ibgeCode: "4301503",
		cityName: "Augusto Pestana",
		state: "RS"
	},
	{
		ibgeCode: "4301552",
		cityName: "Áurea",
		state: "RS"
	},
	{
		ibgeCode: "4301602",
		cityName: "Bagé",
		state: "RS"
	},
	{
		ibgeCode: "4301636",
		cityName: "Balneário Pinhal",
		state: "RS"
	},
	{
		ibgeCode: "4301651",
		cityName: "Barão",
		state: "RS"
	},
	{
		ibgeCode: "4301701",
		cityName: "Barão de Cotegipe",
		state: "RS"
	},
	{
		ibgeCode: "4301750",
		cityName: "Barão do Triunfo",
		state: "RS"
	},
	{
		ibgeCode: "4301859",
		cityName: "Barra do Guarita",
		state: "RS"
	},
	{
		ibgeCode: "4301875",
		cityName: "Barra do Quaraí",
		state: "RS"
	},
	{
		ibgeCode: "4301909",
		cityName: "Barra do Ribeiro",
		state: "RS"
	},
	{
		ibgeCode: "4301925",
		cityName: "Barra do Rio Azul",
		state: "RS"
	},
	{
		ibgeCode: "4301958",
		cityName: "Barra Funda",
		state: "RS"
	},
	{
		ibgeCode: "4301800",
		cityName: "Barracão",
		state: "RS"
	},
	{
		ibgeCode: "4302006",
		cityName: "Barros Cassal",
		state: "RS"
	},
	{
		ibgeCode: "4302055",
		cityName: "Benjamin Constant do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4302105",
		cityName: "Bento Gonçalves",
		state: "RS"
	},
	{
		ibgeCode: "4302154",
		cityName: "Boa Vista das Missões",
		state: "RS"
	},
	{
		ibgeCode: "4302204",
		cityName: "Boa Vista do Buricá",
		state: "RS"
	},
	{
		ibgeCode: "4302220",
		cityName: "Boa Vista do Cadeado",
		state: "RS"
	},
	{
		ibgeCode: "4302238",
		cityName: "Boa Vista do Incra",
		state: "RS"
	},
	{
		ibgeCode: "4302253",
		cityName: "Boa Vista do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4302303",
		cityName: "Bom Jesus",
		state: "RS"
	},
	{
		ibgeCode: "4302352",
		cityName: "Bom Princípio",
		state: "RS"
	},
	{
		ibgeCode: "4302378",
		cityName: "Bom Progresso",
		state: "RS"
	},
	{
		ibgeCode: "4302402",
		cityName: "Bom Retiro do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4302451",
		cityName: "Boqueirão do Leão",
		state: "RS"
	},
	{
		ibgeCode: "4302501",
		cityName: "Bossoroca",
		state: "RS"
	},
	{
		ibgeCode: "4302584",
		cityName: "Bozano",
		state: "RS"
	},
	{
		ibgeCode: "4302600",
		cityName: "Braga",
		state: "RS"
	},
	{
		ibgeCode: "4302659",
		cityName: "Brochier",
		state: "RS"
	},
	{
		ibgeCode: "4302709",
		cityName: "Butiá",
		state: "RS"
	},
	{
		ibgeCode: "4302808",
		cityName: "Caçapava do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4302907",
		cityName: "Cacequi",
		state: "RS"
	},
	{
		ibgeCode: "4303004",
		cityName: "Cachoeira do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4303103",
		cityName: "Cachoeirinha",
		state: "RS"
	},
	{
		ibgeCode: "4303202",
		cityName: "Cacique Doble",
		state: "RS"
	},
	{
		ibgeCode: "4303301",
		cityName: "Caibaté",
		state: "RS"
	},
	{
		ibgeCode: "4303400",
		cityName: "Caiçara",
		state: "RS"
	},
	{
		ibgeCode: "4303509",
		cityName: "Camaquã",
		state: "RS"
	},
	{
		ibgeCode: "4303558",
		cityName: "Camargo",
		state: "RS"
	},
	{
		ibgeCode: "4303608",
		cityName: "Cambará do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4303673",
		cityName: "Campestre da Serra",
		state: "RS"
	},
	{
		ibgeCode: "4303707",
		cityName: "Campina das Missões",
		state: "RS"
	},
	{
		ibgeCode: "4303806",
		cityName: "Campinas do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4303905",
		cityName: "Campo Bom",
		state: "RS"
	},
	{
		ibgeCode: "4304002",
		cityName: "Campo Novo",
		state: "RS"
	},
	{
		ibgeCode: "4304101",
		cityName: "Campos Borges",
		state: "RS"
	},
	{
		ibgeCode: "4304200",
		cityName: "Candelária",
		state: "RS"
	},
	{
		ibgeCode: "4304309",
		cityName: "Cândido Godói",
		state: "RS"
	},
	{
		ibgeCode: "4304358",
		cityName: "Candiota",
		state: "RS"
	},
	{
		ibgeCode: "4304408",
		cityName: "Canela",
		state: "RS"
	},
	{
		ibgeCode: "4304507",
		cityName: "Canguçu",
		state: "RS"
	},
	{
		ibgeCode: "4304606",
		cityName: "Canoas",
		state: "RS"
	},
	{
		ibgeCode: "4304614",
		cityName: "Canudos do Vale",
		state: "RS"
	},
	{
		ibgeCode: "4304622",
		cityName: "Capão Bonito do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4304630",
		cityName: "Capão da Canoa",
		state: "RS"
	},
	{
		ibgeCode: "4304655",
		cityName: "Capão do Cipó",
		state: "RS"
	},
	{
		ibgeCode: "4304663",
		cityName: "Capão do Leão",
		state: "RS"
	},
	{
		ibgeCode: "4304689",
		cityName: "Capela de Santana",
		state: "RS"
	},
	{
		ibgeCode: "4304697",
		cityName: "Capitão",
		state: "RS"
	},
	{
		ibgeCode: "4304671",
		cityName: "Capivari do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4304713",
		cityName: "Caraá",
		state: "RS"
	},
	{
		ibgeCode: "4304705",
		cityName: "Carazinho",
		state: "RS"
	},
	{
		ibgeCode: "4304804",
		cityName: "Carlos Barbosa",
		state: "RS"
	},
	{
		ibgeCode: "4304853",
		cityName: "Carlos Gomes",
		state: "RS"
	},
	{
		ibgeCode: "4304903",
		cityName: "Casca",
		state: "RS"
	},
	{
		ibgeCode: "4304952",
		cityName: "Caseiros",
		state: "RS"
	},
	{
		ibgeCode: "4305009",
		cityName: "Catuípe",
		state: "RS"
	},
	{
		ibgeCode: "4305108",
		cityName: "Caxias do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4305116",
		cityName: "Centenário",
		state: "RS"
	},
	{
		ibgeCode: "4305124",
		cityName: "Cerrito",
		state: "RS"
	},
	{
		ibgeCode: "4305132",
		cityName: "Cerro Branco",
		state: "RS"
	},
	{
		ibgeCode: "4305157",
		cityName: "Cerro Grande",
		state: "RS"
	},
	{
		ibgeCode: "4305173",
		cityName: "Cerro Grande do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4305207",
		cityName: "Cerro Largo",
		state: "RS"
	},
	{
		ibgeCode: "4305306",
		cityName: "Chapada",
		state: "RS"
	},
	{
		ibgeCode: "4305355",
		cityName: "Charqueadas",
		state: "RS"
	},
	{
		ibgeCode: "4305371",
		cityName: "Charrua",
		state: "RS"
	},
	{
		ibgeCode: "4305405",
		cityName: "Chiapetta",
		state: "RS"
	},
	{
		ibgeCode: "4305439",
		cityName: "Chuí",
		state: "RS"
	},
	{
		ibgeCode: "4305447",
		cityName: "Chuvisca",
		state: "RS"
	},
	{
		ibgeCode: "4305454",
		cityName: "Cidreira",
		state: "RS"
	},
	{
		ibgeCode: "4305504",
		cityName: "Ciríaco",
		state: "RS"
	},
	{
		ibgeCode: "4305587",
		cityName: "Colinas",
		state: "RS"
	},
	{
		ibgeCode: "4305603",
		cityName: "Colorado",
		state: "RS"
	},
	{
		ibgeCode: "4305702",
		cityName: "Condor",
		state: "RS"
	},
	{
		ibgeCode: "4305801",
		cityName: "Constantina",
		state: "RS"
	},
	{
		ibgeCode: "4305835",
		cityName: "Coqueiro Baixo",
		state: "RS"
	},
	{
		ibgeCode: "4305850",
		cityName: "Coqueiros do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4305871",
		cityName: "Coronel Barros",
		state: "RS"
	},
	{
		ibgeCode: "4305900",
		cityName: "Coronel Bicaco",
		state: "RS"
	},
	{
		ibgeCode: "4305934",
		cityName: "Coronel Pilar",
		state: "RS"
	},
	{
		ibgeCode: "4305959",
		cityName: "Cotiporã",
		state: "RS"
	},
	{
		ibgeCode: "4305975",
		cityName: "Coxilha",
		state: "RS"
	},
	{
		ibgeCode: "4306007",
		cityName: "Crissiumal",
		state: "RS"
	},
	{
		ibgeCode: "4306056",
		cityName: "Cristal",
		state: "RS"
	},
	{
		ibgeCode: "4306072",
		cityName: "Cristal do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4306106",
		cityName: "Cruz Alta",
		state: "RS"
	},
	{
		ibgeCode: "4306130",
		cityName: "Cruzaltense",
		state: "RS"
	},
	{
		ibgeCode: "4306205",
		cityName: "Cruzeiro do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4306304",
		cityName: "David Canabarro",
		state: "RS"
	},
	{
		ibgeCode: "4306320",
		cityName: "Derrubadas",
		state: "RS"
	},
	{
		ibgeCode: "4306353",
		cityName: "Dezesseis de Novembro",
		state: "RS"
	},
	{
		ibgeCode: "4306379",
		cityName: "Dilermando de Aguiar",
		state: "RS"
	},
	{
		ibgeCode: "4306403",
		cityName: "Dois Irmãos",
		state: "RS"
	},
	{
		ibgeCode: "4306429",
		cityName: "Dois Irmãos das Missões",
		state: "RS"
	},
	{
		ibgeCode: "4306452",
		cityName: "Dois Lajeados",
		state: "RS"
	},
	{
		ibgeCode: "4306502",
		cityName: "Dom Feliciano",
		state: "RS"
	},
	{
		ibgeCode: "4306601",
		cityName: "Dom Pedrito",
		state: "RS"
	},
	{
		ibgeCode: "4306551",
		cityName: "Dom Pedro de Alcântara",
		state: "RS"
	},
	{
		ibgeCode: "4306700",
		cityName: "Dona Francisca",
		state: "RS"
	},
	{
		ibgeCode: "4306734",
		cityName: "Doutor Maurício Cardoso",
		state: "RS"
	},
	{
		ibgeCode: "4306759",
		cityName: "Doutor Ricardo",
		state: "RS"
	},
	{
		ibgeCode: "4306767",
		cityName: "Eldorado do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4306809",
		cityName: "Encantado",
		state: "RS"
	},
	{
		ibgeCode: "4306908",
		cityName: "Encruzilhada do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4306924",
		cityName: "Engenho Velho",
		state: "RS"
	},
	{
		ibgeCode: "4306957",
		cityName: "Entre Rios do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4306932",
		cityName: "Entre-Ijuís",
		state: "RS"
	},
	{
		ibgeCode: "4306973",
		cityName: "Erebango",
		state: "RS"
	},
	{
		ibgeCode: "4307005",
		cityName: "Erechim",
		state: "RS"
	},
	{
		ibgeCode: "4307054",
		cityName: "Ernestina",
		state: "RS"
	},
	{
		ibgeCode: "4307203",
		cityName: "Erval Grande",
		state: "RS"
	},
	{
		ibgeCode: "4307302",
		cityName: "Erval Seco",
		state: "RS"
	},
	{
		ibgeCode: "4307401",
		cityName: "Esmeralda",
		state: "RS"
	},
	{
		ibgeCode: "4307450",
		cityName: "Esperança do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4307500",
		cityName: "Espumoso",
		state: "RS"
	},
	{
		ibgeCode: "4307559",
		cityName: "Estação",
		state: "RS"
	},
	{
		ibgeCode: "4307609",
		cityName: "Estância Velha",
		state: "RS"
	},
	{
		ibgeCode: "4307708",
		cityName: "Esteio",
		state: "RS"
	},
	{
		ibgeCode: "4307807",
		cityName: "Estrela",
		state: "RS"
	},
	{
		ibgeCode: "4307815",
		cityName: "Estrela Velha",
		state: "RS"
	},
	{
		ibgeCode: "4307831",
		cityName: "Eugênio de Castro",
		state: "RS"
	},
	{
		ibgeCode: "4307864",
		cityName: "Fagundes Varela",
		state: "RS"
	},
	{
		ibgeCode: "4307906",
		cityName: "Farroupilha",
		state: "RS"
	},
	{
		ibgeCode: "4308003",
		cityName: "Faxinal do Soturno",
		state: "RS"
	},
	{
		ibgeCode: "4308052",
		cityName: "Faxinalzinho",
		state: "RS"
	},
	{
		ibgeCode: "4308078",
		cityName: "Fazenda Vilanova",
		state: "RS"
	},
	{
		ibgeCode: "4308102",
		cityName: "Feliz",
		state: "RS"
	},
	{
		ibgeCode: "4308201",
		cityName: "Flores da Cunha",
		state: "RS"
	},
	{
		ibgeCode: "4308250",
		cityName: "Floriano Peixoto",
		state: "RS"
	},
	{
		ibgeCode: "4308300",
		cityName: "Fontoura Xavier",
		state: "RS"
	},
	{
		ibgeCode: "4308409",
		cityName: "Formigueiro",
		state: "RS"
	},
	{
		ibgeCode: "4308433",
		cityName: "Forquetinha",
		state: "RS"
	},
	{
		ibgeCode: "4308458",
		cityName: "Fortaleza dos Valos",
		state: "RS"
	},
	{
		ibgeCode: "4308508",
		cityName: "Frederico Westphalen",
		state: "RS"
	},
	{
		ibgeCode: "4308607",
		cityName: "Garibaldi",
		state: "RS"
	},
	{
		ibgeCode: "4308656",
		cityName: "Garruchos",
		state: "RS"
	},
	{
		ibgeCode: "4308706",
		cityName: "Gaurama",
		state: "RS"
	},
	{
		ibgeCode: "4308805",
		cityName: "General Câmara",
		state: "RS"
	},
	{
		ibgeCode: "4308854",
		cityName: "Gentil",
		state: "RS"
	},
	{
		ibgeCode: "4308904",
		cityName: "Getúlio Vargas",
		state: "RS"
	},
	{
		ibgeCode: "4309001",
		cityName: "Giruá",
		state: "RS"
	},
	{
		ibgeCode: "4309050",
		cityName: "Glorinha",
		state: "RS"
	},
	{
		ibgeCode: "4309100",
		cityName: "Gramado",
		state: "RS"
	},
	{
		ibgeCode: "4309126",
		cityName: "Gramado dos Loureiros",
		state: "RS"
	},
	{
		ibgeCode: "4309159",
		cityName: "Gramado Xavier",
		state: "RS"
	},
	{
		ibgeCode: "4309209",
		cityName: "Gravataí",
		state: "RS"
	},
	{
		ibgeCode: "4309258",
		cityName: "Guabiju",
		state: "RS"
	},
	{
		ibgeCode: "4309308",
		cityName: "Guaíba",
		state: "RS"
	},
	{
		ibgeCode: "4309407",
		cityName: "Guaporé",
		state: "RS"
	},
	{
		ibgeCode: "4309506",
		cityName: "Guarani das Missões",
		state: "RS"
	},
	{
		ibgeCode: "4309555",
		cityName: "Harmonia",
		state: "RS"
	},
	{
		ibgeCode: "4307104",
		cityName: "Herval",
		state: "RS"
	},
	{
		ibgeCode: "4309571",
		cityName: "Herveiras",
		state: "RS"
	},
	{
		ibgeCode: "4309605",
		cityName: "Horizontina",
		state: "RS"
	},
	{
		ibgeCode: "4309654",
		cityName: "Hulha Negra",
		state: "RS"
	},
	{
		ibgeCode: "4309704",
		cityName: "Humaitá",
		state: "RS"
	},
	{
		ibgeCode: "4309753",
		cityName: "Ibarama",
		state: "RS"
	},
	{
		ibgeCode: "4309803",
		cityName: "Ibiaçá",
		state: "RS"
	},
	{
		ibgeCode: "4309902",
		cityName: "Ibiraiaras",
		state: "RS"
	},
	{
		ibgeCode: "4309951",
		cityName: "Ibirapuitã",
		state: "RS"
	},
	{
		ibgeCode: "4310009",
		cityName: "Ibirubá",
		state: "RS"
	},
	{
		ibgeCode: "4310108",
		cityName: "Igrejinha",
		state: "RS"
	},
	{
		ibgeCode: "4310207",
		cityName: "Ijuí",
		state: "RS"
	},
	{
		ibgeCode: "4310306",
		cityName: "Ilópolis",
		state: "RS"
	},
	{
		ibgeCode: "4310330",
		cityName: "Imbé",
		state: "RS"
	},
	{
		ibgeCode: "4310363",
		cityName: "Imigrante",
		state: "RS"
	},
	{
		ibgeCode: "4310405",
		cityName: "Independência",
		state: "RS"
	},
	{
		ibgeCode: "4310413",
		cityName: "Inhacorá",
		state: "RS"
	},
	{
		ibgeCode: "4310439",
		cityName: "Ipê",
		state: "RS"
	},
	{
		ibgeCode: "4310462",
		cityName: "Ipiranga do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4310504",
		cityName: "Iraí",
		state: "RS"
	},
	{
		ibgeCode: "4310538",
		cityName: "Itaara",
		state: "RS"
	},
	{
		ibgeCode: "4310553",
		cityName: "Itacurubi",
		state: "RS"
	},
	{
		ibgeCode: "4310579",
		cityName: "Itapuca",
		state: "RS"
	},
	{
		ibgeCode: "4310603",
		cityName: "Itaqui",
		state: "RS"
	},
	{
		ibgeCode: "4310652",
		cityName: "Itati",
		state: "RS"
	},
	{
		ibgeCode: "4310702",
		cityName: "Itatiba do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4310751",
		cityName: "Ivorá",
		state: "RS"
	},
	{
		ibgeCode: "4310801",
		cityName: "Ivoti",
		state: "RS"
	},
	{
		ibgeCode: "4310850",
		cityName: "Jaboticaba",
		state: "RS"
	},
	{
		ibgeCode: "4310876",
		cityName: "Jacuizinho",
		state: "RS"
	},
	{
		ibgeCode: "4310900",
		cityName: "Jacutinga",
		state: "RS"
	},
	{
		ibgeCode: "4311007",
		cityName: "Jaguarão",
		state: "RS"
	},
	{
		ibgeCode: "4311106",
		cityName: "Jaguari",
		state: "RS"
	},
	{
		ibgeCode: "4311122",
		cityName: "Jaquirana",
		state: "RS"
	},
	{
		ibgeCode: "4311130",
		cityName: "Jari",
		state: "RS"
	},
	{
		ibgeCode: "4311155",
		cityName: "Jóia",
		state: "RS"
	},
	{
		ibgeCode: "4311205",
		cityName: "Júlio de Castilhos",
		state: "RS"
	},
	{
		ibgeCode: "4311239",
		cityName: "Lagoa Bonita do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4311270",
		cityName: "Lagoa dos Três Cantos",
		state: "RS"
	},
	{
		ibgeCode: "4311304",
		cityName: "Lagoa Vermelha",
		state: "RS"
	},
	{
		ibgeCode: "4311254",
		cityName: "Lagoão",
		state: "RS"
	},
	{
		ibgeCode: "4311403",
		cityName: "Lajeado",
		state: "RS"
	},
	{
		ibgeCode: "4311429",
		cityName: "Lajeado do Bugre",
		state: "RS"
	},
	{
		ibgeCode: "4311502",
		cityName: "Lavras do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4311601",
		cityName: "Liberato Salzano",
		state: "RS"
	},
	{
		ibgeCode: "4311627",
		cityName: "Lindolfo Collor",
		state: "RS"
	},
	{
		ibgeCode: "4311643",
		cityName: "Linha Nova",
		state: "RS"
	},
	{
		ibgeCode: "4311718",
		cityName: "Maçambará",
		state: "RS"
	},
	{
		ibgeCode: "4311700",
		cityName: "Machadinho",
		state: "RS"
	},
	{
		ibgeCode: "4311734",
		cityName: "Mampituba",
		state: "RS"
	},
	{
		ibgeCode: "4311759",
		cityName: "Manoel Viana",
		state: "RS"
	},
	{
		ibgeCode: "4311775",
		cityName: "Maquiné",
		state: "RS"
	},
	{
		ibgeCode: "4311791",
		cityName: "Maratá",
		state: "RS"
	},
	{
		ibgeCode: "4311809",
		cityName: "Marau",
		state: "RS"
	},
	{
		ibgeCode: "4311908",
		cityName: "Marcelino Ramos",
		state: "RS"
	},
	{
		ibgeCode: "4311981",
		cityName: "Mariana Pimentel",
		state: "RS"
	},
	{
		ibgeCode: "4312005",
		cityName: "Mariano Moro",
		state: "RS"
	},
	{
		ibgeCode: "4312054",
		cityName: "Marques de Souza",
		state: "RS"
	},
	{
		ibgeCode: "4312104",
		cityName: "Mata",
		state: "RS"
	},
	{
		ibgeCode: "4312138",
		cityName: "Mato Castelhano",
		state: "RS"
	},
	{
		ibgeCode: "4312153",
		cityName: "Mato Leitão",
		state: "RS"
	},
	{
		ibgeCode: "4312179",
		cityName: "Mato Queimado",
		state: "RS"
	},
	{
		ibgeCode: "4312203",
		cityName: "Maximiliano de Almeida",
		state: "RS"
	},
	{
		ibgeCode: "4312252",
		cityName: "Minas do Leão",
		state: "RS"
	},
	{
		ibgeCode: "4312302",
		cityName: "Miraguaí",
		state: "RS"
	},
	{
		ibgeCode: "4312351",
		cityName: "Montauri",
		state: "RS"
	},
	{
		ibgeCode: "4312377",
		cityName: "Monte Alegre dos Campos",
		state: "RS"
	},
	{
		ibgeCode: "4312385",
		cityName: "Monte Belo do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4312401",
		cityName: "Montenegro",
		state: "RS"
	},
	{
		ibgeCode: "4312427",
		cityName: "Mormaço",
		state: "RS"
	},
	{
		ibgeCode: "4312443",
		cityName: "Morrinhos do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4312450",
		cityName: "Morro Redondo",
		state: "RS"
	},
	{
		ibgeCode: "4312476",
		cityName: "Morro Reuter",
		state: "RS"
	},
	{
		ibgeCode: "4312500",
		cityName: "Mostardas",
		state: "RS"
	},
	{
		ibgeCode: "4312609",
		cityName: "Muçum",
		state: "RS"
	},
	{
		ibgeCode: "4312617",
		cityName: "Muitos Capões",
		state: "RS"
	},
	{
		ibgeCode: "4312625",
		cityName: "Muliterno",
		state: "RS"
	},
	{
		ibgeCode: "4312658",
		cityName: "Não-Me-Toque",
		state: "RS"
	},
	{
		ibgeCode: "4312674",
		cityName: "Nicolau Vergueiro",
		state: "RS"
	},
	{
		ibgeCode: "4312708",
		cityName: "Nonoai",
		state: "RS"
	},
	{
		ibgeCode: "4312757",
		cityName: "Nova Alvorada",
		state: "RS"
	},
	{
		ibgeCode: "4312807",
		cityName: "Nova Araçá",
		state: "RS"
	},
	{
		ibgeCode: "4312906",
		cityName: "Nova Bassano",
		state: "RS"
	},
	{
		ibgeCode: "4312955",
		cityName: "Nova Boa Vista",
		state: "RS"
	},
	{
		ibgeCode: "4313003",
		cityName: "Nova Bréscia",
		state: "RS"
	},
	{
		ibgeCode: "4313011",
		cityName: "Nova Candelária",
		state: "RS"
	},
	{
		ibgeCode: "4313037",
		cityName: "Nova Esperança do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4313060",
		cityName: "Nova Hartz",
		state: "RS"
	},
	{
		ibgeCode: "4313086",
		cityName: "Nova Pádua",
		state: "RS"
	},
	{
		ibgeCode: "4313102",
		cityName: "Nova Palma",
		state: "RS"
	},
	{
		ibgeCode: "4313201",
		cityName: "Nova Petrópolis",
		state: "RS"
	},
	{
		ibgeCode: "4313300",
		cityName: "Nova Prata",
		state: "RS"
	},
	{
		ibgeCode: "4313334",
		cityName: "Nova Ramada",
		state: "RS"
	},
	{
		ibgeCode: "4313359",
		cityName: "Nova Roma do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4313375",
		cityName: "Nova Santa Rita",
		state: "RS"
	},
	{
		ibgeCode: "4313490",
		cityName: "Novo Barreiro",
		state: "RS"
	},
	{
		ibgeCode: "4313391",
		cityName: "Novo Cabrais",
		state: "RS"
	},
	{
		ibgeCode: "4313409",
		cityName: "Novo Hamburgo",
		state: "RS"
	},
	{
		ibgeCode: "4313425",
		cityName: "Novo Machado",
		state: "RS"
	},
	{
		ibgeCode: "4313441",
		cityName: "Novo Tiradentes",
		state: "RS"
	},
	{
		ibgeCode: "4313466",
		cityName: "Novo Xingu",
		state: "RS"
	},
	{
		ibgeCode: "4313508",
		cityName: "Osório",
		state: "RS"
	},
	{
		ibgeCode: "4313607",
		cityName: "Paim Filho",
		state: "RS"
	},
	{
		ibgeCode: "4313656",
		cityName: "Palmares do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4313706",
		cityName: "Palmeira das Missões",
		state: "RS"
	},
	{
		ibgeCode: "4313805",
		cityName: "Palmitinho",
		state: "RS"
	},
	{
		ibgeCode: "4313904",
		cityName: "Panambi",
		state: "RS"
	},
	{
		ibgeCode: "4313953",
		cityName: "Pantano Grande",
		state: "RS"
	},
	{
		ibgeCode: "4314001",
		cityName: "Paraí",
		state: "RS"
	},
	{
		ibgeCode: "4314027",
		cityName: "Paraíso do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4314035",
		cityName: "Pareci Novo",
		state: "RS"
	},
	{
		ibgeCode: "4314050",
		cityName: "Parobé",
		state: "RS"
	},
	{
		ibgeCode: "4314068",
		cityName: "Passa Sete",
		state: "RS"
	},
	{
		ibgeCode: "4314076",
		cityName: "Passo do Sobrado",
		state: "RS"
	},
	{
		ibgeCode: "4314100",
		cityName: "Passo Fundo",
		state: "RS"
	},
	{
		ibgeCode: "4314134",
		cityName: "Paulo Bento",
		state: "RS"
	},
	{
		ibgeCode: "4314159",
		cityName: "Paverama",
		state: "RS"
	},
	{
		ibgeCode: "4314175",
		cityName: "Pedras Altas",
		state: "RS"
	},
	{
		ibgeCode: "4314209",
		cityName: "Pedro Osório",
		state: "RS"
	},
	{
		ibgeCode: "4314308",
		cityName: "Pejuçara",
		state: "RS"
	},
	{
		ibgeCode: "4314407",
		cityName: "Pelotas",
		state: "RS"
	},
	{
		ibgeCode: "4314423",
		cityName: "Picada Café",
		state: "RS"
	},
	{
		ibgeCode: "4314456",
		cityName: "Pinhal",
		state: "RS"
	},
	{
		ibgeCode: "4314464",
		cityName: "Pinhal da Serra",
		state: "RS"
	},
	{
		ibgeCode: "4314472",
		cityName: "Pinhal Grande",
		state: "RS"
	},
	{
		ibgeCode: "4314498",
		cityName: "Pinheirinho do Vale",
		state: "RS"
	},
	{
		ibgeCode: "4314506",
		cityName: "Pinheiro Machado",
		state: "RS"
	},
	{
		ibgeCode: "4314548",
		cityName: "Pinto Bandeira",
		state: "RS"
	},
	{
		ibgeCode: "4314555",
		cityName: "Pirapó",
		state: "RS"
	},
	{
		ibgeCode: "4314605",
		cityName: "Piratini",
		state: "RS"
	},
	{
		ibgeCode: "4314704",
		cityName: "Planalto",
		state: "RS"
	},
	{
		ibgeCode: "4314753",
		cityName: "Poço das Antas",
		state: "RS"
	},
	{
		ibgeCode: "4314779",
		cityName: "Pontão",
		state: "RS"
	},
	{
		ibgeCode: "4314787",
		cityName: "Ponte Preta",
		state: "RS"
	},
	{
		ibgeCode: "4314803",
		cityName: "Portão",
		state: "RS"
	},
	{
		ibgeCode: "4314902",
		cityName: "Porto Alegre",
		state: "RS"
	},
	{
		ibgeCode: "4315008",
		cityName: "Porto Lucena",
		state: "RS"
	},
	{
		ibgeCode: "4315057",
		cityName: "Porto Mauá",
		state: "RS"
	},
	{
		ibgeCode: "4315073",
		cityName: "Porto Vera Cruz",
		state: "RS"
	},
	{
		ibgeCode: "4315107",
		cityName: "Porto Xavier",
		state: "RS"
	},
	{
		ibgeCode: "4315131",
		cityName: "Pouso Novo",
		state: "RS"
	},
	{
		ibgeCode: "4315149",
		cityName: "Presidente Lucena",
		state: "RS"
	},
	{
		ibgeCode: "4315156",
		cityName: "Progresso",
		state: "RS"
	},
	{
		ibgeCode: "4315172",
		cityName: "Protásio Alves",
		state: "RS"
	},
	{
		ibgeCode: "4315206",
		cityName: "Putinga",
		state: "RS"
	},
	{
		ibgeCode: "4315305",
		cityName: "Quaraí",
		state: "RS"
	},
	{
		ibgeCode: "4315313",
		cityName: "Quatro Irmãos",
		state: "RS"
	},
	{
		ibgeCode: "4315321",
		cityName: "Quevedos",
		state: "RS"
	},
	{
		ibgeCode: "4315354",
		cityName: "Quinze de Novembro",
		state: "RS"
	},
	{
		ibgeCode: "4315404",
		cityName: "Redentora",
		state: "RS"
	},
	{
		ibgeCode: "4315453",
		cityName: "Relvado",
		state: "RS"
	},
	{
		ibgeCode: "4315503",
		cityName: "Restinga Sêca",
		state: "RS"
	},
	{
		ibgeCode: "4315552",
		cityName: "Rio dos Índios",
		state: "RS"
	},
	{
		ibgeCode: "4315602",
		cityName: "Rio Grande",
		state: "RS"
	},
	{
		ibgeCode: "4315701",
		cityName: "Rio Pardo",
		state: "RS"
	},
	{
		ibgeCode: "4315750",
		cityName: "Riozinho",
		state: "RS"
	},
	{
		ibgeCode: "4315800",
		cityName: "Roca Sales",
		state: "RS"
	},
	{
		ibgeCode: "4315909",
		cityName: "Rodeio Bonito",
		state: "RS"
	},
	{
		ibgeCode: "4315958",
		cityName: "Rolador",
		state: "RS"
	},
	{
		ibgeCode: "4316006",
		cityName: "Rolante",
		state: "RS"
	},
	{
		ibgeCode: "4316105",
		cityName: "Ronda Alta",
		state: "RS"
	},
	{
		ibgeCode: "4316204",
		cityName: "Rondinha",
		state: "RS"
	},
	{
		ibgeCode: "4316303",
		cityName: "Roque Gonzales",
		state: "RS"
	},
	{
		ibgeCode: "4316402",
		cityName: "Rosário do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4316428",
		cityName: "Sagrada Família",
		state: "RS"
	},
	{
		ibgeCode: "4316436",
		cityName: "Saldanha Marinho",
		state: "RS"
	},
	{
		ibgeCode: "4316451",
		cityName: "Salto do Jacuí",
		state: "RS"
	},
	{
		ibgeCode: "4316477",
		cityName: "Salvador das Missões",
		state: "RS"
	},
	{
		ibgeCode: "4316501",
		cityName: "Salvador do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4316600",
		cityName: "Sananduva",
		state: "RS"
	},
	{
		ibgeCode: "4316709",
		cityName: "Santa Bárbara do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4316733",
		cityName: "Santa Cecília do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4316758",
		cityName: "Santa Clara do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4316808",
		cityName: "Santa Cruz do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4316972",
		cityName: "Santa Margarida do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4316907",
		cityName: "Santa Maria",
		state: "RS"
	},
	{
		ibgeCode: "4316956",
		cityName: "Santa Maria do Herval",
		state: "RS"
	},
	{
		ibgeCode: "4317202",
		cityName: "Santa Rosa",
		state: "RS"
	},
	{
		ibgeCode: "4317251",
		cityName: "Santa Tereza",
		state: "RS"
	},
	{
		ibgeCode: "4317301",
		cityName: "Santa Vitória do Palmar",
		state: "RS"
	},
	{
		ibgeCode: "4317004",
		cityName: "Santana da Boa Vista",
		state: "RS"
	},
	{
		ibgeCode: "4317103",
		cityName: "Sant'Ana do Livramento",
		state: "RS"
	},
	{
		ibgeCode: "4317400",
		cityName: "Santiago",
		state: "RS"
	},
	{
		ibgeCode: "4317509",
		cityName: "Santo Ângelo",
		state: "RS"
	},
	{
		ibgeCode: "4317608",
		cityName: "Santo Antônio da Patrulha",
		state: "RS"
	},
	{
		ibgeCode: "4317707",
		cityName: "Santo Antônio das Missões",
		state: "RS"
	},
	{
		ibgeCode: "4317558",
		cityName: "Santo Antônio do Palma",
		state: "RS"
	},
	{
		ibgeCode: "4317756",
		cityName: "Santo Antônio do Planalto",
		state: "RS"
	},
	{
		ibgeCode: "4317806",
		cityName: "Santo Augusto",
		state: "RS"
	},
	{
		ibgeCode: "4317905",
		cityName: "Santo Cristo",
		state: "RS"
	},
	{
		ibgeCode: "4317954",
		cityName: "Santo Expedito do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4318002",
		cityName: "São Borja",
		state: "RS"
	},
	{
		ibgeCode: "4318051",
		cityName: "São Domingos do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4318101",
		cityName: "São Francisco de Assis",
		state: "RS"
	},
	{
		ibgeCode: "4318200",
		cityName: "São Francisco de Paula",
		state: "RS"
	},
	{
		ibgeCode: "4318309",
		cityName: "São Gabriel",
		state: "RS"
	},
	{
		ibgeCode: "4318408",
		cityName: "São Jerônimo",
		state: "RS"
	},
	{
		ibgeCode: "4318424",
		cityName: "São João da Urtiga",
		state: "RS"
	},
	{
		ibgeCode: "4318432",
		cityName: "São João do Polêsine",
		state: "RS"
	},
	{
		ibgeCode: "4318440",
		cityName: "São Jorge",
		state: "RS"
	},
	{
		ibgeCode: "4318457",
		cityName: "São José das Missões",
		state: "RS"
	},
	{
		ibgeCode: "4318465",
		cityName: "São José do Herval",
		state: "RS"
	},
	{
		ibgeCode: "4318481",
		cityName: "São José do Hortêncio",
		state: "RS"
	},
	{
		ibgeCode: "4318499",
		cityName: "São José do Inhacorá",
		state: "RS"
	},
	{
		ibgeCode: "4318507",
		cityName: "São José do Norte",
		state: "RS"
	},
	{
		ibgeCode: "4318606",
		cityName: "São José do Ouro",
		state: "RS"
	},
	{
		ibgeCode: "4318614",
		cityName: "São José do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4318622",
		cityName: "São José dos Ausentes",
		state: "RS"
	},
	{
		ibgeCode: "4318705",
		cityName: "São Leopoldo",
		state: "RS"
	},
	{
		ibgeCode: "4318804",
		cityName: "São Lourenço do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4318903",
		cityName: "São Luiz Gonzaga",
		state: "RS"
	},
	{
		ibgeCode: "4319000",
		cityName: "São Marcos",
		state: "RS"
	},
	{
		ibgeCode: "4319109",
		cityName: "São Martinho",
		state: "RS"
	},
	{
		ibgeCode: "4319125",
		cityName: "São Martinho da Serra",
		state: "RS"
	},
	{
		ibgeCode: "4319158",
		cityName: "São Miguel das Missões",
		state: "RS"
	},
	{
		ibgeCode: "4319208",
		cityName: "São Nicolau",
		state: "RS"
	},
	{
		ibgeCode: "4319307",
		cityName: "São Paulo das Missões",
		state: "RS"
	},
	{
		ibgeCode: "4319356",
		cityName: "São Pedro da Serra",
		state: "RS"
	},
	{
		ibgeCode: "4319364",
		cityName: "São Pedro das Missões",
		state: "RS"
	},
	{
		ibgeCode: "4319372",
		cityName: "São Pedro do Butiá",
		state: "RS"
	},
	{
		ibgeCode: "4319406",
		cityName: "São Pedro do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4319505",
		cityName: "São Sebastião do Caí",
		state: "RS"
	},
	{
		ibgeCode: "4319604",
		cityName: "São Sepé",
		state: "RS"
	},
	{
		ibgeCode: "4319703",
		cityName: "São Valentim",
		state: "RS"
	},
	{
		ibgeCode: "4319711",
		cityName: "São Valentim do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4319737",
		cityName: "São Valério do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4319752",
		cityName: "São Vendelino",
		state: "RS"
	},
	{
		ibgeCode: "4319802",
		cityName: "São Vicente do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4319901",
		cityName: "Sapiranga",
		state: "RS"
	},
	{
		ibgeCode: "4320008",
		cityName: "Sapucaia do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4320107",
		cityName: "Sarandi",
		state: "RS"
	},
	{
		ibgeCode: "4320206",
		cityName: "Seberi",
		state: "RS"
	},
	{
		ibgeCode: "4320230",
		cityName: "Sede Nova",
		state: "RS"
	},
	{
		ibgeCode: "4320263",
		cityName: "Segredo",
		state: "RS"
	},
	{
		ibgeCode: "4320305",
		cityName: "Selbach",
		state: "RS"
	},
	{
		ibgeCode: "4320321",
		cityName: "Senador Salgado Filho",
		state: "RS"
	},
	{
		ibgeCode: "4320354",
		cityName: "Sentinela do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4320404",
		cityName: "Serafina Corrêa",
		state: "RS"
	},
	{
		ibgeCode: "4320453",
		cityName: "Sério",
		state: "RS"
	},
	{
		ibgeCode: "4320503",
		cityName: "Sertão",
		state: "RS"
	},
	{
		ibgeCode: "4320552",
		cityName: "Sertão Santana",
		state: "RS"
	},
	{
		ibgeCode: "4320578",
		cityName: "Sete de Setembro",
		state: "RS"
	},
	{
		ibgeCode: "4320602",
		cityName: "Severiano de Almeida",
		state: "RS"
	},
	{
		ibgeCode: "4320651",
		cityName: "Silveira Martins",
		state: "RS"
	},
	{
		ibgeCode: "4320677",
		cityName: "Sinimbu",
		state: "RS"
	},
	{
		ibgeCode: "4320701",
		cityName: "Sobradinho",
		state: "RS"
	},
	{
		ibgeCode: "4320800",
		cityName: "Soledade",
		state: "RS"
	},
	{
		ibgeCode: "4320859",
		cityName: "Tabaí",
		state: "RS"
	},
	{
		ibgeCode: "4320909",
		cityName: "Tapejara",
		state: "RS"
	},
	{
		ibgeCode: "4321006",
		cityName: "Tapera",
		state: "RS"
	},
	{
		ibgeCode: "4321105",
		cityName: "Tapes",
		state: "RS"
	},
	{
		ibgeCode: "4321204",
		cityName: "Taquara",
		state: "RS"
	},
	{
		ibgeCode: "4321303",
		cityName: "Taquari",
		state: "RS"
	},
	{
		ibgeCode: "4321329",
		cityName: "Taquaruçu do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4321352",
		cityName: "Tavares",
		state: "RS"
	},
	{
		ibgeCode: "4321402",
		cityName: "Tenente Portela",
		state: "RS"
	},
	{
		ibgeCode: "4321436",
		cityName: "Terra de Areia",
		state: "RS"
	},
	{
		ibgeCode: "4321451",
		cityName: "Teutônia",
		state: "RS"
	},
	{
		ibgeCode: "4321469",
		cityName: "Tio Hugo",
		state: "RS"
	},
	{
		ibgeCode: "4321477",
		cityName: "Tiradentes do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4321493",
		cityName: "Toropi",
		state: "RS"
	},
	{
		ibgeCode: "4321501",
		cityName: "Torres",
		state: "RS"
	},
	{
		ibgeCode: "4321600",
		cityName: "Tramandaí",
		state: "RS"
	},
	{
		ibgeCode: "4321626",
		cityName: "Travesseiro",
		state: "RS"
	},
	{
		ibgeCode: "4321634",
		cityName: "Três Arroios",
		state: "RS"
	},
	{
		ibgeCode: "4321667",
		cityName: "Três Cachoeiras",
		state: "RS"
	},
	{
		ibgeCode: "4321709",
		cityName: "Três Coroas",
		state: "RS"
	},
	{
		ibgeCode: "4321808",
		cityName: "Três de Maio",
		state: "RS"
	},
	{
		ibgeCode: "4321832",
		cityName: "Três Forquilhas",
		state: "RS"
	},
	{
		ibgeCode: "4321857",
		cityName: "Três Palmeiras",
		state: "RS"
	},
	{
		ibgeCode: "4321907",
		cityName: "Três Passos",
		state: "RS"
	},
	{
		ibgeCode: "4321956",
		cityName: "Trindade do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4322004",
		cityName: "Triunfo",
		state: "RS"
	},
	{
		ibgeCode: "4322103",
		cityName: "Tucunduva",
		state: "RS"
	},
	{
		ibgeCode: "4322152",
		cityName: "Tunas",
		state: "RS"
	},
	{
		ibgeCode: "4322186",
		cityName: "Tupanci do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4322202",
		cityName: "Tupanciretã",
		state: "RS"
	},
	{
		ibgeCode: "4322251",
		cityName: "Tupandi",
		state: "RS"
	},
	{
		ibgeCode: "4322301",
		cityName: "Tuparendi",
		state: "RS"
	},
	{
		ibgeCode: "4322327",
		cityName: "Turuçu",
		state: "RS"
	},
	{
		ibgeCode: "4322343",
		cityName: "Ubiretama",
		state: "RS"
	},
	{
		ibgeCode: "4322350",
		cityName: "União da Serra",
		state: "RS"
	},
	{
		ibgeCode: "4322376",
		cityName: "Unistalda",
		state: "RS"
	},
	{
		ibgeCode: "4322400",
		cityName: "Uruguaiana",
		state: "RS"
	},
	{
		ibgeCode: "4322509",
		cityName: "Vacaria",
		state: "RS"
	},
	{
		ibgeCode: "4322533",
		cityName: "Vale do Sol",
		state: "RS"
	},
	{
		ibgeCode: "4322541",
		cityName: "Vale Real",
		state: "RS"
	},
	{
		ibgeCode: "4322525",
		cityName: "Vale Verde",
		state: "RS"
	},
	{
		ibgeCode: "4322558",
		cityName: "Vanini",
		state: "RS"
	},
	{
		ibgeCode: "4322608",
		cityName: "Venâncio Aires",
		state: "RS"
	},
	{
		ibgeCode: "4322707",
		cityName: "Vera Cruz",
		state: "RS"
	},
	{
		ibgeCode: "4322806",
		cityName: "Veranópolis",
		state: "RS"
	},
	{
		ibgeCode: "4322855",
		cityName: "Vespasiano Corrêa",
		state: "RS"
	},
	{
		ibgeCode: "4322905",
		cityName: "Viadutos",
		state: "RS"
	},
	{
		ibgeCode: "4323002",
		cityName: "Viamão",
		state: "RS"
	},
	{
		ibgeCode: "4323101",
		cityName: "Vicente Dutra",
		state: "RS"
	},
	{
		ibgeCode: "4323200",
		cityName: "Victor Graeff",
		state: "RS"
	},
	{
		ibgeCode: "4323309",
		cityName: "Vila Flores",
		state: "RS"
	},
	{
		ibgeCode: "4323358",
		cityName: "Vila Lângaro",
		state: "RS"
	},
	{
		ibgeCode: "4323408",
		cityName: "Vila Maria",
		state: "RS"
	},
	{
		ibgeCode: "4323457",
		cityName: "Vila Nova do Sul",
		state: "RS"
	},
	{
		ibgeCode: "4323507",
		cityName: "Vista Alegre",
		state: "RS"
	},
	{
		ibgeCode: "4323606",
		cityName: "Vista Alegre do Prata",
		state: "RS"
	},
	{
		ibgeCode: "4323705",
		cityName: "Vista Gaúcha",
		state: "RS"
	},
	{
		ibgeCode: "4323754",
		cityName: "Vitória das Missões",
		state: "RS"
	},
	{
		ibgeCode: "4323770",
		cityName: "Westfália",
		state: "RS"
	},
	{
		ibgeCode: "4323804",
		cityName: "Xangri-lá",
		state: "RS"
	}
];
var RO = [
	{
		ibgeCode: "1100015",
		cityName: "Alta Floresta D'Oeste",
		state: "RO"
	},
	{
		ibgeCode: "1100379",
		cityName: "Alto Alegre dos Parecis",
		state: "RO"
	},
	{
		ibgeCode: "1100403",
		cityName: "Alto Paraíso",
		state: "RO"
	},
	{
		ibgeCode: "1100346",
		cityName: "Alvorada D'Oeste",
		state: "RO"
	},
	{
		ibgeCode: "1100023",
		cityName: "Ariquemes",
		state: "RO"
	},
	{
		ibgeCode: "1100452",
		cityName: "Buritis",
		state: "RO"
	},
	{
		ibgeCode: "1100031",
		cityName: "Cabixi",
		state: "RO"
	},
	{
		ibgeCode: "1100601",
		cityName: "Cacaulândia",
		state: "RO"
	},
	{
		ibgeCode: "1100049",
		cityName: "Cacoal",
		state: "RO"
	},
	{
		ibgeCode: "1100700",
		cityName: "Campo Novo de Rondônia",
		state: "RO"
	},
	{
		ibgeCode: "1100809",
		cityName: "Candeias do Jamari",
		state: "RO"
	},
	{
		ibgeCode: "1100908",
		cityName: "Castanheiras",
		state: "RO"
	},
	{
		ibgeCode: "1100056",
		cityName: "Cerejeiras",
		state: "RO"
	},
	{
		ibgeCode: "1100924",
		cityName: "Chupinguaia",
		state: "RO"
	},
	{
		ibgeCode: "1100064",
		cityName: "Colorado do Oeste",
		state: "RO"
	},
	{
		ibgeCode: "1100072",
		cityName: "Corumbiara",
		state: "RO"
	},
	{
		ibgeCode: "1100080",
		cityName: "Costa Marques",
		state: "RO"
	},
	{
		ibgeCode: "1100940",
		cityName: "Cujubim",
		state: "RO"
	},
	{
		ibgeCode: "1100098",
		cityName: "Espigão D'Oeste",
		state: "RO"
	},
	{
		ibgeCode: "1101005",
		cityName: "Governador Jorge Teixeira",
		state: "RO"
	},
	{
		ibgeCode: "1100106",
		cityName: "Guajará-Mirim",
		state: "RO"
	},
	{
		ibgeCode: "1101104",
		cityName: "Itapuã do Oeste",
		state: "RO"
	},
	{
		ibgeCode: "1100114",
		cityName: "Jaru",
		state: "RO"
	},
	{
		ibgeCode: "1100122",
		cityName: "Ji-Paraná",
		state: "RO"
	},
	{
		ibgeCode: "1100130",
		cityName: "Machadinho D'Oeste",
		state: "RO"
	},
	{
		ibgeCode: "1101203",
		cityName: "Ministro Andreazza",
		state: "RO"
	},
	{
		ibgeCode: "1101302",
		cityName: "Mirante da Serra",
		state: "RO"
	},
	{
		ibgeCode: "1101401",
		cityName: "Monte Negro",
		state: "RO"
	},
	{
		ibgeCode: "1100148",
		cityName: "Nova Brasilândia D'Oeste",
		state: "RO"
	},
	{
		ibgeCode: "1100338",
		cityName: "Nova Mamoré",
		state: "RO"
	},
	{
		ibgeCode: "1101435",
		cityName: "Nova União",
		state: "RO"
	},
	{
		ibgeCode: "1100502",
		cityName: "Novo Horizonte do Oeste",
		state: "RO"
	},
	{
		ibgeCode: "1100155",
		cityName: "Ouro Preto do Oeste",
		state: "RO"
	},
	{
		ibgeCode: "1101450",
		cityName: "Parecis",
		state: "RO"
	},
	{
		ibgeCode: "1100189",
		cityName: "Pimenta Bueno",
		state: "RO"
	},
	{
		ibgeCode: "1101468",
		cityName: "Pimenteiras do Oeste",
		state: "RO"
	},
	{
		ibgeCode: "1100205",
		cityName: "Porto Velho",
		state: "RO"
	},
	{
		ibgeCode: "1100254",
		cityName: "Presidente Médici",
		state: "RO"
	},
	{
		ibgeCode: "1101476",
		cityName: "Primavera de Rondônia",
		state: "RO"
	},
	{
		ibgeCode: "1100262",
		cityName: "Rio Crespo",
		state: "RO"
	},
	{
		ibgeCode: "1100288",
		cityName: "Rolim de Moura",
		state: "RO"
	},
	{
		ibgeCode: "1100296",
		cityName: "Santa Luzia D'Oeste",
		state: "RO"
	},
	{
		ibgeCode: "1101484",
		cityName: "São Felipe D'Oeste",
		state: "RO"
	},
	{
		ibgeCode: "1101492",
		cityName: "São Francisco do Guaporé",
		state: "RO"
	},
	{
		ibgeCode: "1100320",
		cityName: "São Miguel do Guaporé",
		state: "RO"
	},
	{
		ibgeCode: "1101500",
		cityName: "Seringueiras",
		state: "RO"
	},
	{
		ibgeCode: "1101559",
		cityName: "Teixeirópolis",
		state: "RO"
	},
	{
		ibgeCode: "1101609",
		cityName: "Theobroma",
		state: "RO"
	},
	{
		ibgeCode: "1101708",
		cityName: "Urupá",
		state: "RO"
	},
	{
		ibgeCode: "1101757",
		cityName: "Vale do Anari",
		state: "RO"
	},
	{
		ibgeCode: "1101807",
		cityName: "Vale do Paraíso",
		state: "RO"
	},
	{
		ibgeCode: "1100304",
		cityName: "Vilhena",
		state: "RO"
	}
];
var RR = [
	{
		ibgeCode: "1400050",
		cityName: "Alto Alegre",
		state: "RR"
	},
	{
		ibgeCode: "1400027",
		cityName: "Amajari",
		state: "RR"
	},
	{
		ibgeCode: "1400100",
		cityName: "Boa Vista",
		state: "RR"
	},
	{
		ibgeCode: "1400159",
		cityName: "Bonfim",
		state: "RR"
	},
	{
		ibgeCode: "1400175",
		cityName: "Cantá",
		state: "RR"
	},
	{
		ibgeCode: "1400209",
		cityName: "Caracaraí",
		state: "RR"
	},
	{
		ibgeCode: "1400233",
		cityName: "Caroebe",
		state: "RR"
	},
	{
		ibgeCode: "1400282",
		cityName: "Iracema",
		state: "RR"
	},
	{
		ibgeCode: "1400308",
		cityName: "Mucajaí",
		state: "RR"
	},
	{
		ibgeCode: "1400407",
		cityName: "Normandia",
		state: "RR"
	},
	{
		ibgeCode: "1400456",
		cityName: "Pacaraima",
		state: "RR"
	},
	{
		ibgeCode: "1400472",
		cityName: "Rorainópolis",
		state: "RR"
	},
	{
		ibgeCode: "1400506",
		cityName: "São João da Baliza",
		state: "RR"
	},
	{
		ibgeCode: "1400605",
		cityName: "São Luiz",
		state: "RR"
	},
	{
		ibgeCode: "1400704",
		cityName: "Uiramutã",
		state: "RR"
	}
];
var SC = [
	{
		ibgeCode: "4200051",
		cityName: "Abdon Batista",
		state: "SC"
	},
	{
		ibgeCode: "4200101",
		cityName: "Abelardo Luz",
		state: "SC"
	},
	{
		ibgeCode: "4200200",
		cityName: "Agrolândia",
		state: "SC"
	},
	{
		ibgeCode: "4200309",
		cityName: "Agronômica",
		state: "SC"
	},
	{
		ibgeCode: "4200408",
		cityName: "Água Doce",
		state: "SC"
	},
	{
		ibgeCode: "4200507",
		cityName: "Águas de Chapecó",
		state: "SC"
	},
	{
		ibgeCode: "4200556",
		cityName: "Águas Frias",
		state: "SC"
	},
	{
		ibgeCode: "4200606",
		cityName: "Águas Mornas",
		state: "SC"
	},
	{
		ibgeCode: "4200705",
		cityName: "Alfredo Wagner",
		state: "SC"
	},
	{
		ibgeCode: "4200754",
		cityName: "Alto Bela Vista",
		state: "SC"
	},
	{
		ibgeCode: "4200804",
		cityName: "Anchieta",
		state: "SC"
	},
	{
		ibgeCode: "4200903",
		cityName: "Angelina",
		state: "SC"
	},
	{
		ibgeCode: "4201000",
		cityName: "Anita Garibaldi",
		state: "SC"
	},
	{
		ibgeCode: "4201109",
		cityName: "Anitápolis",
		state: "SC"
	},
	{
		ibgeCode: "4201208",
		cityName: "Antônio Carlos",
		state: "SC"
	},
	{
		ibgeCode: "4201257",
		cityName: "Apiúna",
		state: "SC"
	},
	{
		ibgeCode: "4201273",
		cityName: "Arabutã",
		state: "SC"
	},
	{
		ibgeCode: "4201307",
		cityName: "Araquari",
		state: "SC"
	},
	{
		ibgeCode: "4201406",
		cityName: "Araranguá",
		state: "SC"
	},
	{
		ibgeCode: "4201505",
		cityName: "Armazém",
		state: "SC"
	},
	{
		ibgeCode: "4201604",
		cityName: "Arroio Trinta",
		state: "SC"
	},
	{
		ibgeCode: "4201653",
		cityName: "Arvoredo",
		state: "SC"
	},
	{
		ibgeCode: "4201703",
		cityName: "Ascurra",
		state: "SC"
	},
	{
		ibgeCode: "4201802",
		cityName: "Atalanta",
		state: "SC"
	},
	{
		ibgeCode: "4201901",
		cityName: "Aurora",
		state: "SC"
	},
	{
		ibgeCode: "4201950",
		cityName: "Balneário Arroio do Silva",
		state: "SC"
	},
	{
		ibgeCode: "4202057",
		cityName: "Balneário Barra do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4202008",
		cityName: "Balneário Camboriú",
		state: "SC"
	},
	{
		ibgeCode: "4202073",
		cityName: "Balneário Gaivota",
		state: "SC"
	},
	{
		ibgeCode: "4212809",
		cityName: "Balneário Piçarras",
		state: "SC"
	},
	{
		ibgeCode: "4220000",
		cityName: "Balneário Rincão",
		state: "SC"
	},
	{
		ibgeCode: "4202081",
		cityName: "Bandeirante",
		state: "SC"
	},
	{
		ibgeCode: "4202099",
		cityName: "Barra Bonita",
		state: "SC"
	},
	{
		ibgeCode: "4202107",
		cityName: "Barra Velha",
		state: "SC"
	},
	{
		ibgeCode: "4202131",
		cityName: "Bela Vista do Toldo",
		state: "SC"
	},
	{
		ibgeCode: "4202156",
		cityName: "Belmonte",
		state: "SC"
	},
	{
		ibgeCode: "4202206",
		cityName: "Benedito Novo",
		state: "SC"
	},
	{
		ibgeCode: "4202305",
		cityName: "Biguaçu",
		state: "SC"
	},
	{
		ibgeCode: "4202404",
		cityName: "Blumenau",
		state: "SC"
	},
	{
		ibgeCode: "4202438",
		cityName: "Bocaina do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4202503",
		cityName: "Bom Jardim da Serra",
		state: "SC"
	},
	{
		ibgeCode: "4202537",
		cityName: "Bom Jesus",
		state: "SC"
	},
	{
		ibgeCode: "4202578",
		cityName: "Bom Jesus do Oeste",
		state: "SC"
	},
	{
		ibgeCode: "4202602",
		cityName: "Bom Retiro",
		state: "SC"
	},
	{
		ibgeCode: "4202453",
		cityName: "Bombinhas",
		state: "SC"
	},
	{
		ibgeCode: "4202701",
		cityName: "Botuverá",
		state: "SC"
	},
	{
		ibgeCode: "4202800",
		cityName: "Braço do Norte",
		state: "SC"
	},
	{
		ibgeCode: "4202859",
		cityName: "Braço do Trombudo",
		state: "SC"
	},
	{
		ibgeCode: "4202875",
		cityName: "Brunópolis",
		state: "SC"
	},
	{
		ibgeCode: "4202909",
		cityName: "Brusque",
		state: "SC"
	},
	{
		ibgeCode: "4203006",
		cityName: "Caçador",
		state: "SC"
	},
	{
		ibgeCode: "4203105",
		cityName: "Caibi",
		state: "SC"
	},
	{
		ibgeCode: "4203154",
		cityName: "Calmon",
		state: "SC"
	},
	{
		ibgeCode: "4203204",
		cityName: "Camboriú",
		state: "SC"
	},
	{
		ibgeCode: "4203303",
		cityName: "Campo Alegre",
		state: "SC"
	},
	{
		ibgeCode: "4203402",
		cityName: "Campo Belo do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4203501",
		cityName: "Campo Erê",
		state: "SC"
	},
	{
		ibgeCode: "4203600",
		cityName: "Campos Novos",
		state: "SC"
	},
	{
		ibgeCode: "4203709",
		cityName: "Canelinha",
		state: "SC"
	},
	{
		ibgeCode: "4203808",
		cityName: "Canoinhas",
		state: "SC"
	},
	{
		ibgeCode: "4203253",
		cityName: "Capão Alto",
		state: "SC"
	},
	{
		ibgeCode: "4203907",
		cityName: "Capinzal",
		state: "SC"
	},
	{
		ibgeCode: "4203956",
		cityName: "Capivari de Baixo",
		state: "SC"
	},
	{
		ibgeCode: "4204004",
		cityName: "Catanduvas",
		state: "SC"
	},
	{
		ibgeCode: "4204103",
		cityName: "Caxambu do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4204152",
		cityName: "Celso Ramos",
		state: "SC"
	},
	{
		ibgeCode: "4204178",
		cityName: "Cerro Negro",
		state: "SC"
	},
	{
		ibgeCode: "4204194",
		cityName: "Chapadão do Lageado",
		state: "SC"
	},
	{
		ibgeCode: "4204202",
		cityName: "Chapecó",
		state: "SC"
	},
	{
		ibgeCode: "4204251",
		cityName: "Cocal do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4204301",
		cityName: "Concórdia",
		state: "SC"
	},
	{
		ibgeCode: "4204350",
		cityName: "Cordilheira Alta",
		state: "SC"
	},
	{
		ibgeCode: "4204400",
		cityName: "Coronel Freitas",
		state: "SC"
	},
	{
		ibgeCode: "4204459",
		cityName: "Coronel Martins",
		state: "SC"
	},
	{
		ibgeCode: "4204558",
		cityName: "Correia Pinto",
		state: "SC"
	},
	{
		ibgeCode: "4204509",
		cityName: "Corupá",
		state: "SC"
	},
	{
		ibgeCode: "4204608",
		cityName: "Criciúma",
		state: "SC"
	},
	{
		ibgeCode: "4204707",
		cityName: "Cunha Porã",
		state: "SC"
	},
	{
		ibgeCode: "4204756",
		cityName: "Cunhataí",
		state: "SC"
	},
	{
		ibgeCode: "4204806",
		cityName: "Curitibanos",
		state: "SC"
	},
	{
		ibgeCode: "4204905",
		cityName: "Descanso",
		state: "SC"
	},
	{
		ibgeCode: "4205001",
		cityName: "Dionísio Cerqueira",
		state: "SC"
	},
	{
		ibgeCode: "4205100",
		cityName: "Dona Emma",
		state: "SC"
	},
	{
		ibgeCode: "4205159",
		cityName: "Doutor Pedrinho",
		state: "SC"
	},
	{
		ibgeCode: "4205175",
		cityName: "Entre Rios",
		state: "SC"
	},
	{
		ibgeCode: "4205191",
		cityName: "Ermo",
		state: "SC"
	},
	{
		ibgeCode: "4205209",
		cityName: "Erval Velho",
		state: "SC"
	},
	{
		ibgeCode: "4205308",
		cityName: "Faxinal dos Guedes",
		state: "SC"
	},
	{
		ibgeCode: "4205357",
		cityName: "Flor do Sertão",
		state: "SC"
	},
	{
		ibgeCode: "4205407",
		cityName: "Florianópolis",
		state: "SC"
	},
	{
		ibgeCode: "4205431",
		cityName: "Formosa do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4205456",
		cityName: "Forquilhinha",
		state: "SC"
	},
	{
		ibgeCode: "4205506",
		cityName: "Fraiburgo",
		state: "SC"
	},
	{
		ibgeCode: "4205555",
		cityName: "Frei Rogério",
		state: "SC"
	},
	{
		ibgeCode: "4205605",
		cityName: "Galvão",
		state: "SC"
	},
	{
		ibgeCode: "4205704",
		cityName: "Garopaba",
		state: "SC"
	},
	{
		ibgeCode: "4205803",
		cityName: "Garuva",
		state: "SC"
	},
	{
		ibgeCode: "4205902",
		cityName: "Gaspar",
		state: "SC"
	},
	{
		ibgeCode: "4206009",
		cityName: "Governador Celso Ramos",
		state: "SC"
	},
	{
		ibgeCode: "4206108",
		cityName: "Grão-Pará",
		state: "SC"
	},
	{
		ibgeCode: "4206207",
		cityName: "Gravatal",
		state: "SC"
	},
	{
		ibgeCode: "4206306",
		cityName: "Guabiruba",
		state: "SC"
	},
	{
		ibgeCode: "4206405",
		cityName: "Guaraciaba",
		state: "SC"
	},
	{
		ibgeCode: "4206504",
		cityName: "Guaramirim",
		state: "SC"
	},
	{
		ibgeCode: "4206603",
		cityName: "Guarujá do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4206652",
		cityName: "Guatambú",
		state: "SC"
	},
	{
		ibgeCode: "4206702",
		cityName: "Herval d'Oeste",
		state: "SC"
	},
	{
		ibgeCode: "4206751",
		cityName: "Ibiam",
		state: "SC"
	},
	{
		ibgeCode: "4206801",
		cityName: "Ibicaré",
		state: "SC"
	},
	{
		ibgeCode: "4206900",
		cityName: "Ibirama",
		state: "SC"
	},
	{
		ibgeCode: "4207007",
		cityName: "Içara",
		state: "SC"
	},
	{
		ibgeCode: "4207106",
		cityName: "Ilhota",
		state: "SC"
	},
	{
		ibgeCode: "4207205",
		cityName: "Imaruí",
		state: "SC"
	},
	{
		ibgeCode: "4207304",
		cityName: "Imbituba",
		state: "SC"
	},
	{
		ibgeCode: "4207403",
		cityName: "Imbuia",
		state: "SC"
	},
	{
		ibgeCode: "4207502",
		cityName: "Indaial",
		state: "SC"
	},
	{
		ibgeCode: "4207577",
		cityName: "Iomerê",
		state: "SC"
	},
	{
		ibgeCode: "4207601",
		cityName: "Ipira",
		state: "SC"
	},
	{
		ibgeCode: "4207650",
		cityName: "Iporã do Oeste",
		state: "SC"
	},
	{
		ibgeCode: "4207684",
		cityName: "Ipuaçu",
		state: "SC"
	},
	{
		ibgeCode: "4207700",
		cityName: "Ipumirim",
		state: "SC"
	},
	{
		ibgeCode: "4207759",
		cityName: "Iraceminha",
		state: "SC"
	},
	{
		ibgeCode: "4207809",
		cityName: "Irani",
		state: "SC"
	},
	{
		ibgeCode: "4207858",
		cityName: "Irati",
		state: "SC"
	},
	{
		ibgeCode: "4207908",
		cityName: "Irineópolis",
		state: "SC"
	},
	{
		ibgeCode: "4208005",
		cityName: "Itá",
		state: "SC"
	},
	{
		ibgeCode: "4208104",
		cityName: "Itaiópolis",
		state: "SC"
	},
	{
		ibgeCode: "4208203",
		cityName: "Itajaí",
		state: "SC"
	},
	{
		ibgeCode: "4208302",
		cityName: "Itapema",
		state: "SC"
	},
	{
		ibgeCode: "4208401",
		cityName: "Itapiranga",
		state: "SC"
	},
	{
		ibgeCode: "4208450",
		cityName: "Itapoá",
		state: "SC"
	},
	{
		ibgeCode: "4208500",
		cityName: "Ituporanga",
		state: "SC"
	},
	{
		ibgeCode: "4208609",
		cityName: "Jaborá",
		state: "SC"
	},
	{
		ibgeCode: "4208708",
		cityName: "Jacinto Machado",
		state: "SC"
	},
	{
		ibgeCode: "4208807",
		cityName: "Jaguaruna",
		state: "SC"
	},
	{
		ibgeCode: "4208906",
		cityName: "Jaraguá do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4208955",
		cityName: "Jardinópolis",
		state: "SC"
	},
	{
		ibgeCode: "4209003",
		cityName: "Joaçaba",
		state: "SC"
	},
	{
		ibgeCode: "4209102",
		cityName: "Joinville",
		state: "SC"
	},
	{
		ibgeCode: "4209151",
		cityName: "José Boiteux",
		state: "SC"
	},
	{
		ibgeCode: "4209177",
		cityName: "Jupiá",
		state: "SC"
	},
	{
		ibgeCode: "4209201",
		cityName: "Lacerdópolis",
		state: "SC"
	},
	{
		ibgeCode: "4209300",
		cityName: "Lages",
		state: "SC"
	},
	{
		ibgeCode: "4209409",
		cityName: "Laguna",
		state: "SC"
	},
	{
		ibgeCode: "4209458",
		cityName: "Lajeado Grande",
		state: "SC"
	},
	{
		ibgeCode: "4209508",
		cityName: "Laurentino",
		state: "SC"
	},
	{
		ibgeCode: "4209607",
		cityName: "Lauro Müller",
		state: "SC"
	},
	{
		ibgeCode: "4209706",
		cityName: "Lebon Régis",
		state: "SC"
	},
	{
		ibgeCode: "4209805",
		cityName: "Leoberto Leal",
		state: "SC"
	},
	{
		ibgeCode: "4209854",
		cityName: "Lindóia do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4209904",
		cityName: "Lontras",
		state: "SC"
	},
	{
		ibgeCode: "4210001",
		cityName: "Luiz Alves",
		state: "SC"
	},
	{
		ibgeCode: "4210035",
		cityName: "Luzerna",
		state: "SC"
	},
	{
		ibgeCode: "4210050",
		cityName: "Macieira",
		state: "SC"
	},
	{
		ibgeCode: "4210100",
		cityName: "Mafra",
		state: "SC"
	},
	{
		ibgeCode: "4210209",
		cityName: "Major Gercino",
		state: "SC"
	},
	{
		ibgeCode: "4210308",
		cityName: "Major Vieira",
		state: "SC"
	},
	{
		ibgeCode: "4210407",
		cityName: "Maracajá",
		state: "SC"
	},
	{
		ibgeCode: "4210506",
		cityName: "Maravilha",
		state: "SC"
	},
	{
		ibgeCode: "4210555",
		cityName: "Marema",
		state: "SC"
	},
	{
		ibgeCode: "4210605",
		cityName: "Massaranduba",
		state: "SC"
	},
	{
		ibgeCode: "4210704",
		cityName: "Matos Costa",
		state: "SC"
	},
	{
		ibgeCode: "4210803",
		cityName: "Meleiro",
		state: "SC"
	},
	{
		ibgeCode: "4210852",
		cityName: "Mirim Doce",
		state: "SC"
	},
	{
		ibgeCode: "4210902",
		cityName: "Modelo",
		state: "SC"
	},
	{
		ibgeCode: "4211009",
		cityName: "Mondaí",
		state: "SC"
	},
	{
		ibgeCode: "4211058",
		cityName: "Monte Carlo",
		state: "SC"
	},
	{
		ibgeCode: "4211108",
		cityName: "Monte Castelo",
		state: "SC"
	},
	{
		ibgeCode: "4211207",
		cityName: "Morro da Fumaça",
		state: "SC"
	},
	{
		ibgeCode: "4211256",
		cityName: "Morro Grande",
		state: "SC"
	},
	{
		ibgeCode: "4211306",
		cityName: "Navegantes",
		state: "SC"
	},
	{
		ibgeCode: "4211405",
		cityName: "Nova Erechim",
		state: "SC"
	},
	{
		ibgeCode: "4211454",
		cityName: "Nova Itaberaba",
		state: "SC"
	},
	{
		ibgeCode: "4211504",
		cityName: "Nova Trento",
		state: "SC"
	},
	{
		ibgeCode: "4211603",
		cityName: "Nova Veneza",
		state: "SC"
	},
	{
		ibgeCode: "4211652",
		cityName: "Novo Horizonte",
		state: "SC"
	},
	{
		ibgeCode: "4211702",
		cityName: "Orleans",
		state: "SC"
	},
	{
		ibgeCode: "4211751",
		cityName: "Otacílio Costa",
		state: "SC"
	},
	{
		ibgeCode: "4211801",
		cityName: "Ouro",
		state: "SC"
	},
	{
		ibgeCode: "4211850",
		cityName: "Ouro Verde",
		state: "SC"
	},
	{
		ibgeCode: "4211876",
		cityName: "Paial",
		state: "SC"
	},
	{
		ibgeCode: "4211892",
		cityName: "Painel",
		state: "SC"
	},
	{
		ibgeCode: "4211900",
		cityName: "Palhoça",
		state: "SC"
	},
	{
		ibgeCode: "4212007",
		cityName: "Palma Sola",
		state: "SC"
	},
	{
		ibgeCode: "4212056",
		cityName: "Palmeira",
		state: "SC"
	},
	{
		ibgeCode: "4212106",
		cityName: "Palmitos",
		state: "SC"
	},
	{
		ibgeCode: "4212205",
		cityName: "Papanduva",
		state: "SC"
	},
	{
		ibgeCode: "4212239",
		cityName: "Paraíso",
		state: "SC"
	},
	{
		ibgeCode: "4212254",
		cityName: "Passo de Torres",
		state: "SC"
	},
	{
		ibgeCode: "4212270",
		cityName: "Passos Maia",
		state: "SC"
	},
	{
		ibgeCode: "4212304",
		cityName: "Paulo Lopes",
		state: "SC"
	},
	{
		ibgeCode: "4212403",
		cityName: "Pedras Grandes",
		state: "SC"
	},
	{
		ibgeCode: "4212502",
		cityName: "Penha",
		state: "SC"
	},
	{
		ibgeCode: "4212601",
		cityName: "Peritiba",
		state: "SC"
	},
	{
		ibgeCode: "4212650",
		cityName: "Pescaria Brava",
		state: "SC"
	},
	{
		ibgeCode: "4212700",
		cityName: "Petrolândia",
		state: "SC"
	},
	{
		ibgeCode: "4212908",
		cityName: "Pinhalzinho",
		state: "SC"
	},
	{
		ibgeCode: "4213005",
		cityName: "Pinheiro Preto",
		state: "SC"
	},
	{
		ibgeCode: "4213104",
		cityName: "Piratuba",
		state: "SC"
	},
	{
		ibgeCode: "4213153",
		cityName: "Planalto Alegre",
		state: "SC"
	},
	{
		ibgeCode: "4213203",
		cityName: "Pomerode",
		state: "SC"
	},
	{
		ibgeCode: "4213302",
		cityName: "Ponte Alta",
		state: "SC"
	},
	{
		ibgeCode: "4213351",
		cityName: "Ponte Alta do Norte",
		state: "SC"
	},
	{
		ibgeCode: "4213401",
		cityName: "Ponte Serrada",
		state: "SC"
	},
	{
		ibgeCode: "4213500",
		cityName: "Porto Belo",
		state: "SC"
	},
	{
		ibgeCode: "4213609",
		cityName: "Porto União",
		state: "SC"
	},
	{
		ibgeCode: "4213708",
		cityName: "Pouso Redondo",
		state: "SC"
	},
	{
		ibgeCode: "4213807",
		cityName: "Praia Grande",
		state: "SC"
	},
	{
		ibgeCode: "4213906",
		cityName: "Presidente Castello Branco",
		state: "SC"
	},
	{
		ibgeCode: "4214003",
		cityName: "Presidente Getúlio",
		state: "SC"
	},
	{
		ibgeCode: "4214102",
		cityName: "Presidente Nereu",
		state: "SC"
	},
	{
		ibgeCode: "4214151",
		cityName: "Princesa",
		state: "SC"
	},
	{
		ibgeCode: "4214201",
		cityName: "Quilombo",
		state: "SC"
	},
	{
		ibgeCode: "4214300",
		cityName: "Rancho Queimado",
		state: "SC"
	},
	{
		ibgeCode: "4214409",
		cityName: "Rio das Antas",
		state: "SC"
	},
	{
		ibgeCode: "4214508",
		cityName: "Rio do Campo",
		state: "SC"
	},
	{
		ibgeCode: "4214607",
		cityName: "Rio do Oeste",
		state: "SC"
	},
	{
		ibgeCode: "4214805",
		cityName: "Rio do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4214706",
		cityName: "Rio dos Cedros",
		state: "SC"
	},
	{
		ibgeCode: "4214904",
		cityName: "Rio Fortuna",
		state: "SC"
	},
	{
		ibgeCode: "4215000",
		cityName: "Rio Negrinho",
		state: "SC"
	},
	{
		ibgeCode: "4215059",
		cityName: "Rio Rufino",
		state: "SC"
	},
	{
		ibgeCode: "4215075",
		cityName: "Riqueza",
		state: "SC"
	},
	{
		ibgeCode: "4215109",
		cityName: "Rodeio",
		state: "SC"
	},
	{
		ibgeCode: "4215208",
		cityName: "Romelândia",
		state: "SC"
	},
	{
		ibgeCode: "4215307",
		cityName: "Salete",
		state: "SC"
	},
	{
		ibgeCode: "4215356",
		cityName: "Saltinho",
		state: "SC"
	},
	{
		ibgeCode: "4215406",
		cityName: "Salto Veloso",
		state: "SC"
	},
	{
		ibgeCode: "4215455",
		cityName: "Sangão",
		state: "SC"
	},
	{
		ibgeCode: "4215505",
		cityName: "Santa Cecília",
		state: "SC"
	},
	{
		ibgeCode: "4215554",
		cityName: "Santa Helena",
		state: "SC"
	},
	{
		ibgeCode: "4215604",
		cityName: "Santa Rosa de Lima",
		state: "SC"
	},
	{
		ibgeCode: "4215653",
		cityName: "Santa Rosa do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4215679",
		cityName: "Santa Terezinha",
		state: "SC"
	},
	{
		ibgeCode: "4215687",
		cityName: "Santa Terezinha do Progresso",
		state: "SC"
	},
	{
		ibgeCode: "4215695",
		cityName: "Santiago do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4215703",
		cityName: "Santo Amaro da Imperatriz",
		state: "SC"
	},
	{
		ibgeCode: "4215802",
		cityName: "São Bento do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4215752",
		cityName: "São Bernardino",
		state: "SC"
	},
	{
		ibgeCode: "4215901",
		cityName: "São Bonifácio",
		state: "SC"
	},
	{
		ibgeCode: "4216008",
		cityName: "São Carlos",
		state: "SC"
	},
	{
		ibgeCode: "4216057",
		cityName: "São Cristóvão do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4216107",
		cityName: "São Domingos",
		state: "SC"
	},
	{
		ibgeCode: "4216206",
		cityName: "São Francisco do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4216305",
		cityName: "São João Batista",
		state: "SC"
	},
	{
		ibgeCode: "4216354",
		cityName: "São João do Itaperiú",
		state: "SC"
	},
	{
		ibgeCode: "4216255",
		cityName: "São João do Oeste",
		state: "SC"
	},
	{
		ibgeCode: "4216404",
		cityName: "São João do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4216503",
		cityName: "São Joaquim",
		state: "SC"
	},
	{
		ibgeCode: "4216602",
		cityName: "São José",
		state: "SC"
	},
	{
		ibgeCode: "4216701",
		cityName: "São José do Cedro",
		state: "SC"
	},
	{
		ibgeCode: "4216800",
		cityName: "São José do Cerrito",
		state: "SC"
	},
	{
		ibgeCode: "4216909",
		cityName: "São Lourenço do Oeste",
		state: "SC"
	},
	{
		ibgeCode: "4217006",
		cityName: "São Ludgero",
		state: "SC"
	},
	{
		ibgeCode: "4217105",
		cityName: "São Martinho",
		state: "SC"
	},
	{
		ibgeCode: "4217154",
		cityName: "São Miguel da Boa Vista",
		state: "SC"
	},
	{
		ibgeCode: "4217204",
		cityName: "São Miguel do Oeste",
		state: "SC"
	},
	{
		ibgeCode: "4217253",
		cityName: "São Pedro de Alcântara",
		state: "SC"
	},
	{
		ibgeCode: "4217303",
		cityName: "Saudades",
		state: "SC"
	},
	{
		ibgeCode: "4217402",
		cityName: "Schroeder",
		state: "SC"
	},
	{
		ibgeCode: "4217501",
		cityName: "Seara",
		state: "SC"
	},
	{
		ibgeCode: "4217550",
		cityName: "Serra Alta",
		state: "SC"
	},
	{
		ibgeCode: "4217600",
		cityName: "Siderópolis",
		state: "SC"
	},
	{
		ibgeCode: "4217709",
		cityName: "Sombrio",
		state: "SC"
	},
	{
		ibgeCode: "4217758",
		cityName: "Sul Brasil",
		state: "SC"
	},
	{
		ibgeCode: "4217808",
		cityName: "Taió",
		state: "SC"
	},
	{
		ibgeCode: "4217907",
		cityName: "Tangará",
		state: "SC"
	},
	{
		ibgeCode: "4217956",
		cityName: "Tigrinhos",
		state: "SC"
	},
	{
		ibgeCode: "4218004",
		cityName: "Tijucas",
		state: "SC"
	},
	{
		ibgeCode: "4218103",
		cityName: "Timbé do Sul",
		state: "SC"
	},
	{
		ibgeCode: "4218202",
		cityName: "Timbó",
		state: "SC"
	},
	{
		ibgeCode: "4218251",
		cityName: "Timbó Grande",
		state: "SC"
	},
	{
		ibgeCode: "4218301",
		cityName: "Três Barras",
		state: "SC"
	},
	{
		ibgeCode: "4218350",
		cityName: "Treviso",
		state: "SC"
	},
	{
		ibgeCode: "4218400",
		cityName: "Treze de Maio",
		state: "SC"
	},
	{
		ibgeCode: "4218509",
		cityName: "Treze Tílias",
		state: "SC"
	},
	{
		ibgeCode: "4218608",
		cityName: "Trombudo Central",
		state: "SC"
	},
	{
		ibgeCode: "4218707",
		cityName: "Tubarão",
		state: "SC"
	},
	{
		ibgeCode: "4218756",
		cityName: "Tunápolis",
		state: "SC"
	},
	{
		ibgeCode: "4218806",
		cityName: "Turvo",
		state: "SC"
	},
	{
		ibgeCode: "4218855",
		cityName: "União do Oeste",
		state: "SC"
	},
	{
		ibgeCode: "4218905",
		cityName: "Urubici",
		state: "SC"
	},
	{
		ibgeCode: "4218954",
		cityName: "Urupema",
		state: "SC"
	},
	{
		ibgeCode: "4219002",
		cityName: "Urussanga",
		state: "SC"
	},
	{
		ibgeCode: "4219101",
		cityName: "Vargeão",
		state: "SC"
	},
	{
		ibgeCode: "4219150",
		cityName: "Vargem",
		state: "SC"
	},
	{
		ibgeCode: "4219176",
		cityName: "Vargem Bonita",
		state: "SC"
	},
	{
		ibgeCode: "4219200",
		cityName: "Vidal Ramos",
		state: "SC"
	},
	{
		ibgeCode: "4219309",
		cityName: "Videira",
		state: "SC"
	},
	{
		ibgeCode: "4219358",
		cityName: "Vitor Meireles",
		state: "SC"
	},
	{
		ibgeCode: "4219408",
		cityName: "Witmarsum",
		state: "SC"
	},
	{
		ibgeCode: "4219507",
		cityName: "Xanxerê",
		state: "SC"
	},
	{
		ibgeCode: "4219606",
		cityName: "Xavantina",
		state: "SC"
	},
	{
		ibgeCode: "4219705",
		cityName: "Xaxim",
		state: "SC"
	},
	{
		ibgeCode: "4219853",
		cityName: "Zortéa",
		state: "SC"
	}
];
var SP = [
	{
		ibgeCode: "3500105",
		cityName: "Adamantina",
		state: "SP"
	},
	{
		ibgeCode: "3500204",
		cityName: "Adolfo",
		state: "SP"
	},
	{
		ibgeCode: "3500303",
		cityName: "Aguaí",
		state: "SP"
	},
	{
		ibgeCode: "3500402",
		cityName: "Águas da Prata",
		state: "SP"
	},
	{
		ibgeCode: "3500501",
		cityName: "Águas de Lindóia",
		state: "SP"
	},
	{
		ibgeCode: "3500550",
		cityName: "Águas de Santa Bárbara",
		state: "SP"
	},
	{
		ibgeCode: "3500600",
		cityName: "Águas de São Pedro",
		state: "SP"
	},
	{
		ibgeCode: "3500709",
		cityName: "Agudos",
		state: "SP"
	},
	{
		ibgeCode: "3500758",
		cityName: "Alambari",
		state: "SP"
	},
	{
		ibgeCode: "3500808",
		cityName: "Alfredo Marcondes",
		state: "SP"
	},
	{
		ibgeCode: "3500907",
		cityName: "Altair",
		state: "SP"
	},
	{
		ibgeCode: "3501004",
		cityName: "Altinópolis",
		state: "SP"
	},
	{
		ibgeCode: "3501103",
		cityName: "Alto Alegre",
		state: "SP"
	},
	{
		ibgeCode: "3501152",
		cityName: "Alumínio",
		state: "SP"
	},
	{
		ibgeCode: "3501202",
		cityName: "Álvares Florence",
		state: "SP"
	},
	{
		ibgeCode: "3501301",
		cityName: "Álvares Machado",
		state: "SP"
	},
	{
		ibgeCode: "3501400",
		cityName: "Álvaro de Carvalho",
		state: "SP"
	},
	{
		ibgeCode: "3501509",
		cityName: "Alvinlândia",
		state: "SP"
	},
	{
		ibgeCode: "3501608",
		cityName: "Americana",
		state: "SP"
	},
	{
		ibgeCode: "3501707",
		cityName: "Américo Brasiliense",
		state: "SP"
	},
	{
		ibgeCode: "3501806",
		cityName: "Américo de Campos",
		state: "SP"
	},
	{
		ibgeCode: "3501905",
		cityName: "Amparo",
		state: "SP"
	},
	{
		ibgeCode: "3502002",
		cityName: "Analândia",
		state: "SP"
	},
	{
		ibgeCode: "3502101",
		cityName: "Andradina",
		state: "SP"
	},
	{
		ibgeCode: "3502200",
		cityName: "Angatuba",
		state: "SP"
	},
	{
		ibgeCode: "3502309",
		cityName: "Anhembi",
		state: "SP"
	},
	{
		ibgeCode: "3502408",
		cityName: "Anhumas",
		state: "SP"
	},
	{
		ibgeCode: "3502507",
		cityName: "Aparecida",
		state: "SP"
	},
	{
		ibgeCode: "3502606",
		cityName: "Aparecida d'Oeste",
		state: "SP"
	},
	{
		ibgeCode: "3502705",
		cityName: "Apiaí",
		state: "SP"
	},
	{
		ibgeCode: "3502754",
		cityName: "Araçariguama",
		state: "SP"
	},
	{
		ibgeCode: "3502804",
		cityName: "Araçatuba",
		state: "SP"
	},
	{
		ibgeCode: "3502903",
		cityName: "Araçoiaba da Serra",
		state: "SP"
	},
	{
		ibgeCode: "3503000",
		cityName: "Aramina",
		state: "SP"
	},
	{
		ibgeCode: "3503109",
		cityName: "Arandu",
		state: "SP"
	},
	{
		ibgeCode: "3503158",
		cityName: "Arapeí",
		state: "SP"
	},
	{
		ibgeCode: "3503208",
		cityName: "Araraquara",
		state: "SP"
	},
	{
		ibgeCode: "3503307",
		cityName: "Araras",
		state: "SP"
	},
	{
		ibgeCode: "3503356",
		cityName: "Arco-Íris",
		state: "SP"
	},
	{
		ibgeCode: "3503406",
		cityName: "Arealva",
		state: "SP"
	},
	{
		ibgeCode: "3503505",
		cityName: "Areias",
		state: "SP"
	},
	{
		ibgeCode: "3503604",
		cityName: "Areiópolis",
		state: "SP"
	},
	{
		ibgeCode: "3503703",
		cityName: "Ariranha",
		state: "SP"
	},
	{
		ibgeCode: "3503802",
		cityName: "Artur Nogueira",
		state: "SP"
	},
	{
		ibgeCode: "3503901",
		cityName: "Arujá",
		state: "SP"
	},
	{
		ibgeCode: "3503950",
		cityName: "Aspásia",
		state: "SP"
	},
	{
		ibgeCode: "3504008",
		cityName: "Assis",
		state: "SP"
	},
	{
		ibgeCode: "3504107",
		cityName: "Atibaia",
		state: "SP"
	},
	{
		ibgeCode: "3504206",
		cityName: "Auriflama",
		state: "SP"
	},
	{
		ibgeCode: "3504305",
		cityName: "Avaí",
		state: "SP"
	},
	{
		ibgeCode: "3504404",
		cityName: "Avanhandava",
		state: "SP"
	},
	{
		ibgeCode: "3504503",
		cityName: "Avaré",
		state: "SP"
	},
	{
		ibgeCode: "3504602",
		cityName: "Bady Bassitt",
		state: "SP"
	},
	{
		ibgeCode: "3504701",
		cityName: "Balbinos",
		state: "SP"
	},
	{
		ibgeCode: "3504800",
		cityName: "Bálsamo",
		state: "SP"
	},
	{
		ibgeCode: "3504909",
		cityName: "Bananal",
		state: "SP"
	},
	{
		ibgeCode: "3505005",
		cityName: "Barão de Antonina",
		state: "SP"
	},
	{
		ibgeCode: "3505104",
		cityName: "Barbosa",
		state: "SP"
	},
	{
		ibgeCode: "3505203",
		cityName: "Bariri",
		state: "SP"
	},
	{
		ibgeCode: "3505302",
		cityName: "Barra Bonita",
		state: "SP"
	},
	{
		ibgeCode: "3505351",
		cityName: "Barra do Chapéu",
		state: "SP"
	},
	{
		ibgeCode: "3505401",
		cityName: "Barra do Turvo",
		state: "SP"
	},
	{
		ibgeCode: "3505500",
		cityName: "Barretos",
		state: "SP"
	},
	{
		ibgeCode: "3505609",
		cityName: "Barrinha",
		state: "SP"
	},
	{
		ibgeCode: "3505708",
		cityName: "Barueri",
		state: "SP"
	},
	{
		ibgeCode: "3505807",
		cityName: "Bastos",
		state: "SP"
	},
	{
		ibgeCode: "3505906",
		cityName: "Batatais",
		state: "SP"
	},
	{
		ibgeCode: "3506003",
		cityName: "Bauru",
		state: "SP"
	},
	{
		ibgeCode: "3506102",
		cityName: "Bebedouro",
		state: "SP"
	},
	{
		ibgeCode: "3506201",
		cityName: "Bento de Abreu",
		state: "SP"
	},
	{
		ibgeCode: "3506300",
		cityName: "Bernardino de Campos",
		state: "SP"
	},
	{
		ibgeCode: "3506359",
		cityName: "Bertioga",
		state: "SP"
	},
	{
		ibgeCode: "3506409",
		cityName: "Bilac",
		state: "SP"
	},
	{
		ibgeCode: "3506508",
		cityName: "Birigui",
		state: "SP"
	},
	{
		ibgeCode: "3506607",
		cityName: "Biritiba Mirim",
		state: "SP"
	},
	{
		ibgeCode: "3506706",
		cityName: "Boa Esperança do Sul",
		state: "SP"
	},
	{
		ibgeCode: "3506805",
		cityName: "Bocaina",
		state: "SP"
	},
	{
		ibgeCode: "3506904",
		cityName: "Bofete",
		state: "SP"
	},
	{
		ibgeCode: "3507001",
		cityName: "Boituva",
		state: "SP"
	},
	{
		ibgeCode: "3507100",
		cityName: "Bom Jesus dos Perdões",
		state: "SP"
	},
	{
		ibgeCode: "3507159",
		cityName: "Bom Sucesso de Itararé",
		state: "SP"
	},
	{
		ibgeCode: "3507209",
		cityName: "Borá",
		state: "SP"
	},
	{
		ibgeCode: "3507308",
		cityName: "Boracéia",
		state: "SP"
	},
	{
		ibgeCode: "3507407",
		cityName: "Borborema",
		state: "SP"
	},
	{
		ibgeCode: "3507456",
		cityName: "Borebi",
		state: "SP"
	},
	{
		ibgeCode: "3507506",
		cityName: "Botucatu",
		state: "SP"
	},
	{
		ibgeCode: "3507605",
		cityName: "Bragança Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3507704",
		cityName: "Braúna",
		state: "SP"
	},
	{
		ibgeCode: "3507753",
		cityName: "Brejo Alegre",
		state: "SP"
	},
	{
		ibgeCode: "3507803",
		cityName: "Brodowski",
		state: "SP"
	},
	{
		ibgeCode: "3507902",
		cityName: "Brotas",
		state: "SP"
	},
	{
		ibgeCode: "3508009",
		cityName: "Buri",
		state: "SP"
	},
	{
		ibgeCode: "3508108",
		cityName: "Buritama",
		state: "SP"
	},
	{
		ibgeCode: "3508207",
		cityName: "Buritizal",
		state: "SP"
	},
	{
		ibgeCode: "3508306",
		cityName: "Cabrália Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3508405",
		cityName: "Cabreúva",
		state: "SP"
	},
	{
		ibgeCode: "3508504",
		cityName: "Caçapava",
		state: "SP"
	},
	{
		ibgeCode: "3508603",
		cityName: "Cachoeira Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3508702",
		cityName: "Caconde",
		state: "SP"
	},
	{
		ibgeCode: "3508801",
		cityName: "Cafelândia",
		state: "SP"
	},
	{
		ibgeCode: "3508900",
		cityName: "Caiabu",
		state: "SP"
	},
	{
		ibgeCode: "3509007",
		cityName: "Caieiras",
		state: "SP"
	},
	{
		ibgeCode: "3509106",
		cityName: "Caiuá",
		state: "SP"
	},
	{
		ibgeCode: "3509205",
		cityName: "Cajamar",
		state: "SP"
	},
	{
		ibgeCode: "3509254",
		cityName: "Cajati",
		state: "SP"
	},
	{
		ibgeCode: "3509304",
		cityName: "Cajobi",
		state: "SP"
	},
	{
		ibgeCode: "3509403",
		cityName: "Cajuru",
		state: "SP"
	},
	{
		ibgeCode: "3509452",
		cityName: "Campina do Monte Alegre",
		state: "SP"
	},
	{
		ibgeCode: "3509502",
		cityName: "Campinas",
		state: "SP"
	},
	{
		ibgeCode: "3509601",
		cityName: "Campo Limpo Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3509700",
		cityName: "Campos do Jordão",
		state: "SP"
	},
	{
		ibgeCode: "3509809",
		cityName: "Campos Novos Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3509908",
		cityName: "Cananéia",
		state: "SP"
	},
	{
		ibgeCode: "3509957",
		cityName: "Canas",
		state: "SP"
	},
	{
		ibgeCode: "3510005",
		cityName: "Cândido Mota",
		state: "SP"
	},
	{
		ibgeCode: "3510104",
		cityName: "Cândido Rodrigues",
		state: "SP"
	},
	{
		ibgeCode: "3510153",
		cityName: "Canitar",
		state: "SP"
	},
	{
		ibgeCode: "3510203",
		cityName: "Capão Bonito",
		state: "SP"
	},
	{
		ibgeCode: "3510302",
		cityName: "Capela do Alto",
		state: "SP"
	},
	{
		ibgeCode: "3510401",
		cityName: "Capivari",
		state: "SP"
	},
	{
		ibgeCode: "3510500",
		cityName: "Caraguatatuba",
		state: "SP"
	},
	{
		ibgeCode: "3510609",
		cityName: "Carapicuíba",
		state: "SP"
	},
	{
		ibgeCode: "3510708",
		cityName: "Cardoso",
		state: "SP"
	},
	{
		ibgeCode: "3510807",
		cityName: "Casa Branca",
		state: "SP"
	},
	{
		ibgeCode: "3510906",
		cityName: "Cássia dos Coqueiros",
		state: "SP"
	},
	{
		ibgeCode: "3511003",
		cityName: "Castilho",
		state: "SP"
	},
	{
		ibgeCode: "3511102",
		cityName: "Catanduva",
		state: "SP"
	},
	{
		ibgeCode: "3511201",
		cityName: "Catiguá",
		state: "SP"
	},
	{
		ibgeCode: "3511300",
		cityName: "Cedral",
		state: "SP"
	},
	{
		ibgeCode: "3511409",
		cityName: "Cerqueira César",
		state: "SP"
	},
	{
		ibgeCode: "3511508",
		cityName: "Cerquilho",
		state: "SP"
	},
	{
		ibgeCode: "3511607",
		cityName: "Cesário Lange",
		state: "SP"
	},
	{
		ibgeCode: "3511706",
		cityName: "Charqueada",
		state: "SP"
	},
	{
		ibgeCode: "3557204",
		cityName: "Chavantes",
		state: "SP"
	},
	{
		ibgeCode: "3511904",
		cityName: "Clementina",
		state: "SP"
	},
	{
		ibgeCode: "3512001",
		cityName: "Colina",
		state: "SP"
	},
	{
		ibgeCode: "3512100",
		cityName: "Colômbia",
		state: "SP"
	},
	{
		ibgeCode: "3512209",
		cityName: "Conchal",
		state: "SP"
	},
	{
		ibgeCode: "3512308",
		cityName: "Conchas",
		state: "SP"
	},
	{
		ibgeCode: "3512407",
		cityName: "Cordeirópolis",
		state: "SP"
	},
	{
		ibgeCode: "3512506",
		cityName: "Coroados",
		state: "SP"
	},
	{
		ibgeCode: "3512605",
		cityName: "Coronel Macedo",
		state: "SP"
	},
	{
		ibgeCode: "3512704",
		cityName: "Corumbataí",
		state: "SP"
	},
	{
		ibgeCode: "3512803",
		cityName: "Cosmópolis",
		state: "SP"
	},
	{
		ibgeCode: "3512902",
		cityName: "Cosmorama",
		state: "SP"
	},
	{
		ibgeCode: "3513009",
		cityName: "Cotia",
		state: "SP"
	},
	{
		ibgeCode: "3513108",
		cityName: "Cravinhos",
		state: "SP"
	},
	{
		ibgeCode: "3513207",
		cityName: "Cristais Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3513306",
		cityName: "Cruzália",
		state: "SP"
	},
	{
		ibgeCode: "3513405",
		cityName: "Cruzeiro",
		state: "SP"
	},
	{
		ibgeCode: "3513504",
		cityName: "Cubatão",
		state: "SP"
	},
	{
		ibgeCode: "3513603",
		cityName: "Cunha",
		state: "SP"
	},
	{
		ibgeCode: "3513702",
		cityName: "Descalvado",
		state: "SP"
	},
	{
		ibgeCode: "3513801",
		cityName: "Diadema",
		state: "SP"
	},
	{
		ibgeCode: "3513850",
		cityName: "Dirce Reis",
		state: "SP"
	},
	{
		ibgeCode: "3513900",
		cityName: "Divinolândia",
		state: "SP"
	},
	{
		ibgeCode: "3514007",
		cityName: "Dobrada",
		state: "SP"
	},
	{
		ibgeCode: "3514106",
		cityName: "Dois Córregos",
		state: "SP"
	},
	{
		ibgeCode: "3514205",
		cityName: "Dolcinópolis",
		state: "SP"
	},
	{
		ibgeCode: "3514304",
		cityName: "Dourado",
		state: "SP"
	},
	{
		ibgeCode: "3514403",
		cityName: "Dracena",
		state: "SP"
	},
	{
		ibgeCode: "3514502",
		cityName: "Duartina",
		state: "SP"
	},
	{
		ibgeCode: "3514601",
		cityName: "Dumont",
		state: "SP"
	},
	{
		ibgeCode: "3514700",
		cityName: "Echaporã",
		state: "SP"
	},
	{
		ibgeCode: "3514809",
		cityName: "Eldorado",
		state: "SP"
	},
	{
		ibgeCode: "3514908",
		cityName: "Elias Fausto",
		state: "SP"
	},
	{
		ibgeCode: "3514924",
		cityName: "Elisiário",
		state: "SP"
	},
	{
		ibgeCode: "3514957",
		cityName: "Embaúba",
		state: "SP"
	},
	{
		ibgeCode: "3515004",
		cityName: "Embu das Artes",
		state: "SP"
	},
	{
		ibgeCode: "3515103",
		cityName: "Embu-Guaçu",
		state: "SP"
	},
	{
		ibgeCode: "3515129",
		cityName: "Emilianópolis",
		state: "SP"
	},
	{
		ibgeCode: "3515152",
		cityName: "Engenheiro Coelho",
		state: "SP"
	},
	{
		ibgeCode: "3515186",
		cityName: "Espírito Santo do Pinhal",
		state: "SP"
	},
	{
		ibgeCode: "3515194",
		cityName: "Espírito Santo do Turvo",
		state: "SP"
	},
	{
		ibgeCode: "3557303",
		cityName: "Estiva Gerbi",
		state: "SP"
	},
	{
		ibgeCode: "3515301",
		cityName: "Estrela do Norte",
		state: "SP"
	},
	{
		ibgeCode: "3515202",
		cityName: "Estrela d'Oeste",
		state: "SP"
	},
	{
		ibgeCode: "3515350",
		cityName: "Euclides da Cunha Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3515400",
		cityName: "Fartura",
		state: "SP"
	},
	{
		ibgeCode: "3515608",
		cityName: "Fernando Prestes",
		state: "SP"
	},
	{
		ibgeCode: "3515509",
		cityName: "Fernandópolis",
		state: "SP"
	},
	{
		ibgeCode: "3515657",
		cityName: "Fernão",
		state: "SP"
	},
	{
		ibgeCode: "3515707",
		cityName: "Ferraz de Vasconcelos",
		state: "SP"
	},
	{
		ibgeCode: "3515806",
		cityName: "Flora Rica",
		state: "SP"
	},
	{
		ibgeCode: "3515905",
		cityName: "Floreal",
		state: "SP"
	},
	{
		ibgeCode: "3516002",
		cityName: "Flórida Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3516101",
		cityName: "Florínea",
		state: "SP"
	},
	{
		ibgeCode: "3516200",
		cityName: "Franca",
		state: "SP"
	},
	{
		ibgeCode: "3516309",
		cityName: "Francisco Morato",
		state: "SP"
	},
	{
		ibgeCode: "3516408",
		cityName: "Franco da Rocha",
		state: "SP"
	},
	{
		ibgeCode: "3516507",
		cityName: "Gabriel Monteiro",
		state: "SP"
	},
	{
		ibgeCode: "3516606",
		cityName: "Gália",
		state: "SP"
	},
	{
		ibgeCode: "3516705",
		cityName: "Garça",
		state: "SP"
	},
	{
		ibgeCode: "3516804",
		cityName: "Gastão Vidigal",
		state: "SP"
	},
	{
		ibgeCode: "3516853",
		cityName: "Gavião Peixoto",
		state: "SP"
	},
	{
		ibgeCode: "3516903",
		cityName: "General Salgado",
		state: "SP"
	},
	{
		ibgeCode: "3517000",
		cityName: "Getulina",
		state: "SP"
	},
	{
		ibgeCode: "3517109",
		cityName: "Glicério",
		state: "SP"
	},
	{
		ibgeCode: "3517208",
		cityName: "Guaiçara",
		state: "SP"
	},
	{
		ibgeCode: "3517307",
		cityName: "Guaimbê",
		state: "SP"
	},
	{
		ibgeCode: "3517406",
		cityName: "Guaíra",
		state: "SP"
	},
	{
		ibgeCode: "3517505",
		cityName: "Guapiaçu",
		state: "SP"
	},
	{
		ibgeCode: "3517604",
		cityName: "Guapiara",
		state: "SP"
	},
	{
		ibgeCode: "3517703",
		cityName: "Guará",
		state: "SP"
	},
	{
		ibgeCode: "3517802",
		cityName: "Guaraçaí",
		state: "SP"
	},
	{
		ibgeCode: "3517901",
		cityName: "Guaraci",
		state: "SP"
	},
	{
		ibgeCode: "3518008",
		cityName: "Guarani d'Oeste",
		state: "SP"
	},
	{
		ibgeCode: "3518107",
		cityName: "Guarantã",
		state: "SP"
	},
	{
		ibgeCode: "3518206",
		cityName: "Guararapes",
		state: "SP"
	},
	{
		ibgeCode: "3518305",
		cityName: "Guararema",
		state: "SP"
	},
	{
		ibgeCode: "3518404",
		cityName: "Guaratinguetá",
		state: "SP"
	},
	{
		ibgeCode: "3518503",
		cityName: "Guareí",
		state: "SP"
	},
	{
		ibgeCode: "3518602",
		cityName: "Guariba",
		state: "SP"
	},
	{
		ibgeCode: "3518701",
		cityName: "Guarujá",
		state: "SP"
	},
	{
		ibgeCode: "3518800",
		cityName: "Guarulhos",
		state: "SP"
	},
	{
		ibgeCode: "3518859",
		cityName: "Guatapará",
		state: "SP"
	},
	{
		ibgeCode: "3518909",
		cityName: "Guzolândia",
		state: "SP"
	},
	{
		ibgeCode: "3519006",
		cityName: "Herculândia",
		state: "SP"
	},
	{
		ibgeCode: "3519055",
		cityName: "Holambra",
		state: "SP"
	},
	{
		ibgeCode: "3519071",
		cityName: "Hortolândia",
		state: "SP"
	},
	{
		ibgeCode: "3519105",
		cityName: "Iacanga",
		state: "SP"
	},
	{
		ibgeCode: "3519204",
		cityName: "Iacri",
		state: "SP"
	},
	{
		ibgeCode: "3519253",
		cityName: "Iaras",
		state: "SP"
	},
	{
		ibgeCode: "3519303",
		cityName: "Ibaté",
		state: "SP"
	},
	{
		ibgeCode: "3519402",
		cityName: "Ibirá",
		state: "SP"
	},
	{
		ibgeCode: "3519501",
		cityName: "Ibirarema",
		state: "SP"
	},
	{
		ibgeCode: "3519600",
		cityName: "Ibitinga",
		state: "SP"
	},
	{
		ibgeCode: "3519709",
		cityName: "Ibiúna",
		state: "SP"
	},
	{
		ibgeCode: "3519808",
		cityName: "Icém",
		state: "SP"
	},
	{
		ibgeCode: "3519907",
		cityName: "Iepê",
		state: "SP"
	},
	{
		ibgeCode: "3520004",
		cityName: "Igaraçu do Tietê",
		state: "SP"
	},
	{
		ibgeCode: "3520103",
		cityName: "Igarapava",
		state: "SP"
	},
	{
		ibgeCode: "3520202",
		cityName: "Igaratá",
		state: "SP"
	},
	{
		ibgeCode: "3520301",
		cityName: "Iguape",
		state: "SP"
	},
	{
		ibgeCode: "3520426",
		cityName: "Ilha Comprida",
		state: "SP"
	},
	{
		ibgeCode: "3520442",
		cityName: "Ilha Solteira",
		state: "SP"
	},
	{
		ibgeCode: "3520400",
		cityName: "Ilhabela",
		state: "SP"
	},
	{
		ibgeCode: "3520509",
		cityName: "Indaiatuba",
		state: "SP"
	},
	{
		ibgeCode: "3520608",
		cityName: "Indiana",
		state: "SP"
	},
	{
		ibgeCode: "3520707",
		cityName: "Indiaporã",
		state: "SP"
	},
	{
		ibgeCode: "3520806",
		cityName: "Inúbia Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3520905",
		cityName: "Ipaussu",
		state: "SP"
	},
	{
		ibgeCode: "3521002",
		cityName: "Iperó",
		state: "SP"
	},
	{
		ibgeCode: "3521101",
		cityName: "Ipeúna",
		state: "SP"
	},
	{
		ibgeCode: "3521150",
		cityName: "Ipiguá",
		state: "SP"
	},
	{
		ibgeCode: "3521200",
		cityName: "Iporanga",
		state: "SP"
	},
	{
		ibgeCode: "3521309",
		cityName: "Ipuã",
		state: "SP"
	},
	{
		ibgeCode: "3521408",
		cityName: "Iracemápolis",
		state: "SP"
	},
	{
		ibgeCode: "3521507",
		cityName: "Irapuã",
		state: "SP"
	},
	{
		ibgeCode: "3521606",
		cityName: "Irapuru",
		state: "SP"
	},
	{
		ibgeCode: "3521705",
		cityName: "Itaberá",
		state: "SP"
	},
	{
		ibgeCode: "3521804",
		cityName: "Itaí",
		state: "SP"
	},
	{
		ibgeCode: "3521903",
		cityName: "Itajobi",
		state: "SP"
	},
	{
		ibgeCode: "3522000",
		cityName: "Itaju",
		state: "SP"
	},
	{
		ibgeCode: "3522109",
		cityName: "Itanhaém",
		state: "SP"
	},
	{
		ibgeCode: "3522158",
		cityName: "Itaoca",
		state: "SP"
	},
	{
		ibgeCode: "3522208",
		cityName: "Itapecerica da Serra",
		state: "SP"
	},
	{
		ibgeCode: "3522307",
		cityName: "Itapetininga",
		state: "SP"
	},
	{
		ibgeCode: "3522406",
		cityName: "Itapeva",
		state: "SP"
	},
	{
		ibgeCode: "3522505",
		cityName: "Itapevi",
		state: "SP"
	},
	{
		ibgeCode: "3522604",
		cityName: "Itapira",
		state: "SP"
	},
	{
		ibgeCode: "3522653",
		cityName: "Itapirapuã Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3522703",
		cityName: "Itápolis",
		state: "SP"
	},
	{
		ibgeCode: "3522802",
		cityName: "Itaporanga",
		state: "SP"
	},
	{
		ibgeCode: "3522901",
		cityName: "Itapuí",
		state: "SP"
	},
	{
		ibgeCode: "3523008",
		cityName: "Itapura",
		state: "SP"
	},
	{
		ibgeCode: "3523107",
		cityName: "Itaquaquecetuba",
		state: "SP"
	},
	{
		ibgeCode: "3523206",
		cityName: "Itararé",
		state: "SP"
	},
	{
		ibgeCode: "3523305",
		cityName: "Itariri",
		state: "SP"
	},
	{
		ibgeCode: "3523404",
		cityName: "Itatiba",
		state: "SP"
	},
	{
		ibgeCode: "3523503",
		cityName: "Itatinga",
		state: "SP"
	},
	{
		ibgeCode: "3523602",
		cityName: "Itirapina",
		state: "SP"
	},
	{
		ibgeCode: "3523701",
		cityName: "Itirapuã",
		state: "SP"
	},
	{
		ibgeCode: "3523800",
		cityName: "Itobi",
		state: "SP"
	},
	{
		ibgeCode: "3523909",
		cityName: "Itu",
		state: "SP"
	},
	{
		ibgeCode: "3524006",
		cityName: "Itupeva",
		state: "SP"
	},
	{
		ibgeCode: "3524105",
		cityName: "Ituverava",
		state: "SP"
	},
	{
		ibgeCode: "3524204",
		cityName: "Jaborandi",
		state: "SP"
	},
	{
		ibgeCode: "3524303",
		cityName: "Jaboticabal",
		state: "SP"
	},
	{
		ibgeCode: "3524402",
		cityName: "Jacareí",
		state: "SP"
	},
	{
		ibgeCode: "3524501",
		cityName: "Jaci",
		state: "SP"
	},
	{
		ibgeCode: "3524600",
		cityName: "Jacupiranga",
		state: "SP"
	},
	{
		ibgeCode: "3524709",
		cityName: "Jaguariúna",
		state: "SP"
	},
	{
		ibgeCode: "3524808",
		cityName: "Jales",
		state: "SP"
	},
	{
		ibgeCode: "3524907",
		cityName: "Jambeiro",
		state: "SP"
	},
	{
		ibgeCode: "3525003",
		cityName: "Jandira",
		state: "SP"
	},
	{
		ibgeCode: "3525102",
		cityName: "Jardinópolis",
		state: "SP"
	},
	{
		ibgeCode: "3525201",
		cityName: "Jarinu",
		state: "SP"
	},
	{
		ibgeCode: "3525300",
		cityName: "Jaú",
		state: "SP"
	},
	{
		ibgeCode: "3525409",
		cityName: "Jeriquara",
		state: "SP"
	},
	{
		ibgeCode: "3525508",
		cityName: "Joanópolis",
		state: "SP"
	},
	{
		ibgeCode: "3525607",
		cityName: "João Ramalho",
		state: "SP"
	},
	{
		ibgeCode: "3525706",
		cityName: "José Bonifácio",
		state: "SP"
	},
	{
		ibgeCode: "3525805",
		cityName: "Júlio Mesquita",
		state: "SP"
	},
	{
		ibgeCode: "3525854",
		cityName: "Jumirim",
		state: "SP"
	},
	{
		ibgeCode: "3525904",
		cityName: "Jundiaí",
		state: "SP"
	},
	{
		ibgeCode: "3526001",
		cityName: "Junqueirópolis",
		state: "SP"
	},
	{
		ibgeCode: "3526100",
		cityName: "Juquiá",
		state: "SP"
	},
	{
		ibgeCode: "3526209",
		cityName: "Juquitiba",
		state: "SP"
	},
	{
		ibgeCode: "3526308",
		cityName: "Lagoinha",
		state: "SP"
	},
	{
		ibgeCode: "3526407",
		cityName: "Laranjal Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3526506",
		cityName: "Lavínia",
		state: "SP"
	},
	{
		ibgeCode: "3526605",
		cityName: "Lavrinhas",
		state: "SP"
	},
	{
		ibgeCode: "3526704",
		cityName: "Leme",
		state: "SP"
	},
	{
		ibgeCode: "3526803",
		cityName: "Lençóis Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3526902",
		cityName: "Limeira",
		state: "SP"
	},
	{
		ibgeCode: "3527009",
		cityName: "Lindóia",
		state: "SP"
	},
	{
		ibgeCode: "3527108",
		cityName: "Lins",
		state: "SP"
	},
	{
		ibgeCode: "3527207",
		cityName: "Lorena",
		state: "SP"
	},
	{
		ibgeCode: "3527256",
		cityName: "Lourdes",
		state: "SP"
	},
	{
		ibgeCode: "3527306",
		cityName: "Louveira",
		state: "SP"
	},
	{
		ibgeCode: "3527405",
		cityName: "Lucélia",
		state: "SP"
	},
	{
		ibgeCode: "3527504",
		cityName: "Lucianópolis",
		state: "SP"
	},
	{
		ibgeCode: "3527603",
		cityName: "Luís Antônio",
		state: "SP"
	},
	{
		ibgeCode: "3527702",
		cityName: "Luiziânia",
		state: "SP"
	},
	{
		ibgeCode: "3527801",
		cityName: "Lupércio",
		state: "SP"
	},
	{
		ibgeCode: "3527900",
		cityName: "Lutécia",
		state: "SP"
	},
	{
		ibgeCode: "3528007",
		cityName: "Macatuba",
		state: "SP"
	},
	{
		ibgeCode: "3528106",
		cityName: "Macaubal",
		state: "SP"
	},
	{
		ibgeCode: "3528205",
		cityName: "Macedônia",
		state: "SP"
	},
	{
		ibgeCode: "3528304",
		cityName: "Magda",
		state: "SP"
	},
	{
		ibgeCode: "3528403",
		cityName: "Mairinque",
		state: "SP"
	},
	{
		ibgeCode: "3528502",
		cityName: "Mairiporã",
		state: "SP"
	},
	{
		ibgeCode: "3528601",
		cityName: "Manduri",
		state: "SP"
	},
	{
		ibgeCode: "3528700",
		cityName: "Marabá Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3528809",
		cityName: "Maracaí",
		state: "SP"
	},
	{
		ibgeCode: "3528858",
		cityName: "Marapoama",
		state: "SP"
	},
	{
		ibgeCode: "3528908",
		cityName: "Mariápolis",
		state: "SP"
	},
	{
		ibgeCode: "3529005",
		cityName: "Marília",
		state: "SP"
	},
	{
		ibgeCode: "3529104",
		cityName: "Marinópolis",
		state: "SP"
	},
	{
		ibgeCode: "3529203",
		cityName: "Martinópolis",
		state: "SP"
	},
	{
		ibgeCode: "3529302",
		cityName: "Matão",
		state: "SP"
	},
	{
		ibgeCode: "3529401",
		cityName: "Mauá",
		state: "SP"
	},
	{
		ibgeCode: "3529500",
		cityName: "Mendonça",
		state: "SP"
	},
	{
		ibgeCode: "3529609",
		cityName: "Meridiano",
		state: "SP"
	},
	{
		ibgeCode: "3529658",
		cityName: "Mesópolis",
		state: "SP"
	},
	{
		ibgeCode: "3529708",
		cityName: "Miguelópolis",
		state: "SP"
	},
	{
		ibgeCode: "3529807",
		cityName: "Mineiros do Tietê",
		state: "SP"
	},
	{
		ibgeCode: "3530003",
		cityName: "Mira Estrela",
		state: "SP"
	},
	{
		ibgeCode: "3529906",
		cityName: "Miracatu",
		state: "SP"
	},
	{
		ibgeCode: "3530102",
		cityName: "Mirandópolis",
		state: "SP"
	},
	{
		ibgeCode: "3530201",
		cityName: "Mirante do Paranapanema",
		state: "SP"
	},
	{
		ibgeCode: "3530300",
		cityName: "Mirassol",
		state: "SP"
	},
	{
		ibgeCode: "3530409",
		cityName: "Mirassolândia",
		state: "SP"
	},
	{
		ibgeCode: "3530508",
		cityName: "Mococa",
		state: "SP"
	},
	{
		ibgeCode: "3530607",
		cityName: "Mogi das Cruzes",
		state: "SP"
	},
	{
		ibgeCode: "3530706",
		cityName: "Mogi Guaçu",
		state: "SP"
	},
	{
		ibgeCode: "3530805",
		cityName: "Mogi Mirim",
		state: "SP"
	},
	{
		ibgeCode: "3530904",
		cityName: "Mombuca",
		state: "SP"
	},
	{
		ibgeCode: "3531001",
		cityName: "Monções",
		state: "SP"
	},
	{
		ibgeCode: "3531100",
		cityName: "Mongaguá",
		state: "SP"
	},
	{
		ibgeCode: "3531209",
		cityName: "Monte Alegre do Sul",
		state: "SP"
	},
	{
		ibgeCode: "3531308",
		cityName: "Monte Alto",
		state: "SP"
	},
	{
		ibgeCode: "3531407",
		cityName: "Monte Aprazível",
		state: "SP"
	},
	{
		ibgeCode: "3531506",
		cityName: "Monte Azul Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3531605",
		cityName: "Monte Castelo",
		state: "SP"
	},
	{
		ibgeCode: "3531803",
		cityName: "Monte Mor",
		state: "SP"
	},
	{
		ibgeCode: "3531704",
		cityName: "Monteiro Lobato",
		state: "SP"
	},
	{
		ibgeCode: "3531902",
		cityName: "Morro Agudo",
		state: "SP"
	},
	{
		ibgeCode: "3532009",
		cityName: "Morungaba",
		state: "SP"
	},
	{
		ibgeCode: "3532058",
		cityName: "Motuca",
		state: "SP"
	},
	{
		ibgeCode: "3532108",
		cityName: "Murutinga do Sul",
		state: "SP"
	},
	{
		ibgeCode: "3532157",
		cityName: "Nantes",
		state: "SP"
	},
	{
		ibgeCode: "3532207",
		cityName: "Narandiba",
		state: "SP"
	},
	{
		ibgeCode: "3532306",
		cityName: "Natividade da Serra",
		state: "SP"
	},
	{
		ibgeCode: "3532405",
		cityName: "Nazaré Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3532504",
		cityName: "Neves Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3532603",
		cityName: "Nhandeara",
		state: "SP"
	},
	{
		ibgeCode: "3532702",
		cityName: "Nipoã",
		state: "SP"
	},
	{
		ibgeCode: "3532801",
		cityName: "Nova Aliança",
		state: "SP"
	},
	{
		ibgeCode: "3532827",
		cityName: "Nova Campina",
		state: "SP"
	},
	{
		ibgeCode: "3532843",
		cityName: "Nova Canaã Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3532868",
		cityName: "Nova Castilho",
		state: "SP"
	},
	{
		ibgeCode: "3532900",
		cityName: "Nova Europa",
		state: "SP"
	},
	{
		ibgeCode: "3533007",
		cityName: "Nova Granada",
		state: "SP"
	},
	{
		ibgeCode: "3533106",
		cityName: "Nova Guataporanga",
		state: "SP"
	},
	{
		ibgeCode: "3533205",
		cityName: "Nova Independência",
		state: "SP"
	},
	{
		ibgeCode: "3533304",
		cityName: "Nova Luzitânia",
		state: "SP"
	},
	{
		ibgeCode: "3533403",
		cityName: "Nova Odessa",
		state: "SP"
	},
	{
		ibgeCode: "3533254",
		cityName: "Novais",
		state: "SP"
	},
	{
		ibgeCode: "3533502",
		cityName: "Novo Horizonte",
		state: "SP"
	},
	{
		ibgeCode: "3533601",
		cityName: "Nuporanga",
		state: "SP"
	},
	{
		ibgeCode: "3533700",
		cityName: "Ocauçu",
		state: "SP"
	},
	{
		ibgeCode: "3533809",
		cityName: "Óleo",
		state: "SP"
	},
	{
		ibgeCode: "3533908",
		cityName: "Olímpia",
		state: "SP"
	},
	{
		ibgeCode: "3534005",
		cityName: "Onda Verde",
		state: "SP"
	},
	{
		ibgeCode: "3534104",
		cityName: "Oriente",
		state: "SP"
	},
	{
		ibgeCode: "3534203",
		cityName: "Orindiúva",
		state: "SP"
	},
	{
		ibgeCode: "3534302",
		cityName: "Orlândia",
		state: "SP"
	},
	{
		ibgeCode: "3534401",
		cityName: "Osasco",
		state: "SP"
	},
	{
		ibgeCode: "3534500",
		cityName: "Oscar Bressane",
		state: "SP"
	},
	{
		ibgeCode: "3534609",
		cityName: "Osvaldo Cruz",
		state: "SP"
	},
	{
		ibgeCode: "3534708",
		cityName: "Ourinhos",
		state: "SP"
	},
	{
		ibgeCode: "3534807",
		cityName: "Ouro Verde",
		state: "SP"
	},
	{
		ibgeCode: "3534757",
		cityName: "Ouroeste",
		state: "SP"
	},
	{
		ibgeCode: "3534906",
		cityName: "Pacaembu",
		state: "SP"
	},
	{
		ibgeCode: "3535002",
		cityName: "Palestina",
		state: "SP"
	},
	{
		ibgeCode: "3535101",
		cityName: "Palmares Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3535200",
		cityName: "Palmeira d'Oeste",
		state: "SP"
	},
	{
		ibgeCode: "3535309",
		cityName: "Palmital",
		state: "SP"
	},
	{
		ibgeCode: "3535408",
		cityName: "Panorama",
		state: "SP"
	},
	{
		ibgeCode: "3535507",
		cityName: "Paraguaçu Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3535606",
		cityName: "Paraibuna",
		state: "SP"
	},
	{
		ibgeCode: "3535705",
		cityName: "Paraíso",
		state: "SP"
	},
	{
		ibgeCode: "3535804",
		cityName: "Paranapanema",
		state: "SP"
	},
	{
		ibgeCode: "3535903",
		cityName: "Paranapuã",
		state: "SP"
	},
	{
		ibgeCode: "3536000",
		cityName: "Parapuã",
		state: "SP"
	},
	{
		ibgeCode: "3536109",
		cityName: "Pardinho",
		state: "SP"
	},
	{
		ibgeCode: "3536208",
		cityName: "Pariquera-Açu",
		state: "SP"
	},
	{
		ibgeCode: "3536257",
		cityName: "Parisi",
		state: "SP"
	},
	{
		ibgeCode: "3536307",
		cityName: "Patrocínio Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3536406",
		cityName: "Paulicéia",
		state: "SP"
	},
	{
		ibgeCode: "3536505",
		cityName: "Paulínia",
		state: "SP"
	},
	{
		ibgeCode: "3536570",
		cityName: "Paulistânia",
		state: "SP"
	},
	{
		ibgeCode: "3536604",
		cityName: "Paulo de Faria",
		state: "SP"
	},
	{
		ibgeCode: "3536703",
		cityName: "Pederneiras",
		state: "SP"
	},
	{
		ibgeCode: "3536802",
		cityName: "Pedra Bela",
		state: "SP"
	},
	{
		ibgeCode: "3536901",
		cityName: "Pedranópolis",
		state: "SP"
	},
	{
		ibgeCode: "3537008",
		cityName: "Pedregulho",
		state: "SP"
	},
	{
		ibgeCode: "3537107",
		cityName: "Pedreira",
		state: "SP"
	},
	{
		ibgeCode: "3537156",
		cityName: "Pedrinhas Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3537206",
		cityName: "Pedro de Toledo",
		state: "SP"
	},
	{
		ibgeCode: "3537305",
		cityName: "Penápolis",
		state: "SP"
	},
	{
		ibgeCode: "3537404",
		cityName: "Pereira Barreto",
		state: "SP"
	},
	{
		ibgeCode: "3537503",
		cityName: "Pereiras",
		state: "SP"
	},
	{
		ibgeCode: "3537602",
		cityName: "Peruíbe",
		state: "SP"
	},
	{
		ibgeCode: "3537701",
		cityName: "Piacatu",
		state: "SP"
	},
	{
		ibgeCode: "3537800",
		cityName: "Piedade",
		state: "SP"
	},
	{
		ibgeCode: "3537909",
		cityName: "Pilar do Sul",
		state: "SP"
	},
	{
		ibgeCode: "3538006",
		cityName: "Pindamonhangaba",
		state: "SP"
	},
	{
		ibgeCode: "3538105",
		cityName: "Pindorama",
		state: "SP"
	},
	{
		ibgeCode: "3538204",
		cityName: "Pinhalzinho",
		state: "SP"
	},
	{
		ibgeCode: "3538303",
		cityName: "Piquerobi",
		state: "SP"
	},
	{
		ibgeCode: "3538501",
		cityName: "Piquete",
		state: "SP"
	},
	{
		ibgeCode: "3538600",
		cityName: "Piracaia",
		state: "SP"
	},
	{
		ibgeCode: "3538709",
		cityName: "Piracicaba",
		state: "SP"
	},
	{
		ibgeCode: "3538808",
		cityName: "Piraju",
		state: "SP"
	},
	{
		ibgeCode: "3538907",
		cityName: "Pirajuí",
		state: "SP"
	},
	{
		ibgeCode: "3539004",
		cityName: "Pirangi",
		state: "SP"
	},
	{
		ibgeCode: "3539103",
		cityName: "Pirapora do Bom Jesus",
		state: "SP"
	},
	{
		ibgeCode: "3539202",
		cityName: "Pirapozinho",
		state: "SP"
	},
	{
		ibgeCode: "3539301",
		cityName: "Pirassununga",
		state: "SP"
	},
	{
		ibgeCode: "3539400",
		cityName: "Piratininga",
		state: "SP"
	},
	{
		ibgeCode: "3539509",
		cityName: "Pitangueiras",
		state: "SP"
	},
	{
		ibgeCode: "3539608",
		cityName: "Planalto",
		state: "SP"
	},
	{
		ibgeCode: "3539707",
		cityName: "Platina",
		state: "SP"
	},
	{
		ibgeCode: "3539806",
		cityName: "Poá",
		state: "SP"
	},
	{
		ibgeCode: "3539905",
		cityName: "Poloni",
		state: "SP"
	},
	{
		ibgeCode: "3540002",
		cityName: "Pompéia",
		state: "SP"
	},
	{
		ibgeCode: "3540101",
		cityName: "Pongaí",
		state: "SP"
	},
	{
		ibgeCode: "3540200",
		cityName: "Pontal",
		state: "SP"
	},
	{
		ibgeCode: "3540259",
		cityName: "Pontalinda",
		state: "SP"
	},
	{
		ibgeCode: "3540309",
		cityName: "Pontes Gestal",
		state: "SP"
	},
	{
		ibgeCode: "3540408",
		cityName: "Populina",
		state: "SP"
	},
	{
		ibgeCode: "3540507",
		cityName: "Porangaba",
		state: "SP"
	},
	{
		ibgeCode: "3540606",
		cityName: "Porto Feliz",
		state: "SP"
	},
	{
		ibgeCode: "3540705",
		cityName: "Porto Ferreira",
		state: "SP"
	},
	{
		ibgeCode: "3540754",
		cityName: "Potim",
		state: "SP"
	},
	{
		ibgeCode: "3540804",
		cityName: "Potirendaba",
		state: "SP"
	},
	{
		ibgeCode: "3540853",
		cityName: "Pracinha",
		state: "SP"
	},
	{
		ibgeCode: "3540903",
		cityName: "Pradópolis",
		state: "SP"
	},
	{
		ibgeCode: "3541000",
		cityName: "Praia Grande",
		state: "SP"
	},
	{
		ibgeCode: "3541059",
		cityName: "Pratânia",
		state: "SP"
	},
	{
		ibgeCode: "3541109",
		cityName: "Presidente Alves",
		state: "SP"
	},
	{
		ibgeCode: "3541208",
		cityName: "Presidente Bernardes",
		state: "SP"
	},
	{
		ibgeCode: "3541307",
		cityName: "Presidente Epitácio",
		state: "SP"
	},
	{
		ibgeCode: "3541406",
		cityName: "Presidente Prudente",
		state: "SP"
	},
	{
		ibgeCode: "3541505",
		cityName: "Presidente Venceslau",
		state: "SP"
	},
	{
		ibgeCode: "3541604",
		cityName: "Promissão",
		state: "SP"
	},
	{
		ibgeCode: "3541653",
		cityName: "Quadra",
		state: "SP"
	},
	{
		ibgeCode: "3541703",
		cityName: "Quatá",
		state: "SP"
	},
	{
		ibgeCode: "3541802",
		cityName: "Queiroz",
		state: "SP"
	},
	{
		ibgeCode: "3541901",
		cityName: "Queluz",
		state: "SP"
	},
	{
		ibgeCode: "3542008",
		cityName: "Quintana",
		state: "SP"
	},
	{
		ibgeCode: "3542107",
		cityName: "Rafard",
		state: "SP"
	},
	{
		ibgeCode: "3542206",
		cityName: "Rancharia",
		state: "SP"
	},
	{
		ibgeCode: "3542305",
		cityName: "Redenção da Serra",
		state: "SP"
	},
	{
		ibgeCode: "3542404",
		cityName: "Regente Feijó",
		state: "SP"
	},
	{
		ibgeCode: "3542503",
		cityName: "Reginópolis",
		state: "SP"
	},
	{
		ibgeCode: "3542602",
		cityName: "Registro",
		state: "SP"
	},
	{
		ibgeCode: "3542701",
		cityName: "Restinga",
		state: "SP"
	},
	{
		ibgeCode: "3542800",
		cityName: "Ribeira",
		state: "SP"
	},
	{
		ibgeCode: "3542909",
		cityName: "Ribeirão Bonito",
		state: "SP"
	},
	{
		ibgeCode: "3543006",
		cityName: "Ribeirão Branco",
		state: "SP"
	},
	{
		ibgeCode: "3543105",
		cityName: "Ribeirão Corrente",
		state: "SP"
	},
	{
		ibgeCode: "3543204",
		cityName: "Ribeirão do Sul",
		state: "SP"
	},
	{
		ibgeCode: "3543238",
		cityName: "Ribeirão dos Índios",
		state: "SP"
	},
	{
		ibgeCode: "3543253",
		cityName: "Ribeirão Grande",
		state: "SP"
	},
	{
		ibgeCode: "3543303",
		cityName: "Ribeirão Pires",
		state: "SP"
	},
	{
		ibgeCode: "3543402",
		cityName: "Ribeirão Preto",
		state: "SP"
	},
	{
		ibgeCode: "3543600",
		cityName: "Rifaina",
		state: "SP"
	},
	{
		ibgeCode: "3543709",
		cityName: "Rincão",
		state: "SP"
	},
	{
		ibgeCode: "3543808",
		cityName: "Rinópolis",
		state: "SP"
	},
	{
		ibgeCode: "3543907",
		cityName: "Rio Claro",
		state: "SP"
	},
	{
		ibgeCode: "3544004",
		cityName: "Rio das Pedras",
		state: "SP"
	},
	{
		ibgeCode: "3544103",
		cityName: "Rio Grande da Serra",
		state: "SP"
	},
	{
		ibgeCode: "3544202",
		cityName: "Riolândia",
		state: "SP"
	},
	{
		ibgeCode: "3543501",
		cityName: "Riversul",
		state: "SP"
	},
	{
		ibgeCode: "3544251",
		cityName: "Rosana",
		state: "SP"
	},
	{
		ibgeCode: "3544301",
		cityName: "Roseira",
		state: "SP"
	},
	{
		ibgeCode: "3544400",
		cityName: "Rubiácea",
		state: "SP"
	},
	{
		ibgeCode: "3544509",
		cityName: "Rubinéia",
		state: "SP"
	},
	{
		ibgeCode: "3544608",
		cityName: "Sabino",
		state: "SP"
	},
	{
		ibgeCode: "3544707",
		cityName: "Sagres",
		state: "SP"
	},
	{
		ibgeCode: "3544806",
		cityName: "Sales",
		state: "SP"
	},
	{
		ibgeCode: "3544905",
		cityName: "Sales Oliveira",
		state: "SP"
	},
	{
		ibgeCode: "3545001",
		cityName: "Salesópolis",
		state: "SP"
	},
	{
		ibgeCode: "3545100",
		cityName: "Salmourão",
		state: "SP"
	},
	{
		ibgeCode: "3545159",
		cityName: "Saltinho",
		state: "SP"
	},
	{
		ibgeCode: "3545209",
		cityName: "Salto",
		state: "SP"
	},
	{
		ibgeCode: "3545308",
		cityName: "Salto de Pirapora",
		state: "SP"
	},
	{
		ibgeCode: "3545407",
		cityName: "Salto Grande",
		state: "SP"
	},
	{
		ibgeCode: "3545506",
		cityName: "Sandovalina",
		state: "SP"
	},
	{
		ibgeCode: "3545605",
		cityName: "Santa Adélia",
		state: "SP"
	},
	{
		ibgeCode: "3545704",
		cityName: "Santa Albertina",
		state: "SP"
	},
	{
		ibgeCode: "3545803",
		cityName: "Santa Bárbara d'Oeste",
		state: "SP"
	},
	{
		ibgeCode: "3546009",
		cityName: "Santa Branca",
		state: "SP"
	},
	{
		ibgeCode: "3546108",
		cityName: "Santa Clara d'Oeste",
		state: "SP"
	},
	{
		ibgeCode: "3546207",
		cityName: "Santa Cruz da Conceição",
		state: "SP"
	},
	{
		ibgeCode: "3546256",
		cityName: "Santa Cruz da Esperança",
		state: "SP"
	},
	{
		ibgeCode: "3546306",
		cityName: "Santa Cruz das Palmeiras",
		state: "SP"
	},
	{
		ibgeCode: "3546405",
		cityName: "Santa Cruz do Rio Pardo",
		state: "SP"
	},
	{
		ibgeCode: "3546504",
		cityName: "Santa Ernestina",
		state: "SP"
	},
	{
		ibgeCode: "3546603",
		cityName: "Santa Fé do Sul",
		state: "SP"
	},
	{
		ibgeCode: "3546702",
		cityName: "Santa Gertrudes",
		state: "SP"
	},
	{
		ibgeCode: "3546801",
		cityName: "Santa Isabel",
		state: "SP"
	},
	{
		ibgeCode: "3546900",
		cityName: "Santa Lúcia",
		state: "SP"
	},
	{
		ibgeCode: "3547007",
		cityName: "Santa Maria da Serra",
		state: "SP"
	},
	{
		ibgeCode: "3547106",
		cityName: "Santa Mercedes",
		state: "SP"
	},
	{
		ibgeCode: "3547502",
		cityName: "Santa Rita do Passa Quatro",
		state: "SP"
	},
	{
		ibgeCode: "3547403",
		cityName: "Santa Rita d'Oeste",
		state: "SP"
	},
	{
		ibgeCode: "3547601",
		cityName: "Santa Rosa de Viterbo",
		state: "SP"
	},
	{
		ibgeCode: "3547650",
		cityName: "Santa Salete",
		state: "SP"
	},
	{
		ibgeCode: "3547205",
		cityName: "Santana da Ponte Pensa",
		state: "SP"
	},
	{
		ibgeCode: "3547304",
		cityName: "Santana de Parnaíba",
		state: "SP"
	},
	{
		ibgeCode: "3547700",
		cityName: "Santo Anastácio",
		state: "SP"
	},
	{
		ibgeCode: "3547809",
		cityName: "Santo André",
		state: "SP"
	},
	{
		ibgeCode: "3547908",
		cityName: "Santo Antônio da Alegria",
		state: "SP"
	},
	{
		ibgeCode: "3548005",
		cityName: "Santo Antônio de Posse",
		state: "SP"
	},
	{
		ibgeCode: "3548054",
		cityName: "Santo Antônio do Aracanguá",
		state: "SP"
	},
	{
		ibgeCode: "3548104",
		cityName: "Santo Antônio do Jardim",
		state: "SP"
	},
	{
		ibgeCode: "3548203",
		cityName: "Santo Antônio do Pinhal",
		state: "SP"
	},
	{
		ibgeCode: "3548302",
		cityName: "Santo Expedito",
		state: "SP"
	},
	{
		ibgeCode: "3548401",
		cityName: "Santópolis do Aguapeí",
		state: "SP"
	},
	{
		ibgeCode: "3548500",
		cityName: "Santos",
		state: "SP"
	},
	{
		ibgeCode: "3548609",
		cityName: "São Bento do Sapucaí",
		state: "SP"
	},
	{
		ibgeCode: "3548708",
		cityName: "São Bernardo do Campo",
		state: "SP"
	},
	{
		ibgeCode: "3548807",
		cityName: "São Caetano do Sul",
		state: "SP"
	},
	{
		ibgeCode: "3548906",
		cityName: "São Carlos",
		state: "SP"
	},
	{
		ibgeCode: "3549003",
		cityName: "São Francisco",
		state: "SP"
	},
	{
		ibgeCode: "3549102",
		cityName: "São João da Boa Vista",
		state: "SP"
	},
	{
		ibgeCode: "3549201",
		cityName: "São João das Duas Pontes",
		state: "SP"
	},
	{
		ibgeCode: "3549250",
		cityName: "São João de Iracema",
		state: "SP"
	},
	{
		ibgeCode: "3549300",
		cityName: "São João do Pau d'Alho",
		state: "SP"
	},
	{
		ibgeCode: "3549409",
		cityName: "São Joaquim da Barra",
		state: "SP"
	},
	{
		ibgeCode: "3549508",
		cityName: "São José da Bela Vista",
		state: "SP"
	},
	{
		ibgeCode: "3549607",
		cityName: "São José do Barreiro",
		state: "SP"
	},
	{
		ibgeCode: "3549706",
		cityName: "São José do Rio Pardo",
		state: "SP"
	},
	{
		ibgeCode: "3549805",
		cityName: "São José do Rio Preto",
		state: "SP"
	},
	{
		ibgeCode: "3549904",
		cityName: "São José dos Campos",
		state: "SP"
	},
	{
		ibgeCode: "3549953",
		cityName: "São Lourenço da Serra",
		state: "SP"
	},
	{
		ibgeCode: "3550001",
		cityName: "São Luiz do Paraitinga",
		state: "SP"
	},
	{
		ibgeCode: "3550100",
		cityName: "São Manuel",
		state: "SP"
	},
	{
		ibgeCode: "3550209",
		cityName: "São Miguel Arcanjo",
		state: "SP"
	},
	{
		ibgeCode: "3550308",
		cityName: "São Paulo",
		state: "SP"
	},
	{
		ibgeCode: "3550407",
		cityName: "São Pedro",
		state: "SP"
	},
	{
		ibgeCode: "3550506",
		cityName: "São Pedro do Turvo",
		state: "SP"
	},
	{
		ibgeCode: "3550605",
		cityName: "São Roque",
		state: "SP"
	},
	{
		ibgeCode: "3550704",
		cityName: "São Sebastião",
		state: "SP"
	},
	{
		ibgeCode: "3550803",
		cityName: "São Sebastião da Grama",
		state: "SP"
	},
	{
		ibgeCode: "3550902",
		cityName: "São Simão",
		state: "SP"
	},
	{
		ibgeCode: "3551009",
		cityName: "São Vicente",
		state: "SP"
	},
	{
		ibgeCode: "3551108",
		cityName: "Sarapuí",
		state: "SP"
	},
	{
		ibgeCode: "3551207",
		cityName: "Sarutaiá",
		state: "SP"
	},
	{
		ibgeCode: "3551306",
		cityName: "Sebastianópolis do Sul",
		state: "SP"
	},
	{
		ibgeCode: "3551405",
		cityName: "Serra Azul",
		state: "SP"
	},
	{
		ibgeCode: "3551603",
		cityName: "Serra Negra",
		state: "SP"
	},
	{
		ibgeCode: "3551504",
		cityName: "Serrana",
		state: "SP"
	},
	{
		ibgeCode: "3551702",
		cityName: "Sertãozinho",
		state: "SP"
	},
	{
		ibgeCode: "3551801",
		cityName: "Sete Barras",
		state: "SP"
	},
	{
		ibgeCode: "3551900",
		cityName: "Severínia",
		state: "SP"
	},
	{
		ibgeCode: "3552007",
		cityName: "Silveiras",
		state: "SP"
	},
	{
		ibgeCode: "3552106",
		cityName: "Socorro",
		state: "SP"
	},
	{
		ibgeCode: "3552205",
		cityName: "Sorocaba",
		state: "SP"
	},
	{
		ibgeCode: "3552304",
		cityName: "Sud Mennucci",
		state: "SP"
	},
	{
		ibgeCode: "3552403",
		cityName: "Sumaré",
		state: "SP"
	},
	{
		ibgeCode: "3552551",
		cityName: "Suzanápolis",
		state: "SP"
	},
	{
		ibgeCode: "3552502",
		cityName: "Suzano",
		state: "SP"
	},
	{
		ibgeCode: "3552601",
		cityName: "Tabapuã",
		state: "SP"
	},
	{
		ibgeCode: "3552700",
		cityName: "Tabatinga",
		state: "SP"
	},
	{
		ibgeCode: "3552809",
		cityName: "Taboão da Serra",
		state: "SP"
	},
	{
		ibgeCode: "3552908",
		cityName: "Taciba",
		state: "SP"
	},
	{
		ibgeCode: "3553005",
		cityName: "Taguaí",
		state: "SP"
	},
	{
		ibgeCode: "3553104",
		cityName: "Taiaçu",
		state: "SP"
	},
	{
		ibgeCode: "3553203",
		cityName: "Taiúva",
		state: "SP"
	},
	{
		ibgeCode: "3553302",
		cityName: "Tambaú",
		state: "SP"
	},
	{
		ibgeCode: "3553401",
		cityName: "Tanabi",
		state: "SP"
	},
	{
		ibgeCode: "3553500",
		cityName: "Tapiraí",
		state: "SP"
	},
	{
		ibgeCode: "3553609",
		cityName: "Tapiratiba",
		state: "SP"
	},
	{
		ibgeCode: "3553658",
		cityName: "Taquaral",
		state: "SP"
	},
	{
		ibgeCode: "3553708",
		cityName: "Taquaritinga",
		state: "SP"
	},
	{
		ibgeCode: "3553807",
		cityName: "Taquarituba",
		state: "SP"
	},
	{
		ibgeCode: "3553856",
		cityName: "Taquarivaí",
		state: "SP"
	},
	{
		ibgeCode: "3553906",
		cityName: "Tarabai",
		state: "SP"
	},
	{
		ibgeCode: "3553955",
		cityName: "Tarumã",
		state: "SP"
	},
	{
		ibgeCode: "3554003",
		cityName: "Tatuí",
		state: "SP"
	},
	{
		ibgeCode: "3554102",
		cityName: "Taubaté",
		state: "SP"
	},
	{
		ibgeCode: "3554201",
		cityName: "Tejupá",
		state: "SP"
	},
	{
		ibgeCode: "3554300",
		cityName: "Teodoro Sampaio",
		state: "SP"
	},
	{
		ibgeCode: "3554409",
		cityName: "Terra Roxa",
		state: "SP"
	},
	{
		ibgeCode: "3554508",
		cityName: "Tietê",
		state: "SP"
	},
	{
		ibgeCode: "3554607",
		cityName: "Timburi",
		state: "SP"
	},
	{
		ibgeCode: "3554656",
		cityName: "Torre de Pedra",
		state: "SP"
	},
	{
		ibgeCode: "3554706",
		cityName: "Torrinha",
		state: "SP"
	},
	{
		ibgeCode: "3554755",
		cityName: "Trabiju",
		state: "SP"
	},
	{
		ibgeCode: "3554805",
		cityName: "Tremembé",
		state: "SP"
	},
	{
		ibgeCode: "3554904",
		cityName: "Três Fronteiras",
		state: "SP"
	},
	{
		ibgeCode: "3554953",
		cityName: "Tuiuti",
		state: "SP"
	},
	{
		ibgeCode: "3555000",
		cityName: "Tupã",
		state: "SP"
	},
	{
		ibgeCode: "3555109",
		cityName: "Tupi Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3555208",
		cityName: "Turiúba",
		state: "SP"
	},
	{
		ibgeCode: "3555307",
		cityName: "Turmalina",
		state: "SP"
	},
	{
		ibgeCode: "3555356",
		cityName: "Ubarana",
		state: "SP"
	},
	{
		ibgeCode: "3555406",
		cityName: "Ubatuba",
		state: "SP"
	},
	{
		ibgeCode: "3555505",
		cityName: "Ubirajara",
		state: "SP"
	},
	{
		ibgeCode: "3555604",
		cityName: "Uchoa",
		state: "SP"
	},
	{
		ibgeCode: "3555703",
		cityName: "União Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3555802",
		cityName: "Urânia",
		state: "SP"
	},
	{
		ibgeCode: "3555901",
		cityName: "Uru",
		state: "SP"
	},
	{
		ibgeCode: "3556008",
		cityName: "Urupês",
		state: "SP"
	},
	{
		ibgeCode: "3556107",
		cityName: "Valentim Gentil",
		state: "SP"
	},
	{
		ibgeCode: "3556206",
		cityName: "Valinhos",
		state: "SP"
	},
	{
		ibgeCode: "3556305",
		cityName: "Valparaíso",
		state: "SP"
	},
	{
		ibgeCode: "3556354",
		cityName: "Vargem",
		state: "SP"
	},
	{
		ibgeCode: "3556404",
		cityName: "Vargem Grande do Sul",
		state: "SP"
	},
	{
		ibgeCode: "3556453",
		cityName: "Vargem Grande Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3556503",
		cityName: "Várzea Paulista",
		state: "SP"
	},
	{
		ibgeCode: "3556602",
		cityName: "Vera Cruz",
		state: "SP"
	},
	{
		ibgeCode: "3556701",
		cityName: "Vinhedo",
		state: "SP"
	},
	{
		ibgeCode: "3556800",
		cityName: "Viradouro",
		state: "SP"
	},
	{
		ibgeCode: "3556909",
		cityName: "Vista Alegre do Alto",
		state: "SP"
	},
	{
		ibgeCode: "3556958",
		cityName: "Vitória Brasil",
		state: "SP"
	},
	{
		ibgeCode: "3557006",
		cityName: "Votorantim",
		state: "SP"
	},
	{
		ibgeCode: "3557105",
		cityName: "Votuporanga",
		state: "SP"
	},
	{
		ibgeCode: "3557154",
		cityName: "Zacarias",
		state: "SP"
	}
];
var SE = [
	{
		ibgeCode: "2800100",
		cityName: "Amparo do São Francisco",
		state: "SE"
	},
	{
		ibgeCode: "2800209",
		cityName: "Aquidabã",
		state: "SE"
	},
	{
		ibgeCode: "2800308",
		cityName: "Aracaju",
		state: "SE"
	},
	{
		ibgeCode: "2800407",
		cityName: "Arauá",
		state: "SE"
	},
	{
		ibgeCode: "2800506",
		cityName: "Areia Branca",
		state: "SE"
	},
	{
		ibgeCode: "2800605",
		cityName: "Barra dos Coqueiros",
		state: "SE"
	},
	{
		ibgeCode: "2800670",
		cityName: "Boquim",
		state: "SE"
	},
	{
		ibgeCode: "2800704",
		cityName: "Brejo Grande",
		state: "SE"
	},
	{
		ibgeCode: "2801009",
		cityName: "Campo do Brito",
		state: "SE"
	},
	{
		ibgeCode: "2801108",
		cityName: "Canhoba",
		state: "SE"
	},
	{
		ibgeCode: "2801207",
		cityName: "Canindé de São Francisco",
		state: "SE"
	},
	{
		ibgeCode: "2801306",
		cityName: "Capela",
		state: "SE"
	},
	{
		ibgeCode: "2801405",
		cityName: "Carira",
		state: "SE"
	},
	{
		ibgeCode: "2801504",
		cityName: "Carmópolis",
		state: "SE"
	},
	{
		ibgeCode: "2801603",
		cityName: "Cedro de São João",
		state: "SE"
	},
	{
		ibgeCode: "2801702",
		cityName: "Cristinápolis",
		state: "SE"
	},
	{
		ibgeCode: "2801900",
		cityName: "Cumbe",
		state: "SE"
	},
	{
		ibgeCode: "2802007",
		cityName: "Divina Pastora",
		state: "SE"
	},
	{
		ibgeCode: "2802106",
		cityName: "Estância",
		state: "SE"
	},
	{
		ibgeCode: "2802205",
		cityName: "Feira Nova",
		state: "SE"
	},
	{
		ibgeCode: "2802304",
		cityName: "Frei Paulo",
		state: "SE"
	},
	{
		ibgeCode: "2802403",
		cityName: "Gararu",
		state: "SE"
	},
	{
		ibgeCode: "2802502",
		cityName: "General Maynard",
		state: "SE"
	},
	{
		ibgeCode: "2802601",
		cityName: "Gracho Cardoso",
		state: "SE"
	},
	{
		ibgeCode: "2802700",
		cityName: "Ilha das Flores",
		state: "SE"
	},
	{
		ibgeCode: "2802809",
		cityName: "Indiaroba",
		state: "SE"
	},
	{
		ibgeCode: "2802908",
		cityName: "Itabaiana",
		state: "SE"
	},
	{
		ibgeCode: "2803005",
		cityName: "Itabaianinha",
		state: "SE"
	},
	{
		ibgeCode: "2803104",
		cityName: "Itabi",
		state: "SE"
	},
	{
		ibgeCode: "2803203",
		cityName: "Itaporanga d'Ajuda",
		state: "SE"
	},
	{
		ibgeCode: "2803302",
		cityName: "Japaratuba",
		state: "SE"
	},
	{
		ibgeCode: "2803401",
		cityName: "Japoatã",
		state: "SE"
	},
	{
		ibgeCode: "2803500",
		cityName: "Lagarto",
		state: "SE"
	},
	{
		ibgeCode: "2803609",
		cityName: "Laranjeiras",
		state: "SE"
	},
	{
		ibgeCode: "2803708",
		cityName: "Macambira",
		state: "SE"
	},
	{
		ibgeCode: "2803807",
		cityName: "Malhada dos Bois",
		state: "SE"
	},
	{
		ibgeCode: "2803906",
		cityName: "Malhador",
		state: "SE"
	},
	{
		ibgeCode: "2804003",
		cityName: "Maruim",
		state: "SE"
	},
	{
		ibgeCode: "2804102",
		cityName: "Moita Bonita",
		state: "SE"
	},
	{
		ibgeCode: "2804201",
		cityName: "Monte Alegre de Sergipe",
		state: "SE"
	},
	{
		ibgeCode: "2804300",
		cityName: "Muribeca",
		state: "SE"
	},
	{
		ibgeCode: "2804409",
		cityName: "Neópolis",
		state: "SE"
	},
	{
		ibgeCode: "2804458",
		cityName: "Nossa Senhora Aparecida",
		state: "SE"
	},
	{
		ibgeCode: "2804508",
		cityName: "Nossa Senhora da Glória",
		state: "SE"
	},
	{
		ibgeCode: "2804607",
		cityName: "Nossa Senhora das Dores",
		state: "SE"
	},
	{
		ibgeCode: "2804706",
		cityName: "Nossa Senhora de Lourdes",
		state: "SE"
	},
	{
		ibgeCode: "2804805",
		cityName: "Nossa Senhora do Socorro",
		state: "SE"
	},
	{
		ibgeCode: "2804904",
		cityName: "Pacatuba",
		state: "SE"
	},
	{
		ibgeCode: "2805000",
		cityName: "Pedra Mole",
		state: "SE"
	},
	{
		ibgeCode: "2805109",
		cityName: "Pedrinhas",
		state: "SE"
	},
	{
		ibgeCode: "2805208",
		cityName: "Pinhão",
		state: "SE"
	},
	{
		ibgeCode: "2805307",
		cityName: "Pirambu",
		state: "SE"
	},
	{
		ibgeCode: "2805406",
		cityName: "Poço Redondo",
		state: "SE"
	},
	{
		ibgeCode: "2805505",
		cityName: "Poço Verde",
		state: "SE"
	},
	{
		ibgeCode: "2805604",
		cityName: "Porto da Folha",
		state: "SE"
	},
	{
		ibgeCode: "2805703",
		cityName: "Propriá",
		state: "SE"
	},
	{
		ibgeCode: "2805802",
		cityName: "Riachão do Dantas",
		state: "SE"
	},
	{
		ibgeCode: "2805901",
		cityName: "Riachuelo",
		state: "SE"
	},
	{
		ibgeCode: "2806008",
		cityName: "Ribeirópolis",
		state: "SE"
	},
	{
		ibgeCode: "2806107",
		cityName: "Rosário do Catete",
		state: "SE"
	},
	{
		ibgeCode: "2806206",
		cityName: "Salgado",
		state: "SE"
	},
	{
		ibgeCode: "2806305",
		cityName: "Santa Luzia do Itanhy",
		state: "SE"
	},
	{
		ibgeCode: "2806503",
		cityName: "Santa Rosa de Lima",
		state: "SE"
	},
	{
		ibgeCode: "2806404",
		cityName: "Santana do São Francisco",
		state: "SE"
	},
	{
		ibgeCode: "2806602",
		cityName: "Santo Amaro das Brotas",
		state: "SE"
	},
	{
		ibgeCode: "2806701",
		cityName: "São Cristóvão",
		state: "SE"
	},
	{
		ibgeCode: "2806800",
		cityName: "São Domingos",
		state: "SE"
	},
	{
		ibgeCode: "2806909",
		cityName: "São Francisco",
		state: "SE"
	},
	{
		ibgeCode: "2807006",
		cityName: "São Miguel do Aleixo",
		state: "SE"
	},
	{
		ibgeCode: "2807105",
		cityName: "Simão Dias",
		state: "SE"
	},
	{
		ibgeCode: "2807204",
		cityName: "Siriri",
		state: "SE"
	},
	{
		ibgeCode: "2807303",
		cityName: "Telha",
		state: "SE"
	},
	{
		ibgeCode: "2807402",
		cityName: "Tobias Barreto",
		state: "SE"
	},
	{
		ibgeCode: "2807501",
		cityName: "Tomar do Geru",
		state: "SE"
	},
	{
		ibgeCode: "2807600",
		cityName: "Umbaúba",
		state: "SE"
	}
];
var TO = [
	{
		ibgeCode: "1700251",
		cityName: "Abreulândia",
		state: "TO"
	},
	{
		ibgeCode: "1700301",
		cityName: "Aguiarnópolis",
		state: "TO"
	},
	{
		ibgeCode: "1700350",
		cityName: "Aliança do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1700400",
		cityName: "Almas",
		state: "TO"
	},
	{
		ibgeCode: "1700707",
		cityName: "Alvorada",
		state: "TO"
	},
	{
		ibgeCode: "1701002",
		cityName: "Ananás",
		state: "TO"
	},
	{
		ibgeCode: "1701051",
		cityName: "Angico",
		state: "TO"
	},
	{
		ibgeCode: "1701101",
		cityName: "Aparecida do Rio Negro",
		state: "TO"
	},
	{
		ibgeCode: "1701309",
		cityName: "Aragominas",
		state: "TO"
	},
	{
		ibgeCode: "1701903",
		cityName: "Araguacema",
		state: "TO"
	},
	{
		ibgeCode: "1702000",
		cityName: "Araguaçu",
		state: "TO"
	},
	{
		ibgeCode: "1702109",
		cityName: "Araguaína",
		state: "TO"
	},
	{
		ibgeCode: "1702158",
		cityName: "Araguanã",
		state: "TO"
	},
	{
		ibgeCode: "1702208",
		cityName: "Araguatins",
		state: "TO"
	},
	{
		ibgeCode: "1702307",
		cityName: "Arapoema",
		state: "TO"
	},
	{
		ibgeCode: "1702406",
		cityName: "Arraias",
		state: "TO"
	},
	{
		ibgeCode: "1702554",
		cityName: "Augustinópolis",
		state: "TO"
	},
	{
		ibgeCode: "1702703",
		cityName: "Aurora do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1702901",
		cityName: "Axixá do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1703008",
		cityName: "Babaçulândia",
		state: "TO"
	},
	{
		ibgeCode: "1703057",
		cityName: "Bandeirantes do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1703073",
		cityName: "Barra do Ouro",
		state: "TO"
	},
	{
		ibgeCode: "1703107",
		cityName: "Barrolândia",
		state: "TO"
	},
	{
		ibgeCode: "1703206",
		cityName: "Bernardo Sayão",
		state: "TO"
	},
	{
		ibgeCode: "1703305",
		cityName: "Bom Jesus do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1703602",
		cityName: "Brasilândia do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1703701",
		cityName: "Brejinho de Nazaré",
		state: "TO"
	},
	{
		ibgeCode: "1703800",
		cityName: "Buriti do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1703826",
		cityName: "Cachoeirinha",
		state: "TO"
	},
	{
		ibgeCode: "1703842",
		cityName: "Campos Lindos",
		state: "TO"
	},
	{
		ibgeCode: "1703867",
		cityName: "Cariri do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1703883",
		cityName: "Carmolândia",
		state: "TO"
	},
	{
		ibgeCode: "1703891",
		cityName: "Carrasco Bonito",
		state: "TO"
	},
	{
		ibgeCode: "1703909",
		cityName: "Caseara",
		state: "TO"
	},
	{
		ibgeCode: "1704105",
		cityName: "Centenário",
		state: "TO"
	},
	{
		ibgeCode: "1705102",
		cityName: "Chapada da Natividade",
		state: "TO"
	},
	{
		ibgeCode: "1704600",
		cityName: "Chapada de Areia",
		state: "TO"
	},
	{
		ibgeCode: "1705508",
		cityName: "Colinas do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1716703",
		cityName: "Colméia",
		state: "TO"
	},
	{
		ibgeCode: "1705557",
		cityName: "Combinado",
		state: "TO"
	},
	{
		ibgeCode: "1705607",
		cityName: "Conceição do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1706001",
		cityName: "Couto Magalhães",
		state: "TO"
	},
	{
		ibgeCode: "1706100",
		cityName: "Cristalândia",
		state: "TO"
	},
	{
		ibgeCode: "1706258",
		cityName: "Crixás do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1706506",
		cityName: "Darcinópolis",
		state: "TO"
	},
	{
		ibgeCode: "1707009",
		cityName: "Dianópolis",
		state: "TO"
	},
	{
		ibgeCode: "1707108",
		cityName: "Divinópolis do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1707207",
		cityName: "Dois Irmãos do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1707306",
		cityName: "Dueré",
		state: "TO"
	},
	{
		ibgeCode: "1707405",
		cityName: "Esperantina",
		state: "TO"
	},
	{
		ibgeCode: "1707553",
		cityName: "Fátima",
		state: "TO"
	},
	{
		ibgeCode: "1707652",
		cityName: "Figueirópolis",
		state: "TO"
	},
	{
		ibgeCode: "1707702",
		cityName: "Filadélfia",
		state: "TO"
	},
	{
		ibgeCode: "1708205",
		cityName: "Formoso do Araguaia",
		state: "TO"
	},
	{
		ibgeCode: "1708304",
		cityName: "Goianorte",
		state: "TO"
	},
	{
		ibgeCode: "1709005",
		cityName: "Goiatins",
		state: "TO"
	},
	{
		ibgeCode: "1709302",
		cityName: "Guaraí",
		state: "TO"
	},
	{
		ibgeCode: "1709500",
		cityName: "Gurupi",
		state: "TO"
	},
	{
		ibgeCode: "1709807",
		cityName: "Ipueiras",
		state: "TO"
	},
	{
		ibgeCode: "1710508",
		cityName: "Itacajá",
		state: "TO"
	},
	{
		ibgeCode: "1710706",
		cityName: "Itaguatins",
		state: "TO"
	},
	{
		ibgeCode: "1710904",
		cityName: "Itapiratins",
		state: "TO"
	},
	{
		ibgeCode: "1711100",
		cityName: "Itaporã do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1711506",
		cityName: "Jaú do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1711803",
		cityName: "Juarina",
		state: "TO"
	},
	{
		ibgeCode: "1711902",
		cityName: "Lagoa da Confusão",
		state: "TO"
	},
	{
		ibgeCode: "1711951",
		cityName: "Lagoa do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1712009",
		cityName: "Lajeado",
		state: "TO"
	},
	{
		ibgeCode: "1712157",
		cityName: "Lavandeira",
		state: "TO"
	},
	{
		ibgeCode: "1712405",
		cityName: "Lizarda",
		state: "TO"
	},
	{
		ibgeCode: "1712454",
		cityName: "Luzinópolis",
		state: "TO"
	},
	{
		ibgeCode: "1712504",
		cityName: "Marianópolis do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1712702",
		cityName: "Mateiros",
		state: "TO"
	},
	{
		ibgeCode: "1712801",
		cityName: "Maurilândia do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1713205",
		cityName: "Miracema do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1713304",
		cityName: "Miranorte",
		state: "TO"
	},
	{
		ibgeCode: "1713601",
		cityName: "Monte do Carmo",
		state: "TO"
	},
	{
		ibgeCode: "1713700",
		cityName: "Monte Santo do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1713957",
		cityName: "Muricilândia",
		state: "TO"
	},
	{
		ibgeCode: "1714203",
		cityName: "Natividade",
		state: "TO"
	},
	{
		ibgeCode: "1714302",
		cityName: "Nazaré",
		state: "TO"
	},
	{
		ibgeCode: "1714880",
		cityName: "Nova Olinda",
		state: "TO"
	},
	{
		ibgeCode: "1715002",
		cityName: "Nova Rosalândia",
		state: "TO"
	},
	{
		ibgeCode: "1715101",
		cityName: "Novo Acordo",
		state: "TO"
	},
	{
		ibgeCode: "1715150",
		cityName: "Novo Alegre",
		state: "TO"
	},
	{
		ibgeCode: "1715259",
		cityName: "Novo Jardim",
		state: "TO"
	},
	{
		ibgeCode: "1715507",
		cityName: "Oliveira de Fátima",
		state: "TO"
	},
	{
		ibgeCode: "1721000",
		cityName: "Palmas",
		state: "TO"
	},
	{
		ibgeCode: "1715705",
		cityName: "Palmeirante",
		state: "TO"
	},
	{
		ibgeCode: "1713809",
		cityName: "Palmeiras do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1715754",
		cityName: "Palmeirópolis",
		state: "TO"
	},
	{
		ibgeCode: "1716109",
		cityName: "Paraíso do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1716208",
		cityName: "Paranã",
		state: "TO"
	},
	{
		ibgeCode: "1716307",
		cityName: "Pau D'Arco",
		state: "TO"
	},
	{
		ibgeCode: "1716505",
		cityName: "Pedro Afonso",
		state: "TO"
	},
	{
		ibgeCode: "1716604",
		cityName: "Peixe",
		state: "TO"
	},
	{
		ibgeCode: "1716653",
		cityName: "Pequizeiro",
		state: "TO"
	},
	{
		ibgeCode: "1717008",
		cityName: "Pindorama do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1717206",
		cityName: "Piraquê",
		state: "TO"
	},
	{
		ibgeCode: "1717503",
		cityName: "Pium",
		state: "TO"
	},
	{
		ibgeCode: "1717800",
		cityName: "Ponte Alta do Bom Jesus",
		state: "TO"
	},
	{
		ibgeCode: "1717909",
		cityName: "Ponte Alta do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1718006",
		cityName: "Porto Alegre do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1718204",
		cityName: "Porto Nacional",
		state: "TO"
	},
	{
		ibgeCode: "1718303",
		cityName: "Praia Norte",
		state: "TO"
	},
	{
		ibgeCode: "1718402",
		cityName: "Presidente Kennedy",
		state: "TO"
	},
	{
		ibgeCode: "1718451",
		cityName: "Pugmil",
		state: "TO"
	},
	{
		ibgeCode: "1718501",
		cityName: "Recursolândia",
		state: "TO"
	},
	{
		ibgeCode: "1718550",
		cityName: "Riachinho",
		state: "TO"
	},
	{
		ibgeCode: "1718659",
		cityName: "Rio da Conceição",
		state: "TO"
	},
	{
		ibgeCode: "1718709",
		cityName: "Rio dos Bois",
		state: "TO"
	},
	{
		ibgeCode: "1718758",
		cityName: "Rio Sono",
		state: "TO"
	},
	{
		ibgeCode: "1718808",
		cityName: "Sampaio",
		state: "TO"
	},
	{
		ibgeCode: "1718840",
		cityName: "Sandolândia",
		state: "TO"
	},
	{
		ibgeCode: "1718865",
		cityName: "Santa Fé do Araguaia",
		state: "TO"
	},
	{
		ibgeCode: "1718881",
		cityName: "Santa Maria do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1718899",
		cityName: "Santa Rita do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1718907",
		cityName: "Santa Rosa do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1719004",
		cityName: "Santa Tereza do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1720002",
		cityName: "Santa Terezinha do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1720101",
		cityName: "São Bento do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1720150",
		cityName: "São Félix do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1720200",
		cityName: "São Miguel do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1720259",
		cityName: "São Salvador do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1720309",
		cityName: "São Sebastião do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1720499",
		cityName: "São Valério",
		state: "TO"
	},
	{
		ibgeCode: "1720655",
		cityName: "Silvanópolis",
		state: "TO"
	},
	{
		ibgeCode: "1720804",
		cityName: "Sítio Novo do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1720853",
		cityName: "Sucupira",
		state: "TO"
	},
	{
		ibgeCode: "1708254",
		cityName: "Tabocão",
		state: "TO"
	},
	{
		ibgeCode: "1720903",
		cityName: "Taguatinga",
		state: "TO"
	},
	{
		ibgeCode: "1720937",
		cityName: "Taipas do Tocantins",
		state: "TO"
	},
	{
		ibgeCode: "1720978",
		cityName: "Talismã",
		state: "TO"
	},
	{
		ibgeCode: "1721109",
		cityName: "Tocantínia",
		state: "TO"
	},
	{
		ibgeCode: "1721208",
		cityName: "Tocantinópolis",
		state: "TO"
	},
	{
		ibgeCode: "1721257",
		cityName: "Tupirama",
		state: "TO"
	},
	{
		ibgeCode: "1721307",
		cityName: "Tupiratins",
		state: "TO"
	},
	{
		ibgeCode: "1722081",
		cityName: "Wanderlândia",
		state: "TO"
	},
	{
		ibgeCode: "1722107",
		cityName: "Xambioá",
		state: "TO"
	}
];
var dataJson$4 = {
	AC: AC,
	AL: AL,
	AP: AP,
	AM: AM,
	BA: BA,
	CE: CE,
	DF: DF,
	ES: ES,
	GO: GO,
	MA: MA,
	MT: MT,
	MS: MS,
	MG: MG,
	PA: PA,
	PB: PB,
	PR: PR,
	PE: PE,
	PI: PI,
	RJ: RJ,
	RN: RN,
	RS: RS,
	RO: RO,
	RR: RR,
	SC: SC,
	SP: SP,
	SE: SE,
	TO: TO
};

/**
 * @returns StatesBRDataList[] - returns a mapped list with data from all cities separated by states in Brazil
 *
 * References:
 * @see https://www.cidade-brasil.com.br/
 * @see https://cidades.ibge.gov.br/
 * @see https://pt.wikipedia.org/wiki/Discagem_direta_%C3%A0_dist%C3%A2ncia
 *
 * 5570 cities are cataloged with their respective ibge codes according to IBGE
 * If you find inconsistency in any city, please contact caio.cezar.dequeiroz@gmail.com or submit a PR.
 * @see https://cidades.ibge.gov.br/.
 */
const mapCitiesByState = dataJson$4;
/**
 *
 * @param {string | undefined} state - key that represents the abbreviated name of the states of Brazil
 * @returns StatesBRDataList[] - returns a mapped list with data from all cities that are included within the searched state of Brazil
 */
const getCitiesListByState = (state) => {
    return mapCitiesByState[state];
};
/**
 *
 * @param {string | undefined} state - abbreviated name of the state
 * @param {string | undefined} term - full term or part of the city name
 * @returns StatesBRDataList[] - returns a list with data from all cities that match the argument
 */
const searchCitiesByTerm = (state, term) => (mapCitiesByState[state] ?? []).filter((city) => city.cityName.toLocaleLowerCase().includes(term?.toLocaleLowerCase() ?? ''));
/**
 *
 * @param {string | undefined} state - abbreviated name of the state
 * @param {string | undefined} ibgeCode - city ibge code
 * @returns StatesBRDataList[] - returns a list with data from all cities that match the argument
 */
const searchCitiesByIBGECode = (state, ibgeCode) => {
    const arrStates = mapCitiesByState[state];
    if (!ibgeCode)
        return arrStates;
    return arrStates.filter((state) => state.ibgeCode.includes(ibgeCode));
};

var dataJson$3 = [
	{
		countryNamePTBR: "Afeganistão",
		countryName: "Afghanistan",
		abbreviationAlpha3: "AFG",
		abbreviationFips10: "AF",
		domain: ".af",
		areaCodeList: [
			"20",
			"30",
			"40",
			"50",
			"60",
			"70"
		],
		ddi: "93"
	},
	{
		countryNamePTBR: "Albânia",
		countryName: "Albania",
		abbreviationAlpha3: "ALB",
		abbreviationFips10: "AL",
		domain: ".al",
		areaCodeList: [
			"4",
			"22",
			"32",
			"33",
			"34",
			"35",
			"52",
			"53",
			"68",
			"69",
			"82",
			"84",
			"211",
			"212",
			"213",
			"214",
			"215",
			"216",
			"217",
			"218",
			"219",
			"242",
			"311",
			"312",
			"313",
			"342",
			"361",
			"368",
			"371",
			"387",
			"388",
			"391",
			"392",
			"393",
			"394",
			"511",
			"512",
			"513",
			"514",
			"545",
			"554",
			"561",
			"563",
			"571",
			"577",
			"581",
			"591",
			"811",
			"812",
			"813",
			"814",
			"815",
			"832",
			"852",
			"861",
			"881",
			"885",
			"893"
		],
		ddi: "355"
	},
	{
		countryNamePTBR: "Argélia",
		countryName: "Algeria",
		abbreviationAlpha3: "DZA",
		abbreviationFips10: "AG",
		domain: ".dz",
		areaCodeList: [
			"21",
			"24",
			"25",
			"26",
			"27",
			"29",
			"31",
			"32",
			"33",
			"34",
			"35",
			"36",
			"37",
			"38",
			"41",
			"43",
			"45",
			"46",
			"48",
			"49",
			"61"
		],
		ddi: "213"
	},
	{
		countryNamePTBR: "Andorra",
		countryName: "Andorra",
		abbreviationAlpha3: "AND",
		abbreviationFips10: "AN",
		domain: ".ad",
		areaCodeList: [
			"3",
			"7"
		],
		ddi: "376"
	},
	{
		countryNamePTBR: "Angola",
		countryName: "Angola",
		abbreviationAlpha3: "AGO",
		abbreviationFips10: "AO",
		domain: ".ao",
		areaCodeList: [
			"2",
			"31",
			"33",
			"34",
			"35",
			"36",
			"41",
			"48",
			"49",
			"51",
			"52",
			"53",
			"54",
			"61",
			"64",
			"65",
			"72",
			"91",
			"92"
		],
		ddi: "244"
	},
	{
		countryNamePTBR: "Antártica",
		countryName: "Antarctica",
		abbreviationAlpha3: "ATA",
		abbreviationFips10: "AY",
		domain: ".aq",
		areaCodeList: [
			"10",
			"11",
			"12",
			"13"
		],
		ddi: "672"
	},
	{
		countryNamePTBR: "Argentina",
		countryName: "Argentina",
		abbreviationAlpha3: "ARG",
		abbreviationFips10: "AR",
		domain: ".ar",
		areaCodeList: [
			"11",
			"221",
			"223",
			"261",
			"264",
			"291",
			"297",
			"299",
			"341",
			"342",
			"343",
			"345",
			"351",
			"358",
			"381",
			"385",
			"387",
			"531",
			"2293",
			"2324",
			"2627",
			"2652",
			"2965",
			"3461",
			"3525",
			"3717",
			"3722",
			"3752",
			"3756",
			"3783",
			"3822",
			"3833"
		],
		ddi: "54"
	},
	{
		countryNamePTBR: "Armênia",
		countryName: "Armenia",
		abbreviationAlpha3: "ARM",
		abbreviationFips10: "AM",
		domain: ".am",
		areaCodeList: [
			"9",
			"10",
			"22",
			"23",
			"24",
			"26",
			"31",
			"32",
			"33",
			"34",
			"35",
			"36",
			"37",
			"38",
			"41",
			"42",
			"43",
			"44",
			"45",
			"46",
			"49",
			"51",
			"52",
			"53",
			"54",
			"55",
			"56",
			"57",
			"61",
			"62",
			"63",
			"64",
			"65",
			"66",
			"69",
			"81",
			"82",
			"83",
			"84",
			"85",
			"86",
			"87"
		],
		ddi: "374"
	},
	{
		countryNamePTBR: "Austrália",
		countryName: "Australia",
		abbreviationAlpha3: "AUS",
		abbreviationFips10: "AS",
		domain: ".au",
		areaCodeList: [
			"2",
			"3",
			"4",
			"7",
			"8",
			"10",
			"11",
			"12",
			"13"
		],
		ddi: "61"
	},
	{
		countryNamePTBR: "Áustria",
		countryName: "Austria",
		abbreviationAlpha3: "AUT",
		abbreviationFips10: "AU",
		domain: ".at",
		areaCodeList: [
			"1",
			"316",
			"463",
			"512",
			"650",
			"660",
			"662",
			"664",
			"676",
			"699",
			"732",
			"2622",
			"2635",
			"2732",
			"2742",
			"3842",
			"4242",
			"4352",
			"5356",
			"5552",
			"7242"
		],
		ddi: "43"
	},
	{
		countryNamePTBR: "Azerbaijão",
		countryName: "Azerbaijan",
		abbreviationAlpha3: "AZE",
		abbreviationFips10: "AJ",
		domain: ".az",
		areaCodeList: [
			"12",
			"22",
			"50",
			"55",
			"110",
			"111",
			"113",
			"114",
			"115",
			"119",
			"135",
			"136",
			"138",
			"140",
			"141",
			"143",
			"144",
			"145",
			"147",
			"150",
			"151",
			"152",
			"153",
			"154",
			"157",
			"159",
			"160",
			"163",
			"164",
			"166",
			"167",
			"168",
			"169",
			"170",
			"171",
			"172",
			"174",
			"175",
			"176",
			"177",
			"178",
			"190",
			"192",
			"193",
			"195",
			"197",
			"198",
			"199",
			"216",
			"230",
			"231",
			"232",
			"234",
			"241",
			"244",
			"246",
			"255",
			"265",
			"279"
		],
		ddi: "994"
	},
	{
		countryNamePTBR: "Bahamas",
		countryName: "Bahamas",
		abbreviationAlpha3: "BHS",
		abbreviationFips10: "BF",
		domain: ".bs",
		areaCodeList: [
			"242"
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "Bangladesh",
		countryName: "Bangladesh",
		abbreviationAlpha3: "BGD",
		abbreviationFips10: "BG",
		domain: ".bd",
		areaCodeList: [
			"2",
			"31",
			"41",
			"51",
			"71",
			"81",
			"91",
			"321",
			"331",
			"341",
			"351",
			"361",
			"371",
			"381",
			"402",
			"421",
			"423",
			"431",
			"441",
			"448",
			"451",
			"461",
			"468",
			"471",
			"481",
			"488",
			"491",
			"498",
			"521",
			"531",
			"541",
			"551",
			"552",
			"561",
			"568",
			"571",
			"581",
			"591",
			"601",
			"628",
			"631",
			"641",
			"651",
			"661",
			"681",
			"691",
			"721",
			"731",
			"732",
			"741",
			"751",
			"761",
			"771",
			"781",
			"791",
			"821",
			"831",
			"841",
			"851",
			"861",
			"871",
			"921",
			"931",
			"941",
			"951",
			"981",
			"3028",
			"3035",
			"3036",
			"3037",
			"3223",
			"3224",
			"3424",
			"3427",
			"3529",
			"3823",
			"4027",
			"4222",
			"4225",
			"4228",
			"4326",
			"4332",
			"4422",
			"4424",
			"4425",
			"4623",
			"4662",
			"4724",
			"5033",
			"5222",
			"5327",
			"5334",
			"5526",
			"6254",
			"6257",
			"6423",
			"7022",
			"7023",
			"7622",
			"8023",
			"8032",
			"8034",
			"8233",
			"8424",
			"8525",
			"8528",
			"8626",
			"8723",
			"8732",
			"9028",
			"9033",
			"9225",
			"9233",
			"9423",
			"9424",
			"9435",
			"9524"
		],
		ddi: "880"
	},
	{
		countryNamePTBR: "Belarus",
		countryName: "Belarus",
		abbreviationAlpha3: "BLR",
		abbreviationFips10: "BO",
		domain: ".by",
		areaCodeList: [
			"15",
			"16",
			"17",
			"21",
			"22",
			"23",
			"152",
			"162",
			"163",
			"165",
			"212",
			"214",
			"222",
			"225",
			"1511",
			"1512",
			"1513",
			"1514",
			"1515",
			"1561",
			"1562",
			"1563",
			"1564",
			"1591",
			"1592",
			"1593",
			"1594",
			"1595",
			"1596",
			"1597",
			"1631",
			"1632",
			"1633",
			"1641",
			"1642",
			"1643",
			"1644",
			"1645",
			"1646",
			"1647",
			"1651",
			"1652",
			"1655",
			"1710",
			"1713",
			"1714",
			"1715",
			"1716",
			"1717",
			"1718",
			"1719",
			"1770",
			"1771",
			"1772",
			"1773",
			"1774",
			"1775",
			"1776",
			"1777",
			"1779",
			"1792",
			"1793",
			"1794",
			"1795",
			"1796",
			"1797",
			"2130",
			"2131",
			"2132",
			"2133",
			"2135",
			"2136",
			"2137",
			"2138",
			"2139",
			"2151",
			"2152",
			"2153",
			"2154",
			"2155",
			"2156",
			"2157",
			"2158",
			"2159",
			"2161",
			"2230",
			"2231",
			"2232",
			"2233",
			"2234",
			"2235",
			"2236",
			"2237",
			"2238",
			"2239",
			"2240",
			"2241",
			"2242",
			"2243",
			"2244",
			"2245",
			"2246",
			"2247",
			"2248",
			"2322",
			"2330",
			"2332",
			"2333",
			"2334",
			"2336",
			"2337",
			"2339",
			"2340",
			"2342",
			"2344",
			"2345",
			"2346",
			"2347",
			"2350",
			"2351",
			"2353",
			"2354",
			"2355",
			"2356",
			"2357"
		],
		ddi: "375"
	},
	{
		countryNamePTBR: "Bélgica",
		countryName: "Belgium",
		abbreviationAlpha3: "BEL",
		abbreviationFips10: "BE",
		domain: ".be",
		areaCodeList: [
			"2",
			"3",
			"4",
			"9",
			"10",
			"11",
			"12",
			"13",
			"14",
			"15",
			"16",
			"19",
			"50",
			"51",
			"52",
			"53",
			"54",
			"55",
			"58",
			"59",
			"60",
			"61",
			"63",
			"64",
			"65",
			"67",
			"69",
			"71",
			"80",
			"81",
			"82",
			"83",
			"85",
			"86",
			"87",
			"89",
			"472",
			"485",
			"495"
		],
		ddi: "32"
	},
	{
		countryNamePTBR: "Belize",
		countryName: "Belize",
		abbreviationAlpha3: "BLZ",
		abbreviationFips10: "BH",
		domain: ".bz",
		areaCodeList: [
			"2",
			"3",
			"4",
			"5",
			"6",
			"7",
			"9",
			"93"
		],
		ddi: "501"
	},
	{
		countryNamePTBR: "Benin",
		countryName: "Benin",
		abbreviationAlpha3: "BEN",
		abbreviationFips10: "BN",
		domain: ".bj",
		areaCodeList: [
			"20",
			"21",
			"22",
			"23"
		],
		ddi: "229"
	},
	{
		countryNamePTBR: "Butão",
		countryName: "Bhutan",
		abbreviationAlpha3: "BTN",
		abbreviationFips10: "BT",
		domain: ".bt",
		areaCodeList: [
			"2",
			"3",
			"4",
			"5",
			"6",
			"7",
			"8",
			"17"
		],
		ddi: "975"
	},
	{
		countryNamePTBR: "Bolívia",
		countryName: "Bolivia",
		abbreviationAlpha3: "BOL",
		abbreviationFips10: "BL",
		domain: ".bo",
		areaCodeList: [
			"2",
			"3",
			"4",
			"706",
			"710",
			"720",
			"770"
		],
		ddi: "591"
	},
	{
		countryNamePTBR: "Bósnia e Herzegovina",
		countryName: "Bosnia and Herzegovina",
		abbreviationAlpha3: "BIH",
		abbreviationFips10: "BK",
		domain: ".ba",
		areaCodeList: [
			"30",
			"31",
			"32",
			"33",
			"34",
			"35",
			"36",
			"37",
			"38",
			"39",
			"49",
			"50",
			"51",
			"52",
			"53",
			"54",
			"55",
			"56",
			"57",
			"58",
			"59",
			"61",
			"63",
			"65"
		],
		ddi: "387"
	},
	{
		countryNamePTBR: "Botsuana",
		countryName: "Botswana",
		abbreviationAlpha3: "BWA",
		abbreviationFips10: "BC",
		domain: ".bw",
		areaCodeList: [
			"24",
			"26",
			"29",
			"31",
			"46",
			"47",
			"49",
			"53",
			"54",
			"57",
			"58",
			"59",
			"62",
			"65",
			"68",
			"71",
			"72",
			"340"
		],
		ddi: "267"
	},
	{
		countryNamePTBR: "Brasil",
		countryName: "Brazil",
		abbreviationAlpha3: "BRA",
		abbreviationFips10: "BR",
		domain: ".br",
		areaCodeList: [
			"11",
			"12",
			"13",
			"14",
			"15",
			"16",
			"17",
			"18",
			"19",
			"21",
			"22",
			"24",
			"27",
			"28",
			"31",
			"32",
			"33",
			"34",
			"35",
			"37",
			"38",
			"41",
			"42",
			"43",
			"44",
			"45",
			"46",
			"47",
			"48",
			"49",
			"51",
			"53",
			"54",
			"55",
			"61",
			"62",
			"63",
			"64",
			"65",
			"66",
			"67",
			"68",
			"69",
			"71",
			"73",
			"74",
			"75",
			"77",
			"79",
			"81",
			"82",
			"83",
			"84",
			"85",
			"86",
			"87",
			"88",
			"89",
			"91",
			"92",
			"93",
			"94",
			"95",
			"96",
			"97",
			"98",
			"99"
		],
		ddi: "55"
	},
	{
		countryNamePTBR: "Ilhas Virgens (Reino Unido)",
		countryName: "British Virgin Islands",
		abbreviationAlpha3: "VGB",
		abbreviationFips10: "VI",
		domain: ".vg",
		areaCodeList: [
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "Brunei",
		countryName: "Brunei",
		abbreviationAlpha3: "BRN",
		abbreviationFips10: "BX",
		domain: ".bn",
		areaCodeList: [
			"2",
			"3",
			"4",
			"5",
			"86"
		],
		ddi: "673"
	},
	{
		countryNamePTBR: "Bulgária",
		countryName: "Bulgaria",
		abbreviationAlpha3: "BGR",
		abbreviationFips10: "BU",
		domain: ".bg",
		areaCodeList: [
			"2",
			"32",
			"34",
			"38",
			"42",
			"44",
			"46",
			"52",
			"54",
			"56",
			"58",
			"62",
			"64",
			"66",
			"68",
			"73",
			"76",
			"78",
			"82",
			"84",
			"86",
			"87",
			"88",
			"89",
			"92",
			"94",
			"96",
			"301",
			"361",
			"431",
			"601",
			"751"
		],
		ddi: "359"
	},
	{
		countryNamePTBR: "Burundi",
		countryName: "Burundi",
		abbreviationAlpha3: "BDI",
		abbreviationFips10: "BY",
		domain: ".bi",
		areaCodeList: [
		],
		ddi: "257"
	},
	{
		countryNamePTBR: "Camboja",
		countryName: "Cambodia",
		abbreviationAlpha3: "KHM",
		abbreviationFips10: "CB",
		domain: ".kh",
		areaCodeList: [
			"11",
			"12",
			"15",
			"18",
			"23",
			"24",
			"25",
			"26",
			"32",
			"33",
			"34",
			"35",
			"36",
			"42",
			"43",
			"44",
			"52",
			"53",
			"54",
			"55",
			"62",
			"63",
			"64",
			"65",
			"72",
			"73",
			"74",
			"75"
		],
		ddi: "855"
	},
	{
		countryNamePTBR: "Canadá",
		countryName: "Canada",
		abbreviationAlpha3: "CAN",
		abbreviationFips10: "CA",
		domain: ".ca",
		areaCodeList: [
			"204",
			"226",
			"236",
			"249",
			"250",
			"289",
			"306",
			"343",
			"403",
			"416",
			"418",
			"438",
			"450",
			"506",
			"514",
			"519",
			"579",
			"581",
			"587",
			"600",
			"604",
			"613",
			"647",
			"705",
			"709",
			"778",
			"780",
			"807",
			"819",
			"867",
			"902",
			"905"
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "Ilhas Cayman",
		countryName: "Cayman Islands",
		abbreviationAlpha3: "CYM",
		abbreviationFips10: "CJ",
		domain: ".ky",
		areaCodeList: [
			"345"
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "República Centro-Africana",
		countryName: "Central African Republic",
		abbreviationAlpha3: "CAF",
		abbreviationFips10: "CT",
		domain: ".cf",
		areaCodeList: [
		],
		ddi: "236"
	},
	{
		countryNamePTBR: "Chade",
		countryName: "Chad",
		abbreviationAlpha3: "TCD",
		abbreviationFips10: "CD",
		domain: ".td",
		areaCodeList: [
			"51",
			"69"
		],
		ddi: "237"
	},
	{
		countryNamePTBR: "Chile",
		countryName: "Chile",
		abbreviationAlpha3: "CHL",
		abbreviationFips10: "CI",
		domain: ".cl",
		areaCodeList: [
			"2",
			"32",
			"33",
			"34",
			"35",
			"41",
			"42",
			"43",
			"45",
			"51",
			"52",
			"53",
			"55",
			"57",
			"58",
			"61",
			"63",
			"64",
			"65",
			"67",
			"71",
			"72",
			"73",
			"75"
		],
		ddi: "56"
	},
	{
		countryNamePTBR: "China",
		countryName: "China",
		abbreviationAlpha3: "CHN",
		abbreviationFips10: "CH",
		domain: ".cn",
		areaCodeList: [
			"10",
			"20",
			"21",
			"22",
			"23",
			"24",
			"25",
			"27",
			"28",
			"29",
			"310",
			"311",
			"312",
			"313",
			"314",
			"315",
			"319",
			"335",
			"351",
			"352",
			"353",
			"355",
			"357",
			"370",
			"371",
			"372",
			"373",
			"374",
			"375",
			"377",
			"378",
			"379",
			"391",
			"410",
			"411",
			"413",
			"414",
			"415",
			"416",
			"417",
			"418",
			"419",
			"421",
			"429",
			"431",
			"432",
			"433",
			"434",
			"435",
			"436",
			"437",
			"438",
			"439",
			"451",
			"452",
			"454",
			"457",
			"459",
			"467",
			"470",
			"471",
			"472",
			"473",
			"474",
			"475",
			"476",
			"477",
			"510",
			"511",
			"512",
			"513",
			"514",
			"515",
			"516",
			"517",
			"518",
			"519",
			"530",
			"531",
			"532",
			"533",
			"534",
			"535",
			"536",
			"537",
			"538",
			"539",
			"551",
			"552",
			"553",
			"555",
			"556",
			"559",
			"570",
			"571",
			"572",
			"573",
			"574",
			"575",
			"576",
			"577",
			"579",
			"591",
			"592",
			"593",
			"594",
			"595",
			"596",
			"597",
			"598",
			"599",
			"710",
			"711",
			"714",
			"716",
			"719",
			"724",
			"730",
			"731",
			"732",
			"733",
			"734",
			"736",
			"737",
			"739",
			"750",
			"751",
			"752",
			"753",
			"754",
			"755",
			"756",
			"757",
			"758",
			"759",
			"760",
			"771",
			"772",
			"773",
			"774",
			"775",
			"776",
			"778",
			"779",
			"790",
			"791",
			"792",
			"793",
			"794",
			"795",
			"796",
			"797",
			"798",
			"799",
			"810",
			"812",
			"813",
			"814",
			"816",
			"817",
			"819",
			"831",
			"833",
			"834",
			"835",
			"836",
			"851",
			"852",
			"853",
			"855",
			"856",
			"859",
			"871",
			"872",
			"873",
			"876",
			"877",
			"878",
			"890",
			"891",
			"892",
			"894",
			"895",
			"898",
			"910",
			"911",
			"912",
			"913",
			"914",
			"915",
			"916",
			"917",
			"919",
			"931",
			"932",
			"933",
			"934",
			"935",
			"937",
			"938",
			"939",
			"951",
			"954",
			"971",
			"976",
			"979",
			"990",
			"991",
			"992",
			"993",
			"994",
			"995",
			"996",
			"997",
			"998",
			"999",
			"3011",
			"3013",
			"3276",
			"3420",
			"3602",
			"3627",
			"3651",
			"3832",
			"3836",
			"3881",
			"3891",
			"4415",
			"4434",
			"4435",
			"4436",
			"4437",
			"4458",
			"4615",
			"4617",
			"4618",
			"4638",
			"4652",
			"4665",
			"4803",
			"4812",
			"4813",
			"4814",
			"4817",
			"4823",
			"4841",
			"4843",
			"4848",
			"4858",
			"4862",
			"4868",
			"4873",
			"4881",
			"4890",
			"5211",
			"5217",
			"5218",
			"5231",
			"5232",
			"5241",
			"5244",
			"5247",
			"5401",
			"5422",
			"5427",
			"5430",
			"5448",
			"5457",
			"5467",
			"5473",
			"5482",
			"5483",
			"5492",
			"5604",
			"5612",
			"5639",
			"5885",
			"7032",
			"7038",
			"7048",
			"7051",
			"7052",
			"7056",
			"7060",
			"7073",
			"7077",
			"7212",
			"7232",
			"7238",
			"7239",
			"7278",
			"7402",
			"7420",
			"7442",
			"7446",
			"7462",
			"7480",
			"7620",
			"7647",
			"7681",
			"7683",
			"7808",
			"7815",
			"7847",
			"7848",
			"7852",
			"8003",
			"8054",
			"8221",
			"8236",
			"8244",
			"8269",
			"8279",
			"8286",
			"8425",
			"8437",
			"8638",
			"8676",
			"8869",
			"8885",
			"8891",
			"9003",
			"9022",
			"9032",
			"9041",
			"9081",
			"9091",
			"9093",
			"9096",
			"9097",
			"9229",
			"9231",
			"9233",
			"9263",
			"9421",
			"9440",
			"9447",
			"9453",
			"9467",
			"9471",
			"9472",
			"9473",
			"9477"
		],
		ddi: "86"
	},
	{
		countryNamePTBR: "Ilhas Cocos",
		countryName: "Cocos Keeling Islands",
		abbreviationAlpha3: "CCK",
		abbreviationFips10: "CK",
		domain: ".cc",
		areaCodeList: [
		],
		ddi: "672"
	},
	{
		countryNamePTBR: "Colômbia",
		countryName: "Colombia",
		abbreviationAlpha3: "COL",
		abbreviationFips10: "CO",
		domain: ".co",
		areaCodeList: [
			"1",
			"2",
			"4",
			"5",
			"6",
			"7",
			"8",
			"300",
			"310",
			"315"
		],
		ddi: "57"
	},
	{
		countryNamePTBR: "Comores",
		countryName: "Comoros",
		abbreviationAlpha3: "COM",
		abbreviationFips10: "CN",
		domain: ".km",
		areaCodeList: [
		],
		ddi: "269"
	},
	{
		countryNamePTBR: "Ilhas Cook",
		countryName: "Cook Islands",
		abbreviationAlpha3: "COK",
		abbreviationFips10: "CW",
		domain: ".ck",
		areaCodeList: [
			"2",
			"31",
			"33",
			"34",
			"35",
			"36",
			"37",
			"41",
			"42",
			"43",
			"44",
			"45"
		],
		ddi: "682"
	},
	{
		countryNamePTBR: "Costa Rica",
		countryName: "Costa Rica",
		abbreviationAlpha3: "CRI",
		abbreviationFips10: "CS",
		domain: ".cr",
		areaCodeList: [
		],
		ddi: "506"
	},
	{
		countryNamePTBR: "Croácia",
		countryName: "Croatia",
		abbreviationAlpha3: "HRV",
		abbreviationFips10: "HR",
		domain: ".hr",
		areaCodeList: [
			"1",
			"20",
			"21",
			"22",
			"23",
			"31",
			"32",
			"33",
			"34",
			"35",
			"40",
			"42",
			"43",
			"44",
			"47",
			"48",
			"49",
			"51",
			"52",
			"53",
			"91",
			"95",
			"98"
		],
		ddi: "385"
	},
	{
		countryNamePTBR: "Cuba",
		countryName: "Cuba",
		abbreviationAlpha3: "CUB",
		abbreviationFips10: "CU",
		domain: ".cu",
		areaCodeList: [
			"5",
			"7",
			"8",
			"21",
			"22",
			"23",
			"24",
			"31",
			"32",
			"33",
			"41",
			"42",
			"43",
			"45",
			"52",
			"59",
			"61",
			"62",
			"63",
			"64",
			"66",
			"67",
			"82",
			"84",
			"85",
			"86",
			"225",
			"226",
			"315",
			"335",
			"338",
			"432",
			"650",
			"680",
			"686",
			"692",
			"789",
			"6929"
		],
		ddi: "53"
	},
	{
		countryNamePTBR: "Chipre",
		countryName: "Cyprus",
		abbreviationAlpha3: "CYP",
		abbreviationFips10: "CY",
		domain: ".cy",
		areaCodeList: [
			"22",
			"23",
			"24",
			"25",
			"26",
			"99",
			"992",
			"998"
		],
		ddi: "357"
	},
	{
		countryNamePTBR: "Tcheca",
		countryName: "Czech",
		abbreviationAlpha3: "CZE",
		abbreviationFips10: "EZ",
		domain: ".cz",
		areaCodeList: [
		],
		ddi: "420"
	},
	{
		countryNamePTBR: "República Democrática do Congo",
		countryName: "Democratic Republic of the Congo",
		abbreviationAlpha3: "COD",
		abbreviationFips10: "CG",
		domain: ".cd",
		areaCodeList: [
			"1",
			"2",
			"3",
			"4",
			"5",
			"6"
		],
		ddi: "243"
	},
	{
		countryNamePTBR: "Dinamarca",
		countryName: "Denmark",
		abbreviationAlpha3: "DNK",
		abbreviationFips10: "DA",
		domain: ".dk",
		areaCodeList: [
			"89",
			"808"
		],
		ddi: "45"
	},
	{
		countryNamePTBR: "Dominica",
		countryName: "Dominica",
		abbreviationAlpha3: "DMA",
		abbreviationFips10: "DO",
		domain: ".dm",
		areaCodeList: [
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "República Dominicana",
		countryName: "Dominican Republic",
		abbreviationAlpha3: "DOM",
		abbreviationFips10: "DR",
		domain: ".do",
		areaCodeList: [
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "Equador",
		countryName: "Ecuador",
		abbreviationAlpha3: "ECU",
		abbreviationFips10: "EC",
		domain: ".ec",
		areaCodeList: [
			"2",
			"3",
			"4",
			"5",
			"6",
			"7"
		],
		ddi: "593"
	},
	{
		countryNamePTBR: "Egito",
		countryName: "Egypt",
		abbreviationAlpha3: "EGY",
		abbreviationFips10: "EG",
		domain: ".eg",
		areaCodeList: [
			"2",
			"3",
			"13",
			"40",
			"45",
			"48",
			"50",
			"65",
			"66",
			"88",
			"93",
			"95",
			"97"
		],
		ddi: "20"
	},
	{
		countryNamePTBR: "El Salvador",
		countryName: "El Salvador",
		abbreviationAlpha3: "SLV",
		abbreviationFips10: "ES",
		domain: ".sv",
		areaCodeList: [
			"2",
			"3",
			"4",
			"6"
		],
		ddi: "503"
	},
	{
		countryNamePTBR: "Guiné Equatorial",
		countryName: "Equatorial Guinea",
		abbreviationAlpha3: "GNQ",
		abbreviationFips10: "EK",
		domain: ".gq",
		areaCodeList: [
			"7",
			"8",
			"9"
		],
		ddi: "240"
	},
	{
		countryNamePTBR: "Eritreia",
		countryName: "Eritrea",
		abbreviationAlpha3: "ERI",
		abbreviationFips10: "ER",
		domain: ".er",
		areaCodeList: [
		],
		ddi: "291"
	},
	{
		countryNamePTBR: "Estônia",
		countryName: "Estonia",
		abbreviationAlpha3: "EST",
		abbreviationFips10: "EN",
		domain: ".ee",
		areaCodeList: [
			"32",
			"33",
			"38",
			"39",
			"43",
			"44",
			"45",
			"46",
			"47",
			"48",
			"60",
			"73",
			"76",
			"77",
			"78",
			"79"
		],
		ddi: "372"
	},
	{
		countryNamePTBR: "Etiópia",
		countryName: "Ethiopia",
		abbreviationAlpha3: "ETH",
		abbreviationFips10: "ET",
		domain: ".et",
		areaCodeList: [
			"1",
			"2",
			"3",
			"4",
			"5",
			"6",
			"7",
			"8",
			"9"
		],
		ddi: "251"
	},
	{
		countryNamePTBR: "Ilhas Malvinas",
		countryName: "Falkland Islands Malvinas",
		abbreviationAlpha3: "FLK",
		abbreviationFips10: "FK",
		domain: ".fk",
		areaCodeList: [
		],
		ddi: "500"
	},
	{
		countryNamePTBR: "Estados Federados da Micronésia",
		countryName: "Federated States of Micronesia",
		abbreviationAlpha3: "FSM",
		abbreviationFips10: "FM",
		domain: ".fm",
		areaCodeList: [
		],
		ddi: "691"
	},
	{
		countryNamePTBR: "Fiji",
		countryName: "Fiji",
		abbreviationAlpha3: "FJI",
		abbreviationFips10: "FJ",
		domain: ".fj",
		areaCodeList: [
			"32",
			"65",
			"88"
		],
		ddi: "679"
	},
	{
		countryNamePTBR: "Finlândia",
		countryName: "Finland",
		abbreviationAlpha3: "FIN",
		abbreviationFips10: "FI",
		domain: ".fi",
		areaCodeList: [
			"2",
			"3",
			"5",
			"6",
			"8",
			"9",
			"13",
			"14",
			"15",
			"16",
			"17",
			"18",
			"19"
		],
		ddi: "358"
	},
	{
		countryNamePTBR: "França",
		countryName: "France",
		abbreviationAlpha3: "FRA",
		abbreviationFips10: "FR",
		domain: ".fr",
		areaCodeList: [
			"1",
			"2",
			"3",
			"4",
			"5"
		],
		ddi: "33"
	},
	{
		countryNamePTBR: "Guiana Francesa",
		countryName: "French Guiana",
		abbreviationAlpha3: "GUF",
		abbreviationFips10: "FG",
		domain: ".gf",
		areaCodeList: [
		],
		ddi: "594"
	},
	{
		countryNamePTBR: "Polinésia Francesa",
		countryName: "French Polynesia",
		abbreviationAlpha3: "PYF",
		abbreviationFips10: "FP",
		domain: ".pf",
		areaCodeList: [
		],
		ddi: "689"
	},
	{
		countryNamePTBR: "Gabão",
		countryName: "Gabon",
		abbreviationAlpha3: "GAB",
		abbreviationFips10: "GB",
		domain: ".ga",
		areaCodeList: [
		],
		ddi: "241"
	},
	{
		countryNamePTBR: "Gâmbia",
		countryName: "Gambia",
		abbreviationAlpha3: "GMB",
		abbreviationFips10: "GA",
		domain: ".gm",
		areaCodeList: [
			"2",
			"42",
			"43",
			"441",
			"446",
			"447",
			"449"
		],
		ddi: "220"
	},
	{
		countryNamePTBR: "Geórgia",
		countryName: "Georgia",
		abbreviationAlpha3: "GEO",
		abbreviationFips10: "GG",
		domain: ".ge",
		areaCodeList: [
			"32",
			"77",
			"93",
			"122",
			"222",
			"311",
			"313",
			"315",
			"331",
			"335",
			"340",
			"341",
			"342",
			"344",
			"345",
			"348",
			"349",
			"350",
			"351",
			"352",
			"353",
			"355",
			"356",
			"357",
			"358",
			"359",
			"360",
			"361",
			"362",
			"363",
			"364",
			"365",
			"366",
			"367",
			"368",
			"369",
			"370",
			"371",
			"379",
			"392",
			"393",
			"396"
		],
		ddi: "995"
	},
	{
		countryNamePTBR: "Alemanha",
		countryName: "Germany",
		abbreviationAlpha3: "DEU",
		abbreviationFips10: "GM",
		domain: ".de",
		areaCodeList: [
			"30",
			"40",
			"69",
			"89",
			"172",
			"201",
			"211",
			"221",
			"228",
			"261",
			"331",
			"335",
			"341",
			"345",
			"351",
			"355",
			"361",
			"365",
			"371",
			"381",
			"385",
			"391",
			"395",
			"421",
			"431",
			"511",
			"611",
			"621",
			"711",
			"911",
			"6151",
			"6172",
			"6221",
			"9353",
			"38223"
		],
		ddi: "49"
	},
	{
		countryNamePTBR: "Gana",
		countryName: "Ghana",
		abbreviationAlpha3: "GHA",
		abbreviationFips10: "GH",
		domain: ".gh",
		areaCodeList: [
			"21",
			"22",
			"31",
			"42",
			"51",
			"71",
			"72",
			"81"
		],
		ddi: "233"
	},
	{
		countryNamePTBR: "Gibraltar",
		countryName: "Gibraltar",
		abbreviationAlpha3: "GIB",
		abbreviationFips10: "GI",
		domain: ".gi",
		areaCodeList: [
			"4"
		],
		ddi: "350"
	},
	{
		countryNamePTBR: "Grécia",
		countryName: "Greece",
		abbreviationAlpha3: "GRC",
		abbreviationFips10: "GR",
		domain: ".gr",
		areaCodeList: [
			"21",
			"69",
			"231",
			"241",
			"251",
			"261",
			"271",
			"281",
			"2221",
			"2222",
			"2223",
			"2224",
			"2226",
			"2227",
			"2228",
			"2229",
			"2231",
			"2232",
			"2233",
			"2234",
			"2235",
			"2236",
			"2237",
			"2238",
			"2241",
			"2242",
			"2243",
			"2244",
			"2245",
			"2246",
			"2247",
			"2251",
			"2252",
			"2253",
			"2254",
			"2261",
			"2262",
			"2263",
			"2264",
			"2265",
			"2266",
			"2267",
			"2268",
			"2271",
			"2272",
			"2273",
			"2274",
			"2275",
			"2281",
			"2282",
			"2283",
			"2284",
			"2285",
			"2286",
			"2287",
			"2288",
			"2289",
			"2291",
			"2292",
			"2293",
			"2294",
			"2295",
			"2296",
			"2297",
			"2298",
			"2299",
			"2321",
			"2322",
			"2323",
			"2324",
			"2325",
			"2327",
			"2331",
			"2332",
			"2333",
			"2341",
			"2343",
			"2351",
			"2352",
			"2353",
			"2371",
			"2372",
			"2373",
			"2374",
			"2375",
			"2376",
			"2377",
			"2381",
			"2382",
			"2384",
			"2385",
			"2386",
			"2391",
			"2392",
			"2393",
			"2394",
			"2395",
			"2396",
			"2397",
			"2399",
			"2421",
			"2422",
			"2423",
			"2424",
			"2425",
			"2426",
			"2427",
			"2431",
			"2432",
			"2433",
			"2434",
			"2441",
			"2443",
			"2444",
			"2445",
			"2461",
			"2462",
			"2463",
			"2464",
			"2465",
			"2467",
			"2468",
			"2491",
			"2492",
			"2493",
			"2494",
			"2495",
			"2521",
			"2522",
			"2523",
			"2524",
			"2531",
			"2532",
			"2533",
			"2534",
			"2535",
			"2541",
			"2542",
			"2544",
			"2551",
			"2552",
			"2553",
			"2554",
			"2555",
			"2556",
			"2591",
			"2592",
			"2593",
			"2594",
			"2621",
			"2622",
			"2623",
			"2624",
			"2625",
			"2626",
			"2631",
			"2632",
			"2634",
			"2635",
			"2641",
			"2642",
			"2643",
			"2644",
			"2645",
			"2646",
			"2647",
			"2653",
			"2654",
			"2655",
			"2656",
			"2657",
			"2658",
			"2659",
			"2661",
			"2662",
			"2663",
			"2664",
			"2665",
			"2666",
			"2671",
			"2674",
			"2681",
			"2682",
			"2683",
			"2684",
			"2685",
			"2691",
			"2692",
			"2694",
			"2695",
			"2696",
			"2721",
			"2722",
			"2723",
			"2724",
			"2725",
			"2731",
			"2732",
			"2733",
			"2735",
			"2736",
			"2741",
			"2742",
			"2743",
			"2744",
			"2746",
			"2747",
			"2751",
			"2752",
			"2753",
			"2754",
			"2755",
			"2757",
			"2761",
			"2763",
			"2765",
			"2791",
			"2792",
			"2795",
			"2796",
			"2797",
			"2821",
			"2822",
			"2823",
			"2824",
			"2825",
			"2831",
			"2832",
			"2833",
			"2834",
			"2841",
			"2842",
			"2843",
			"2844",
			"2891",
			"2892",
			"2893",
			"2894",
			"2895",
			"2897"
		],
		ddi: "30"
	},
	{
		countryNamePTBR: "Gronelândia",
		countryName: "Greenland",
		abbreviationAlpha3: "GRL",
		abbreviationFips10: "GL",
		domain: ".gl",
		areaCodeList: [
			"3",
			"61",
			"64",
			"66",
			"68",
			"81",
			"84",
			"86",
			"87",
			"89",
			"91",
			"92",
			"94",
			"95",
			"96",
			"97",
			"98",
			"99",
			"691"
		],
		ddi: "299"
	},
	{
		countryNamePTBR: "Grenada",
		countryName: "Grenada",
		abbreviationAlpha3: "GRD",
		abbreviationFips10: "GJ",
		domain: ".gd",
		areaCodeList: [
			"414"
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "Guadalupe",
		countryName: "Guadeloupe",
		abbreviationAlpha3: "GLP",
		abbreviationFips10: "GP",
		domain: ".gp",
		areaCodeList: [
		],
		ddi: "590"
	},
	{
		countryNamePTBR: "Guam",
		countryName: "Guam",
		abbreviationAlpha3: "GUM",
		abbreviationFips10: "GQ",
		domain: ".gu",
		areaCodeList: [
		],
		ddi: "671"
	},
	{
		countryNamePTBR: "Guatemala",
		countryName: "Guatemala",
		abbreviationAlpha3: "GTM",
		abbreviationFips10: "GT",
		domain: ".gt",
		areaCodeList: [
			"8",
			"26",
			"81",
			"84",
			"86",
			"97"
		],
		ddi: "502"
	},
	{
		countryNamePTBR: "Guiné",
		countryName: "Guinea",
		abbreviationAlpha3: "GIN",
		abbreviationFips10: "GV",
		domain: ".gn",
		areaCodeList: [
			"24",
			"31",
			"32",
			"41",
			"42",
			"46",
			"51",
			"53",
			"61",
			"68",
			"69",
			"71",
			"81",
			"91",
			"94",
			"97",
			"98",
			"613"
		],
		ddi: "224"
	},
	{
		countryNamePTBR: "Guiné-Bissau",
		countryName: "Guinea-Bissau",
		abbreviationAlpha3: "GNB",
		abbreviationFips10: "PU",
		domain: ".gw",
		areaCodeList: [
			"22",
			"25",
			"31",
			"32",
			"33",
			"35",
			"41",
			"51",
			"52",
			"53",
			"61",
			"62",
			"81",
			"82",
			"83",
			"84",
			"91",
			"92",
			"93"
		],
		ddi: "245"
	},
	{
		countryNamePTBR: "Guiana",
		countryName: "Guyana",
		abbreviationAlpha3: "GUY",
		abbreviationFips10: "GY",
		domain: ".gy",
		areaCodeList: [
			"221",
			"228",
			"229",
			"261",
			"264",
			"266",
			"278",
			"330",
			"333",
			"337",
			"441",
			"444",
			"455",
			"777"
		],
		ddi: "592"
	},
	{
		countryNamePTBR: "Haiti",
		countryName: "Haiti",
		abbreviationAlpha3: "HTI",
		abbreviationFips10: "HA",
		domain: ".ht",
		areaCodeList: [
			"330",
			"420",
			"510",
			"851"
		],
		ddi: "509"
	},
	{
		countryNamePTBR: "Honduras",
		countryName: "Honduras",
		abbreviationAlpha3: "HND",
		abbreviationFips10: "HO",
		domain: ".hn",
		areaCodeList: [
			"2",
			"4",
			"5",
			"6",
			"7",
			"8"
		],
		ddi: "504"
	},
	{
		countryNamePTBR: "Hong Kong",
		countryName: "Hong Kong",
		abbreviationAlpha3: "HKG",
		abbreviationFips10: "HK",
		domain: ".hk",
		areaCodeList: [
			"2"
		],
		ddi: "852"
	},
	{
		countryNamePTBR: "Hungria",
		countryName: "Hungary",
		abbreviationAlpha3: "HUN",
		abbreviationFips10: "HU",
		domain: ".hu",
		areaCodeList: [
			"1",
			"22",
			"23",
			"24",
			"25",
			"26",
			"27",
			"28",
			"29",
			"32",
			"33",
			"34",
			"35",
			"36",
			"37",
			"42",
			"44",
			"45",
			"46",
			"47",
			"48",
			"49",
			"52",
			"53",
			"54",
			"56",
			"57",
			"59",
			"62",
			"63",
			"66",
			"68",
			"69",
			"72",
			"73",
			"74",
			"75",
			"76",
			"77",
			"78",
			"79",
			"80",
			"82",
			"83",
			"84",
			"85",
			"87",
			"88",
			"89",
			"92",
			"93",
			"94",
			"95",
			"96",
			"99"
		],
		ddi: "36"
	},
	{
		countryNamePTBR: "Islândia",
		countryName: "Iceland",
		abbreviationAlpha3: "ISL",
		abbreviationFips10: "IC",
		domain: ".is",
		areaCodeList: [
			"4",
			"5"
		],
		ddi: "354"
	},
	{
		countryNamePTBR: "Índia",
		countryName: "India",
		abbreviationAlpha3: "IND",
		abbreviationFips10: "IN",
		domain: ".in",
		areaCodeList: [
			"11",
			"20",
			"22",
			"33",
			"40",
			"44",
			"79",
			"80",
			"135",
			"141",
			"144",
			"145",
			"151",
			"172",
			"177",
			"181",
			"183",
			"194",
			"261",
			"265",
			"281",
			"294",
			"422",
			"512",
			"522",
			"562",
			"612",
			"744",
			"747",
			"755",
			"821",
			"1362",
			"1462",
			"1482",
			"1582",
			"2432",
			"2974",
			"2982",
			"5619",
			"5642",
			"5644",
			"6432",
			"7462",
			"8252",
			"8572"
		],
		ddi: "91"
	},
	{
		countryNamePTBR: "Indonésia",
		countryName: "Indonesia",
		abbreviationAlpha3: "IDN",
		abbreviationFips10: "ID",
		domain: ".id",
		areaCodeList: [
			"4",
			"5",
			"6",
			"9",
			"21",
			"22",
			"23",
			"24",
			"25",
			"26",
			"27",
			"28",
			"29",
			"31",
			"32",
			"33",
			"34",
			"35",
			"36",
			"37",
			"38",
			"39",
			"61",
			"71",
			"72",
			"75",
			"76",
			"77",
			"770",
			"778"
		],
		ddi: "62"
	},
	{
		countryNamePTBR: "Irã",
		countryName: "Iran",
		abbreviationAlpha3: "IRN",
		abbreviationFips10: "IR",
		domain: ".ir",
		areaCodeList: [
			"21",
			"111",
			"132",
			"173",
			"231",
			"242",
			"251",
			"256",
			"281",
			"311",
			"342",
			"352",
			"382",
			"411",
			"443",
			"452",
			"511",
			"612",
			"663",
			"712",
			"743",
			"763",
			"772",
			"812",
			"831",
			"842",
			"875",
			"772773"
		],
		ddi: "98"
	},
	{
		countryNamePTBR: "Iraque",
		countryName: "Iraq",
		abbreviationAlpha3: "IRQ",
		abbreviationFips10: "IZ",
		domain: ".iq",
		areaCodeList: [
			"1",
			"32",
			"33",
			"40",
			"50",
			"60"
		],
		ddi: "964"
	},
	{
		countryNamePTBR: "Irlanda",
		countryName: "Ireland",
		abbreviationAlpha3: "IRL",
		abbreviationFips10: "EI",
		domain: ".ie",
		areaCodeList: [
			"1",
			"21",
			"41",
			"42",
			"45",
			"51",
			"52",
			"53",
			"61",
			"64",
			"65",
			"66",
			"71",
			"91",
			"402",
			"506"
		],
		ddi: "353"
	},
	{
		countryNamePTBR: "Ilha de Man",
		countryName: "Isle of Man",
		abbreviationAlpha3: "IMN",
		abbreviationFips10: "",
		domain: ".im",
		areaCodeList: [
			"1624"
		],
		ddi: "44"
	},
	{
		countryNamePTBR: "Israel",
		countryName: "Israel",
		abbreviationAlpha3: "ISR",
		abbreviationFips10: "IS",
		domain: ".il",
		areaCodeList: [
			"2",
			"3",
			"4",
			"8",
			"9"
		],
		ddi: "972"
	},
	{
		countryNamePTBR: "Itália",
		countryName: "Italy",
		abbreviationAlpha3: "ITA",
		abbreviationFips10: "IT",
		domain: ".it",
		areaCodeList: [
			"2",
			"6",
			"10",
			"11",
			"15",
			"19",
			"30",
			"31",
			"35",
			"39",
			"40",
			"41",
			"45",
			"49",
			"50",
			"51",
			"55",
			"59",
			"70",
			"71",
			"75",
			"79",
			"80",
			"81",
			"85",
			"89",
			"90",
			"91",
			"95",
			"99",
			"121",
			"122",
			"123",
			"124",
			"125",
			"131",
			"141",
			"142",
			"143",
			"144",
			"161",
			"163",
			"165",
			"166",
			"171",
			"172",
			"173",
			"174",
			"175",
			"182",
			"183",
			"184",
			"185",
			"187",
			"321",
			"322",
			"323",
			"324",
			"331",
			"332",
			"341",
			"342",
			"343",
			"344",
			"345",
			"346",
			"362",
			"363",
			"364",
			"365",
			"371",
			"372",
			"373",
			"374",
			"375",
			"376",
			"377",
			"381",
			"382",
			"383",
			"384",
			"385",
			"386",
			"421",
			"422",
			"423",
			"424",
			"425",
			"426",
			"427",
			"428",
			"429",
			"431",
			"432",
			"433",
			"434",
			"435",
			"436",
			"437",
			"438",
			"439",
			"442",
			"444",
			"445",
			"461",
			"462",
			"463",
			"464",
			"465",
			"471",
			"472",
			"473",
			"474",
			"481",
			"521",
			"522",
			"523",
			"524",
			"525",
			"532",
			"533",
			"534",
			"535",
			"536",
			"541",
			"542",
			"543",
			"544",
			"545",
			"546",
			"547",
			"549",
			"564",
			"565",
			"566",
			"571",
			"572",
			"573",
			"574",
			"575",
			"577",
			"578",
			"583",
			"584",
			"585",
			"586",
			"587",
			"588",
			"721",
			"722",
			"731",
			"732",
			"733",
			"734",
			"735",
			"736",
			"737",
			"742",
			"743",
			"744",
			"746",
			"761",
			"763",
			"765",
			"766",
			"771",
			"773",
			"774",
			"775",
			"776",
			"781",
			"782",
			"783",
			"784",
			"785",
			"789",
			"823",
			"824",
			"825",
			"827",
			"828",
			"831",
			"832",
			"833",
			"835",
			"836",
			"861",
			"862",
			"863",
			"864",
			"865",
			"871",
			"872",
			"873",
			"874",
			"875",
			"881",
			"882",
			"883",
			"884",
			"885",
			"921",
			"922",
			"923",
			"924",
			"925",
			"931",
			"932",
			"933",
			"934",
			"935",
			"941",
			"942",
			"961",
			"962",
			"963",
			"964",
			"965",
			"966",
			"967",
			"968",
			"971",
			"972",
			"973",
			"974",
			"975",
			"976",
			"981",
			"982",
			"983",
			"984",
			"985"
		],
		ddi: "39"
	},
	{
		countryNamePTBR: "Costa do Marfim",
		countryName: "Ivory Coast",
		abbreviationAlpha3: "CIV",
		abbreviationFips10: "IV",
		domain: ".ci",
		areaCodeList: [
			"20",
			"21",
			"22",
			"23",
			"24",
			"30",
			"31",
			"32",
			"33",
			"34",
			"35",
			"36"
		],
		ddi: "225"
	},
	{
		countryNamePTBR: "Jamaica",
		countryName: "Jamaica",
		abbreviationAlpha3: "JAM",
		abbreviationFips10: "JM",
		domain: ".jm",
		areaCodeList: [
			"658",
			"876"
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "Japão",
		countryName: "Japan",
		abbreviationAlpha3: "JPN",
		abbreviationFips10: "JA",
		domain: ".jp",
		areaCodeList: [
			"3",
			"11",
			"45",
			"52",
			"66",
			"070",
			"090",
			"98",
			"425",
			"468",
			"561",
			"956"
		],
		ddi: "81"
	},
	{
		countryNamePTBR: "Jersey",
		countryName: "Jersey",
		abbreviationAlpha3: "JEY",
		abbreviationFips10: "JE",
		domain: ".je",
		areaCodeList: [
			"1534",
			"7700",
			"7797",
			"7829"
		],
		ddi: "44"
	},
	{
		countryNamePTBR: "Jordânia",
		countryName: "Jordan",
		abbreviationAlpha3: "JOR",
		abbreviationFips10: "JO",
		domain: ".jo",
		areaCodeList: [
			"2",
			"3",
			"5",
			"6",
			"77",
			"79"
		],
		ddi: "2"
	},
	{
		countryNamePTBR: "Cazaquistão",
		countryName: "Kazakhstan",
		abbreviationAlpha3: "KAZ",
		abbreviationFips10: "KZ",
		domain: ".kz",
		areaCodeList: [
			"310",
			"311",
			"312",
			"313",
			"314",
			"315",
			"317",
			"318",
			"321",
			"322",
			"323",
			"324",
			"325",
			"326",
			"327",
			"328",
			"329",
			"330",
			"336",
			"717"
		],
		ddi: "7"
	},
	{
		countryNamePTBR: "Quênia",
		countryName: "Kenya",
		abbreviationAlpha3: "KEN",
		abbreviationFips10: "KE",
		domain: ".ke",
		areaCodeList: [
			"12",
			"20",
			"25",
			"40",
			"41",
			"42",
			"43",
			"44",
			"45",
			"46",
			"50",
			"51",
			"52",
			"53",
			"54",
			"55",
			"56",
			"57",
			"58",
			"59",
			"60",
			"61",
			"62",
			"64",
			"65",
			"66",
			"67",
			"68",
			"69",
			"722",
			"733"
		],
		ddi: "254"
	},
	{
		countryNamePTBR: "Kiribati",
		countryName: "Kiribati",
		abbreviationAlpha3: "KIR",
		abbreviationFips10: "KR",
		domain: ".ki",
		areaCodeList: [
			"21",
			"25",
			"28",
			"31",
			"33",
			"34",
			"35",
			"36",
			"37",
			"38",
			"39",
			"40",
			"41",
			"42",
			"43",
			"44",
			"45",
			"46",
			"47",
			"48",
			"49",
			"81",
			"83",
			"84",
			"85"
		],
		ddi: "686"
	},
	{
		countryNamePTBR: "Kosovo",
		countryName: "Kosovo",
		abbreviationAlpha3: "XKX",
		abbreviationFips10: "KV",
		domain: ".ko",
		areaCodeList: [
		],
		ddi: "383"
	},
	{
		countryNamePTBR: "Kuwait",
		countryName: "Kuwait",
		abbreviationAlpha3: "KWT",
		abbreviationFips10: "KU",
		domain: ".kw",
		areaCodeList: [
			"224",
			"240",
			"261",
			"327",
			"361",
			"371",
			"381",
			"383",
			"390",
			"391",
			"394",
			"395",
			"398",
			"431",
			"455",
			"461",
			"467",
			"470",
			"471",
			"477",
			"480",
			"481",
			"487",
			"531",
			"538",
			"541",
			"551",
			"561",
			"571"
		],
		ddi: "965"
	},
	{
		countryNamePTBR: "Quirguizistão",
		countryName: "Kyrgyzstan",
		abbreviationAlpha3: "KGZ",
		abbreviationFips10: "KG",
		domain: ".kg",
		areaCodeList: [
			"312",
			"322",
			"502",
			"517"
		],
		ddi: "996"
	},
	{
		countryNamePTBR: "Laos",
		countryName: "Laos",
		abbreviationAlpha3: "LAO",
		abbreviationFips10: "LA",
		domain: ".la",
		areaCodeList: [
			"20",
			"21",
			"31",
			"41",
			"51",
			"54",
			"71"
		],
		ddi: "856"
	},
	{
		countryNamePTBR: "Letônia",
		countryName: "Latvia",
		abbreviationAlpha3: "LVA",
		abbreviationFips10: "LG",
		domain: ".lv",
		areaCodeList: [
			"7",
			"30",
			"31",
			"32",
			"33",
			"34",
			"36",
			"37",
			"38",
			"39",
			"40",
			"41",
			"42",
			"43",
			"44",
			"45",
			"46",
			"47",
			"48",
			"50",
			"51",
			"52",
			"53",
			"54",
			"56",
			"57",
			"59"
		],
		ddi: "371"
	},
	{
		countryNamePTBR: "Líbano",
		countryName: "Lebanon",
		abbreviationAlpha3: "LBN",
		abbreviationFips10: "LE",
		domain: ".lb",
		areaCodeList: [
			"1",
			"3",
			"4",
			"5",
			"6",
			"7",
			"8",
			"9"
		],
		ddi: "961"
	},
	{
		countryNamePTBR: "Líbia",
		countryName: "Libya",
		abbreviationAlpha3: "LBY",
		abbreviationFips10: "LY",
		domain: ".ly",
		areaCodeList: [
			"21",
			"22",
			"23",
			"24",
			"25",
			"26",
			"31",
			"41",
			"47",
			"51",
			"54",
			"57",
			"61",
			"63",
			"67",
			"71",
			"73",
			"81",
			"82",
			"84",
			"205",
			"206",
			"224",
			"252",
			"271",
			"272",
			"274",
			"275",
			"277",
			"279",
			"281",
			"282",
			"284",
			"322",
			"323",
			"325",
			"326",
			"421",
			"422",
			"423",
			"425",
			"427",
			"452",
			"453",
			"454",
			"481",
			"482",
			"484",
			"521",
			"522",
			"523",
			"524",
			"526",
			"529",
			"551",
			"553",
			"554",
			"555",
			"581",
			"582",
			"583",
			"584",
			"623",
			"624",
			"625",
			"626",
			"627",
			"628",
			"629",
			"652",
			"653",
			"654",
			"655",
			"657",
			"681",
			"682",
			"683",
			"684",
			"685",
			"721",
			"723",
			"724",
			"725",
			"726",
			"727",
			"729",
			"731",
			"732",
			"733",
			"734",
			"821",
			"851",
			"852",
			"854",
			"884"
		],
		ddi: "218"
	},
	{
		countryNamePTBR: "Liechtenstein",
		countryName: "Liechtenstein",
		abbreviationAlpha3: "LIE",
		abbreviationFips10: "LS",
		domain: ".li",
		areaCodeList: [
			"2"
		],
		ddi: "423"
	},
	{
		countryNamePTBR: "Lituânia",
		countryName: "Lithuania",
		abbreviationAlpha3: "LTU",
		abbreviationFips10: "LH",
		domain: ".lt",
		areaCodeList: [
			"37",
			"45",
			"57",
			"310",
			"313",
			"315",
			"318",
			"319",
			"340",
			"342",
			"343",
			"345",
			"346",
			"349",
			"380",
			"381",
			"382",
			"383",
			"385",
			"386",
			"387",
			"389",
			"421",
			"422",
			"425",
			"426",
			"427",
			"428",
			"441",
			"443",
			"444",
			"445",
			"446",
			"447",
			"448",
			"449",
			"450",
			"451",
			"458",
			"459",
			"460",
			"469",
			"521",
			"528"
		],
		ddi: "370"
	},
	{
		countryNamePTBR: "Luxemburgo",
		countryName: "Luxembourg",
		abbreviationAlpha3: "LUX",
		abbreviationFips10: "LU",
		domain: ".lu",
		areaCodeList: [
		],
		ddi: "352"
	},
	{
		countryNamePTBR: "Macau",
		countryName: "Macau",
		abbreviationAlpha3: "MAC",
		abbreviationFips10: "MC",
		domain: ".mo",
		areaCodeList: [
		],
		ddi: "853"
	},
	{
		countryNamePTBR: "Madagascar",
		countryName: "Madagascar",
		abbreviationAlpha3: "MDG",
		abbreviationFips10: "MA",
		domain: ".mg",
		areaCodeList: [
			"13",
			"22",
			"42",
			"44",
			"47",
			"53",
			"54",
			"56",
			"57",
			"62",
			"67",
			"69",
			"72",
			"73",
			"75",
			"82",
			"86",
			"88",
			"92",
			"94",
			"95"
		],
		ddi: "261"
	},
	{
		countryNamePTBR: "Malásia",
		countryName: "Malaysia",
		abbreviationAlpha3: "MYS",
		abbreviationFips10: "MY",
		domain: ".my",
		areaCodeList: [
			"3",
			"4",
			"5",
			"6",
			"7",
			"8",
			"9"
		],
		ddi: "60"
	},
	{
		countryNamePTBR: "Maldivas",
		countryName: "Maldives",
		abbreviationAlpha3: "MDV",
		abbreviationFips10: "MV",
		domain: ".mv",
		areaCodeList: [
			"20",
			"21",
			"22",
			"23",
			"31",
			"35",
			"39",
			"44",
			"45",
			"46",
			"47",
			"51",
			"52",
			"54",
			"57",
			"654",
			"658",
			"662",
			"668",
			"670",
			"672",
			"674",
			"678"
		],
		ddi: "960"
	},
	{
		countryNamePTBR: "Malta",
		countryName: "Malta",
		abbreviationAlpha3: "MLT",
		abbreviationFips10: "MT",
		domain: ".mt",
		areaCodeList: [
		],
		ddi: "356"
	},
	{
		countryNamePTBR: "Ilhas Marshall",
		countryName: "Marshall Islands",
		abbreviationAlpha3: "MHL",
		abbreviationFips10: "RM",
		domain: ".mh",
		areaCodeList: [
			"247",
			"329"
		],
		ddi: "692"
	},
	{
		countryNamePTBR: "Martinica",
		countryName: "Martinique",
		abbreviationAlpha3: "MTQ",
		abbreviationFips10: "MB",
		domain: ".mq",
		areaCodeList: [
		],
		ddi: "596"
	},
	{
		countryNamePTBR: "Mauritânia",
		countryName: "Mauritania",
		abbreviationAlpha3: "MRT",
		abbreviationFips10: "MR",
		domain: ".mr",
		areaCodeList: [
			"12",
			"16",
			"17",
			"18"
		],
		ddi: "222"
	},
	{
		countryNamePTBR: "México",
		countryName: "Mexico",
		abbreviationAlpha3: "MEX",
		abbreviationFips10: "MX",
		domain: ".mx",
		areaCodeList: [
			"1",
			"33",
			"55",
			"81",
			"222",
			"229",
			"241",
			"320",
			"322",
			"330",
			"350",
			"370",
			"443",
			"444",
			"449",
			"461",
			"462",
			"477",
			"614",
			"618",
			"624",
			"631",
			"646",
			"656",
			"662",
			"664",
			"667",
			"668",
			"669",
			"686",
			"744",
			"777",
			"833",
			"844",
			"861",
			"867",
			"871",
			"899",
			"932",
			"938",
			"951",
			"961",
			"971",
			"984",
			"993",
			"998",
			"999"
		],
		ddi: "52"
	},
	{
		countryNamePTBR: "Moldávia",
		countryName: "Moldova",
		abbreviationAlpha3: "MDA",
		abbreviationFips10: "MD",
		domain: ".md",
		areaCodeList: [
			"22",
			"210",
			"215",
			"216",
			"219",
			"230",
			"231",
			"235",
			"236",
			"237",
			"241",
			"242",
			"243",
			"244",
			"246",
			"247",
			"248",
			"249",
			"250",
			"251",
			"252",
			"254",
			"256",
			"258",
			"259",
			"262",
			"263",
			"264",
			"265",
			"268",
			"269",
			"271",
			"272",
			"273",
			"277",
			"291",
			"293",
			"294",
			"297",
			"298",
			"299",
			"533",
			"552",
			"555",
			"557"
		],
		ddi: "373"
	},
	{
		countryNamePTBR: "Mongólia",
		countryName: "Mongolia",
		abbreviationAlpha3: "MNG",
		abbreviationFips10: "MG",
		domain: ".mn",
		areaCodeList: [
			"11"
		],
		ddi: "976"
	},
	{
		countryNamePTBR: "Montenegro",
		countryName: "Montenegro",
		abbreviationAlpha3: "MNE",
		abbreviationFips10: "MJ",
		domain: ".me",
		areaCodeList: [
			"81",
			"82",
			"83",
			"84",
			"85",
			"86",
			"87",
			"88",
			"89"
		],
		ddi: "382"
	},
	{
		countryNamePTBR: "Montserrat",
		countryName: "Montserrat",
		abbreviationAlpha3: "MSR",
		abbreviationFips10: "MH",
		domain: ".ms",
		areaCodeList: [
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "Marrocos",
		countryName: "Morocco",
		abbreviationAlpha3: "MAR",
		abbreviationFips10: "MO",
		domain: ".ma",
		areaCodeList: [
			"22",
			"23",
			"37",
			"39",
			"44",
			"48",
			"55",
			"56"
		],
		ddi: "212"
	},
	{
		countryNamePTBR: "Moçambique",
		countryName: "Mozambique",
		abbreviationAlpha3: "MOZ",
		abbreviationFips10: "MZ",
		domain: ".mz",
		areaCodeList: [
			"21",
			"23",
			"24",
			"26",
			"221",
			"222",
			"251",
			"252"
		],
		ddi: "258"
	},
	{
		countryNamePTBR: "Mianmar",
		countryName: "Myanmar",
		abbreviationAlpha3: "MMR",
		abbreviationFips10: "BM",
		domain: ".mm",
		areaCodeList: [
			"1",
			"2",
			"42",
			"53",
			"57",
			"58",
			"59",
			"69",
			"71",
			"80"
		],
		ddi: "95"
	},
	{
		countryNamePTBR: "Namíbia",
		countryName: "Namibia",
		abbreviationAlpha3: "NAM",
		abbreviationFips10: "WA",
		domain: ".na",
		areaCodeList: [
			"61",
			"62",
			"63",
			"64",
			"65",
			"66",
			"67",
			"81",
			"628",
			"638",
			"658",
			"668",
			"6342",
			"6362",
			"6638",
			"6642",
			"6751",
			"632532"
		],
		ddi: "264"
	},
	{
		countryNamePTBR: "Nauru",
		countryName: "Nauru",
		abbreviationAlpha3: "NRU",
		abbreviationFips10: "NR",
		domain: ".nr",
		areaCodeList: [
		],
		ddi: "674"
	},
	{
		countryNamePTBR: "Nepal",
		countryName: "Nepal",
		abbreviationAlpha3: "NPL",
		abbreviationFips10: "NP",
		domain: ".np",
		areaCodeList: [
			"1",
			"21",
			"23",
			"24",
			"26",
			"29",
			"41",
			"46",
			"49",
			"56",
			"64",
			"81",
			"91"
		],
		ddi: "977"
	},
	{
		countryNamePTBR: "Países Baixos",
		countryName: "Netherlands",
		abbreviationAlpha3: "NLD",
		abbreviationFips10: "NL",
		domain: ".nl",
		areaCodeList: [
			"10",
			"20",
			"23",
			"24",
			"26",
			"30",
			"35",
			"40",
			"45",
			"50",
			"70",
			"71",
			"73",
			"570"
		],
		ddi: "31"
	},
	{
		countryNamePTBR: "Nova Caledônia",
		countryName: "New Caledonia",
		abbreviationAlpha3: "NCL",
		abbreviationFips10: "NC",
		domain: ".nc",
		areaCodeList: [
			"23",
			"35",
			"42",
			"45"
		],
		ddi: "687"
	},
	{
		countryNamePTBR: "Nova Zelândia",
		countryName: "New Zealand",
		abbreviationAlpha3: "NZL",
		abbreviationFips10: "NZ",
		domain: ".nz",
		areaCodeList: [
			"3",
			"4",
			"6",
			"7",
			"9",
			"24"
		],
		ddi: "64"
	},
	{
		countryNamePTBR: "Nicarágua",
		countryName: "Nicaragua",
		abbreviationAlpha3: "NIC",
		abbreviationFips10: "NU",
		domain: ".ni",
		areaCodeList: [
			"2",
			"43",
			"44",
			"46",
			"52",
			"53",
			"54",
			"55",
			"71",
			"311",
			"341",
			"4222",
			"4522",
			"4682"
		],
		ddi: "505"
	},
	{
		countryNamePTBR: "Níger",
		countryName: "Niger",
		abbreviationAlpha3: "NER",
		abbreviationFips10: "NG",
		domain: ".ne",
		areaCodeList: [
		],
		ddi: "227"
	},
	{
		countryNamePTBR: "Nigéria",
		countryName: "Nigeria",
		abbreviationAlpha3: "NGA",
		abbreviationFips10: "NI",
		domain: ".ng",
		areaCodeList: [
			"1",
			"2",
			"9",
			"30",
			"31",
			"33",
			"34",
			"35",
			"36",
			"37",
			"38",
			"39",
			"41",
			"42",
			"43",
			"44",
			"45",
			"46",
			"47",
			"48",
			"50",
			"51",
			"52",
			"53",
			"54",
			"55",
			"56",
			"57",
			"58",
			"59",
			"60",
			"61",
			"62",
			"63",
			"64",
			"65",
			"66",
			"67",
			"68",
			"69",
			"70",
			"71",
			"72",
			"73",
			"74",
			"75",
			"76",
			"77",
			"78",
			"79",
			"82",
			"83",
			"84",
			"85",
			"86",
			"87",
			"88",
			"89"
		],
		ddi: "234"
	},
	{
		countryNamePTBR: "Niue",
		countryName: "Niue",
		abbreviationAlpha3: "NIU",
		abbreviationFips10: "NE",
		domain: ".nu",
		areaCodeList: [
			"1"
		],
		ddi: "683"
	},
	{
		countryNamePTBR: "Ilha Norfolk",
		countryName: "Norfolk Island",
		abbreviationAlpha3: "NFK",
		abbreviationFips10: "NF",
		domain: ".nf",
		areaCodeList: [
		],
		ddi: "672"
	},
	{
		countryNamePTBR: "Coréia do Norte",
		countryName: "North Korea",
		abbreviationAlpha3: "PRK",
		abbreviationFips10: "KN",
		domain: ".kp",
		areaCodeList: [
			"2"
		],
		ddi: "850"
	},
	{
		countryNamePTBR: "Noruega",
		countryName: "Norway",
		abbreviationAlpha3: "NOR",
		abbreviationFips10: "NO",
		domain: ".no",
		areaCodeList: [
			"2",
			"31",
			"33",
			"35",
			"37",
			"38",
			"51",
			"53",
			"57",
			"61",
			"62",
			"63",
			"69",
			"70",
			"72",
			"74",
			"75",
			"77",
			"78"
		],
		ddi: "47"
	},
	{
		countryNamePTBR: "Omã",
		countryName: "Oman",
		abbreviationAlpha3: "OMN",
		abbreviationFips10: "MU",
		domain: ".om",
		areaCodeList: [
			"23",
			"24",
			"25",
			"26"
		],
		ddi: "968"
	},
	{
		countryNamePTBR: "Paquistão",
		countryName: "Pakistan",
		abbreviationAlpha3: "PAK",
		abbreviationFips10: "PK",
		domain: ".pk",
		areaCodeList: [
			"21",
			"41",
			"42",
			"51",
			"55",
			"61",
			"71",
			"81",
			"91",
			"221",
			"441",
			"442",
			"451",
			"524",
			"604",
			"621",
			"992",
			"5799"
		],
		ddi: "92"
	},
	{
		countryNamePTBR: "Palau",
		countryName: "Palau",
		abbreviationAlpha3: "PLW",
		abbreviationFips10: "PS",
		domain: ".pw",
		areaCodeList: [
		],
		ddi: "680"
	},
	{
		countryNamePTBR: "Palestina",
		countryName: "Palestine",
		abbreviationAlpha3: "PSE",
		abbreviationFips10: "WE",
		domain: ".ps",
		areaCodeList: [
		],
		ddi: "970"
	},
	{
		countryNamePTBR: "Panamá",
		countryName: "Panama",
		abbreviationAlpha3: "PAN",
		abbreviationFips10: "PM",
		domain: ".pa",
		areaCodeList: [
			"2",
			"4",
			"7",
			"9"
		],
		ddi: "507"
	},
	{
		countryNamePTBR: "Papua Nova Guiné",
		countryName: "Papua New Guinea",
		abbreviationAlpha3: "PNG",
		abbreviationFips10: "PP",
		domain: ".pg",
		areaCodeList: [
			"30",
			"34",
			"45",
			"47",
			"52",
			"70",
			"84",
			"95"
		],
		ddi: "675"
	},
	{
		countryNamePTBR: "Paraguai",
		countryName: "Paraguay",
		abbreviationAlpha3: "PRY",
		abbreviationFips10: "PA",
		domain: ".py",
		areaCodeList: [
			"21",
			"24",
			"25",
			"27",
			"28",
			"31",
			"36",
			"61",
			"63",
			"71",
			"72",
			"74",
			"82",
			"86",
			"521",
			"541"
		],
		ddi: "595"
	},
	{
		countryNamePTBR: "Peru",
		countryName: "Peru",
		abbreviationAlpha3: "PER",
		abbreviationFips10: "PE",
		domain: ".pe",
		areaCodeList: [
			"1",
			"14",
			"34",
			"44",
			"54",
			"64",
			"74",
			"84",
			"94",
			"6495"
		],
		ddi: "51"
	},
	{
		countryNamePTBR: "Filipinas",
		countryName: "Philippines",
		abbreviationAlpha3: "PHL",
		abbreviationFips10: "RP",
		domain: ".ph",
		areaCodeList: [
			"2",
			"9",
			"32",
			"33",
			"34",
			"42",
			"43",
			"45",
			"46",
			"47",
			"48",
			"52",
			"53",
			"56",
			"62",
			"63",
			"64",
			"72",
			"74",
			"75",
			"82",
			"83",
			"88",
			"93",
			"452",
			"455",
			"3522",
			"3524",
			"5421",
			"8822"
		],
		ddi: "63"
	},
	{
		countryNamePTBR: "Polônia",
		countryName: "Poland",
		abbreviationAlpha3: "POL",
		abbreviationFips10: "PL",
		domain: ".pl",
		areaCodeList: [
			"10",
			"12",
			"14",
			"15",
			"16",
			"17",
			"18",
			"22",
			"23",
			"24",
			"25",
			"29",
			"30",
			"32",
			"33",
			"34",
			"35",
			"36",
			"40",
			"41",
			"42",
			"43",
			"44",
			"48",
			"49",
			"50",
			"51",
			"52",
			"53",
			"54",
			"55",
			"56",
			"57",
			"58",
			"59",
			"61",
			"62",
			"63",
			"64",
			"65",
			"66",
			"67",
			"68",
			"69",
			"71",
			"72",
			"74",
			"75",
			"76",
			"77",
			"80",
			"81",
			"82",
			"84",
			"85",
			"86",
			"87",
			"89",
			"91",
			"92",
			"94",
			"95",
			"115",
			"119",
			"131",
			"136",
			"137",
			"146",
			"165",
			"171",
			"184",
			"187",
			"192",
			"194",
			"195",
			"196",
			"197",
			"198",
			"216",
			"218",
			"238",
			"255",
			"256",
			"335",
			"376",
			"381",
			"387",
			"435",
			"451",
			"457",
			"478",
			"496",
			"498",
			"506",
			"511",
			"518",
			"531",
			"532",
			"536",
			"555",
			"557",
			"568",
			"591",
			"636",
			"641",
			"646",
			"647",
			"657",
			"666",
			"667",
			"668",
			"725",
			"794",
			"797",
			"831",
			"836",
			"837",
			"868",
			"878",
			"923",
			"928",
			"931",
			"932",
			"936",
			"962",
			"965",
			"966"
		],
		ddi: "48"
	},
	{
		countryNamePTBR: "Portugal",
		countryName: "Portugal",
		abbreviationAlpha3: "PRT",
		abbreviationFips10: "PO",
		domain: ".pt",
		areaCodeList: [
			"21",
			"22",
			"231",
			"232",
			"233",
			"234",
			"235",
			"236",
			"238",
			"239",
			"241",
			"242",
			"243",
			"244",
			"245",
			"249",
			"251",
			"252",
			"253",
			"254",
			"255",
			"256",
			"258",
			"259",
			"261",
			"262",
			"263",
			"265",
			"266",
			"268",
			"269",
			"271",
			"272",
			"273",
			"274",
			"275",
			"276",
			"277",
			"278",
			"279",
			"281",
			"282",
			"283",
			"284",
			"285",
			"286",
			"289",
			"291",
			"292",
			"295",
			"296"
		],
		ddi: "351"
	},
	{
		countryNamePTBR: "Principado de Mônaco",
		countryName: "Principality of Monaco",
		abbreviationAlpha3: "MCO",
		abbreviationFips10: "MN",
		domain: ".mc",
		areaCodeList: [
		],
		ddi: "377"
	},
	{
		countryNamePTBR: "Porto Rico",
		countryName: "Puerto Rico",
		abbreviationAlpha3: "PRI",
		abbreviationFips10: "RQ",
		domain: ".pr",
		areaCodeList: [
			"787"
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "Qatar",
		countryName: "Qatar",
		abbreviationAlpha3: "QAT",
		abbreviationFips10: "QA",
		domain: ".qa",
		areaCodeList: [
		],
		ddi: "974"
	},
	{
		countryNamePTBR: "República do Congo",
		countryName: "Republic of the Congo",
		abbreviationAlpha3: "COG",
		abbreviationFips10: "CF",
		domain: ".cg",
		areaCodeList: [
			"21",
			"22",
			"23",
			"24",
			"25",
			"28",
			"29",
			"52",
			"66",
			"441"
		],
		ddi: "242"
	},
	{
		countryNamePTBR: "Romênia",
		countryName: "Romania",
		abbreviationAlpha3: "ROU",
		abbreviationFips10: "RO",
		domain: ".ro",
		areaCodeList: [
			"21",
			"230",
			"231",
			"232",
			"233",
			"234",
			"235",
			"236",
			"237",
			"238",
			"239",
			"240",
			"241",
			"242",
			"243",
			"244",
			"245",
			"246",
			"247",
			"248",
			"249",
			"250",
			"251",
			"252",
			"253",
			"254",
			"255",
			"256",
			"257",
			"258",
			"259",
			"260",
			"261",
			"262",
			"263",
			"264",
			"265",
			"266",
			"267",
			"268",
			"269",
			"2179"
		],
		ddi: "40"
	},
	{
		countryNamePTBR: "Rússia",
		countryName: "Russia",
		abbreviationAlpha3: "RUS",
		abbreviationFips10: "RS",
		domain: ".ru",
		areaCodeList: [
			"401",
			"471",
			"472",
			"473",
			"474",
			"475",
			"481",
			"482",
			"483",
			"484",
			"485",
			"486",
			"487",
			"491",
			"492",
			"493",
			"494",
			"495",
			"496"
		],
		ddi: "7"
	},
	{
		countryNamePTBR: "Ruanda",
		countryName: "Rwanda",
		abbreviationAlpha3: "RWA",
		abbreviationFips10: "RW",
		domain: ".rw",
		areaCodeList: [
		],
		ddi: "250"
	},
	{
		countryNamePTBR: "Samoa",
		countryName: "Samoa",
		abbreviationAlpha3: "WSM",
		abbreviationFips10: "WS",
		domain: ".ws",
		areaCodeList: [
		],
		ddi: "685"
	},
	{
		countryNamePTBR: "São Marino",
		countryName: "San Marino",
		abbreviationAlpha3: "SMR",
		abbreviationFips10: "SM",
		domain: ".sm",
		areaCodeList: [
			"0"
		],
		ddi: "378"
	},
	{
		countryNamePTBR: "Arábia Saudita",
		countryName: "Saudi Arabia",
		abbreviationAlpha3: "SAU",
		abbreviationFips10: "SA",
		domain: ".sa",
		areaCodeList: [
			"11",
			"12",
			"13",
			"14",
			"16",
			"17"
		],
		ddi: "966"
	},
	{
		countryNamePTBR: "Senegal",
		countryName: "Senegal",
		abbreviationAlpha3: "SEN",
		abbreviationFips10: "SG",
		domain: ".sn",
		areaCodeList: [
			"8",
			"9"
		],
		ddi: "221"
	},
	{
		countryNamePTBR: "Sérvia",
		countryName: "Serbia",
		abbreviationAlpha3: "SRB",
		abbreviationFips10: "RI",
		domain: ".rs",
		areaCodeList: [
			"10",
			"11",
			"12",
			"13",
			"14",
			"18",
			"19",
			"20",
			"21",
			"22",
			"24",
			"25",
			"28",
			"30",
			"31",
			"34",
			"35",
			"36",
			"37",
			"38",
			"39"
		],
		ddi: "381"
	},
	{
		countryNamePTBR: "Serra Leoa",
		countryName: "Sierra Leone",
		abbreviationAlpha3: "SLE",
		abbreviationFips10: "SL",
		domain: ".sl",
		areaCodeList: [
			"22",
			"32"
		],
		ddi: "232"
	},
	{
		countryNamePTBR: "Cingapura",
		countryName: "Singapore",
		abbreviationAlpha3: "SGP",
		abbreviationFips10: "SN",
		domain: ".sg",
		areaCodeList: [
			"635",
			"644",
			"645",
			"653",
			"673",
			"675",
			"676",
			"677",
			"678"
		],
		ddi: "65"
	},
	{
		countryNamePTBR: "Eslováquia",
		countryName: "Slovakia",
		abbreviationAlpha3: "SVK",
		abbreviationFips10: "LO",
		domain: ".sk",
		areaCodeList: [
			"2",
			"31",
			"32",
			"33",
			"34",
			"35",
			"36",
			"37",
			"38",
			"41",
			"42",
			"43",
			"44",
			"45",
			"46",
			"47",
			"48",
			"51",
			"52",
			"53",
			"54",
			"55",
			"56",
			"57",
			"58"
		],
		ddi: "421"
	},
	{
		countryNamePTBR: "Eslovênia",
		countryName: "Slovenia",
		abbreviationAlpha3: "SVN",
		abbreviationFips10: "SI",
		domain: ".si",
		areaCodeList: [
			"1",
			"2",
			"3",
			"4",
			"5",
			"7"
		],
		ddi: "386"
	},
	{
		countryNamePTBR: "Ilhas Salomão",
		countryName: "Solomon Islands",
		abbreviationAlpha3: "SLB",
		abbreviationFips10: "BP",
		domain: ".sb",
		areaCodeList: [
			"74"
		],
		ddi: "677"
	},
	{
		countryNamePTBR: "Somália",
		countryName: "Somalia",
		abbreviationAlpha3: "SOM",
		abbreviationFips10: "SO",
		domain: ".so",
		areaCodeList: [
			"1",
			"61"
		],
		ddi: "252"
	},
	{
		countryNamePTBR: "África do Sul",
		countryName: "South Africa",
		abbreviationAlpha3: "ZAF",
		abbreviationFips10: "SF",
		domain: ".za",
		areaCodeList: [
			"11",
			"12",
			"16",
			"21",
			"24",
			"31",
			"41",
			"51",
			"57",
			"331",
			"431",
			"571",
			"102103"
		],
		ddi: "27"
	},
	{
		countryNamePTBR: "Coréia do Sul",
		countryName: "South Korea",
		abbreviationAlpha3: "KOR",
		abbreviationFips10: "KS",
		domain: ".kr",
		areaCodeList: [
			"2",
			"31",
			"32",
			"33",
			"41",
			"42",
			"43",
			"51",
			"52",
			"53",
			"54",
			"55",
			"61",
			"62",
			"63",
			"64"
		],
		ddi: "82"
	},
	{
		countryNamePTBR: "Espanha",
		countryName: "Spain",
		abbreviationAlpha3: "ESP",
		abbreviationFips10: "SP",
		domain: ".es",
		areaCodeList: [
			"91",
			"93",
			"94",
			"95",
			"96",
			"920",
			"921",
			"922",
			"923",
			"924",
			"925",
			"927",
			"928",
			"941",
			"942",
			"943",
			"945",
			"947",
			"948",
			"949",
			"950",
			"952",
			"953",
			"954",
			"956",
			"957",
			"958",
			"959",
			"964",
			"967",
			"968",
			"969",
			"971",
			"972",
			"973",
			"974",
			"976",
			"977",
			"978",
			"979",
			"980",
			"981",
			"982",
			"983",
			"985",
			"986",
			"987",
			"988"
		],
		ddi: "34"
	},
	{
		countryNamePTBR: "Sri Lanka",
		countryName: "Sri Lanka",
		abbreviationAlpha3: "LKA",
		abbreviationFips10: "CE",
		domain: ".lk",
		areaCodeList: [
			"8",
			"34",
			"86",
			"95",
			"97",
			"214",
			"234",
			"245",
			"254",
			"265",
			"274",
			"314",
			"324",
			"335",
			"345",
			"354",
			"365",
			"375",
			"415",
			"454",
			"475",
			"515",
			"524",
			"554",
			"574",
			"634",
			"654",
			"664",
			"674",
			"5424"
		],
		ddi: "94"
	},
	{
		countryNamePTBR: "Sudão",
		countryName: "Sudan",
		abbreviationAlpha3: "SDN",
		abbreviationFips10: "SU",
		domain: ".sd",
		areaCodeList: [
			"11",
			"21",
			"31",
			"41",
			"51",
			"61",
			"71",
			"81",
			"183",
			"441",
			"616"
		],
		ddi: "249"
	},
	{
		countryNamePTBR: "Suriname",
		countryName: "Suriname",
		abbreviationAlpha3: "SUR",
		abbreviationFips10: "NS",
		domain: ".sr",
		areaCodeList: [
			"2",
			"3",
			"4"
		],
		ddi: "597"
	},
	{
		countryNamePTBR: "Suécia",
		countryName: "Sweden",
		abbreviationAlpha3: "SWE",
		abbreviationFips10: "SW",
		domain: ".se",
		areaCodeList: [
			"8",
			"11",
			"13",
			"16",
			"18",
			"19",
			"21",
			"23",
			"26",
			"31",
			"33",
			"35",
			"36",
			"40",
			"42",
			"44",
			"46",
			"54",
			"60",
			"63",
			"90",
			"120",
			"121",
			"122",
			"123",
			"125",
			"140",
			"141",
			"142",
			"143",
			"144",
			"150",
			"151",
			"152",
			"155",
			"156",
			"157",
			"158",
			"159",
			"171",
			"173",
			"174",
			"175",
			"176",
			"220",
			"221",
			"222",
			"223",
			"224",
			"225",
			"226",
			"227",
			"240",
			"241",
			"243",
			"246",
			"247",
			"248",
			"250",
			"251",
			"253",
			"258",
			"270",
			"271",
			"278",
			"280",
			"281",
			"290",
			"291",
			"292",
			"293",
			"294",
			"295",
			"297",
			"300",
			"301",
			"302",
			"303",
			"304",
			"320",
			"321",
			"322",
			"325",
			"340",
			"345",
			"346",
			"370",
			"371",
			"372",
			"380",
			"381",
			"382",
			"383",
			"390",
			"392",
			"393",
			"410",
			"411",
			"413",
			"414",
			"415",
			"416",
			"417",
			"418",
			"430",
			"431",
			"433",
			"435",
			"451",
			"454",
			"455",
			"456",
			"457",
			"459",
			"470",
			"471",
			"472",
			"474",
			"476",
			"477",
			"478",
			"479",
			"480",
			"481",
			"485",
			"486",
			"490",
			"491",
			"492",
			"493",
			"494",
			"495",
			"496",
			"498",
			"499",
			"500",
			"501",
			"502",
			"503",
			"504",
			"505",
			"506",
			"510",
			"511",
			"512",
			"513",
			"514",
			"515",
			"520",
			"521",
			"522",
			"523",
			"524",
			"525",
			"526",
			"528",
			"530",
			"531",
			"532",
			"533",
			"534",
			"550",
			"551",
			"552",
			"553",
			"554",
			"555",
			"560",
			"563",
			"564",
			"565",
			"570",
			"571",
			"573",
			"580",
			"581",
			"582",
			"583",
			"584",
			"585",
			"586",
			"587",
			"589",
			"590",
			"591",
			"611",
			"612",
			"613",
			"620",
			"621",
			"622",
			"623",
			"624",
			"640",
			"642",
			"643",
			"644",
			"645",
			"647",
			"650",
			"651",
			"652",
			"653",
			"657",
			"660",
			"661",
			"662",
			"663",
			"670",
			"671",
			"672",
			"680",
			"682",
			"684",
			"687",
			"690",
			"691",
			"692",
			"693",
			"695",
			"696",
			"910",
			"911",
			"912",
			"913",
			"914",
			"915",
			"916",
			"918",
			"920",
			"921",
			"922",
			"923",
			"924",
			"925",
			"926",
			"927",
			"928",
			"929",
			"930",
			"932",
			"933",
			"934",
			"935",
			"940",
			"941",
			"942",
			"943",
			"950",
			"951",
			"952",
			"953",
			"954",
			"960",
			"961",
			"970",
			"971",
			"973",
			"975",
			"976",
			"977",
			"978",
			"980",
			"981"
		],
		ddi: "46"
	},
	{
		countryNamePTBR: "Suíça",
		countryName: "Switzerland",
		abbreviationAlpha3: "CHE",
		abbreviationFips10: "SZ",
		domain: ".ch",
		areaCodeList: [
			"21",
			"22",
			"24",
			"26",
			"27",
			"31",
			"32",
			"33",
			"41",
			"43",
			"52",
			"56",
			"61",
			"62",
			"71",
			"81",
			"91"
		],
		ddi: "41"
	},
	{
		countryNamePTBR: "Síria",
		countryName: "Syria",
		abbreviationAlpha3: "SYR",
		abbreviationFips10: "SY",
		domain: ".sy",
		areaCodeList: [
			"11",
			"12",
			"13",
			"14",
			"15",
			"16",
			"21",
			"22",
			"23",
			"25",
			"31",
			"33",
			"34",
			"41",
			"43",
			"51",
			"52",
			"53"
		],
		ddi: "963"
	},
	{
		countryNamePTBR: "São Tomé e Príncipe",
		countryName: "São Tomé and Príncipe",
		abbreviationAlpha3: "STP",
		abbreviationFips10: "TP",
		domain: ".st",
		areaCodeList: [
		],
		ddi: "239"
	},
	{
		countryNamePTBR: "Taiwan",
		countryName: "Taiwan",
		abbreviationAlpha3: "TWN",
		abbreviationFips10: "TW",
		domain: ".tw",
		areaCodeList: [
			"2",
			"3",
			"4",
			"5",
			"6",
			"7",
			"8",
			"37",
			"38",
			"39",
			"49",
			"89"
		],
		ddi: "886"
	},
	{
		countryNamePTBR: "Tajiquistão",
		countryName: "Tajikistan",
		abbreviationAlpha3: "TJK",
		abbreviationFips10: "TI",
		domain: ".tj",
		areaCodeList: [
			"372",
			"3131",
			"3222",
			"3240",
			"3249",
			"3322",
			"3422",
			"3475",
			"3771",
			"34402",
			"35220",
			"37745"
		],
		ddi: "992"
	},
	{
		countryNamePTBR: "Tanzânia",
		countryName: "Tanzania",
		abbreviationAlpha3: "TZA",
		abbreviationFips10: "TZ",
		domain: ".tz",
		areaCodeList: [
			"22",
			"23",
			"24",
			"25",
			"26",
			"27",
			"28",
			"223"
		],
		ddi: "255"
	},
	{
		countryNamePTBR: "Tailândia",
		countryName: "Thailand",
		abbreviationAlpha3: "THA",
		abbreviationFips10: "TH",
		domain: ".th",
		areaCodeList: [
			"2",
			"32",
			"34",
			"36",
			"38",
			"39",
			"42",
			"44",
			"45",
			"53",
			"54",
			"55",
			"56",
			"73",
			"74",
			"76",
			"77"
		],
		ddi: "66"
	},
	{
		countryNamePTBR: "Timor Leste",
		countryName: "Timor-Leste",
		abbreviationAlpha3: "TLS",
		abbreviationFips10: "TT",
		domain: ".tl",
		areaCodeList: [
		],
		ddi: "670"
	},
	{
		countryNamePTBR: "Togo",
		countryName: "Togo",
		abbreviationAlpha3: "TGO",
		abbreviationFips10: "TO",
		domain: ".tg",
		areaCodeList: [
			"2",
			"3",
			"4",
			"5",
			"6",
			"7"
		],
		ddi: "228"
	},
	{
		countryNamePTBR: "Tokelau",
		countryName: "Tokelau",
		abbreviationAlpha3: "TKL",
		abbreviationFips10: "TL",
		domain: ".tk",
		areaCodeList: [
		],
		ddi: "690"
	},
	{
		countryNamePTBR: "Tonga",
		countryName: "Tonga",
		abbreviationAlpha3: "TON",
		abbreviationFips10: "TN",
		domain: ".to",
		areaCodeList: [
			"20",
			"29",
			"31",
			"33",
			"35",
			"37",
			"41",
			"43",
			"50",
			"60",
			"70",
			"80",
			"85"
		],
		ddi: "676"
	},
	{
		countryNamePTBR: "Trinidad e Tobago",
		countryName: "Trinidad and Tobago",
		abbreviationAlpha3: "TTO",
		abbreviationFips10: "TD",
		domain: ".tt",
		areaCodeList: [
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "Tunísia",
		countryName: "Tunisia",
		abbreviationAlpha3: "TUN",
		abbreviationFips10: "TS",
		domain: ".tn",
		areaCodeList: [
			"1",
			"2",
			"3",
			"4",
			"5",
			"6",
			"7",
			"8",
			"9"
		],
		ddi: "216"
	},
	{
		countryNamePTBR: "Turquia",
		countryName: "Turkey",
		abbreviationAlpha3: "TUR",
		abbreviationFips10: "TU",
		domain: ".tr",
		areaCodeList: [
			"212",
			"216",
			"222",
			"224",
			"226",
			"228",
			"232",
			"236",
			"242",
			"246",
			"248",
			"252",
			"256",
			"258",
			"262",
			"264",
			"266",
			"272",
			"274",
			"276",
			"282",
			"284",
			"286",
			"288",
			"312",
			"318",
			"322",
			"324",
			"326",
			"332",
			"338",
			"342",
			"344",
			"346",
			"352",
			"354",
			"356",
			"358",
			"362",
			"364",
			"366",
			"368",
			"372",
			"374",
			"376",
			"378",
			"382",
			"384",
			"386",
			"388",
			"412",
			"414",
			"416",
			"422",
			"424",
			"426",
			"428",
			"432",
			"434",
			"436",
			"438",
			"442",
			"446",
			"452",
			"454",
			"456",
			"458",
			"462",
			"464",
			"466",
			"472",
			"474",
			"476",
			"478",
			"482",
			"484",
			"486",
			"488"
		],
		ddi: "90"
	},
	{
		countryNamePTBR: "Turcomenistão",
		countryName: "Turkmenistan",
		abbreviationAlpha3: "TKM",
		abbreviationFips10: "TX",
		domain: ".tm",
		areaCodeList: [
			"12",
			"222",
			"243",
			"322",
			"378",
			"522"
		],
		ddi: "993"
	},
	{
		countryNamePTBR: "Uganda",
		countryName: "Uganda",
		abbreviationAlpha3: "UGA",
		abbreviationFips10: "UG",
		domain: ".ug",
		areaCodeList: [
			"41",
			"42",
			"43"
		],
		ddi: "256"
	},
	{
		countryNamePTBR: "Ucrânia",
		countryName: "Ukraine",
		abbreviationAlpha3: "UKR",
		abbreviationFips10: "UP",
		domain: ".ua",
		areaCodeList: [
			"62",
			"562"
		],
		ddi: "380"
	},
	{
		countryNamePTBR: "Emirados Árabes Unidos",
		countryName: "United Arab Emirates",
		abbreviationAlpha3: "ARE",
		abbreviationFips10: "AE",
		domain: ".ae",
		areaCodeList: [
			"2",
			"3",
			"4",
			"6",
			"9",
			"48",
			"58",
			"70",
			"77",
			"88"
		],
		ddi: "971"
	},
	{
		countryNamePTBR: "Reino Unido",
		countryName: "United Kingdom",
		abbreviationAlpha3: "GBR",
		abbreviationFips10: "UK",
		domain: ".uk",
		areaCodeList: [
			"20",
			"23",
			"24",
			"28",
			"29",
			"113",
			"114",
			"115",
			"116",
			"117",
			"118",
			"121",
			"131",
			"141",
			"151",
			"161",
			"191",
			"1200",
			"1202",
			"1204",
			"1205",
			"1206",
			"1207",
			"1208",
			"1209",
			"1223",
			"1224",
			"1225",
			"1226",
			"1227",
			"1228",
			"1229",
			"1233",
			"1234",
			"1235",
			"1236",
			"1237",
			"1239",
			"1241",
			"1242",
			"1243",
			"1244",
			"1245",
			"1246",
			"1248",
			"1249",
			"1250",
			"1252",
			"1253",
			"1254",
			"1255",
			"1257",
			"1258",
			"1259",
			"1260",
			"1261",
			"1262",
			"1263",
			"1264",
			"1267",
			"1268",
			"1269",
			"1270",
			"1271",
			"1273",
			"1274",
			"1276",
			"1277",
			"1278",
			"1279",
			"1280",
			"1282",
			"1283",
			"1284",
			"1285",
			"1286",
			"1287",
			"1288",
			"1289",
			"1290",
			"1291",
			"1292",
			"1293",
			"1294",
			"1295",
			"1296",
			"1297",
			"1298",
			"1299",
			"1300",
			"1301",
			"1302",
			"1303",
			"1304",
			"1305",
			"1307",
			"1308",
			"1309",
			"1320",
			"1322",
			"1323",
			"1324",
			"1325",
			"1326",
			"1327",
			"1328",
			"1329",
			"1330",
			"1332",
			"1333",
			"1335",
			"1337",
			"1339",
			"1340",
			"1341",
			"1342",
			"1343",
			"1344",
			"1346",
			"1347",
			"1348",
			"1349",
			"1350",
			"1352",
			"1353",
			"1354",
			"1355",
			"1356",
			"1358",
			"1359",
			"1360",
			"1361",
			"1362",
			"1363",
			"1364",
			"1366",
			"1367",
			"1368",
			"1369",
			"1371",
			"1372",
			"1373",
			"1376",
			"1377",
			"1379",
			"1380",
			"1381",
			"1382",
			"1383",
			"1384",
			"1387",
			"1388",
			"1389",
			"1392",
			"1394",
			"1395",
			"1397",
			"1398",
			"1400",
			"1403",
			"1404",
			"1405",
			"1406",
			"1407",
			"1408",
			"1409",
			"1420",
			"1422",
			"1423",
			"1424",
			"1425",
			"1427",
			"1428",
			"1429",
			"1430",
			"1431",
			"1432",
			"1433",
			"1434",
			"1435",
			"1436",
			"1437",
			"1438",
			"1439",
			"1440",
			"1442",
			"1443",
			"1444",
			"1445",
			"1446",
			"1449",
			"1450",
			"1451",
			"1452",
			"1453",
			"1454",
			"1455",
			"1456",
			"1457",
			"1458",
			"1460",
			"1461",
			"1462",
			"1463",
			"1464",
			"1465",
			"1466",
			"1467",
			"1469",
			"1470",
			"1471",
			"1472",
			"1473",
			"1474",
			"1475",
			"1476",
			"1478",
			"1479",
			"1480",
			"1482",
			"1483",
			"1484",
			"1485",
			"1487",
			"1488",
			"1490",
			"1491",
			"1492",
			"1493",
			"1494",
			"1495",
			"1496",
			"1497",
			"1499",
			"1501",
			"1502",
			"1503",
			"1505",
			"1506",
			"1507",
			"1508",
			"1509",
			"1520",
			"1522",
			"1524",
			"1525",
			"1526",
			"1527",
			"1528",
			"1529",
			"1530",
			"1535",
			"1536",
			"1539",
			"1540",
			"1542",
			"1543",
			"1544",
			"1545",
			"1546",
			"1547",
			"1548",
			"1549",
			"1550",
			"1553",
			"1554",
			"1555",
			"1556",
			"1557",
			"1558",
			"1559",
			"1560",
			"1561",
			"1563",
			"1564",
			"1565",
			"1566",
			"1567",
			"1568",
			"1569",
			"1570",
			"1571",
			"1572",
			"1573",
			"1575",
			"1576",
			"1577",
			"1578"
		],
		ddi: "44"
	},
	{
		countryNamePTBR: "Estados Unidos da América",
		countryName: "United States of America",
		abbreviationAlpha3: "USA",
		abbreviationFips10: "US",
		domain: ".us",
		areaCodeList: [
			"201",
			"202",
			"203",
			"205",
			"206",
			"207",
			"208",
			"209",
			"209",
			"210",
			"212",
			"213",
			"214",
			"215",
			"216",
			"217",
			"218",
			"219",
			"224",
			"225",
			"227",
			"228",
			"229",
			"231",
			"234",
			"239",
			"240",
			"248",
			"251",
			"252",
			"253",
			"254",
			"256",
			"260",
			"262",
			"267",
			"269",
			"270",
			"274",
			"276",
			"278",
			"281",
			"283",
			"301",
			"302",
			"303",
			"304",
			"305",
			"307",
			"308",
			"309",
			"310",
			"312",
			"313",
			"314",
			"315",
			"316",
			"317",
			"318",
			"319",
			"320",
			"321",
			"323",
			"325",
			"330",
			"331",
			"334",
			"336",
			"337",
			"339",
			"341",
			"347",
			"351",
			"352",
			"360",
			"361",
			"364",
			"369",
			"380",
			"385",
			"386",
			"401",
			"402",
			"404",
			"405",
			"406",
			"407",
			"408",
			"409",
			"410",
			"412",
			"413",
			"414",
			"415",
			"417",
			"419",
			"423",
			"424",
			"425",
			"430",
			"432",
			"434",
			"435",
			"440",
			"442",
			"443",
			"445",
			"447",
			"458",
			"464",
			"469",
			"470",
			"475",
			"478",
			"479",
			"480",
			"484",
			"501",
			"502",
			"503",
			"504",
			"505",
			"507",
			"508",
			"509",
			"510",
			"512",
			"513",
			"515",
			"516",
			"517",
			"518",
			"520",
			"530",
			"531",
			"534",
			"540",
			"541",
			"551",
			"557",
			"559",
			"561",
			"562",
			"563",
			"564",
			"567",
			"570",
			"571",
			"573",
			"574",
			"575",
			"580",
			"585",
			"586",
			"601",
			"602",
			"603",
			"605",
			"606",
			"607",
			"608",
			"609",
			"610",
			"612",
			"614",
			"615",
			"616",
			"617",
			"618",
			"619",
			"620",
			"623",
			"626",
			"627",
			"628",
			"630",
			"631",
			"636",
			"641",
			"646",
			"650",
			"651",
			"657",
			"659",
			"660",
			"661",
			"662",
			"667",
			"669",
			"678",
			"679",
			"681",
			"682",
			"689",
			"701",
			"702",
			"703",
			"704",
			"706",
			"707",
			"708",
			"712",
			"713",
			"714",
			"715",
			"716",
			"717",
			"718",
			"719",
			"720",
			"724",
			"727",
			"730",
			"731",
			"732",
			"734",
			"737",
			"740",
			"747",
			"752",
			"754",
			"757",
			"760",
			"762",
			"763",
			"764",
			"765",
			"769",
			"770",
			"772",
			"773",
			"774",
			"775",
			"779",
			"781",
			"785",
			"786",
			"801",
			"802",
			"803",
			"804",
			"805",
			"806",
			"808",
			"810",
			"812",
			"813",
			"814",
			"815",
			"816",
			"817",
			"818",
			"828",
			"830",
			"831",
			"832",
			"835",
			"843",
			"845",
			"847",
			"848",
			"850",
			"856",
			"857",
			"858",
			"859",
			"860",
			"862",
			"863",
			"864",
			"865",
			"870",
			"872",
			"878",
			"901",
			"903",
			"904",
			"906",
			"907",
			"908",
			"909",
			"910",
			"912",
			"913",
			"914",
			"915",
			"916",
			"917",
			"918",
			"919",
			"920",
			"925",
			"927",
			"928",
			"931",
			"935",
			"936",
			"937",
			"938",
			"940",
			"941",
			"947",
			"949",
			"951",
			"952",
			"954",
			"956",
			"957",
			"959",
			"970",
			"971",
			"972",
			"973",
			"975",
			"978",
			"979",
			"980",
			"984",
			"985",
			"989"
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "Ilhas Virgens dos Estados Unidos",
		countryName: "United States Virgin Islands",
		abbreviationAlpha3: "VIR",
		abbreviationFips10: "VQ",
		domain: ".vi",
		areaCodeList: [
		],
		ddi: "1"
	},
	{
		countryNamePTBR: "Uruguai",
		countryName: "Uruguay",
		abbreviationAlpha3: "URY",
		abbreviationFips10: "UY",
		domain: ".uy",
		areaCodeList: [
			"2",
			"32",
			"33",
			"34",
			"36",
			"38",
			"42",
			"43",
			"44",
			"45",
			"47",
			"52",
			"53",
			"55",
			"62",
			"63",
			"64",
			"72",
			"73",
			"311",
			"312",
			"313",
			"315",
			"317",
			"318",
			"319",
			"324",
			"337",
			"338",
			"339",
			"342",
			"345",
			"348",
			"349",
			"352",
			"354",
			"364",
			"365",
			"367",
			"368",
			"369",
			"379",
			"390",
			"399",
			"412",
			"413",
			"415",
			"446",
			"448",
			"449",
			"455",
			"456",
			"457",
			"458",
			"459",
			"463",
			"464",
			"466",
			"469",
			"474",
			"475",
			"476",
			"477",
			"479",
			"486",
			"534",
			"536",
			"537",
			"538",
			"539",
			"542",
			"544",
			"546",
			"552",
			"556",
			"557",
			"562",
			"567",
			"568",
			"569",
			"574",
			"575",
			"576",
			"577",
			"586",
			"587",
			"588",
			"645",
			"654",
			"656",
			"658",
			"664",
			"675",
			"679",
			"688",
			"722",
			"742",
			"747",
			"754",
			"764",
			"766",
			"772",
			"776",
			"777",
			"778",
			"779"
		],
		ddi: "598"
	},
	{
		countryNamePTBR: "Uzbequistão",
		countryName: "Uzbekistan",
		abbreviationAlpha3: "UZB",
		abbreviationFips10: "UZ",
		domain: ".uz",
		areaCodeList: [
			"61",
			"62",
			"65",
			"66",
			"67",
			"71",
			"72",
			"73",
			"74",
			"75",
			"76"
		],
		ddi: "998"
	},
	{
		countryNamePTBR: "Vanuatu",
		countryName: "Vanuatu",
		abbreviationAlpha3: "VUT",
		abbreviationFips10: "NH",
		domain: ".vu",
		areaCodeList: [
			"22",
			"23",
			"24",
			"36",
			"282",
			"383",
			"385",
			"484",
			"686"
		],
		ddi: "678"
	},
	{
		countryNamePTBR: "Cidade do Vaticano",
		countryName: "Vatican City",
		abbreviationAlpha3: "VAT",
		abbreviationFips10: "VT",
		domain: ".va",
		areaCodeList: [
			"06"
		],
		ddi: "379"
	},
	{
		countryNamePTBR: "Venezuela",
		countryName: "Venezuela",
		abbreviationAlpha3: "VEN",
		abbreviationFips10: "VE",
		domain: ".ve",
		areaCodeList: [
			"212",
			"241",
			"242",
			"243",
			"251",
			"261",
			"264",
			"268",
			"274",
			"276",
			"281",
			"285",
			"291",
			"293"
		],
		ddi: "58"
	},
	{
		countryNamePTBR: "Vietnã",
		countryName: "Vietnam",
		abbreviationAlpha3: "VNM",
		abbreviationFips10: "VM",
		domain: ".vn",
		areaCodeList: [
			"4",
			"8",
			"18",
			"19",
			"20",
			"22",
			"23",
			"25",
			"26",
			"27",
			"29",
			"30",
			"31",
			"33",
			"34",
			"36",
			"37",
			"38",
			"39",
			"50",
			"51",
			"52",
			"53",
			"54",
			"55",
			"56",
			"57",
			"58",
			"59",
			"60",
			"61",
			"62",
			"63",
			"64",
			"65",
			"66",
			"67",
			"68",
			"70",
			"71",
			"72",
			"73",
			"74",
			"76",
			"77",
			"78",
			"79",
			"210",
			"211",
			"240",
			"241",
			"280",
			"281",
			"320",
			"321",
			"350",
			"351",
			"510",
			"651",
			"780",
			"781"
		],
		ddi: "84"
	},
	{
		countryNamePTBR: "Iêmen",
		countryName: "Yemen",
		abbreviationAlpha3: "YEM",
		abbreviationFips10: "YM",
		domain: ".ye",
		areaCodeList: [
			"1",
			"2",
			"3",
			"4",
			"5",
			"7"
		],
		ddi: "967"
	},
	{
		countryNamePTBR: "Zâmbia",
		countryName: "Zambia",
		abbreviationAlpha3: "ZMB",
		abbreviationFips10: "ZA",
		domain: ".zm",
		areaCodeList: [
			"1",
			"2"
		],
		ddi: "260"
	},
	{
		countryNamePTBR: "Zimbábue",
		countryName: "Zimbabwe",
		abbreviationAlpha3: "ZWE",
		abbreviationFips10: "ZI",
		domain: ".zw",
		areaCodeList: [
			"4",
			"9",
			"011",
			"20",
			"023",
			"091"
		],
		ddi: "263"
	}
];

/**
 * @returns CountryData[] - returns a list with data from all mapped countries
 */
const countriesDataList = dataJson$3;
/**
 *
 * @param {string | undefined} term - full term or part of the abbreviations by alpha3 format
 * @returns StatesBRDataList[] - returns a list with data from all countries that match the argument
 */
const searchCountryByAbbreviationAlpha3 = (term) => countriesDataList.filter((country) => country.abbreviationAlpha3
    .toLocaleLowerCase()
    .includes(term?.toLocaleLowerCase() ?? ''));

var dataJson$2 = [
	{
		stateName: "Acre",
		abbreviation: "AC",
		areaCodeList: [
			"68"
		],
		capital: "Rio Branco"
	},
	{
		stateName: "Alagoas",
		abbreviation: "AL",
		areaCodeList: [
			"82"
		],
		capital: "Maceió"
	},
	{
		stateName: "Amapá",
		abbreviation: "AP",
		areaCodeList: [
			"96"
		],
		capital: "Macapá"
	},
	{
		stateName: "Amazonas",
		abbreviation: "AM",
		areaCodeList: [
			"92",
			"97"
		],
		capital: "Manaus"
	},
	{
		stateName: "Bahia",
		abbreviation: "BA",
		areaCodeList: [
			"71",
			"73",
			"74",
			"75",
			"77"
		],
		capital: "Salvador"
	},
	{
		stateName: "Ceará",
		abbreviation: "CE",
		areaCodeList: [
			"85",
			"88"
		],
		capital: "Fortaleza"
	},
	{
		stateName: "Distrito Federal",
		abbreviation: "DF",
		areaCodeList: [
			"61"
		],
		capital: "Brasília"
	},
	{
		stateName: "Espírito Santo",
		abbreviation: "ES",
		areaCodeList: [
			"27",
			"28"
		],
		capital: "Vitória"
	},
	{
		stateName: "Goiás",
		abbreviation: "GO",
		areaCodeList: [
			"62",
			"62"
		],
		capital: "Goiânia"
	},
	{
		stateName: "Maranhão",
		abbreviation: "MA",
		areaCodeList: [
			"98",
			"99"
		],
		capital: "São Luís"
	},
	{
		stateName: "Mato Grosso",
		abbreviation: "MT",
		areaCodeList: [
			"65",
			"66"
		],
		capital: "Cuiabá"
	},
	{
		stateName: "Mato Grosso do Sul",
		abbreviation: "MS",
		areaCodeList: [
			"67"
		],
		capital: "Campo Grande"
	},
	{
		stateName: "Minas Gerais",
		abbreviation: "MG",
		areaCodeList: [
			"31",
			"32",
			"33",
			"34",
			"35",
			"37",
			"38"
		],
		capital: "Belo Horizonte"
	},
	{
		stateName: "Pará",
		abbreviation: "PA",
		areaCodeList: [
			"91",
			"93",
			"94"
		],
		capital: "Belém"
	},
	{
		stateName: "Paraíba",
		abbreviation: "PB",
		areaCodeList: [
			"83"
		],
		capital: "João Pessoa"
	},
	{
		stateName: "Paraná",
		abbreviation: "PR",
		areaCodeList: [
			"41",
			"42",
			"43",
			"44",
			"45",
			"46"
		],
		capital: "Curitiba"
	},
	{
		stateName: "Pernambuco",
		abbreviation: "PE",
		areaCodeList: [
			"81",
			"87"
		],
		capital: "Recife"
	},
	{
		stateName: "Piauí",
		abbreviation: "PI",
		areaCodeList: [
			"86",
			"89"
		],
		capital: "Teresina"
	},
	{
		stateName: "Rio de Janeiro",
		abbreviation: "RJ",
		areaCodeList: [
			"21",
			"22",
			"24"
		],
		capital: "Rio de Janeiro"
	},
	{
		stateName: "Rio Grande do Norte",
		abbreviation: "RN",
		areaCodeList: [
			"84"
		],
		capital: "Natal"
	},
	{
		stateName: "Rio Grande do Sul",
		abbreviation: "RS",
		areaCodeList: [
			"51",
			"53",
			"54",
			"55"
		],
		capital: "Porto Alegre"
	},
	{
		stateName: "Rondônia",
		abbreviation: "RO",
		areaCodeList: [
			"69"
		],
		capital: "Porto Velho"
	},
	{
		stateName: "Roraima",
		abbreviation: "RR",
		areaCodeList: [
			"95"
		],
		capital: "Boa vista"
	},
	{
		stateName: "Santa Catarina",
		abbreviation: "SC",
		areaCodeList: [
			"47",
			"48",
			"49"
		],
		capital: "Florianópolis"
	},
	{
		stateName: "São Paulo",
		abbreviation: "SP",
		areaCodeList: [
			"11",
			"12",
			"13",
			"14",
			"15",
			"16",
			"17",
			"18",
			"19"
		],
		capital: "São Paulo"
	},
	{
		stateName: "Sergipe",
		abbreviation: "SE",
		areaCodeList: [
			"79"
		],
		capital: "Aracajú"
	},
	{
		stateName: "Tocantins",
		abbreviation: "TO",
		areaCodeList: [
			"63"
		],
		capital: "Palmas"
	}
];

/**
 * @returns StatesBRDataList[] - returns a list with data from all states in Brazil
 */
const mapState = dataJson$2;
/**
 *
 * @param {string | undefined} term - full term or part of the abbreviations of the states of Brazil
 * @returns StatesBRDataList[] - returns a list with data from all states that match the argument
 */
const searchCitiesByStateAbbreviation = (term) => mapState.filter((state) => state.abbreviation
    .toLocaleLowerCase()
    .includes(term?.toLocaleLowerCase() ?? ''));
/**
 *
 * @param {string | undefined} term - full term or part of the state name
 * @returns StatesBRDataList[] - returns a list with data from all states that match the argument
 */
const searchStateByName = (term) => mapState.filter((state) => state.stateName
    .toLocaleLowerCase()
    .includes(term?.toLocaleLowerCase() ?? ''));

/**
 *
 * @param value
 * @returns number | null
 *
 * @summary
 * is a simple checksum formula used to validate a variety of identification numbers
 * The check digit is calculated as follows:

 * If the number already contains the check digit, drop that digit to form the "payload". The check digit is usually the last digit.
 * With the payload, start with the rightmost digit. Moving left, double the value of every second digit (including the rightmost digit).
 * Add the resulting digit values together.
 *
 * References:
 * @see https://en.wikipedia.org/wiki/Luhn_algorithm
 *
 */
const luhnAlgorithm = (value) => {
    if (!value.length || (Array.isArray(value) && value.every((item) => !item)))
        return null;
    if (typeof value === 'string')
        value = value.split('');
    value = value
        .map((item) => item.toString().replace(/\D/g, ''))
        .filter(Boolean)
        .reverse();
    if (value.every((item) => !item))
        return null;
    const result = value.reduce(callbackReducerLunhAlgorithm, 0);
    return +result;
};
const callbackReducerLunhAlgorithm = (accumulator, currentValue, currentIndex) => {
    if (currentIndex % 2 !== 0) {
        return Number(accumulator) + Number(currentValue);
    }
    const multiplyBy2 = Number(currentValue) * 2;
    const sum = multiplyBy2 > 9 ? (multiplyBy2 % 10) + 1 : multiplyBy2;
    return Number(accumulator) + sum;
};

/**
 * @param {Object} LunhMod10Algorithm
 * @property digits
 * @property reverseNumbers - When you need to reverse the numbers due to algorithm adaptations
 * @property onlyValidCheckDigit - It just checks the check digit with the result of the Lunh algorithm
 * @returns number | null
 *
 */
const lunhMod10Algorithm = ({ digits, onlyValidCheckDigit = false, reverseNumbers = false, }) => {
    const originalValue = digits;
    const checkDigit = digits.charAt(digits.length - 1);
    digits = digits.substring(0, digits.length - 1);
    if (reverseNumbers)
        digits = digits.split('').reverse().join('');
    const result = luhnAlgorithm(digits);
    if (!result)
        return false;
    let validateCheckDigit = 10 - (result % 10);
    if (onlyValidCheckDigit)
        return validateCheckDigit.toString() === checkDigit;
    validateCheckDigit = validateCheckDigit === 10 ? 0 : validateCheckDigit;
    if (checkDigit !== validateCheckDigit.toString())
        return false;
    const validateMod10 = luhnAlgorithm(reverseNumbers ? originalValue.split('').reverse().join('') : originalValue);
    return Boolean(validateMod10 && validateMod10 % 10 === 0);
};

/**
 * @param {Object} LunhMod11Algorithm
 * @property digits
 * @property reverseNumbers - When you need to reverse the numbers due to algorithm adaptations
 * @returns number | null
 *
 * @summary
   The DAC (Self-Conference Digit) modulo 11, from a number is calculated
    multiplying each digit by the sequence of multipliers 2,3,4,5,6,7,8,9,2,3,4....
    from right to left.

    The sum of the products of this multiplication is divided by 11, you get the remainder of the division,
    this remainder must be subtracted from 11, the product of the subtraction is the DAC.

    Reference:
    @see https://cmsarquivos.febraban.org.br/Arquivos/documentos/PDF/Layout%20-%20C%C3%B3digo%20de%20Barras%20-%20Vers%C3%A3o%207%20-%2001_03_2023_mn.pdf
 */
const lunhMod11Algorithm = ({ digits, reverseNumbers = true, }) => {
    if (!digits.length ||
        (Array.isArray(digits) && digits.every((item) => !item)))
        return null;
    if (typeof digits === 'string')
        digits = digits.split('');
    digits = digits
        .map((item) => item.toString().replace(/\D/g, ''))
        .filter(Boolean);
    if (reverseNumbers)
        digits = digits.reverse();
    if (digits.every((item) => !item))
        return null;
    const result = reducerCheckDigitControl(digits.join(''));
    return 11 - (Number(result) % 11);
};

var discover = {
	innPattern: [
		65,
		6011,
		644,
		645,
		646,
		647,
		648,
		649
	],
	lengthsNumber: [
		16,
		19
	],
	brandCardType: "discover",
	nameBrandCard: "Discover"
};
var elo = {
	innPattern: [
		401178,
		401179,
		438935,
		457631,
		457632,
		431274,
		451416,
		457393,
		504175,
		506699,
		[
			506700,
			506778
		],
		[
			509000,
			509999
		],
		627780,
		636297,
		636368,
		[
			650031,
			650033
		],
		[
			650035,
			650051
		],
		[
			650405,
			650439
		],
		[
			650485,
			650538
		],
		[
			650541,
			650598
		],
		[
			650700,
			650718
		],
		[
			650720,
			650727
		],
		[
			650901,
			650978
		],
		[
			651652,
			651679
		],
		[
			655000,
			655019
		],
		[
			655021,
			655058
		]
	],
	lengthsNumber: [
		16
	],
	brandCardType: "elo",
	nameBrandCard: "Elo"
};
var hiper = {
	innPattern: [
		37095,
		63737423,
		63743358,
		637568,
		637599,
		637609,
		637612
	],
	lengthsNumber: [
		16
	],
	brandCardType: "hiper",
	nameBrandCard: "Hiper"
};
var hipercard = {
	innPattern: [
		606282
	],
	lengthsNumber: [
		16
	],
	brandCardType: "hipercard",
	nameBrandCard: "Hipercard"
};
var jcb = {
	innPattern: [
		2131,
		1800,
		[
			3528,
			3589
		]
	],
	lengthsNumber: [
		16,
		17,
		18,
		19
	],
	brandCardType: "jcb",
	nameBrandCard: "JCB"
};
var maestro = {
	innPattern: [
		6,
		[
			56,
			59
		],
		63,
		67,
		493698,
		[
			500000,
			504174
		],
		[
			504176,
			506698
		],
		[
			506779,
			508999
		]
	],
	lengthsNumber: [
		16,
		17,
		18,
		19
	],
	brandCardType: "maestro",
	nameBrandCard: "Maestro"
};
var mastercard = {
	innPattern: [
		[
			51,
			55
		],
		[
			23,
			26
		],
		[
			223,
			229
		],
		[
			270,
			271
		],
		[
			2221,
			2229
		],
		2720
	],
	lengthsNumber: [
		16
	],
	brandCardType: "mastercard",
	nameBrandCard: "Mastercard"
};
var mir = {
	innPattern: [
		[
			2200,
			2204
		]
	],
	lengthsNumber: [
		16,
		17,
		18,
		19
	],
	brandCardType: "mir",
	nameBrandCard: "Mir"
};
var unionpay = {
	innPattern: [
		620,
		810,
		[
			623,
			626
		],
		6270,
		6272,
		6276,
		[
			6282,
			6289
		],
		6291,
		6292,
		[
			8110,
			8131
		],
		[
			8132,
			8151
		],
		[
			8152,
			8163
		],
		[
			8164,
			8171
		],
		[
			62100,
			62182
		],
		[
			62184,
			62187
		],
		[
			62185,
			62197
		],
		[
			62200,
			62205
		],
		[
			62207,
			62209
		],
		[
			622010,
			622999
		],
		622018,
		[
			627700,
			627779
		],
		[
			627781,
			627799
		]
	],
	lengthsNumber: [
		14,
		15,
		16,
		17,
		18,
		19
	],
	brandCardType: "unionpay",
	nameBrandCard: "UnionPay"
};
var visa = {
	innPattern: [
		4
	],
	lengthsNumber: [
		13,
		16,
		19
	],
	brandCardType: "visa",
	nameBrandCard: "Visa"
};
var dataJson$1 = {
	"american-express": {
	innPattern: [
		34,
		37
	],
	lengthsNumber: [
		15
	],
	brandCardType: "american-express",
	nameBrandCard: "American Express"
},
	"diners-club": {
	innPattern: [
		30,
		36,
		38,
		39
	],
	lengthsNumber: [
		14,
		16,
		19
	],
	brandCardType: "diners-club",
	nameBrandCard: "Diners Club"
},
	discover: discover,
	elo: elo,
	hiper: hiper,
	hipercard: hipercard,
	jcb: jcb,
	maestro: maestro,
	mastercard: mastercard,
	mir: mir,
	unionpay: unionpay,
	visa: visa,
	"visa-electron": {
	innPattern: [
		4026,
		4508,
		4844,
		4913,
		4917,
		417500
	],
	lengthsNumber: [
		16
	],
	brandCardType: "visa-electron",
	nameBrandCard: "Visa Electron"
}
};

/**
 * @returns MapBankData - returns a mapped list with the data of the mapped credit companies.
 *
 * @summary
 * - References:
    The 13 main payment card brands were cataloged and their identifiers extracted
    If you find inconsistency in any data referenting of payments cards,
    please contact caio.cezar.dequeiroz@gmail.com or submit a PR.
 * @see https://en.wikipedia.org/wiki/Payment_card_number#Issuer_identification_number_.28IIN.29
 */
const mapPaymentCardList = dataJson$1;

var M10 = "Banco Moneo S.A.";
var M11 = "Banco IBM S.A.";
var M20 = "Banco Toyota do Brasil S.A.";
var M21 = "Banco Daimlerchrysler S.A.";
var M03 = "Banco Fiat S.A.";
var M12 = "Banco Maxinvest S.A.";
var M22 = "Banco Honda S.A.";
var M13 = "Banco Tricury S.A.";
var M14 = "Banco Volkswagen S.A.";
var M23 = "Banco Volvo (Brasil) S.A.";
var M15 = "Banco BRJ S.A.";
var M06 = "Banco de Lage Landen Brasil S.A.";
var M24 = "Banco PSA Finance Brasil S.A.";
var M07 = "Banco GMAC S.A.";
var M16 = "Banco Rodobens S.A.";
var M08 = "Banco Citicard S.A.";
var M17 = "Banco Ourinvest S.A.";
var M18 = "Banco Ford S.A.";
var M09 = "Banco Itaucred Financiamentos S.A.";
var M19 = "Banco CNH Capital S.A.";
var dataJson = {
	"104": "Caixa Econômica Federal",
	"107": "Banco BBM S.A.",
	"113": "Magliano S.A. Corretora de Câmbio e Valores Mobiliários",
	"168": "HSBC Finance (Brasil) S.A. – Banco Múltiplo",
	"184": "Banco Itaú BBA S.A.",
	"204": "Banco Bradesco Cartões S.A.",
	"208": "Banco BTG Pactual S.A.",
	"212": "Banco Matone S.A.",
	"213": "Banco Arbi S.A.",
	"214": "Banco Dibens S.A.",
	"215": "Banco Comercial e de Investimento Sudameris S.A.",
	"217": "Banco John Deere S.A.",
	"218": "Banco Bonsucesso S.A.",
	"222": "Banco Credit Agricole Brasil S.A.",
	"224": "Banco Fibra S.A.",
	"225": "Banco Brascan S.A.",
	"229": "Banco Cruzeiro do Sul S.A.",
	"230": "Unicard Banco Múltiplo S.A.",
	"233": "Banco GE Capital S.A.",
	"237": "Banco Bradesco S.A.",
	"241": "Banco Clássico S.A.",
	"243": "Banco Máxima S.A.",
	"246": "Banco ABC Brasil S.A.",
	"248": "Banco Boavista Interatlântico S.A.",
	"249": "Banco Investcred Unibanco S.A.",
	"250": "Banco Schahin S.A.",
	"254": "Paraná Banco S.A.",
	"260": "Nu Pagamentos S.A (Nubank)",
	"263": "Banco Cacique S.A.",
	"265": "Banco Fator S.A.",
	"266": "Banco Cédula S.A.",
	"300": "Banco de La Nación Argentina",
	"318": "Banco BMG S.A.",
	"320": "Banco Industrial e Comercial S.A.",
	"341": "Itaú Unibanco S.A.",
	"356": "Banco Real S.A.",
	"366": "Banco Société Générale Brasil S.A.",
	"370": "Banco WestLB do Brasil S.A.",
	"376": "Banco J. P. Morgan S.A.",
	"389": "Banco Mercantil do Brasil S.A.",
	"394": "Banco Bradesco Financiamentos S.A.",
	"399": "HSBC Bank Brasil S.A. – Banco Múltiplo",
	"409": "Unibanco – União de Bancos Brasileiros S.A.",
	"412": "Banco Capital S.A.",
	"422": "Banco Safra S.A.",
	"453": "Banco Rural S.A.",
	"456": "Banco de Tokyo-Mitsubishi UFJ Brasil S.A.",
	"464": "Banco Sumitomo Mitsui Brasileiro S.A.",
	"473": "Banco Caixa Geral – Brasil S.A.",
	"477": "Citibank N.A.",
	"479": "Banco ItaúBank S.A.",
	"487": "Deutsche Bank S.A. – Banco Alemão",
	"488": "JPMorgan Chase Bank",
	"492": "ING Bank N.V.",
	"494": "Banco de La República Oriental del Uruguay",
	"495": "Banco de La Provincia de Buenos Aires",
	"505": "Banco Credit Suisse (Brasil) S.A.",
	"600": "Banco Luso Brasileiro S.A.",
	"604": "Banco Industrial do Brasil S.A.",
	"610": "Banco VR S.A.",
	"611": "Banco Paulista S.A.",
	"612": "Banco Guanabara S.A.",
	"613": "Banco Pecúnia S.A.",
	"623": "Banco Panamericano S.A.",
	"626": "Banco Ficsa S.A.",
	"630": "Banco Intercap S.A.",
	"633": "Banco Rendimento S.A.",
	"634": "Banco Triângulo S.A.",
	"637": "Banco Sofisa S.A.",
	"638": "Banco Prosper S.A.",
	"641": "Banco Alvorada S.A.",
	"643": "Banco Pine S.A.",
	"652": "Itaú Unibanco Holding S.A.",
	"653": "Banco Indusval S.A.",
	"654": "Banco A. J. Renner S.A.",
	"655": "Banco Votorantim S.A.",
	"707": "Banco Daycoval S.A.",
	"719": "Banif – Banco Internacional do Funchal (Brasil) S.A.",
	"721": "Banco Credibel S.A.",
	"724": "Banco Porto Seguro S.A.",
	"734": "Banco Gerdau S.A.",
	"735": "Banco Pottencial S.A.",
	"738": "Banco Morada S.A.",
	"739": "Banco BGN S.A.",
	"740": "Banco Barclays S.A.",
	"741": "Banco Ribeirão Preto S.A.",
	"743": "Banco Semear S.A.",
	"744": "BankBoston N.A.",
	"745": "Banco Citibank S.A.",
	"746": "Banco Modal S.A.",
	"747": "Banco Rabobank International Brasil S.A.",
	"748": "Banco Cooperativo Sicredi S.A.",
	"749": "Banco Simples S.A.",
	"751": "Dresdner Bank Brasil S.A. – Banco Múltiplo",
	"752": "Banco BNP Paribas Brasil S.A.",
	"753": "NBC Bank Brasil S.A. – Banco Múltiplo",
	"755": "Bank of America Merrill Lynch Banco Múltiplo S.A.",
	"756": "Banco Cooperativo do Brasil S.A. (Bancoob)",
	"757": "Banco KEB do Brasil S.A.",
	"000": "Banco Bankpar S.A.",
	"001": "Banco do Brasil S.A.",
	"003": "Banco da Amazônia S.A. (Basa)",
	"004": "Banco do Nordeste do Brasil S.A. (BNB)",
	"012": "Banco Standard de Investimentos S.A.",
	"014": "Natixis Brasil S.A. Banco Múltiplo",
	"019": "Banco Azteca do Brasil S.A.",
	"021": "Banestes S.A. Banco do Estado do Espírito Santo",
	"024": "Banco de Pernambuco S.A. (Bandepe)",
	"025": "Banco Alfa S.A.",
	"029": "Banco Banerj S.A.",
	"031": "Banco Beg S.A.",
	"033": "Banco Santander (Brasil) S.A.",
	"036": "Banco Bradesco BBI S.A.",
	"037": "Banco do Estado do Pará S.A. (Banpará)",
	"039": "Banco do Estado do Piauí S.A. – BEP",
	"040": "Banco Cargill S.A.",
	"041": "Banco do Estado do Rio Grande do Sul S.A. (Banrisul)",
	"044": "Banco BVA S.A.",
	"045": "Banco Opportunity S.A.",
	"047": "Banco do Estado de Sergipe S.A. (Banese)",
	"062": "Hipercard Banco Múltiplo S.A.",
	"063": "Banco Ibi S.A. Banco Múltiplo",
	"064": "Goldman Sachs do Brasil Banco Múltiplo S.A.",
	"065": "Banco Bracce S.A.",
	"066": "Banco Morgan Stanley S.A.",
	"069": "BPN Brasil Banco Múltiplo S.A.",
	"070": "BRB – Banco de Brasília S.A.",
	"072": "Banco Rural Mais S.A.",
	"073": "BB Banco Popular do Brasil S.A.",
	"074": "Banco J. Safra S.A.",
	"075": "Banco CR2 S.A.",
	"076": "Banco KDB S.A.",
	"077": "Banco Intermedium S.A. (Inter)",
	"078": "BES Investimento do Brasil S.A. – Banco de Investimento",
	"079": "JBS Banco S.A.",
	"081": "Concórdia Banco S.A.",
	"082": "Banco Topázio S.A.",
	"083": "Banco da China Brasil S.A.",
	"084": "Unicred Norte do Paraná",
	"085": "Cooperativa Central de Crédito Urbano-CECRED",
	"086": "OBOE Crédito Financiamento e Investimento S.A.",
	"087": "Cooperativa Unicred Central Santa Catarina",
	"088": "Banco Randon S.A.",
	"089": "Cooperativa de Crédito Rural da Região de Mogiana",
	"090": "Cooperativa Central de Economia e Crédito Mutuo das Unicreds",
	"091": "Unicred Central do Rio Grande do Sul",
	"092": "Brickell S.A. Crédito, financiamento e Investimento",
	"094": "Banco Petra S.A.",
	"096": "Banco BM&amp;F de Serviços de Liquidação e Custódia S.A",
	"097": "Cooperativa Central de Crédito Noroeste Brasileiro Ltda.",
	"098": "Credicorol Cooperativa de Crédito Rural",
	"099": "Cooperativa Central de Economia e Crédito Mutuo das Unicreds",
	M10: M10,
	M11: M11,
	M20: M20,
	M21: M21,
	M03: M03,
	M12: M12,
	M22: M22,
	M13: M13,
	M14: M14,
	M23: M23,
	M15: M15,
	M06: M06,
	M24: M24,
	M07: M07,
	M16: M16,
	M08: M08,
	M17: M17,
	M18: M18,
	M09: M09,
	M19: M19
};

/**
 * @returns MapBankData - returns a mapped list with the code and name of the Banks operating in Brazil
 *
 * References:
    @see https://blog.vhsys.com.br/numero-do-banco/
    @see https://portal.febraban.org.br/
 */
const mapBankData = dataJson;
/**
 * @param {BankCode} key - bank code
 * @returns MapBankData - returns the name of the bank by its code
 */
const filterBankByCode = (key) => {
    return mapBankData[key];
};
/**
 * @param {BankCode} name - bank name
 * @returns MapBankData - returns the code of the bank by its name
 */
const filterBankByName = (name) => {
    return Object.keys(mapBankData).find((key) => mapBankData[key] === name);
};

const utils = {
    mapCitiesByState,
    searchCitiesByIBGECode,
    searchCitiesByTerm,
    getCitiesListByState,
    countriesDataList,
    searchCountryByAbbreviationAlpha3,
    mapState,
    searchCitiesByStateAbbreviation,
    searchStateByName,
    luhnAlgorithm,
    lunhMod10Algorithm,
    lunhMod11Algorithm,
    mapPaymentCardList,
    mapBankData,
    filterBankByCode,
    filterBankByName,
    reducerCheckDigitControl,
};

const stateRegistrationAcre = (digits) => {
    const regexFormatStateRegistrationAcre = new RegExp(/^01[0-9]{11}$/);
    if (!regexFormatStateRegistrationAcre.test(digits))
        return false;
    const checkDigits = digits.slice(11, digits.length).split('');
    let validationByModule11ForFirstDigit = utils.lunhMod11Algorithm({
        digits: digits.slice(0, digits.length - 2),
    });
    if (validationByModule11ForFirstDigit === 10 ||
        validationByModule11ForFirstDigit === 11)
        validationByModule11ForFirstDigit = 0;
    if (validationByModule11ForFirstDigit &&
        validationByModule11ForFirstDigit.toString() !== checkDigits[0])
        return false;
    let validationByModule11ForSecondDigit = utils.lunhMod11Algorithm({
        digits: digits.slice(0, digits.length - 1),
    });
    if (validationByModule11ForSecondDigit === 10 ||
        validationByModule11ForSecondDigit === 11)
        validationByModule11ForSecondDigit = 0;
    if (validationByModule11ForSecondDigit &&
        validationByModule11ForSecondDigit.toString() !== checkDigits[1])
        return false;
    return true;
};

const validationWithOneCheckDigitAndMod11 = ({ digits, regexFormat, }) => {
    if (!regexFormat.test(digits))
        return false;
    const getInitialPositionCheckDigits = digits.length - 1;
    const checkDigits = digits
        .slice(getInitialPositionCheckDigits, digits.length)
        .split('');
    const baseDigits = digits.slice(0, getInitialPositionCheckDigits);
    let validationByModule11 = utils.lunhMod11Algorithm({
        digits: baseDigits,
        reverseNumbers: true,
    });
    if (validationByModule11 === 10 || validationByModule11 === 11)
        validationByModule11 = 0;
    if (validationByModule11 &&
        validationByModule11.toString() !== checkDigits[0])
        return false;
    return true;
};

const stateRegistrationAlagoas = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^24[0-9]{7}$/),
    });
};

const stateRegistrationAmazonas = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^[0-9]{9}$/),
    });
};

const stateRegistrationAmapa = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^03[0-9]{7}$/),
    });
};

const mod10AlgorithmAdapter = ({ digits, reverseNumbers, }) => {
    if (!digits.length ||
        (Array.isArray(digits) && digits.every((item) => !item)))
        return null;
    if (typeof digits === 'string')
        digits = digits.split('');
    digits = digits
        .map((item) => item.toString().replace(/\D/g, ''))
        .filter(Boolean);
    if (reverseNumbers)
        digits = digits.reverse();
    if (digits.every((item) => !item))
        return null;
    const result = utils.reducerCheckDigitControl(digits.join(''));
    const restMod10 = result % 10;
    if (restMod10 === 0 || restMod10 === 10)
        return 0;
    else
        return 10 - restMod10;
};

const calculateWithMod10 = (digits) => {
    const getInitialPositionCheckDigits = digits.length - 2;
    const checkDigits = digits
        .slice(getInitialPositionCheckDigits, digits.length)
        .split('');
    const baseDigits = digits.slice(0, getInitialPositionCheckDigits);
    const validationByMod10ForSecondDigits = mod10AlgorithmAdapter({
        digits: baseDigits,
        reverseNumbers: true,
    });
    if (validationByMod10ForSecondDigits === null)
        return false;
    const secondCheckDigit = validationByMod10ForSecondDigits.toString();
    if (secondCheckDigit !== checkDigits[1])
        return false;
    const validationByMod10ForFirstDigits = mod10AlgorithmAdapter({
        digits: baseDigits + secondCheckDigit,
        reverseNumbers: true,
    });
    if (validationByMod10ForFirstDigits === null)
        return false;
    const firstCheckDigit = validationByMod10ForFirstDigits.toString();
    if (firstCheckDigit !== checkDigits[0])
        return false;
    return true;
};

const stateRegistrationBahia = (digits) => {
    const regexFormatStateRegistrationBahia = new RegExp(/^[0-9]{8,9}$/);
    if (!regexFormatStateRegistrationBahia.test(digits))
        return false;
    return calculateWithMod10(digits);
};

const stateRegistrationCeara = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^[0-9]{9}$/),
    });
};

const stateRegistrationDistritoFederal = (digits) => {
    const regexFormatStateRegistrationDistritoFederal = new RegExp(/^07[0-9]{6}00(1|2|3)[0-9]{2}$/);
    if (!regexFormatStateRegistrationDistritoFederal.test(digits))
        return false;
    const checkDigits = digits.slice(11, digits.length).split('');
    const baseDigits = digits.slice(0, digits.length - 2);
    const validationByMod11ForFirstDigits = utils.lunhMod11Algorithm({
        digits: baseDigits,
        reverseNumbers: true,
    });
    if (validationByMod11ForFirstDigits === null)
        return false;
    let firstCheckDigit;
    if (validationByMod11ForFirstDigits === 10 ||
        validationByMod11ForFirstDigits === 11)
        firstCheckDigit = '0';
    else
        firstCheckDigit = validationByMod11ForFirstDigits.toString();
    if (firstCheckDigit !== checkDigits[0])
        return false;
    const validationByMod11ForSecondDigits = utils.lunhMod11Algorithm({
        digits: baseDigits + firstCheckDigit,
        reverseNumbers: true,
    });
    if (validationByMod11ForSecondDigits === null)
        return false;
    let secondCheckDigit;
    if (validationByMod11ForSecondDigits === 10 ||
        validationByMod11ForFirstDigits === 11)
        secondCheckDigit = '0';
    else
        secondCheckDigit = validationByMod11ForSecondDigits.toString();
    if (secondCheckDigit !== checkDigits[1])
        return false;
    return true;
};

const stateRegistrationEspiritoSanto = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^[0-9]{9}$/),
    });
};

const stateRegistrationGoias = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^(10|11|20|29)[0-9]{7}$/),
    });
};

const stateRegistrationMaranhao = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^12[0-9]{7}$/),
    });
};

const findNextTen = (value) => Math.ceil(value / 10) * 10;

const mod11AlgorithmAdapter$3 = ({ digits }) => {
    let multiplier = 2;
    const reducerByModule11 = digits.reduce((accumulator, currenValue) => {
        const result = Number(currenValue) * multiplier;
        multiplier = multiplier === 11 ? 2 : ++multiplier;
        return Number(accumulator) + result;
    }, 0);
    return 11 - (reducerByModule11 % 11);
};

const stateRegistrationMinasGerais = (digits) => {
    const regexFormatStateRegistrationMinasGerais = new RegExp(/^[0-9]{13}$/);
    if (!regexFormatStateRegistrationMinasGerais.test(digits))
        return false;
    const checkDigits = digits.slice(11, digits.length).split('');
    const digitsForCalcFirstCheckDigit = digits
        .slice(0, digits.length - 2)
        .split('');
    digitsForCalcFirstCheckDigit.splice(3, 0, '0');
    const reduceLunhAlgorithm = utils.luhnAlgorithm(digitsForCalcFirstCheckDigit);
    if (reduceLunhAlgorithm === null)
        return false;
    const firstCheckDigit = findNextTen(reduceLunhAlgorithm) - reduceLunhAlgorithm;
    if (firstCheckDigit.toString() !== checkDigits[0])
        return false;
    const digitsForCalcSecondCheckDigit = digits
        .slice(0, digits.length - 1)
        .split('')
        .reverse();
    let validationByModule11 = mod11AlgorithmAdapter$3({
        digits: digitsForCalcSecondCheckDigit,
    });
    if (validationByModule11 === 10 || validationByModule11 === 11)
        validationByModule11 = 0;
    if (validationByModule11 &&
        validationByModule11.toString() !== checkDigits[1])
        return false;
    return true;
};

const stateRegistrationMatoGrossoDoSul = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^28[0-9]{7}$/),
    });
};

const stateRegistrationMatoGrosso = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^[0-9]{11}$/),
    });
};

const stateRegistrationPara = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^15[0-9]{7}$/),
    });
};

const stateRegistrationParaiba = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^[0-9]{9}$/),
    });
};

const stateRegistrationPernambuco = (digits) => {
    const regexFormatStateRegistrationPernambuco = new RegExp(/^[0-9]{9}$/);
    if (!regexFormatStateRegistrationPernambuco.test(digits))
        return false;
    const checkDigits = digits.slice(7, digits.length).split('');
    let validationByModule11ForFirstDigit = utils.lunhMod11Algorithm({
        digits: digits.slice(0, digits.length - 2),
    });
    if (validationByModule11ForFirstDigit === 10 ||
        validationByModule11ForFirstDigit === 11)
        validationByModule11ForFirstDigit = 0;
    if (validationByModule11ForFirstDigit &&
        validationByModule11ForFirstDigit.toString() !== checkDigits[0])
        return false;
    let validationByModule11ForSecondDigit = utils.lunhMod11Algorithm({
        digits: digits.slice(0, digits.length - 1),
    });
    if (validationByModule11ForSecondDigit === 10 ||
        validationByModule11ForSecondDigit === 11)
        validationByModule11ForSecondDigit = 0;
    if (validationByModule11ForSecondDigit &&
        validationByModule11ForSecondDigit.toString() !== checkDigits[1])
        return false;
    return true;
};

const stateRegistrationPiaui = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^[0-9]{9}$/),
    });
};

const mod11AlgorithmAdapter$2 = ({ digits }) => {
    let multiplier = 2;
    const reducerByModule11 = digits.reduce((accumulator, currenValue) => {
        const result = Number(currenValue) * multiplier;
        multiplier = multiplier === 7 ? 2 : ++multiplier;
        return Number(accumulator) + result;
    }, 0);
    return 11 - (reducerByModule11 % 11);
};

const stateRegistrationParana = (digits) => {
    const regexFormatStateRegistrationParana = new RegExp(/^[0-9]{10}$/);
    if (!regexFormatStateRegistrationParana.test(digits))
        return false;
    const getInitialPositionCheckDigits = digits.length - 2;
    const checkDigits = digits
        .slice(getInitialPositionCheckDigits, digits.length)
        .split('');
    const baseDigits = digits
        .slice(0, getInitialPositionCheckDigits)
        .split('')
        .reverse();
    let validationByModule11AdapterForFirstDigit = mod11AlgorithmAdapter$2({
        digits: baseDigits,
    });
    if (validationByModule11AdapterForFirstDigit === 10 ||
        validationByModule11AdapterForFirstDigit === 11)
        validationByModule11AdapterForFirstDigit = 0;
    if (validationByModule11AdapterForFirstDigit &&
        validationByModule11AdapterForFirstDigit.toString() !== checkDigits[0])
        return false;
    baseDigits.unshift(checkDigits[0]);
    let validationByModule11ForSecondDigit = mod11AlgorithmAdapter$2({
        digits: baseDigits,
    });
    if (validationByModule11ForSecondDigit === 10 ||
        validationByModule11ForSecondDigit === 11)
        validationByModule11ForSecondDigit = 0;
    if (validationByModule11ForSecondDigit &&
        validationByModule11ForSecondDigit.toString() !== checkDigits[1])
        return false;
    return true;
};

const stateRegistrationRioDeJaneiro = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^[0-9]{8}$/),
    });
};

const stateRegistrationRioGrandeDoNorte = (digits) => {
    const regexFormatStateRegistrationRioGrandeDoNorte = new RegExp(/^20[0-9]{7,8}$/);
    if (!regexFormatStateRegistrationRioGrandeDoNorte.test(digits))
        return false;
    const getInitialPositionCheckDigits = digits.length - 1;
    const checkDigits = digits
        .slice(getInitialPositionCheckDigits, digits.length)
        .split('');
    const baseDigits = digits
        .slice(0, getInitialPositionCheckDigits)
        .split('')
        .reverse();
    let multiplier = 2;
    const reducerByModule11 = baseDigits.reduce((accumulator, currenValue) => {
        const result = Number(currenValue) * multiplier;
        multiplier = ++multiplier;
        return Number(accumulator) + result;
    }, 0);
    let validationByModule11 = 11 - (reducerByModule11 % 11);
    if (validationByModule11 === 10 || validationByModule11 === 11)
        validationByModule11 = 0;
    if (validationByModule11 &&
        validationByModule11.toString() !== checkDigits[0])
        return false;
    return true;
};

const stateRegistrationRondonia = (digits) => {
    const regexFormatStateRegistrationRondonia = new RegExp(/^[0-9]{9,14}$/);
    if (!regexFormatStateRegistrationRondonia.test(digits))
        return false;
    const baseDigits = digits.length === 9 ? digits.slice(3, digits.length) : digits;
    return validationWithOneCheckDigitAndMod11({
        digits: baseDigits,
        regexFormat: new RegExp(/./),
    });
};

const stateRegistrationRoraima = (digits) => {
    const regexFormatStateRegistrationRoraima = new RegExp(/^24[0-9]{7}$/);
    if (!regexFormatStateRegistrationRoraima.test(digits))
        return false;
    const getInitialPositionCheckDigits = digits.length - 1;
    const checkDigits = digits
        .slice(getInitialPositionCheckDigits, digits.length)
        .split('');
    const baseDigits = digits.slice(0, getInitialPositionCheckDigits).split('');
    let multiplier = 1;
    const reducerByModule11 = baseDigits.reduce((accumulator, currenValue) => {
        const result = Number(currenValue) * multiplier;
        multiplier = ++multiplier;
        return Number(accumulator) + result;
    }, 0);
    let validationByModule11 = reducerByModule11 % 9;
    if (validationByModule11 === 10 || validationByModule11 === 11)
        validationByModule11 = 0;
    if (validationByModule11 &&
        validationByModule11.toString() !== checkDigits[0])
        return false;
    return true;
};

const stateRegistrationRioGrandeDoSul = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^[0-9]{10}$/),
    });
};

const stateRegistrationSantaCatarina = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^[0-9]{9}$/),
    });
};

const stateRegistrationSergipe = (digits) => {
    return validationWithOneCheckDigitAndMod11({
        digits,
        regexFormat: new RegExp(/^[0-9]{9}$/),
    });
};

const mod11AlgorithmAdapter$1 = ({ digits, validationRuralStateRegistration, }) => {
    if (validationRuralStateRegistration) {
        let multiplier = 2;
        const reducerByModule11 = digits.reduce((accumulator, currenValue) => {
            const result = Number(currenValue) * multiplier;
            multiplier = multiplier === 10 ? 2 : ++multiplier;
            return Number(accumulator) + result;
        }, 0);
        return reducerByModule11 % 11;
    }
    else {
        let multiplier = 1;
        const reducerByModule11 = digits.reduce((accumulator, currenValue) => {
            multiplier =
                multiplier === 2 || multiplier === 9 ? ++multiplier : multiplier;
            const result = Number(currenValue) * multiplier;
            multiplier = multiplier === 10 ? 1 : ++multiplier;
            return Number(accumulator) + result;
        }, 0);
        return reducerByModule11 % 11;
    }
};

const generalValidationStateRegistration = ({ digits, checkDigits, }) => {
    let validationByModule11AdapterForFirstDigit = mod11AlgorithmAdapter$1({
        digits: digits.slice(0, 8).split(''),
        validationRuralStateRegistration: false,
    });
    if (validationByModule11AdapterForFirstDigit === 10 ||
        validationByModule11AdapterForFirstDigit === 11)
        validationByModule11AdapterForFirstDigit = 0;
    if (validationByModule11AdapterForFirstDigit.toString() !== checkDigits[0])
        return false;
    let validationByModule11AdapterForSecondDigit = mod11AlgorithmAdapter$1({
        digits: digits
            .slice(0, digits.length - 1)
            .split('')
            .reverse(),
        validationRuralStateRegistration: true,
    });
    if (validationByModule11AdapterForSecondDigit === 10 ||
        validationByModule11AdapterForSecondDigit === 11)
        validationByModule11AdapterForSecondDigit = 0;
    if (validationByModule11AdapterForSecondDigit.toString() !== checkDigits[1])
        return false;
    return true;
};

const ruralValidationStateRegistration = ({ digits, checkDigits, }) => {
    let validationByModule11AdapterForFirstDigit = mod11AlgorithmAdapter$1({
        digits: digits.slice(0, 8).split(''),
        validationRuralStateRegistration: false,
    });
    if (validationByModule11AdapterForFirstDigit === 10 ||
        validationByModule11AdapterForFirstDigit === 11)
        validationByModule11AdapterForFirstDigit = 0;
    if (validationByModule11AdapterForFirstDigit.toString() !== checkDigits[0])
        return false;
    return true;
};

const stateRegistrationSaoPaulo = (digits) => {
    const regexFormatStateRegistrationSaoPaulo = new RegExp(/(^P[0-9]{12}$)|(^[0-9]{12}$)/);
    if (!regexFormatStateRegistrationSaoPaulo.test(digits))
        return false;
    const validationRuralStateRegistration = digits.length === 13 && digits.charAt(0) === 'P';
    let baseDigits;
    let checkDigits = [];
    let isValid;
    if (validationRuralStateRegistration) {
        //rural state registration
        baseDigits = digits.slice(1, 9);
        checkDigits.push(digits.charAt(9));
        isValid = ruralValidationStateRegistration({
            digits: baseDigits,
            checkDigits,
        });
    }
    else {
        baseDigits = digits;
        checkDigits = (digits.charAt(8) + digits.charAt(digits.length - 1)).split('');
        isValid = generalValidationStateRegistration({
            digits: baseDigits,
            checkDigits,
        });
    }
    return isValid;
};

const stateRegistrationTocantins = (digits) => {
    const regexFormatStateRegistrationTocantins = new RegExp(/^[0-9]{2}(01|02|03|99)[0-9]{7}$/);
    if (!regexFormatStateRegistrationTocantins.test(digits))
        return false;
    const baseDigits = digits.slice(0, 2) + digits.slice(4, digits.length);
    return validationWithOneCheckDigitAndMod11({
        digits: baseDigits,
        regexFormat: new RegExp(/./),
    });
};

const factoryStateRegistrationValidatorByState = (uf, digits) => {
    const factory = {
        AC: stateRegistrationAcre,
        AL: stateRegistrationAlagoas,
        AM: stateRegistrationAmazonas,
        AP: stateRegistrationAmapa,
        BA: stateRegistrationBahia,
        CE: stateRegistrationCeara,
        DF: stateRegistrationDistritoFederal,
        ES: stateRegistrationEspiritoSanto,
        GO: stateRegistrationGoias,
        MA: stateRegistrationMaranhao,
        MG: stateRegistrationMinasGerais,
        MS: stateRegistrationMatoGrossoDoSul,
        MT: stateRegistrationMatoGrosso,
        PA: stateRegistrationPara,
        PB: stateRegistrationParaiba,
        PE: stateRegistrationPernambuco,
        PI: stateRegistrationPiaui,
        PR: stateRegistrationParana,
        RJ: stateRegistrationRioDeJaneiro,
        RN: stateRegistrationRioGrandeDoNorte,
        RO: stateRegistrationRondonia,
        RR: stateRegistrationRoraima,
        RS: stateRegistrationRioGrandeDoSul,
        SC: stateRegistrationSantaCatarina,
        SE: stateRegistrationSergipe,
        SP: stateRegistrationSaoPaulo,
        TO: stateRegistrationTocantins,
    };
    return factory[uf] ? factory[uf](digits) : false;
};

const stateRegistrationValidator = ({ digits, uf, }) => {
    if (!digits || !uf)
        return false;
    if (/^P[0-9]{12}$/.test(digits)) {
        digits = digits?.replace(/\W/g, '');
    }
    else {
        digits = digits?.replace(/\D/g, '');
    }
    const isValid = factoryStateRegistrationValidatorByState(uf, digits);
    return isValid;
};

/* eslint-disable prettier/prettier */
/* eslint-disable no-useless-escape */
/**
 *
  @param {Object} EmailValidator
  @returns boolean

  @summary
  Motivation:
    - Testing emails with dynamic patterns for the email domain and username.

  Details:
    - For the username:
      * Only alphanumeric characters and the set of characters . - _ will be accepted.
      * It must start with an alphanumeric character, and after that, it can be preceded by . - _
      * There can't be sequences of . - _; between each character, there must be at least 1 alphanumeric character.
      * The end of the email name cannot end with . - _
    - For the email domain:
      * Domains with a minimum of 2 characters and a maximum of 26 characters will be accepted (according to the domain registration rules at
        https://registro.br/dominio/regras/). If there is a need for minimum and/or maximum values for the domain, you should use the paramsEmailValidator.minMaxEmailDomain.
      * It may contain characters of type . - _, but there can't be sequences of these characters.
      * If there is a need to validate a specific domain or with specific regex rules, you can use the paramsEmailValidator.emailDomainName typeof RegExp.

     @example <caption>Example passing customRegex to validate email domain</caption>
      emailValidator({ email: 'jon.doe@hotmail.com', paramsEmailValidator: {
        emailDomainName: RegExp(/hotmail/)',
        minMaxUserNameEmail: {max: 15}
      }});
      // returns true
    @example <caption>When passing arguments that will be used in the size rules of the username or domain, the expected value should be passed decreased by 1 unit.</caption>
      The minimum size of the username should be 10 characters, and the maximum size should be 15 characters. In paramsEmailValidator.minMaxUserNameEmail,
      the argument to be used is: { min: 9, max: 14 }.
*/
const emailValidator = ({ email, paramsEmailValidator, }) => {
    if (!email)
        return false;
    const patternValidator = `^(([a-zA-Z0-9][\-_.]{0,1})){${paramsEmailValidator?.minMaxUserNameEmail?.min ?? 1},${paramsEmailValidator?.minMaxUserNameEmail?.max ?? ''}}([a-zA-Z0-9]@)${paramsEmailValidator?.emailDomainName?.source ??
        `(([a-zA-Z0-9][-.]{0,1}){${paramsEmailValidator?.minMaxEmailDomain?.min ?? 2},${paramsEmailValidator?.minMaxEmailDomain?.max ?? 26}})([a-zA-Z0-9][.]{1}[a-zA-Z0-9]+)$`}`;
    const regexValidator = new RegExp(patternValidator);
    return regexValidator.test(email);
};

const cnpjValidator = (cnpj) => {
    const VALID_LENGTH = 14;
    cnpj = normalizeToValidation({ value: cnpj, length: VALID_LENGTH });
    if (!cnpj)
        return false;
    let sum = 0;
    let factor = 5;
    for (let i = 0; i < 12; i++) {
        sum += parseInt(cnpj.charAt(i), 10) * factor;
        factor = factor === 2 ? 9 : factor - 1;
    }
    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(cnpj.charAt(12), 10)) {
        return false;
    }
    sum = 0;
    factor = 6;
    for (let i = 0; i < 13; i++) {
        sum += parseInt(cnpj.charAt(i), 10) * factor;
        factor = factor === 2 ? 9 : factor - 1;
    }
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(cnpj.charAt(13), 10))
        return false;
    return true;
};

const nisValidator = (nis) => {
    const VALID_LENGTH = 11;
    nis = normalizeToValidation({ value: nis, length: VALID_LENGTH });
    if (!nis)
        return false;
    const multiplierBase = 3298765432;
    let total = 0;
    for (let i = 0; i < 10; i++) {
        const multiplying = Number(nis[i]);
        const multiplier = Number(String(multiplierBase).charAt(i));
        total += multiplying * multiplier;
    }
    let remainder = 11 - (total % 11);
    remainder = remainder === 10 || remainder === 11 ? 0 : remainder;
    const digit = Number(nis.charAt(10));
    return remainder === digit;
};

const cpfValidator = (cpf) => {
    const VALID_LENGTH = 11;
    cpf = normalizeToValidation({ value: cpf, length: VALID_LENGTH });
    if (!cpf)
        return false;
    let sum = 0;
    for (let i = 1; i <= 9; i++)
        sum += parseInt(cpf[i - 1], 10) * (11 - i);
    let remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11)
        remainder = 0;
    if (remainder !== parseInt(cpf.substring(9, 10), 10))
        return false;
    sum = 0;
    for (let j = 1; j <= 10; j++)
        sum += parseInt(cpf[j - 1], 10) * (12 - j);
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11)
        remainder = 0;
    if (remainder !== parseInt(cpf[10], 10))
        return false;
    return true;
};

/**
 @param {Object} PhoneValidator
 @returns boolean

 @summary
  Motivation:
    - Phone number test with validations of mobile phone numbers (BR), public utility numbers (BR),
      numbers without area code (BR), international numbers and custom validations with regex patterns.

  Details:
    - Numbering structure of a telephone number:
        CC = Coutry Code;
        NDC = Number Area State Code (National Destination Code);
        N = Number phone;
        +CC NDC N => +55 85 99999-9999
        reference: https://www.itu.int/rec/T-REC-E.164-201011-I/en

    - Validation priority order:
      * If there is paramsPhoneValidator, the following order is parsed:
        1º: If there is param Phone Validator.custom Pattern Phone;
        2º: Whether validation should occur with international phone numbers, based on E.164;
        3º: Whether validation should only occur with mobile phone numbers (BR);
            - If paramsPhoneValidator.onlyMobilePhoneBR is true, there is a condition that
              validation occurs with or without the DDD digits, with paramsPhoneValidator.numberWithoutCodeAreas.
        4º: Whether validation should occur only for public utility numbers;
      * If there is no paramsPhoneValidator or if you have paramsPhoneValidator.numberWithoutCodeAreas},
            validation will occur with standard Brazilian numbers.

    - Rules for telephone numbering in Brazil:
      Cellular Telephony - Initial digit:
        - 9 for Bands A (96 to 99) and B (91 to 94);
        - 8 for Bands D and E;
        - 7 Cellular and Trunking (Nextel);
        - 6 for bands A, B, D and E*;
      Fixed Telephony - Initial digit
        - 2 to 5;
      Public utility numbers:
        - Composed of 3 to 4 numbers, starting with the digit 1.
      reference: https://www.teleco.com.br/num.asp
 */
const phoneValidator = ({ phone, paramsPhoneValidator, }) => {
    phone = normalizeToValidation({ value: phone });
    if (!phone)
        return false;
    let numbersWithouCodeAreas = false;
    if (paramsPhoneValidator) {
        const { onlyMobilePhoneBR, canReceiveInternationalNumbers, customPatternPhone, publicUtilityNumberBR, } = paramsPhoneValidator;
        if (customPatternPhone &&
            Object.values(customPatternPhone).every((item) => item)) {
            const { coutryCode, areaStateCode, phoneNumber } = customPatternPhone;
            const regexCustomPatternPhone = new RegExp(`${coutryCode.source}${areaStateCode.source}${phoneNumber.source}`);
            try {
                return Boolean(regexCustomPatternPhone.test(phone));
            }
            catch (err) {
                console.log('err', err);
                return false;
            }
        }
        if (canReceiveInternationalNumbers) {
            const regexE164 = /^([0-9]{1,3})(\d{2,4})(\d{7,9})$/;
            return Boolean(regexE164.test(phone));
        }
        numbersWithouCodeAreas = Boolean(paramsPhoneValidator?.numberWithoutCodeAreas);
        if (onlyMobilePhoneBR) {
            if (!(phone.length > 4 && phone.length <= (!numbersWithouCodeAreas ? 11 : 9)))
                return false;
            const regexDDD = !numbersWithouCodeAreas ? /(\d{2})$/g : '';
            const phoneFormat = phone
                .split('')
                .reverse()
                .join('')
                .replace(regexDDD, '');
            if (phoneFormat.length === 9 && phoneFormat.match(/(?:[6-9]9)$/))
                return true;
            if (phoneFormat.length === 8 && phoneFormat.match(/[6-9]$/))
                return true;
            return false;
        }
        if (publicUtilityNumberBR) {
            return Boolean(phone.length >= 3 && phone.length <= 4 && phone.match(/^(1(\d){2,3}$)/));
        }
    }
    return Boolean(phone.match(!numbersWithouCodeAreas
        ? /^([1-9]{2})(9{0,1})([2-9]{1}\d{6,7})$/
        : /^(9{0,1})([2-9]{1}\d{6,7})$/));
};

const matchPatternINN = (cardNumber, patternINN) => {
    patternINN = patternINN.toString();
    return (cardNumber.slice(0, patternINN.length) ===
        patternINN.slice(0, cardNumber.length));
};

/**
 *  @param {string} cardNumber
 *  @param {number} min - minimum number of patternINN range
 *  @param {number} max - maximum number of patternINN range
 *  @returns boolean
 */
const matchRangeINN = (cardNumber, min, max) => {
    const checkDigits = cardNumber.slice(0, min.toString().length);
    return Number(checkDigits) >= min && Number(checkDigits) <= max;
};

const matchValidator = (cardNumber, patternINN) => {
    if (Array.isArray(patternINN)) {
        return matchRangeINN(cardNumber, patternINN[0], patternINN[1]);
    }
    return matchPatternINN(cardNumber, patternINN);
};

const findCardBrand = ({ cardNumber, cardBrandData, arrayBrandsCombinatons, }) => {
    if (!cardNumber)
        return;
    for (const patternINN of cardBrandData.innPattern) {
        if (!matchValidator(cardNumber, patternINN))
            continue;
        arrayBrandsCombinatons.push(cardBrandData);
        break;
    }
};

const findCardsBrandsCombinations = ({ cardNumber, cardBrandData, }) => {
    if (!cardNumber)
        return [];
    const arrayBrandsCombinatons = [];
    const cardBrandDataList = utils.mapPaymentCardList;
    if (!cardBrandData) {
        for (const brand in cardBrandDataList) {
            findCardBrand({
                cardNumber,
                cardBrandData: cardBrandDataList[brand],
                arrayBrandsCombinatons,
            });
        }
    }
    else {
        findCardBrand({
            cardNumber,
            cardBrandData,
            arrayBrandsCombinatons,
        });
    }
    return arrayBrandsCombinatons;
};

class PaymentCardValidator {
    cardNumber;
    constructor({ cardNumber }) {
        this.cardNumber = cardNumber;
    }
    getData() {
        const originalCardNumber = this.cardNumber || null;
        const brand = this.findBrandsCards({
            cardNumber: this.cardNumber?.replace(/\D/g, '') ?? '',
        });
        const isValid = this.isValid();
        const bankName = isValid && brand[0]?.nameBrandCard ? brand[0]?.nameBrandCard : null;
        let bankDigits = '';
        if (brand.length !== 0 && isValid) {
            for (const pattern of brand[0].innPattern) {
                if (!matchValidator(String(this.cardNumber), pattern))
                    continue;
                bankDigits = pattern.toString();
                break;
            }
        }
        const data = {
            cardNumber: originalCardNumber,
            bankDigits: bankDigits || null,
            bankName,
            isValid,
        };
        return data;
    }
    findBrandsCards({ cardNumber, cardBrandData, }) {
        return findCardsBrandsCombinations({
            cardNumber,
            cardBrandData,
        });
    }
    isValid(paramsPaymentCardValidator) {
        this.cardNumber = normalizeToValidation({ value: this.cardNumber });
        const validationByMod10 = utils.lunhMod10Algorithm({
            digits: this.cardNumber ?? '',
            reverseNumbers: true,
        });
        if (!this.cardNumber)
            return false;
        if (paramsPaymentCardValidator) {
            const { customPatternPaymentCard, specificBrandCard } = paramsPaymentCardValidator;
            if (customPatternPaymentCard)
                return customPatternPaymentCard.test(this.cardNumber);
            if (!validationByMod10)
                return false;
            if (specificBrandCard) {
                const brandCard = utils.mapPaymentCardList[specificBrandCard];
                return (this.findBrandsCards({
                    cardNumber: this.cardNumber,
                    cardBrandData: brandCard,
                }).length > 0);
            }
        }
        if (!validationByMod10)
            return false;
        return (this.findBrandsCards({
            cardNumber: this.cardNumber,
        }).length > 0);
    }
    static init(deps) {
        const instance = new PaymentCardValidator(deps);
        return instance;
    }
}

const checkIsBankSlipOrTaxCollection = (digits) => {
    return Number(digits.charAt(0)) !== 8 ? 'bank' : 'tax_collection';
};

const paymentSlipSegmentIdentification = {
    '1': 'municipal',
    '2': 'sanitation',
    '3': 'gas_energy',
    '4': 'telecom',
    '5': 'government_agencies',
    '6': 'others',
    '7': 'transit',
    '9': 'only_banks',
};
const paymentSlipSegmentType = {
    municipal: 'Taxas Municipais',
    sanitation: 'Taxas de Saneamento',
    gas_energy: 'Taxas de Energia Elétrica e Gás',
    telecom: 'Taxas de Telecomunicações',
    government_agencies: 'Taxas de Órgãos Governamentais',
    transit: 'Taxas de Trânsito',
    only_banks: 'Uso Exclusivo dos Bancos',
    payment_bank_slip: 'Pagamento de Boletos Bancários',
    others: 'Outros',
};
const barCodeOrTypeableLine = {
    barcode: { type: 'Cód. Barras', key: 'barcode' },
    typeable_line: { type: 'Linha Digitável', key: 'typeable_line' },
};

const mod11AlgorithmAdapter = (digits, codeChecker) => {
    const mod11 = utils.lunhMod11Algorithm({ digits });
    const resultMod11 = mod11 === 0 || mod11 === 10 || mod11 === 11 ? 1 : mod11;
    return resultMod11 === Number(codeChecker);
};

const convertAmount = (amount) => {
    if (typeof amount === 'string') {
        amount = amount.replace(/\D/g, '').split('');
        amount.splice(amount.length - 2, 0, '.');
        amount = amount.join('');
    }
    return amount
        ? new Intl.NumberFormat('en', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Number(amount))
        : null;
};

/**
 * @param {string | number} dateElapsed - Number of days traveled since 1997-10-07. Amount extracted from the payment slip
 * @returns string | null
 */
const convertDatePaymentoSlip = (dateElapsed) => {
    if (!dateElapsed ||
        (typeof dateElapsed === 'number' && dateElapsed < 0) ||
        (typeof dateElapsed === 'string' && !dateElapsed.replace(/\D/g, '')))
        return null;
    const _BASE_DATE = new Date('1997-10-07').getTime();
    const baseTime = 1000 * 60 * 60 * 24; //1 day
    const dateAnalyzeMilessecound = Math.floor(Number(dateElapsed) * baseTime + _BASE_DATE);
    let dateAnalyze = new Date(dateAnalyzeMilessecound);
    if (!(dateAnalyze instanceof Date) || !isFinite(dateAnalyze.getTime())) {
        return null;
    }
    dateAnalyze = dateAnalyze
        .toISOString()
        .replace(/T\d{2}:\d{2}:\d{2}\.\d{3}Z$/, '')
        .split('-')
        .reverse()
        .join('/');
    return dateAnalyze;
};

const bankSlipBarCode = ({ digits, mapPaymentSlipData }) => {
    const regexBarCode = new RegExp(/^[0-9]{44}$/);
    if (!regexBarCode.test(digits))
        return false;
    const digitBlocks = [
        digits.slice(0, 3),
        digits.slice(3, 4),
        digits.slice(4, 5),
        digits.slice(5, 9),
        digits.slice(9, 19),
        digits.slice(19, digits.length), //otherInfos
    ];
    const [bankCode, , verifyingDigit, expiration, amount, ,] = digitBlocks;
    const digitsToMod11 = digitBlocks
        .filter((_, currentIndex) => currentIndex !== 2)
        .join('');
    const checkDigitWithMod11 = mod11AlgorithmAdapter(digitsToMod11, verifyingDigit);
    if (!checkDigitWithMod11)
        return false;
    mapPaymentSlipData.set('bankCode', bankCode);
    mapPaymentSlipData.set('bankName', utils.filterBankByCode(bankCode));
    mapPaymentSlipData.set('price', convertAmount(amount));
    mapPaymentSlipData.set('expirationDate', convertDatePaymentoSlip(expiration));
    return checkDigitWithMod11;
};

const bankSlipTypeableLine = ({ digits, mapPaymentSlipData, }) => {
    const regexBarCode = new RegExp(/^[0-9]{47}$/);
    if (!regexBarCode.test(digits))
        return false;
    const [blockBankAndCurrency, blockFreeField1, blockFreeField2, generalCheckerCode, blockExpirationFactorAndAmount,] = [
        digits.substring(0, 10),
        digits.substring(10, 21),
        digits.substring(21, 32),
        digits.substring(32, 33),
        digits.substring(33, digits.length),
    ];
    const transformTypeableLineToBarCode = `${digits.slice(0, 4)}${digits.slice(33, 37)}${digits.slice(37, 47)}${digits.slice(4, 9)}${digits.slice(10, 20)}${digits.slice(21, 31)}`;
    const checkBlockValidationsMod10 = utils.lunhMod10Algorithm({
        digits: blockBankAndCurrency,
        onlyValidCheckDigit: true,
    }) &&
        utils.lunhMod10Algorithm({
            digits: blockFreeField1,
            onlyValidCheckDigit: true,
        }) &&
        utils.lunhMod10Algorithm({
            digits: blockFreeField2,
            onlyValidCheckDigit: true,
        });
    const checkCodeMod11 = mod11AlgorithmAdapter(transformTypeableLineToBarCode, Number(generalCheckerCode));
    if (!checkBlockValidationsMod10 || !checkCodeMod11)
        return false;
    const bankCode = blockBankAndCurrency.slice(0, 3);
    mapPaymentSlipData.set('bankCode', bankCode);
    mapPaymentSlipData.set('bankName', utils.filterBankByCode(bankCode));
    const amount = blockExpirationFactorAndAmount.slice(5, blockExpirationFactorAndAmount.length);
    mapPaymentSlipData.set('price', convertAmount(amount));
    const expiration = blockExpirationFactorAndAmount.slice(0, 4);
    mapPaymentSlipData.set('expirationDate', convertDatePaymentoSlip(expiration));
    return checkCodeMod11;
};

const bankSlip = ({ digits, mapPaymentSlipData }) => {
    const isBarCodeOrTypeableLine = digits.length === 44
        ? barCodeOrTypeableLine.barcode.key
        : digits.length === 47
            ? barCodeOrTypeableLine.typeable_line.key
            : undefined;
    if (!isBarCodeOrTypeableLine) {
        return false;
    }
    mapPaymentSlipData.set('barCodeOrTypeableLine', barCodeOrTypeableLine[isBarCodeOrTypeableLine]?.type);
    mapPaymentSlipData.set('segmentPaymentSplip', paymentSlipSegmentType.payment_bank_slip);
    if (isBarCodeOrTypeableLine === barCodeOrTypeableLine.barcode.key) {
        return bankSlipBarCode({ digits, mapPaymentSlipData });
    }
    else if (isBarCodeOrTypeableLine === barCodeOrTypeableLine.typeable_line.key) {
        return bankSlipTypeableLine({ digits, mapPaymentSlipData });
    }
    else {
        return false;
    }
};

/**
 * @param {string | number} expirationDate - If there is a due date in the free field, it must come first place and in YYYYMMDD format.
 * @returns string | null
 *
 */
const convertDatePaymentSlipTaxCollection = (expirationDate) => {
    if (!expirationDate) {
        return null;
    }
    const cleanExpirationDate = expirationDate.toString().replace(/\D/g, '');
    const formattedExpirationDate = `${cleanExpirationDate.slice(0, 4)}-${cleanExpirationDate.slice(4, 6)}-${cleanExpirationDate.slice(6, 8)}`;
    let parsedExpirationDate = new Date(formattedExpirationDate);
    if (!(parsedExpirationDate instanceof Date) ||
        !isFinite(parsedExpirationDate.getTime())) {
        return null;
    }
    parsedExpirationDate = parsedExpirationDate
        .toISOString()
        .slice(0, 10)
        .split('-')
        .reverse()
        .join('/');
    return parsedExpirationDate;
};

const moduleToBeUsedForValidation = (verifyingDigit, digits, referenceValue) => {
    if (!digits || !referenceValue)
        return false;
    const regexToModule10 = new RegExp(/6|7/);
    const regexToModule11 = new RegExp(/8|9/);
    if (regexToModule10.test(referenceValue)) {
        /*The verifying digit is added to the block of digits for Mod10 validation,
          where the lunhMod10Algorithm method removes the last digit and calculates
          the block by the lunh algorithm and after that checks the verifying digit.
         */
        return Boolean(utils.lunhMod10Algorithm({
            digits: digits + verifyingDigit,
            onlyValidCheckDigit: true,
        }));
    }
    else if (regexToModule11.test(referenceValue)) {
        return mod11AlgorithmAdapter(digits, verifyingDigit);
    }
    else {
        return false;
    }
};

const taxCollectionBarCode = ({ digits, mapPaymentSlipData, }) => {
    const regexBarCode = /^[0-9]{44}$/;
    if (!regexBarCode.test(digits))
        return false;
    const digitBlocks = [
        digits.slice(0, 1),
        digits.slice(1, 2),
        digits.slice(2, 3),
        digits.slice(3, 4),
        digits.slice(4, 15),
        digits.slice(15, 23),
        digits.slice(23, digits.length), // blockFreeField
    ];
    const [serviceType, segmentType, referenceValue, verifyingDigit, amount, , blockFreeField,] = digitBlocks;
    if (serviceType !== '8')
        return false;
    const digitsToValidation = digitBlocks
        .filter((_, currentIndex) => currentIndex !== 3)
        .join('');
    const checkDigitsWithinModuleValidation = moduleToBeUsedForValidation(verifyingDigit, digitsToValidation, referenceValue);
    if (!checkDigitsWithinModuleValidation)
        return false;
    const segmentTypeKey = paymentSlipSegmentIdentification[segmentType];
    mapPaymentSlipData.set('segmentPaymentSplip', paymentSlipSegmentType[segmentTypeKey]);
    mapPaymentSlipData.set('price', convertAmount(amount));
    const expiration = blockFreeField.slice(0, 8);
    mapPaymentSlipData.set('expirationDate', convertDatePaymentSlipTaxCollection(expiration));
    return checkDigitsWithinModuleValidation;
};

const taxCollectionTypeableLine = ({ digits, mapPaymentSlipData, }) => {
    const regexTypeableLine = /^[0-9]{48}$/;
    if (!regexTypeableLine.test(digits))
        return false;
    const [blockMainInfosValidation, blockWithAmount, blockFreeField1, blockFreeField2,] = [
        digits.slice(0, 12),
        digits.slice(12, 24),
        digits.slice(24, 36),
        digits.slice(36, digits.length), // blockFreeField2
    ];
    const serviceType = blockMainInfosValidation.slice(0, 1);
    const segmentType = blockMainInfosValidation.slice(1, 2);
    const referenceValue = blockMainInfosValidation.slice(2, 3);
    if (serviceType !== '8')
        return false;
    const checkDigitsWithinModuleValidation = moduleToBeUsedForValidation(blockMainInfosValidation.charAt(blockMainInfosValidation.length - 1), blockMainInfosValidation.slice(0, blockMainInfosValidation.length - 1), referenceValue) &&
        moduleToBeUsedForValidation(blockWithAmount.charAt(blockWithAmount.length - 1), blockWithAmount.slice(0, blockMainInfosValidation.length - 1), referenceValue) &&
        moduleToBeUsedForValidation(blockFreeField1.charAt(blockFreeField1.length - 1), blockFreeField1.slice(0, blockFreeField1.length - 1), referenceValue) &&
        moduleToBeUsedForValidation(blockFreeField2.charAt(blockFreeField2.length - 1), blockFreeField2.slice(0, blockFreeField2.length - 1), referenceValue);
    if (!checkDigitsWithinModuleValidation)
        return false;
    const segmentTypeKey = paymentSlipSegmentIdentification[segmentType];
    mapPaymentSlipData.set('segmentPaymentSplip', paymentSlipSegmentType[segmentTypeKey]);
    const amount = blockMainInfosValidation.slice(4, 11) + blockWithAmount.slice(0, 4);
    mapPaymentSlipData.set('price', convertAmount(amount));
    const expiration = blockFreeField2.slice(0, 8);
    mapPaymentSlipData.set('expirationDate', convertDatePaymentSlipTaxCollection(expiration));
    return checkDigitsWithinModuleValidation;
};

const taxColletionSlip = ({ digits, mapPaymentSlipData, }) => {
    const isBarCodeOrTypeableLine = digits.length === 44
        ? barCodeOrTypeableLine.barcode.key
        : digits.length === 48
            ? barCodeOrTypeableLine.typeable_line.key
            : undefined;
    if (!isBarCodeOrTypeableLine) {
        return false;
    }
    mapPaymentSlipData.set('bankCode', null);
    mapPaymentSlipData.set('bankName', null);
    mapPaymentSlipData.set('barCodeOrTypeableLine', barCodeOrTypeableLine[isBarCodeOrTypeableLine]?.type);
    if (isBarCodeOrTypeableLine === barCodeOrTypeableLine.barcode.key) {
        return taxCollectionBarCode({ digits, mapPaymentSlipData });
    }
    else if (isBarCodeOrTypeableLine === barCodeOrTypeableLine.typeable_line.key) {
        return taxCollectionTypeableLine({ digits, mapPaymentSlipData });
    }
    else {
        return false;
    }
};

/**
 * @param {string | number | null} amount - amount extracted from the payment slip
 * @param {string | number | Array<string | number> | undefined} amountReference - value entered as an argument for validation
 * @returns boolean
 */
const validAmount = (amount, amountReference) => {
    const normalizeAmountReference = convertAmount(amountReference);
    return Boolean(amount && normalizeAmountReference && amount === normalizeAmountReference);
};

/**
 * @param {string | null} dateElapsed - Number of days traveled since 1997-10-07. Amount extracted from the payment slip
 * @param {Date} dateReference - Date informed as argument for analysis
 * @returns boolean
 *
 */
const validateDatePaymentoSlipToDate = (dateElapsed, dateReference) => {
    if (!dateReference)
        return false;
    const dateAnalyze = new Date(dateReference)
        .toISOString()
        .replace(/T\d{2}:\d{2}:\d{2}\.\d{3}Z$/, '')
        .split('-')
        .reverse()
        .join('/');
    return dateElapsed === dateAnalyze;
};

/**
 * @param {string | null} dateReference - If there is a due date in the free field, it must come first place and in YYYYMMDD format.
 * @param {Date} dateReference - Date informed as argument for analysis
 * @returns boolean
 *
 */
const validateDatePaymentSlipTaxCollection = (expirationDate, dateReference) => {
    if (!expirationDate || !dateReference) {
        return false;
    }
    const formattedDateReference = dateReference.toString().replace(/\D/g, '');
    const parsedDateReference = formattedDateReference
        ? new Date(dateReference)
        : undefined;
    if (!parsedDateReference) {
        return false;
    }
    const formattedParsedDateReference = parsedDateReference
        .toISOString()
        .slice(0, 10)
        .split('-')
        .reverse()
        .join('/');
    return formattedParsedDateReference === expirationDate;
};

/**
   *
    @class PaymentSlipValidator

    @summary
    Motivation:
      - Testing and capture data payment slip with types bank slip and tax collection..

    Details:
      - It is possible to validate and capture data payment slips (banking) and collection slips, in typeable line formats and barcode numbering.
      - Among the validations are: validation by the issuing bank of the bill; segment type, payment amount; due date.
      - Among the data captured are: payment slip digits; issuing bank code; issuing bank name; payment slip price; expiration date; segment to
        which the payment slip is inserted; if the payment slip is type barcode or typeable lines.

    Limitations:
      - In accordance with FEBRABAN (Brazilian Federation of Banks) regulations: "Layout" Standard for Collection/Receipt Using Bar Codes, version 06,
      for collection-type slips, due dates do not follow a pattern. The issuing bank is responsible for inserting this data in the blocks of free or
      unavailable fields, and, if inserted, it must be have the format YYYYMMDD. As a result, validation of the due date for payment slips does not have
      a standard, so it is not recommended that the validation of a payment slip is verified only by the due date.
    @see https://cmsarquivos.febraban.org.br/Arquivos/documentos/PDF/Layout%20-%20C%C3%B3digo%20de%20Barras%20ATUALIZADO.pdf.
  */
class PaymentSlipValidator {
    digits;
    typesOfPaymentSlip = {
        bank: { type: 'Boleto Bancário', key: 'bank' },
        tax_collection: { type: 'Boleto de Arrecadação', key: 'tax_collection' },
    };
    regexLengthDigitsValidator = new RegExp(/^[0-9]{44,48}/);
    constructor({ digits }) {
        this.digits = digits;
    }
    checkIsBankSlipOrTaxCollection() {
        return checkIsBankSlipOrTaxCollection(this.digits?.replace(/\D/g, '') || '');
    }
    capturePaymentSlipData() {
        const mapPaymentSlipData = new Map();
        let isValid = false;
        this.digits = normalizeToValidation({ value: this.digits });
        if (!this.digits || !this.regexLengthDigitsValidator.test(this.digits)) {
            return {
                success: false,
                mapPaymentSlipData,
            };
        }
        const isBankSlipOrTaxCollection = this.checkIsBankSlipOrTaxCollection();
        mapPaymentSlipData.set('typeOfPaymentSlip', this.typesOfPaymentSlip[isBankSlipOrTaxCollection].type);
        mapPaymentSlipData.set('typeOfPaymentSlipKey', this.typesOfPaymentSlip[isBankSlipOrTaxCollection].key);
        if (isBankSlipOrTaxCollection === this.typesOfPaymentSlip.bank.key) {
            isValid = bankSlip({
                digits: this.digits,
                mapPaymentSlipData,
            });
        }
        if (isBankSlipOrTaxCollection === this.typesOfPaymentSlip.tax_collection.key) {
            isValid = taxColletionSlip({
                digits: this.digits,
                mapPaymentSlipData,
            });
        }
        if (!isValid) {
            mapPaymentSlipData.clear();
            return {
                success: false,
                mapPaymentSlipData,
            };
        }
        return {
            success: true,
            mapPaymentSlipData,
        };
    }
    getData() {
        const originalCardNumber = this.digits;
        const { success, mapPaymentSlipData } = this.capturePaymentSlipData();
        const data = {
            digits: originalCardNumber,
            bankName: mapPaymentSlipData.get('bankName') ?? null,
            bankCode: mapPaymentSlipData.get('bankCode') ?? null,
            price: mapPaymentSlipData.get('price') ?? null,
            expirationDate: mapPaymentSlipData.get('expirationDate') ?? null,
            typeOfPaymentSlip: mapPaymentSlipData.get('typeOfPaymentSlip') ?? null,
            barCodeOrTypeableLine: mapPaymentSlipData.get('barCodeOrTypeableLine') ?? null,
            segmentPaymentSplip: mapPaymentSlipData.get('segmentPaymentSplip') ?? null,
            isValid: success,
        };
        return data;
    }
    /**
     *
     * @param paramsPaymentSlipValidator
     * @argument validByBank: Bank code or bank name can be passed for validation
     * @argument validSegmentType: Used to check which segment the payment slip is inserted in
     * @argument validByPrice: Used to check the value of the payment slip
     * @argument validByDate: Used to check the date of the payment slip
     * @argument validByTypeOfPaymentSlip: Used to check if the payment slip is of the Banking or Collection type
     * @argument validByIfIsBarCodeOrTypeableLine: Used to check if the payment slip is a barcode type or typeable lines
     * @returns boolean
     */
    isValid(paramsPaymentSlipValidator) {
        const { success, mapPaymentSlipData } = this.capturePaymentSlipData();
        if (paramsPaymentSlipValidator) {
            const { validByBank, validSegmentType, validByDate, validByIfIsBarCodeOrTypeableLine, validByPrice, validByTypeOfPaymentSlip, } = paramsPaymentSlipValidator;
            if (validByBank) {
                if (validByTypeOfPaymentSlip &&
                    mapPaymentSlipData.has('typeOfPaymentSlip') &&
                    mapPaymentSlipData.get('typeOfPaymentSlip') ===
                        this.typesOfPaymentSlip.tax_collection.type) {
                    return false;
                }
                const bankCode = mapPaymentSlipData.get('bankCode');
                let isValidBank = false;
                if (validByBank.length === 3) {
                    isValidBank = validByBank.toString() === bankCode;
                }
                else {
                    isValidBank = mapPaymentSlipData.get('bankName') === validByBank;
                }
                if (!isValidBank)
                    return false;
            }
            if (validSegmentType) {
                let isValidSegmentType = false;
                if (mapPaymentSlipData.get('typeOfPaymentSlipKey') ===
                    this.typesOfPaymentSlip.bank.key &&
                    paymentSlipSegmentType.payment_bank_slip === validSegmentType &&
                    validSegmentType === mapPaymentSlipData.get('segmentPaymentSplip')) {
                    isValidSegmentType = true;
                }
                if (mapPaymentSlipData.get('typeOfPaymentSlipKey') ===
                    this.typesOfPaymentSlip.tax_collection.key &&
                    Object.values(paymentSlipSegmentType).includes(validSegmentType) &&
                    validSegmentType === mapPaymentSlipData.get('segmentPaymentSplip')) {
                    isValidSegmentType = true;
                }
                if (!isValidSegmentType)
                    return false;
            }
            if (validByDate) {
                let isValidByDate = false;
                if (mapPaymentSlipData.get('typeOfPaymentSlipKey') ===
                    this.typesOfPaymentSlip.bank.key) {
                    isValidByDate = validateDatePaymentoSlipToDate(mapPaymentSlipData.get('expirationDate'), new Date(validByDate));
                }
                if (mapPaymentSlipData.get('typeOfPaymentSlipKey') ===
                    this.typesOfPaymentSlip.tax_collection.key) {
                    isValidByDate = validateDatePaymentSlipTaxCollection(mapPaymentSlipData.get('expirationDate'), new Date(validByDate));
                }
                if (!isValidByDate)
                    return false;
            }
            if (validByIfIsBarCodeOrTypeableLine) {
                if (mapPaymentSlipData.has('barCodeOrTypeableLine') &&
                    validByIfIsBarCodeOrTypeableLine !==
                        mapPaymentSlipData.get('barCodeOrTypeableLine'))
                    return false;
            }
            if (validByPrice) {
                if (!validAmount(mapPaymentSlipData.get('price'), validByPrice))
                    return false;
            }
            if (validByTypeOfPaymentSlip) {
                if (mapPaymentSlipData.has('typeOfPaymentSlip') &&
                    validByTypeOfPaymentSlip !==
                        mapPaymentSlipData.get('typeOfPaymentSlip')) {
                    return false;
                }
            }
        }
        return success;
    }
    /**
     *
     * @param deps
     * @returns instance of PaymentSlipValidator
     */
    static init(deps) {
        const instance = new PaymentSlipValidator(deps);
        return instance;
    }
}

const voterRegistrationValidation = (digits) => {
    const VALID_LENGTH = 12;
    digits = normalizeToValidation({ value: digits, length: VALID_LENGTH });
    if (!digits)
        return false;
    const digitsUF = digits.slice(8, 10);
    const checkDigits = digits.slice(10, digits.length).split('');
    let validationFirstCheckDigit = utils.lunhMod11Algorithm({
        digits: digits.slice(0, digits.length - 4),
    });
    if (validationFirstCheckDigit === null)
        return false;
    if (validationFirstCheckDigit === 10 || validationFirstCheckDigit === 11) {
        if (digitsUF.match(/^(01|02)/)) {
            validationFirstCheckDigit = 1;
        }
        else {
            validationFirstCheckDigit = 0;
        }
    }
    if (validationFirstCheckDigit.toString() !== checkDigits[0])
        return false;
    let validationSecontCheckDigit = utils.lunhMod11Algorithm({
        digits: digits.slice(8, 11),
    });
    if (validationSecontCheckDigit === null)
        return false;
    if (validationSecontCheckDigit === 10 || validationSecontCheckDigit === 11) {
        if (digitsUF.match(/^(01|02)/)) {
            validationSecontCheckDigit = 1;
        }
        else {
            validationSecontCheckDigit = 0;
        }
    }
    if (validationSecontCheckDigit.toString() !== checkDigits[1])
        return false;
    return true;
};

class CepValidator {
    cep;
    regexCep = new RegExp(/^[0-9]{8}$|^[0-9]{5}-[0-9]{3}$/);
    _URL_SEARCH_DATA_CEP = 'https://apigetcep.cloud/:cep';
    constructor(cep) {
        this.cep = cep;
    }
    formatUrlSearchDataCep(cep) {
        return this._URL_SEARCH_DATA_CEP.replace(':cep', cep);
    }
    isValid() {
        if (!this.cep || !this.regexCep.test(this.cep))
            return false;
        this.cep = this.cep?.replace(/\D/g, '');
        return true;
    }
    async getData(signal) {
        const cepIsValid = this.isValid();
        const dataCep = {
            cep: null,
            uf: null,
            bairro: null,
            complemento: null,
            cidade: null,
            logradouro: null,
            estado: null,
            enderecoPostal: null,
            isValid: cepIsValid,
        };
        try {
            if (!cepIsValid)
                throw new Error('Cep inválido!');
            const responseCep = await fetch(this.formatUrlSearchDataCep(this.cep), {
                signal,
            })
                .then((response) => response.json())
                .catch((error) => error);
            if (responseCep instanceof Error || responseCep instanceof DOMException) {
                if (responseCep?.name.match(/CanceledError|AbortError/)) {
                    throw new Error('Requisição cancelada.');
                }
                else {
                    throw new Error('Erro no servidor.');
                }
            }
            if (!responseCep?.success)
                throw new Error(responseCep?.error);
            return {
                ...responseCep?.data,
                isValid: responseCep?.success,
            };
        }
        catch (error) {
            return {
                ...dataCep,
                isValid: false,
                error: error?.message,
            };
        }
    }
    static init(deps) {
        const instance = new CepValidator(deps);
        return instance;
    }
}

const validators = {
    cpf: cpfValidator,
    cnpj: cnpjValidator,
    email: emailValidator,
    nis: nisValidator,
    phone: phoneValidator,
    paymentCard: PaymentCardValidator.init,
    paymentSlip: PaymentSlipValidator.init,
    stateRegistration: stateRegistrationValidator,
    voterRegistration: voterRegistrationValidation,
    cnh: cnhValidator,
    renavam: renavamValidator,
    cep: CepValidator.init,
};

export { validators };
//# sourceMappingURL=index.mjs.map
